import { bikeGif, helmetGif } from "./data/markersData";

const LOCALSTORAGE = false;

const mockprod = [
    {
        "id": 1603,
        "customer": {
            "id": 377,
            "title": "Cicli Valentini",
            "description": "Cicli Valentini \u00e8 un bike rental a Castiglione del Lago, sul Lago Trasimeno, con negozio, officina e servizio noleggio.\r\nNasce dalla passione e dall\u2019esperienza nel ciclismo, con un approccio competente e orientato all\u2019accoglienza di turisti e sportivi.\r\nL\u2019offerta include e-bike, mountain bike, bici tradizionali e bici da corsa, con supporto e assistenza tecnica in caso di necessit\u00e0.\r\n\u00c8 possibile ritirare le bici rapidamente in zona Trasimeno e, su richiesta, riceverle anche con consegna.\r\nIl servizio copre il lago e i principali itinerari nei dintorni, fino all\u2019area tra Umbria e bassa Toscana.\r\nUna soluzione completa per scoprire il Trasimeno e i suoi borghi su due ruote, in libert\u00e0 e sicurezza.",
            "color": "#182783",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Cicli_Valentini.jpg",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/logo_cicli_valentini.png"
            ],
            "contacts": {
                "address": "Via Firenze, 68, Via Firenze, 68, 06061 Castiglione del Lago PG, Italia",
                "email": "info@ciclivalentini.it",
                "phone": "+39 075951663"
            },
            "coordinate": {
                "latitude": 43.13062,
                "longitude": 12.04269
            },
            "tours": 2,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/bf66cfd3-1fd5-4208-bc1b-12719903b4d6.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/89d148fa-1919-407a-b4db-d4b7e1560c47.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/08641b96-a8d9-4e1e-a4c3-70e0a7462a4a.jpg"
            ]
        },
        "title": "Da Castiglione del Lago Trasimeno a Cortona",
        "description": "Tour e-bike andata e ritorno dal nostro bike rental a Castiglione del Lago, sulle sponde del Trasimeno, fino a Cortona. Il percorso alterna asfalto e sterrato e si sviluppa quasi interamente su strade secondarie, con solo un breve tratto inevitabile di statale. Un itinerario panoramico che collega il paesaggio del Lago Trasimeno alle colline toscane e al fascino storico di Cortona.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1603.webp",
        "price": 25.0,
        "location": "Val d'Orcia",
        "location_id": 36,
        "tags": [
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1636,
                "title": "Da Castiglione del Lago Trasimeno a Cortona",
                "description": "Questo tour e-bike parte dal nostro bike rental a Castiglione del Lago, nel cuore dell\u2019area del Trasimeno, e conduce fino a Cortona lungo un itinerario andata e ritorno panoramico e molto piacevole. Il percorso alterna asfalto e sterrato, ma si sviluppa quasi interamente su strade secondarie tranquille, con solo un breve tratto inevitabile di statale, risultando ideale per chi desidera pedalare lontano dal traffico e immergersi gradualmente nel paesaggio tra Umbria e Toscana.\n\nFin dalla partenza si pedala nel suggestivo contesto del Lago Trasimeno, tra campagna aperta, dolci colline e scorci che accompagnano l\u2019uscita dall\u2019area lacustre verso la Val di Chiana. Il tour racconta in modo naturale il passaggio da un paesaggio legato all\u2019acqua e agli ampi orizzonti del lago a uno pi\u00f9 tipicamente toscano, fatto di colline, strade bianche, campi coltivati e borghi storici.\n\nLa meta \u00e8 Cortona, una delle cittadine pi\u00f9 affascinanti della Toscana, di origine etrusca e poi sviluppatasi in epoca romana e medievale. Arroccata sulla collina e affacciata sulla Val di Chiana, Cortona rappresenta l\u2019arrivo ideale di questo itinerario, con il suo carattere storico, le sue mura antiche e l\u2019atmosfera autentica di borgo toscano.\n\nDopo la sosta, il rientro verso Castiglione del Lago segue lo stesso spirito del tour: un percorso scorrevole e vario che unisce il fascino del Trasimeno alla bellezza senza tempo di Cortona.",
                "notes": null,
                "start_address": "Via Firenze, 68, 06061 Castiglione del Lago PG, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    43.13051,
                    12.04238
                ],
                "preview_track": [
                    "43.13051;12.04238",
                    "43.13092;12.04198",
                    "43.1323;12.04311",
                    "43.13233;12.04333",
                    "43.13242;12.04344",
                    "43.13353;12.04424",
                    "43.13359;12.04435",
                    "43.13367;12.04428",
                    "43.13368;12.04425",
                    "43.13369;12.04331",
                    "43.13372;12.04254",
                    "43.13382;12.04106",
                    "43.13498;12.03962",
                    "43.13504;12.03916",
                    "43.13587;12.03724",
                    "43.13956;12.03578",
                    "43.14005;12.03589",
                    "43.14118;12.03188",
                    "43.14277;12.0304",
                    "43.14398;12.03147",
                    "43.14421;12.03147",
                    "43.14458;12.03153",
                    "43.14477;12.03131",
                    "43.14517;12.03083",
                    "43.14565;12.03025",
                    "43.14603;12.02977",
                    "43.1465;12.02923",
                    "43.14702;12.02879",
                    "43.1473;12.02837",
                    "43.14844;12.02771",
                    "43.1488;12.02711",
                    "43.14918;12.02656",
                    "43.14945;12.02632",
                    "43.1493;12.02534",
                    "43.1494;12.02483",
                    "43.14966;12.02447",
                    "43.15153;12.02316",
                    "43.15205;12.02434",
                    "43.15267;12.02458",
                    "43.15323;12.02397",
                    "43.15348;12.0235",
                    "43.15404;12.02331",
                    "43.15437;12.02284",
                    "43.15498;12.02229",
                    "43.15556;12.02208",
                    "43.15617;12.02184",
                    "43.15653;12.022",
                    "43.15707;12.02155",
                    "43.15751;12.02182",
                    "43.1578;12.02141",
                    "43.15823;12.02065",
                    "43.15912;12.02006",
                    "43.16;12.01963",
                    "43.16045;12.01958",
                    "43.16103;12.01931",
                    "43.16138;12.0192",
                    "43.16212;12.01901",
                    "43.16252;12.01921",
                    "43.16322;12.0188",
                    "43.16334;12.01819",
                    "43.16363;12.01795",
                    "43.16395;12.01813",
                    "43.16443;12.01798",
                    "43.16527;12.01765",
                    "43.16535;12.01736",
                    "43.16564;12.01742",
                    "43.16631;12.0172",
                    "43.16699;12.01742",
                    "43.16777;12.01736",
                    "43.16803;12.01768",
                    "43.16843;12.0174",
                    "43.16913;12.01741",
                    "43.16958;12.01724",
                    "43.16995;12.01754",
                    "43.1704;12.01753",
                    "43.17111;12.01761",
                    "43.17185;12.01735",
                    "43.1728;12.01695",
                    "43.17416;12.01677",
                    "43.17488;12.01724",
                    "43.17581;12.0175",
                    "43.17601;12.01617",
                    "43.17638;12.01537",
                    "43.17675;12.01532",
                    "43.1783;12.01556",
                    "43.17893;12.01567",
                    "43.17999;12.01591",
                    "43.1804;12.01613",
                    "43.18098;12.01562",
                    "43.18126;12.01533",
                    "43.18156;12.01539",
                    "43.18238;12.01726",
                    "43.18407;12.01886",
                    "43.18535;12.01992",
                    "43.18569;12.02062",
                    "43.18636;12.02311",
                    "43.18655;12.02315",
                    "43.18713;12.02334",
                    "43.1881;12.02308",
                    "43.18883;12.02289",
                    "43.19044;12.0227",
                    "43.19167;12.02251",
                    "43.19276;12.02432",
                    "43.19399;12.02603",
                    "43.19509;12.02778",
                    "43.19653;12.02959",
                    "43.19747;12.02927",
                    "43.19868;12.02991",
                    "43.19971;12.03086",
                    "43.2007;12.03107",
                    "43.20133;12.03117",
                    "43.20148;12.03156",
                    "43.20365;12.03023",
                    "43.20383;12.02938",
                    "43.20391;12.02603",
                    "43.20486;12.02453",
                    "43.20531;12.02415",
                    "43.20731;12.02376",
                    "43.20912;12.02324",
                    "43.2122;12.02133",
                    "43.21345;12.02041",
                    "43.21416;12.01932",
                    "43.21462;12.01737",
                    "43.21702;12.01412",
                    "43.21895;12.01078",
                    "43.21916;12.00917",
                    "43.2193;12.00865",
                    "43.21953;12.00821",
                    "43.22038;12.00775",
                    "43.22232;12.00607",
                    "43.22344;12.00535",
                    "43.22466;12.0049",
                    "43.22681;12.00448",
                    "43.22933;12.00431",
                    "43.23116;12.00388",
                    "43.23185;12.00367",
                    "43.23294;12.00416",
                    "43.23388;12.00411",
                    "43.23508;12.00324",
                    "43.23595;12.00419",
                    "43.23984;12.00387",
                    "43.24428;12.0031",
                    "43.24643;12.00274",
                    "43.25148;12.00192",
                    "43.25324;12.00162",
                    "43.25859;12.0007",
                    "43.26071;12.00044",
                    "43.2609;12.00014",
                    "43.26159;11.99864",
                    "43.26234;11.99731",
                    "43.26345;11.99651",
                    "43.26443;11.99636",
                    "43.26583;11.99539",
                    "43.26792;11.99322",
                    "43.26871;11.9921",
                    "43.26906;11.992",
                    "43.26938;11.99192",
                    "43.26935;11.99109",
                    "43.26929;11.9899",
                    "43.26962;11.98863",
                    "43.27055;11.98726",
                    "43.27085;11.98707",
                    "43.27108;11.98678",
                    "43.2707;11.98589",
                    "43.27;11.98489",
                    "43.27006;11.98478",
                    "43.2716;11.98641",
                    "43.27155;11.98729",
                    "43.2713;11.98776",
                    "43.27083;11.9891",
                    "43.27081;11.9901",
                    "43.27104;11.99071",
                    "43.27139;11.99194",
                    "43.27162;11.99197",
                    "43.27137;11.99023",
                    "43.27154;11.98945",
                    "43.27235;11.98823",
                    "43.27295;11.98672",
                    "43.27306;11.9857",
                    "43.27292;11.98519",
                    "43.27332;11.98571",
                    "43.27336;11.98716",
                    "43.27327;11.98831",
                    "43.27299;11.98891",
                    "43.27265;11.9894",
                    "43.2726;11.98999",
                    "43.27287;11.99039",
                    "43.27321;11.99098",
                    "43.27311;11.99201",
                    "43.27315;11.99203",
                    "43.27348;11.9911",
                    "43.27344;11.98986",
                    "43.27414;11.98847",
                    "43.27414;11.98772",
                    "43.2741;11.98794",
                    "43.27403;11.98816",
                    "43.2738;11.98889",
                    "43.27313;11.98965",
                    "43.27287;11.99039",
                    "43.27262;11.9901",
                    "43.27262;11.98949",
                    "43.27291;11.989",
                    "43.27323;11.98849",
                    "43.27331;11.98779",
                    "43.27336;11.98578",
                    "43.27297;11.98519",
                    "43.27298;11.98555",
                    "43.27304;11.98631",
                    "43.2726;11.98783",
                    "43.2716;11.98933",
                    "43.27138;11.99003",
                    "43.27162;11.99189",
                    "43.27142;11.992",
                    "43.2711;11.99086",
                    "43.27104;11.99071",
                    "43.27081;11.9901",
                    "43.27083;11.9891",
                    "43.2713;11.98776",
                    "43.27155;11.98729",
                    "43.2716;11.98641",
                    "43.27006;11.98478",
                    "43.27;11.98489",
                    "43.2707;11.98589",
                    "43.27108;11.98678",
                    "43.27085;11.98707",
                    "43.27055;11.98726",
                    "43.26962;11.98863",
                    "43.26929;11.9899",
                    "43.26935;11.99109",
                    "43.26938;11.99192",
                    "43.26906;11.992",
                    "43.2689;11.99187",
                    "43.2686;11.99225",
                    "43.26785;11.99329",
                    "43.26716;11.99388",
                    "43.26516;11.99601",
                    "43.2637;11.99642",
                    "43.26297;11.99682",
                    "43.26199;11.99802",
                    "43.2615;11.99877",
                    "43.2608;12.00035",
                    "43.26058;12.0004",
                    "43.25734;12.00095",
                    "43.252;12.00184",
                    "43.24608;12.0028",
                    "43.24371;12.00319",
                    "43.23752;12.00424",
                    "43.23572;12.00378",
                    "43.23488;12.00326",
                    "43.23361;12.00426",
                    "43.23267;12.00402",
                    "43.23176;12.00365",
                    "43.231;12.00392",
                    "43.22859;12.00447",
                    "43.22599;12.00464",
                    "43.2241;12.005",
                    "43.22303;12.00568",
                    "43.22209;12.00622",
                    "43.22026;12.00784",
                    "43.2195;12.00832",
                    "43.21906;12.00961",
                    "43.21891;12.01094",
                    "43.21664;12.01454",
                    "43.21455;12.01745",
                    "43.21409;12.01949",
                    "43.21334;12.02051",
                    "43.21212;12.02138",
                    "43.20888;12.02337",
                    "43.20699;12.02381",
                    "43.20518;12.02421",
                    "43.20397;12.02586",
                    "43.20382;12.02897",
                    "43.20369;12.03011",
                    "43.20293;12.03252",
                    "43.20279;12.03339",
                    "43.20265;12.03474",
                    "43.20205;12.03523",
                    "43.19884;12.03705",
                    "43.1981;12.03795",
                    "43.19738;12.03889",
                    "43.19536;12.04158",
                    "43.19366;12.04206",
                    "43.19234;12.04144",
                    "43.19098;12.04018",
                    "43.18986;12.03983",
                    "43.18961;12.04001",
                    "43.18979;12.03965",
                    "43.18984;12.03951",
                    "43.18856;12.03902",
                    "43.1876;12.03795",
                    "43.18712;12.0357",
                    "43.18687;12.03549",
                    "43.18679;12.03544",
                    "43.18641;12.0362",
                    "43.18609;12.03649",
                    "43.18555;12.03686",
                    "43.1852;12.03534",
                    "43.18475;12.03452",
                    "43.18462;12.0315",
                    "43.18501;12.02939",
                    "43.18534;12.02676",
                    "43.18508;12.02581",
                    "43.18453;12.02454",
                    "43.1864;12.02374",
                    "43.18651;12.02372",
                    "43.18636;12.02311",
                    "43.18569;12.02062",
                    "43.18535;12.01992",
                    "43.18407;12.01886",
                    "43.18238;12.01726",
                    "43.18156;12.01539",
                    "43.18126;12.01533",
                    "43.18098;12.01562",
                    "43.1804;12.01613",
                    "43.17999;12.01591",
                    "43.17854;12.0156",
                    "43.17827;12.01557",
                    "43.17675;12.01532",
                    "43.17638;12.01537",
                    "43.17601;12.01617",
                    "43.17581;12.0175",
                    "43.17488;12.01724",
                    "43.17416;12.01677",
                    "43.1728;12.01695",
                    "43.17185;12.01735",
                    "43.17111;12.01761",
                    "43.1704;12.01753",
                    "43.16995;12.01754",
                    "43.16958;12.01724",
                    "43.16913;12.01741",
                    "43.16843;12.0174",
                    "43.16803;12.01768",
                    "43.16777;12.01736",
                    "43.16699;12.01742",
                    "43.16631;12.0172",
                    "43.16564;12.01742",
                    "43.16535;12.01736",
                    "43.16527;12.01765",
                    "43.16421;12.01806",
                    "43.16378;12.01798",
                    "43.16344;12.01806",
                    "43.16323;12.01865",
                    "43.16308;12.01896",
                    "43.16231;12.01921",
                    "43.16164;12.019",
                    "43.16112;12.01934",
                    "43.16068;12.01937",
                    "43.16023;12.01956",
                    "43.15961;12.01986",
                    "43.15857;12.02038",
                    "43.1578;12.02131",
                    "43.1576;12.02179",
                    "43.15713;12.02163",
                    "43.15659;12.02197",
                    "43.15627;12.02183",
                    "43.15561;12.02212",
                    "43.15511;12.02222",
                    "43.15465;12.02265",
                    "43.15413;12.02323",
                    "43.15358;12.02347",
                    "43.15322;12.02382",
                    "43.15272;12.02456",
                    "43.15207;12.0244",
                    "43.15158;12.02314",
                    "43.14972;12.02441",
                    "43.14944;12.0248",
                    "43.14919;12.02504",
                    "43.14949;12.02628",
                    "43.14924;12.02651",
                    "43.14889;12.02696",
                    "43.14851;12.02764",
                    "43.14746;12.02826",
                    "43.14707;12.02875",
                    "43.14667;12.02898",
                    "43.14613;12.02959",
                    "43.14568;12.03013",
                    "43.14527;12.03078",
                    "43.14483;12.03117",
                    "43.14441;12.03164",
                    "43.14413;12.0315",
                    "43.14339;12.03007",
                    "43.14164;12.03136",
                    "43.14017;12.03503",
                    "43.13986;12.0362",
                    "43.13951;12.03578",
                    "43.13549;12.03809",
                    "43.13504;12.03916",
                    "43.1348;12.03929",
                    "43.13499;12.03959",
                    "43.13385;12.04094",
                    "43.13376;12.04247",
                    "43.1337;12.04273",
                    "43.13367;12.04421",
                    "43.13357;12.04417",
                    "43.13246;12.0433",
                    "43.13245;12.04327",
                    "43.13243;12.04318",
                    "43.13221;12.04299",
                    "43.13115;12.04214",
                    "43.13081;12.04179",
                    "43.13051;12.04238"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/bd197a5d-5bfd-4ee4-a124-c789794a04e9.jpeg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ec117bc5-a5c5-43ff-bcfd-32db97fa035f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/1500f27a-e7f5-4d27-a9db-b3afc6396e3b.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Cortona, arrivo in una citt\u00e0 etrusca",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/2d491400-04a5-48a3-b534-bcb0603b0d9c.fotog__43_27414441031662_11_987702874953994",
                        "latitude": 43.27414441031662,
                        "longitude": 11.987702874953994,
                        "description": "La meta del tour \u00e8 Cortona, uno dei borghi collinari pi\u00f9 affascinanti della Toscana. Fu un importante centro etrusco e conserva ancora oggi testimonianze molto antiche, come tratti di mura del V secolo a.C., oltre al suo carattere medievale fatto di vicoli, piazze e scorci sulla Val di Chiana. Arrivare in e-bike a Cortona significa chiudere il tour con una tappa di grande fascino storico e paesaggistico, capace di dare all\u2019intera esperienza un finale davvero memorabile."
                    },
                    {
                        "name": "Strade secondarie tra Val di Chiana e Toscana autentica",
                        "type": "photo",
                        "image": "",
                        "latitude": 43.204892672272685,
                        "longitude": 12.024586545436456,
                        "description": "Uno dei grandi punti di forza del tour \u00e8 la qualit\u00e0 del percorso: quasi tutto si sviluppa su strade secondarie, con fondo misto tra asfalto e sterrato, lontano dal traffico e immerso in un paesaggio rurale molto piacevole. La pedalata accompagna dal Trasimeno verso la Val di Chiana, area storicamente importante e oggi conosciuta per i suoi ampi spazi agricoli, le colline morbide e l\u2019atmosfera autentica. \u00c8 il tipo di itinerario ideale per chi cerca una vera esperienza e-bike, panoramica e rilassata."
                    },
                    {
                        "name": "Dal Lago Trasimeno alle colline di confine",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/2c98727b-6c89-4e1c-a133-d498649f3d04.lago___43_132507892377795_12_04329572686476",
                        "latitude": 43.132507892377795,
                        "longitude": 12.04329572686476,
                        "description": "Il tour parte da Castiglione del Lago, uno dei borghi pi\u00f9 belli affacciati sul Trasimeno, costruito su un promontorio che in antichit\u00e0 era considerato quasi la \u201cquarta isola\u201d del lago. Da qui si pedala lasciandosi alle spalle l\u2019ambiente lacustre per entrare gradualmente in un paesaggio di campagna aperta e dolci colline, nel punto in cui Umbria e Toscana quasi si toccano. \u00c8 uno degli aspetti pi\u00f9 affascinanti del percorso: sentire il passaggio naturale tra due territori diversi ma perfettamente collegati."
                    }
                ],
                "infos": {
                    "distance": 47312
                }
            }
        ],
        "catalogue": [
            {
                "id": 49,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 50,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1539,
        "customer": {
            "id": 166,
            "title": "Ciclitorricelli",
            "description": "Descrizione da modificare",
            "color": "#94b177",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Ciclitorricelli.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/EST2012.png"
            ],
            "contacts": {
                "address": "Via Giuseppe Verdi, 236B, Via Giuseppe Verdi, 236B, 53014 Monteroni d'Arbia SI, Italia",
                "email": "ciclitorricelli@libero.it",
                "phone": "0577385666"
            },
            "coordinate": {
                "latitude": 43.23062,
                "longitude": 11.41792
            },
            "tours": 2,
            "gallery": []
        },
        "title": "Crete Senesi Classic E-Bike Tour ",
        "description": "- 30 km in bicicletta su alcune delle strade sterrate pi\u00f9 famose al mondo vicino a Siena\r\n- Il punto di partenza e di ritorno \u00e8 Monteroni d'Arbia (a 15 minuti di auto da Siena) e il tour ha una durata stimata di 3 ore, pause incluse.\r\n- Pedalerete su comode e-bike di alta gamma, con le quali non dovrete faticare!\r\n- Padbike ha sviluppato un'innovativa app di navigazione: Outdoora che vi guider\u00e0 lungo tutto il percorso!",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/925.png",
        "price": 25.0,
        "location": "Siena",
        "location_id": 4,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1574,
                "title": "Crete Senesi Classic E-Bike Tour",
                "description": "Le Crete Senesi sono uno splendido territorio caratterizzato da dolci colline, casali isolati e terreni brulli, che creano un panorama unico e suggestivo.",
                "notes": "be careful on clay sections of the road if it has rained recently!",
                "start_address": "Via Giuseppe Verdi, 236 B, 53014 Monteroni d'Arbia SI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/925.png",
                "track": [
                    43.23082,
                    11.41785
                ],
                "preview_track": [
                    "43.23082;11.41785",
                    "43.23063;11.41719",
                    "43.23147;11.41674",
                    "43.23284;11.41557",
                    "43.23317;11.41543",
                    "43.23456;11.41759",
                    "43.23486;11.41806",
                    "43.23498;11.41838",
                    "43.23499;11.41857",
                    "43.23492;11.41877",
                    "43.23485;11.41894",
                    "43.23487;11.41897",
                    "43.2349;11.41897",
                    "43.23499;11.41926",
                    "43.23669;11.42354",
                    "43.2372;11.42311",
                    "43.23732;11.42314",
                    "43.23742;11.42341",
                    "43.23751;11.4235",
                    "43.23766;11.42352",
                    "43.23797;11.42343",
                    "43.2381;11.42343",
                    "43.2382;11.42349",
                    "43.23831;11.42368",
                    "43.23858;11.42458",
                    "43.23881;11.42468",
                    "43.23934;11.42521",
                    "43.24018;11.42522",
                    "43.24067;11.4253",
                    "43.24286;11.42801",
                    "43.24425;11.42767",
                    "43.24484;11.42816",
                    "43.24552;11.42953",
                    "43.24557;11.42968",
                    "43.24594;11.43058",
                    "43.24613;11.43167",
                    "43.24743;11.43269",
                    "43.248;11.43351",
                    "43.2491;11.43394",
                    "43.25024;11.43539",
                    "43.2501;11.43628",
                    "43.25038;11.4377",
                    "43.25065;11.43941",
                    "43.24949;11.4404",
                    "43.24841;11.4416",
                    "43.24836;11.44269",
                    "43.24837;11.44329",
                    "43.24881;11.44488",
                    "43.24848;11.44603",
                    "43.2484;11.44677",
                    "43.24843;11.44749",
                    "43.24862;11.44811",
                    "43.2484;11.44854",
                    "43.24819;11.44923",
                    "43.24788;11.45095",
                    "43.24784;11.45291",
                    "43.24751;11.45375",
                    "43.24773;11.45539",
                    "43.24896;11.45601",
                    "43.24953;11.45652",
                    "43.25123;11.45751",
                    "43.25156;11.45756",
                    "43.25186;11.45738",
                    "43.25276;11.45821",
                    "43.25275;11.45927",
                    "43.25347;11.45993",
                    "43.25384;11.46079",
                    "43.25529;11.4617",
                    "43.25661;11.46224",
                    "43.25777;11.46147",
                    "43.25848;11.46155",
                    "43.25992;11.46317",
                    "43.2606;11.46362",
                    "43.26123;11.46514",
                    "43.26198;11.46619",
                    "43.26291;11.46788",
                    "43.26359;11.46986",
                    "43.26382;11.47129",
                    "43.26434;11.47181",
                    "43.26496;11.47326",
                    "43.26612;11.47388",
                    "43.26675;11.47396",
                    "43.26777;11.47553",
                    "43.26871;11.4767",
                    "43.26975;11.47847",
                    "43.27026;11.47862",
                    "43.27101;11.48043",
                    "43.27132;11.4811",
                    "43.27179;11.48139",
                    "43.27255;11.48164",
                    "43.27258;11.48196",
                    "43.27202;11.4822",
                    "43.2718;11.48272",
                    "43.27197;11.48299",
                    "43.27258;11.48303",
                    "43.27319;11.48351",
                    "43.27292;11.48385",
                    "43.27293;11.4843",
                    "43.27323;11.4845",
                    "43.27372;11.48511",
                    "43.27423;11.48573",
                    "43.27442;11.48548",
                    "43.27485;11.485",
                    "43.27508;11.48478",
                    "43.27536;11.48458",
                    "43.27584;11.4843",
                    "43.27673;11.48391",
                    "43.27757;11.48345",
                    "43.27922;11.48381",
                    "43.28061;11.48383",
                    "43.28088;11.48383",
                    "43.28229;11.48345",
                    "43.28334;11.48401",
                    "43.28481;11.48425",
                    "43.28566;11.48406",
                    "43.28637;11.48481",
                    "43.2875;11.4848",
                    "43.28847;11.48516",
                    "43.28893;11.48456",
                    "43.28906;11.48434",
                    "43.28962;11.48373",
                    "43.29022;11.48348",
                    "43.29066;11.48345",
                    "43.29115;11.48365",
                    "43.29131;11.48358",
                    "43.29209;11.48242",
                    "43.29253;11.48118",
                    "43.293;11.47968",
                    "43.2932;11.47848",
                    "43.29357;11.47695",
                    "43.29358;11.47575",
                    "43.29368;11.47393",
                    "43.29347;11.47255",
                    "43.29273;11.47218",
                    "43.29194;11.47102",
                    "43.2919;11.4697",
                    "43.2927;11.46842",
                    "43.29317;11.46662",
                    "43.29337;11.4657",
                    "43.29343;11.46545",
                    "43.29325;11.46379",
                    "43.29293;11.46304",
                    "43.29192;11.46261",
                    "43.29151;11.46166",
                    "43.2905;11.4603",
                    "43.28971;11.45914",
                    "43.28888;11.4576",
                    "43.28832;11.45602",
                    "43.28815;11.4548",
                    "43.28791;11.45374",
                    "43.28754;11.45181",
                    "43.28663;11.44957",
                    "43.28596;11.44616",
                    "43.28392;11.44357",
                    "43.28287;11.4421",
                    "43.28284;11.44195",
                    "43.28323;11.44163",
                    "43.28448;11.44103",
                    "43.28466;11.44081",
                    "43.28457;11.4391",
                    "43.28502;11.43763",
                    "43.2858;11.43513",
                    "43.28585;11.43409",
                    "43.28659;11.43135",
                    "43.28742;11.42963",
                    "43.28755;11.42805",
                    "43.28822;11.42698",
                    "43.28882;11.42595",
                    "43.28845;11.42365",
                    "43.28861;11.4232",
                    "43.28871;11.42308",
                    "43.28873;11.42304",
                    "43.28795;11.42254",
                    "43.28756;11.42195",
                    "43.28671;11.42217",
                    "43.28606;11.42323",
                    "43.28555;11.42367",
                    "43.28429;11.42469",
                    "43.28267;11.42527",
                    "43.28188;11.42529",
                    "43.28118;11.42431",
                    "43.27999;11.42353",
                    "43.27901;11.42395",
                    "43.27801;11.42403",
                    "43.27728;11.42348",
                    "43.27674;11.42314",
                    "43.276;11.42287",
                    "43.2755;11.42235",
                    "43.2753;11.42252",
                    "43.27372;11.42378",
                    "43.27261;11.42542",
                    "43.27219;11.4256",
                    "43.27118;11.426",
                    "43.2705;11.42627",
                    "43.27014;11.42657",
                    "43.26974;11.42616",
                    "43.26871;11.42567",
                    "43.26784;11.4262",
                    "43.26683;11.42638",
                    "43.26628;11.42582",
                    "43.26574;11.42551",
                    "43.26514;11.42532",
                    "43.2647;11.42572",
                    "43.26413;11.42602",
                    "43.26351;11.42658",
                    "43.26323;11.42762",
                    "43.2629;11.42809",
                    "43.26225;11.42801",
                    "43.2615;11.42728",
                    "43.25979;11.42499",
                    "43.25959;11.42409",
                    "43.25854;11.42385",
                    "43.25773;11.42402",
                    "43.2561;11.42415",
                    "43.25485;11.42243",
                    "43.25316;11.42065",
                    "43.25295;11.41935",
                    "43.25242;11.41836",
                    "43.25211;11.41782",
                    "43.25221;11.41675",
                    "43.25207;11.41666",
                    "43.25198;11.41675",
                    "43.25098;11.4176",
                    "43.25043;11.41759",
                    "43.24902;11.41658",
                    "43.24792;11.41646",
                    "43.24739;11.4165",
                    "43.24353;11.41484",
                    "43.24314;11.415",
                    "43.24334;11.41563",
                    "43.24299;11.41676",
                    "43.2424;11.4181",
                    "43.23853;11.42296",
                    "43.23818;11.42346",
                    "43.23812;11.42343",
                    "43.23801;11.42342",
                    "43.23769;11.42351",
                    "43.23754;11.4235",
                    "43.23744;11.42343",
                    "43.23734;11.42316",
                    "43.23722;11.4231",
                    "43.23669;11.42354",
                    "43.23489;11.41902",
                    "43.23489;11.41896",
                    "43.23483;11.4189",
                    "43.23493;11.4188",
                    "43.23513;11.41856",
                    "43.2352;11.4184",
                    "43.23509;11.41826",
                    "43.23495;11.41816",
                    "43.23457;11.41761",
                    "43.23425;11.4171",
                    "43.23305;11.41536",
                    "43.23193;11.41643",
                    "43.23081;11.41709",
                    "43.23063;11.41719",
                    "43.23082;11.41785"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/386cf597-c0f0-4389-919d-1d4794672bb1.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/67b6a96b-13a5-42e2-8bd4-352e05620540.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c362b80f-9f28-4ef1-bf06-9574f742356b.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/4ad6d385-7ae9-478d-9839-c8057b514938.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/207a2648-9667-4029-8473-6c69eeb74cc1.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Sito Transitorio ",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/3360843b-150f-459b-8952-5369ccaf87d3.f71bc__43_29332369603296_11_465589523577364",
                        "latitude": 43.29332369603296,
                        "longitude": 11.465589523577364,
                        "description": "Nel 1993 l\u2019artista francese Jean-Paul Philippe installo\u2019 questa scultura in pietra, composta da differenti elementi: una sedia che accoglie il viandante, un banco o sarcofago e una grande finestra all\u2019interno della quale, il disco solare tramonta, il giorno del solstizio d\u2019estate. Proprio durante il giorno del solstizio d\u2019estate il sole tramonta nell\u2019 appiombo della grande finestra in pietra, creando uno spettacolo veramente incantevole."
                    },
                    {
                        "name": "Eroica",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/2a2e2a9b-a1ba-4cc1-8778-292200d3092d.pippo__43_27129360920457_11_481142044067385",
                        "latitude": 43.27129360920457,
                        "longitude": 11.481142044067385,
                        "description": "L'Eroica \u00e8 una manifestazione ciclistica non competitiva che si svolge nella provincia di Siena e che celebra il ciclismo classico, con percorsi su strade sterrate e l'utilizzo di biciclette d'epoca. Si tratta di un evento che invita i partecipanti a vivere la bellezza della fatica e a godersi il paesaggio toscano. "
                    }
                ],
                "infos": {
                    "distance": 26064
                }
            }
        ],
        "catalogue": [
            {
                "id": 39,
                "name": "E-bike Front",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/ba48646d-223d-4fa2-bd6d-dedf7351ad87.jpg"
            },
            {
                "id": 40,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 892,
        "customer": {
            "id": 34,
            "title": "Padbike",
            "description": "Padbike, a tour operator based in Florence, specialized in designing and organizing E-Bike travel experiences.\r\nIn 2024 it opened an in-house Software & Development division for the development of Outdoora.",
            "color": "#404040",
            "theme_dark": true,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Padbike.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/provaRisorsa_1.png"
            ],
            "contacts": {
                "address": "Via dei Renai, 13, Via dei Renai, 13, 50125 Firenze FI, Italia",
                "email": "padbikeapp@gmail.com",
                "phone": "+393888353749"
            },
            "coordinate": {
                "latitude": 43.76491,
                "longitude": 11.25982
            },
            "tours": 12,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/21851540-c174-42ce-9ec2-d50341a79f83.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/389e886d-2941-43cc-bc89-86cfd16f0c82.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8aa350b2-3694-4348-ac22-b832c90da9c1.jpg"
            ]
        },
        "title": "Da Lucca a Pisa E-Bike Tour",
        "description": "Il punto di partenza e rientro di questo tour auto guidato in E-bike \u00e8 la citt\u00e0 di Lucca. \r\n\r\nDopo aver ricevuto le vostre E-Bike a noleggio vi verr\u00e0 spiegato brevemente il funzionamento della nostra App di navigazione.\r\n\r\nSi parte!\r\n\r\nPer iniziare percorrerete un breve anello circolare sopra i bastioni di Lucca, per poi imboccare la ciclabile del Serchio che con qualche deviazione vi porter\u00e0 fino a Pisa. Vi aspetta un tour di sola andata di circa 27 km immersi nelle campagne Toscane!",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/50e093d8-110a-40d0-bd1a-c9eaeb0ee0ef.jpg",
        "price": 25.0,
        "location": "Lucca",
        "location_id": null,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1024,
                "title": "DA LUCCA  A PISA IN E-BIKE!",
                "description": "Questo E-Bike tour auto guidato da Lucca  a Pisa \u00e8 adatto pressoch\u00e9 a chiunque! Sia che siate una famiglia che un gruppo di amici, il nostro noleggio di riferimento avr\u00e0 le E-Bike adatte a voi. Inoltre se 27km di escursione vi sembrano pochi potrete selezionare il tour pi\u00f9 lungo di  37km.",
                "notes": "",
                "start_address": "Lucca",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/50e093d8-110a-40d0-bd1a-c9eaeb0ee0ef.jpg",
                "track": [
                    43.8379,
                    10.50588
                ],
                "preview_track": [
                    "43.8379;10.50588",
                    "43.8377;10.50616",
                    "43.83753;10.5066",
                    "43.83731;10.50729",
                    "43.837;10.5068",
                    "43.83675;10.50677",
                    "43.83661;10.50842",
                    "43.83584;10.50872",
                    "43.83572;10.50867",
                    "43.8365;10.5085",
                    "43.83669;10.50676",
                    "43.83665;10.50589",
                    "43.83641;10.50577",
                    "43.83647;10.50433",
                    "43.83673;10.50377",
                    "43.83708;10.50365",
                    "43.83718;10.5036",
                    "43.83762;10.50345",
                    "43.83803;10.5033",
                    "43.83815;10.50325",
                    "43.83834;10.50364",
                    "43.83857;10.50369",
                    "43.83876;10.50338",
                    "43.83888;10.50308",
                    "43.83909;10.50281",
                    "43.8393;10.50261",
                    "43.83934;10.50205",
                    "43.8388;10.50169",
                    "43.83891;10.50121",
                    "43.84041;10.49716",
                    "43.84074;10.49675",
                    "43.84314;10.49561",
                    "43.84338;10.49569",
                    "43.84462;10.49668",
                    "43.84589;10.49788",
                    "43.84668;10.50261",
                    "43.84662;10.50275",
                    "43.84661;10.50309",
                    "43.8471;10.5025",
                    "43.84732;10.50233",
                    "43.84854;10.50254",
                    "43.84878;10.50187",
                    "43.84938;10.50183",
                    "43.85012;10.50145",
                    "43.85018;10.50131",
                    "43.85039;10.50112",
                    "43.85136;10.50045",
                    "43.85179;10.50043",
                    "43.85205;10.50125",
                    "43.85246;10.50155",
                    "43.85267;10.5021",
                    "43.85294;10.50251",
                    "43.85358;10.50285",
                    "43.85359;10.50126",
                    "43.85363;10.50086",
                    "43.85235;10.49512",
                    "43.8522;10.49299",
                    "43.8522;10.49213",
                    "43.85234;10.48921",
                    "43.85256;10.48577",
                    "43.85272;10.48413",
                    "43.85336;10.47901",
                    "43.85468;10.47317",
                    "43.85543;10.47105",
                    "43.85701;10.46658",
                    "43.85729;10.46499",
                    "43.85728;10.46115",
                    "43.85722;10.46041",
                    "43.85635;10.45644",
                    "43.8558;10.45506",
                    "43.85393;10.45179",
                    "43.85239;10.4501",
                    "43.85228;10.45011",
                    "43.85207;10.44988",
                    "43.84556;10.44675",
                    "43.8429;10.4432",
                    "43.83935;10.43433",
                    "43.83529;10.42773",
                    "43.8344;10.42649",
                    "43.83388;10.42698",
                    "43.83342;10.42668",
                    "43.83278;10.42518",
                    "43.83044;10.42033",
                    "43.83007;10.42004",
                    "43.82825;10.41847",
                    "43.82569;10.41724",
                    "43.82393;10.41624",
                    "43.82208;10.41504",
                    "43.82073;10.41434",
                    "43.82063;10.41472",
                    "43.82052;10.41472",
                    "43.81987;10.4145",
                    "43.81961;10.41428",
                    "43.8195;10.41439",
                    "43.81926;10.41439",
                    "43.81913;10.41471",
                    "43.81901;10.4148",
                    "43.81828;10.41453",
                    "43.81773;10.41479",
                    "43.81754;10.41498",
                    "43.81726;10.41494",
                    "43.81601;10.41404",
                    "43.81523;10.41339",
                    "43.81455;10.41318",
                    "43.81235;10.41213",
                    "43.81169;10.41203",
                    "43.81175;10.41159",
                    "43.81208;10.41068",
                    "43.81216;10.41037",
                    "43.80929;10.40835",
                    "43.80772;10.40683",
                    "43.80618;10.40429",
                    "43.80379;10.40007",
                    "43.80354;10.39974",
                    "43.80279;10.39954",
                    "43.80214;10.39981",
                    "43.80078;10.40164",
                    "43.79818;10.40523",
                    "43.79637;10.4078",
                    "43.79443;10.41025",
                    "43.7915;10.41496",
                    "43.79112;10.41591",
                    "43.79099;10.41607",
                    "43.79112;10.41591",
                    "43.79119;10.41618",
                    "43.79146;10.41625",
                    "43.79177;10.41651",
                    "43.79156;10.41674",
                    "43.7912;10.41691",
                    "43.79068;10.41713",
                    "43.78945;10.41844",
                    "43.788;10.41922",
                    "43.78444;10.41944",
                    "43.78366;10.41919",
                    "43.78273;10.41831",
                    "43.78224;10.41681",
                    "43.78212;10.41567",
                    "43.78101;10.41481",
                    "43.77981;10.41369",
                    "43.77862;10.41383",
                    "43.7784;10.4139",
                    "43.7774;10.4133",
                    "43.77655;10.41261",
                    "43.77604;10.41181",
                    "43.77553;10.41108",
                    "43.77488;10.41052",
                    "43.7746;10.41053",
                    "43.77338;10.4106",
                    "43.7711;10.41086",
                    "43.77034;10.41133",
                    "43.76746;10.4123",
                    "43.76715;10.41232",
                    "43.76676;10.41223",
                    "43.76205;10.41083",
                    "43.75816;10.40967",
                    "43.75772;10.40945",
                    "43.75521;10.40717",
                    "43.75289;10.40566",
                    "43.75191;10.40528",
                    "43.75123;10.40508",
                    "43.74706;10.4037",
                    "43.74343;10.40248",
                    "43.74139;10.40182",
                    "43.73962;10.40134",
                    "43.73917;10.40116",
                    "43.73825;10.40107",
                    "43.7374;10.40098",
                    "43.73669;10.4009",
                    "43.73506;10.40071",
                    "43.73395;10.40057",
                    "43.73286;10.3993",
                    "43.73177;10.39804",
                    "43.73146;10.39763",
                    "43.72923;10.39496",
                    "43.72768;10.39324",
                    "43.72754;10.39306",
                    "43.72743;10.39277",
                    "43.72734;10.39271",
                    "43.72661;10.39181",
                    "43.72608;10.39119",
                    "43.72542;10.39102",
                    "43.72499;10.39134",
                    "43.72493;10.39137",
                    "43.72489;10.39135",
                    "43.72486;10.3913",
                    "43.7243;10.39159",
                    "43.72381;10.39184",
                    "43.72323;10.39211",
                    "43.72289;10.39223"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f846ab23-2dde-49df-ae12-5859e7ef89a1.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/8bc05a4d-bf46-4585-9a49-b14d21502299.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/40e8dbb3-bdd0-4361-beeb-5b292c358da3.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/4d00ccb6-9ad0-4fea-baab-aec30a8a216f.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Campo dei Miracoli",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/00c6f39d-36be-41b9-955c-e308eb8c017b.from___43_72280808638291_10_392224192619324",
                        "latitude": 43.72280808638291,
                        "longitude": 10.392224192619324,
                        "description": "Con la nostra app di navigazione raggiungerete direttamente Piazza dei Miracoli, dal 1987 Patrimonio dell\u2019Umanit\u00e0 UNESCO. Qui si concentra il cuore religioso di Pisa: la Cattedrale, il Battistero, il Campo Santo e il Campanile, quei \u201cmiracoli\u201d battezzati cos\u00ec da Gabriele D\u2019Annunzio nel 1910 per la loro bellezza e originalit\u00e0. Molto prima dell\u2019impronta medievale, per\u00f2, quest\u2019area era gi\u00e0 vissuta: in et\u00e0 etrusca e poi romana, come testimoniano le fondazioni e i mosaici pavimentali di due domus rinvenuti tra la Cattedrale e il Campo Santo. La piazza come la conosciamo inizia a prendere forma nel 1063, quando viene fondato il nuovo duomo dedicato a Santa Maria Maggiore, finanziato grazie all\u2019impresa militare pisana in Sicilia guidata da Giovanni Orlandi.\n\nUna volta arrivati, potete legare le vostre E-Bike con il lucchetto integrato e visitare con calma questa piazza famosissima. Se vi viene appetito, consigliamo uno spuntino alla paninoteca Porci Comodi, nel pieno centro. E, a visita conclusa, dalla stazione di Pisa San Rossore un treno vi riporter\u00e0 a Lucca in circa 30 minuti."
                    },
                    {
                        "name": "Mura di Lucca ",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/ed3b8896-8d02-4d3d-aa4e-7313c5a03607.mura___43_843352774757086_10_495794005692007",
                        "latitude": 43.843352774757086,
                        "longitude": 10.495794005692007,
                        "description": "Le mura di Lucca, lunghe 4 km e 223 m, furono ricostruite tra il 1544 e il 1648 come deterrente contro Firenze e poi il Granducato di Toscana, senza mai arrivare alla guerra. Nel periodo di Maria Luisa di Borbone-Spagna (1815\u20131824) divennero una passeggiata pubblica. Oggi sono un parco sopraelevato usato per camminare e fare sport, e ospitano eventi come Lucca Comics & Games e il Lucca Summer Festival."
                    },
                    {
                        "name": "Acquedotto Nottolini",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d1010c9a-5b59-4c68-822e-8ac5ada5d15d.acque__43_83572640212599_10_50871982239187",
                        "latitude": 43.83572640212599,
                        "longitude": 10.50871982239187,
                        "description": "L\u2019acquedotto di Lorenzo Nottolini, in stile neoclassico, si trova a Lucca e fu progettato dal regio architetto lucchese Nottolini. Deciso da Maria Luisa di Borbone nel 1822 per motivi igienici (dopo secoli di uso dei pozzi e la perdita di antiche fonti, forse gi\u00e0 romane), venne costruito tra il 1822 e il 1833 con alcune interruzioni. Oggi l\u2019opera \u00e8 ancora integra dal punto di vista architettonico (tranne il tratto tagliato dall\u2019A11), ma non \u00e8 pi\u00f9 in funzione: \u00e8 tutelata come monumento.\n"
                    },
                    {
                        "name": "Fiume Serchio ",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/0be3916c-b54c-4037-90b7-92b516bc61b6.ebike__43_80378323380394_10_4000723361969",
                        "latitude": 43.80378323380394,
                        "longitude": 10.4000723361969,
                        "description": "Il Serchio \u00e8 il terzo fiume della Toscana (111 km): nasce dal Monte Sillano in Garfagnana e sfocia nel Tirreno vicino a Pisa. Anticamente detto Auser, \u00e8 soggetto a piene improvvise, che per secoli hanno causato ingenti danni ai lucchesi (da qui il detto \u201c\u00c8 costato quanto il Serchio ai lucchesi\u201d). \u00c8 ricordato anche in letteratura da Dante, Ariosto e D\u2019Annunzio."
                    }
                ],
                "infos": {
                    "distance": 26841
                }
            }
        ],
        "catalogue": [
            {
                "id": 47,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 48,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1355,
        "customer": {
            "id": 34,
            "title": "Padbike",
            "description": "Padbike, a tour operator based in Florence, specialized in designing and organizing E-Bike travel experiences.\r\nIn 2024 it opened an in-house Software & Development division for the development of Outdoora.",
            "color": "#404040",
            "theme_dark": true,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Padbike.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/provaRisorsa_1.png"
            ],
            "contacts": {
                "address": "Via dei Renai, 13, Via dei Renai, 13, 50125 Firenze FI, Italia",
                "email": "padbikeapp@gmail.com",
                "phone": "+393888353749"
            },
            "coordinate": {
                "latitude": 43.76491,
                "longitude": 11.25982
            },
            "tours": 12,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/21851540-c174-42ce-9ec2-d50341a79f83.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/389e886d-2941-43cc-bc89-86cfd16f0c82.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8aa350b2-3694-4348-ac22-b832c90da9c1.jpg"
            ]
        },
        "title": "Seceda Bike Tour",
        "description": "Un tour in MTB spettacolare nel cuore della Val Gardena: partenza da Ortisei, salita panoramica verso l\u2019altopiano di Resciesa e proseguimento fino agli splendidi prati del Seceda, con vista mozzafiato sulle Dolomiti. Discesa tecnica e avventurosa attraverso la Vallunga, immersa in paesaggi selvaggi, per poi risalire sull\u2019altro versante della valle in direzione del Sassolungo Bike Park, dove single track e tratti flow regalano adrenalina pura.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1355.jpg",
        "price": 25.0,
        "location": "Dolomiti",
        "location_id": 2,
        "tags": [
            "Natura",
            "Montagne"
        ],
        "routes": [
            {
                "id": 1388,
                "title": "Seceda Bike Tour",
                "description": "Un tour in MTB spettacolare nel cuore della Val Gardena: partenza da Ortisei, salita panoramica verso l\u2019altopiano di Resciesa e proseguimento fino agli splendidi prati del Seceda, con vista mozzafiato sulle Dolomiti. Discesa tecnica e avventurosa attraverso la Vallunga, immersa in paesaggi selvaggi, per poi risalire sull\u2019altro versante della valle in direzione del Sassolungo Bike Park, dove single track e tratti flow regalano adrenalina pura.",
                "notes": "",
                "start_address": "BikeRS",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1355.jpg",
                "track": [
                    46.55639,
                    11.75497
                ],
                "preview_track": [
                    "46.55639;11.75497",
                    "46.5565;11.75457",
                    "46.55665;11.75384",
                    "46.55664;11.75349",
                    "46.55679;11.75236",
                    "46.5569;11.75117",
                    "46.55691;11.75059",
                    "46.55695;11.75019",
                    "46.55729;11.74943",
                    "46.55754;11.74913",
                    "46.55826;11.74885",
                    "46.55911;11.74843",
                    "46.55933;11.74763",
                    "46.55947;11.74615",
                    "46.55951;11.74544",
                    "46.55926;11.74437",
                    "46.55944;11.74325",
                    "46.55954;11.74274",
                    "46.55958;11.7421",
                    "46.5594;11.74116",
                    "46.55936;11.74023",
                    "46.55917;11.739",
                    "46.55931;11.73838",
                    "46.55939;11.73739",
                    "46.55957;11.73657",
                    "46.55961;11.73566",
                    "46.55967;11.73478",
                    "46.55927;11.73404",
                    "46.55894;11.73333",
                    "46.55837;11.73285",
                    "46.55797;11.73208",
                    "46.55811;11.73135",
                    "46.5583;11.72989",
                    "46.55847;11.72951",
                    "46.55888;11.72957",
                    "46.55984;11.72997",
                    "46.56001;11.72987",
                    "46.56024;11.72982",
                    "46.56016;11.72951",
                    "46.56026;11.72898",
                    "46.55986;11.72799",
                    "46.55915;11.72691",
                    "46.55874;11.72568",
                    "46.55855;11.72508",
                    "46.559;11.72434",
                    "46.55921;11.72366",
                    "46.5592;11.72318",
                    "46.55905;11.72124",
                    "46.55913;11.71978",
                    "46.55905;11.71868",
                    "46.55927;11.7168",
                    "46.55906;11.71646",
                    "46.55878;11.7152",
                    "46.55883;11.71487",
                    "46.55882;11.7145",
                    "46.5589;11.71376",
                    "46.5593;11.71284",
                    "46.55976;11.71145",
                    "46.55937;11.71055",
                    "46.55927;11.71016",
                    "46.55979;11.7093",
                    "46.56047;11.70844",
                    "46.56076;11.70773",
                    "46.56075;11.70758",
                    "46.56116;11.70684",
                    "46.56144;11.70605",
                    "46.56132;11.7052",
                    "46.56133;11.70459",
                    "46.56143;11.70428",
                    "46.56181;11.70377",
                    "46.56192;11.70348",
                    "46.56245;11.70259",
                    "46.56274;11.70247",
                    "46.56322;11.70225",
                    "46.56414;11.70161",
                    "46.5652;11.69996",
                    "46.56555;11.69887",
                    "46.56606;11.69803",
                    "46.56676;11.69777",
                    "46.56727;11.69752",
                    "46.56781;11.69706",
                    "46.56802;11.69703",
                    "46.5684;11.69687",
                    "46.569;11.69642",
                    "46.56903;11.69612",
                    "46.56868;11.69566",
                    "46.56874;11.69556",
                    "46.56925;11.69573",
                    "46.56956;11.69563",
                    "46.56995;11.69533",
                    "46.57013;11.69546",
                    "46.5703;11.69642",
                    "46.57019;11.69724",
                    "46.57019;11.69798",
                    "46.57044;11.69746",
                    "46.57086;11.69708",
                    "46.57121;11.69673",
                    "46.57176;11.69594",
                    "46.57231;11.69533",
                    "46.57292;11.69505",
                    "46.57303;11.69462",
                    "46.57342;11.69448",
                    "46.57351;11.69424",
                    "46.57345;11.69378",
                    "46.57397;11.69191",
                    "46.57468;11.68992",
                    "46.57628;11.68905",
                    "46.57637;11.68889",
                    "46.5763;11.68848",
                    "46.57613;11.68778",
                    "46.57665;11.68831",
                    "46.57671;11.6871",
                    "46.57651;11.68588",
                    "46.57654;11.6857",
                    "46.57649;11.68327",
                    "46.5764;11.68195",
                    "46.57624;11.68057",
                    "46.57585;11.67846",
                    "46.5757;11.67786",
                    "46.5758;11.67752",
                    "46.57567;11.67694",
                    "46.57577;11.67661",
                    "46.57583;11.67622",
                    "46.5759;11.67605",
                    "46.57589;11.67571",
                    "46.57494;11.67698",
                    "46.57542;11.67578",
                    "46.57556;11.67532",
                    "46.57588;11.67441",
                    "46.57558;11.67443",
                    "46.57531;11.67494",
                    "46.57545;11.67374",
                    "46.57556;11.67292",
                    "46.5756;11.67259",
                    "46.57535;11.67162",
                    "46.57511;11.67122",
                    "46.57518;11.67056",
                    "46.57536;11.67024",
                    "46.57547;11.67039",
                    "46.57562;11.67156",
                    "46.57563;11.67169",
                    "46.57569;11.67172",
                    "46.57587;11.6716",
                    "46.57605;11.67128",
                    "46.5766;11.67032",
                    "46.57688;11.67087",
                    "46.57774;11.67229",
                    "46.57788;11.67225",
                    "46.5976;11.67927",
                    "46.59796;11.67986",
                    "46.59796;11.67932",
                    "46.59793;11.67885",
                    "46.59809;11.67931",
                    "46.59829;11.68024",
                    "46.5985;11.68114",
                    "46.59851;11.67846",
                    "46.59902;11.67587",
                    "46.59921;11.67411",
                    "46.59939;11.67286",
                    "46.59946;11.67156",
                    "46.59964;11.67055",
                    "46.59978;11.66923",
                    "46.59986;11.66826",
                    "46.5999;11.66741",
                    "46.6;11.66641",
                    "46.59997;11.66488",
                    "46.60004;11.664",
                    "46.60014;11.66275",
                    "46.60039;11.66186",
                    "46.60054;11.66149",
                    "46.60046;11.66077",
                    "46.60061;11.65977",
                    "46.60081;11.65903",
                    "46.60073;11.65822",
                    "46.60049;11.65743",
                    "46.60025;11.65663",
                    "46.60021;11.65548",
                    "46.60046;11.6544",
                    "46.60066;11.65421",
                    "46.60061;11.65654",
                    "46.60172;11.6623",
                    "46.60177;11.66439",
                    "46.60173;11.66504",
                    "46.6017;11.66577",
                    "46.60167;11.66758",
                    "46.60132;11.66993",
                    "46.60102;11.67133",
                    "46.60081;11.67354",
                    "46.60046;11.67714",
                    "46.60036;11.67956",
                    "46.60052;11.6806",
                    "46.60052;11.68068",
                    "46.60051;11.68084",
                    "46.60177;11.6798",
                    "46.60256;11.67883",
                    "46.60302;11.67829",
                    "46.60366;11.67763",
                    "46.60426;11.67737",
                    "46.60476;11.67765",
                    "46.60531;11.67801",
                    "46.60564;11.67838",
                    "46.60569;11.67924",
                    "46.60557;11.68045",
                    "46.60582;11.68233",
                    "46.60607;11.68321",
                    "46.60679;11.68359",
                    "46.6073;11.68371",
                    "46.60775;11.6835",
                    "46.60778;11.68362",
                    "46.60711;11.6853",
                    "46.60711;11.68627",
                    "46.60732;11.68754",
                    "46.60763;11.68792",
                    "46.60782;11.68831",
                    "46.60816;11.68893",
                    "46.60823;11.68946",
                    "46.60836;11.69008",
                    "46.60879;11.69122",
                    "46.60917;11.6924",
                    "46.60949;11.6939",
                    "46.60952;11.69436",
                    "46.60939;11.6948",
                    "46.60896;11.69587",
                    "46.60895;11.69604",
                    "46.60902;11.69746",
                    "46.60947;11.69909",
                    "46.6097;11.70029",
                    "46.60978;11.70155",
                    "46.60987;11.70281",
                    "46.60988;11.70393",
                    "46.60988;11.70469",
                    "46.60981;11.70564",
                    "46.6097;11.70677",
                    "46.60967;11.70775",
                    "46.6097;11.70812",
                    "46.60981;11.7087",
                    "46.61033;11.70969",
                    "46.61068;11.7105",
                    "46.61093;11.71134",
                    "46.61098;11.7116",
                    "46.61105;11.71235",
                    "46.61132;11.71331",
                    "46.61145;11.71448",
                    "46.61159;11.71565",
                    "46.61168;11.71663",
                    "46.61171;11.71741",
                    "46.61169;11.71815",
                    "46.61168;11.71902",
                    "46.61158;11.71957",
                    "46.61153;11.72023",
                    "46.61145;11.72111",
                    "46.61132;11.72167",
                    "46.61087;11.72233",
                    "46.61043;11.72292",
                    "46.61048;11.72339",
                    "46.6106;11.72394",
                    "46.61044;11.72466",
                    "46.61027;11.72692",
                    "46.61033;11.72716",
                    "46.61039;11.72535",
                    "46.61054;11.72417",
                    "46.61055;11.72356",
                    "46.61041;11.72316",
                    "46.61064;11.72251",
                    "46.61126;11.72194",
                    "46.61139;11.72136",
                    "46.61121;11.7208",
                    "46.61057;11.71909",
                    "46.60967;11.7167",
                    "46.60894;11.71556",
                    "46.60842;11.71472",
                    "46.60824;11.71375",
                    "46.60788;11.7124",
                    "46.60653;11.71103",
                    "46.60615;11.71108",
                    "46.60564;11.71073",
                    "46.60512;11.70997",
                    "46.60399;11.70862",
                    "46.60277;11.70653",
                    "46.60277;11.70596",
                    "46.6021;11.70645",
                    "46.60163;11.70791",
                    "46.60076;11.70684",
                    "46.60057;11.70676",
                    "46.59993;11.70613",
                    "46.59906;11.7053",
                    "46.59781;11.70414",
                    "46.59583;11.70304",
                    "46.59532;11.70259",
                    "46.59441;11.70204",
                    "46.59294;11.70169",
                    "46.59217;11.70076",
                    "46.59152;11.70066",
                    "46.59113;11.7006",
                    "46.59082;11.70024",
                    "46.59018;11.70022",
                    "46.5899;11.70077",
                    "46.58994;11.70176",
                    "46.58969;11.70227",
                    "46.59784;11.72442",
                    "46.59824;11.72465",
                    "46.59852;11.72427",
                    "46.59884;11.72413",
                    "46.5994;11.72448",
                    "46.60032;11.72554",
                    "46.60038;11.72587",
                    "46.59971;11.72486",
                    "46.59896;11.72418",
                    "46.59861;11.72419",
                    "46.59836;11.72454",
                    "46.59793;11.72478",
                    "46.59807;11.72522",
                    "46.59814;11.72546",
                    "46.59805;11.72586",
                    "46.59808;11.72615",
                    "46.59809;11.72623",
                    "46.59775;11.72632",
                    "46.59774;11.72643",
                    "46.59768;11.72657",
                    "46.59755;11.72717",
                    "46.59771;11.72778",
                    "46.5979;11.72934",
                    "46.5975;11.72945",
                    "46.5974;11.72944",
                    "46.59714;11.72911",
                    "46.59677;11.72868",
                    "46.59642;11.72867",
                    "46.59605;11.72824",
                    "46.59566;11.72788",
                    "46.59534;11.72725",
                    "46.59508;11.72718",
                    "46.59474;11.7266",
                    "46.59423;11.72654",
                    "46.59397;11.72642",
                    "46.59353;11.72656",
                    "46.59311;11.72653",
                    "46.59293;11.72672",
                    "46.59297;11.72695",
                    "46.59346;11.72775",
                    "46.59358;11.72875",
                    "46.59381;11.72878",
                    "46.5941;11.72916",
                    "46.59495;11.73032",
                    "46.59499;11.7318",
                    "46.59502;11.7326",
                    "46.59519;11.73356",
                    "46.59547;11.73448",
                    "46.59541;11.7349",
                    "46.59518;11.73556",
                    "46.59469;11.73575",
                    "46.59407;11.73594",
                    "46.59399;11.73611",
                    "46.59399;11.73663",
                    "46.59352;11.7374",
                    "46.5936;11.73792",
                    "46.59305;11.73838",
                    "46.5922;11.73808",
                    "46.59149;11.73833",
                    "46.59048;11.73845",
                    "46.58974;11.73832",
                    "46.58915;11.73777",
                    "46.58803;11.73838",
                    "46.58755;11.73818",
                    "46.58651;11.73676",
                    "46.58609;11.73677",
                    "46.58576;11.73707",
                    "46.58486;11.73757",
                    "46.58365;11.73846",
                    "46.58302;11.73831",
                    "46.58223;11.73887",
                    "46.58169;11.73939",
                    "46.58139;11.73999",
                    "46.58126;11.7403",
                    "46.58126;11.7403",
                    "46.58096;11.74017",
                    "46.58089;11.74056",
                    "46.58045;11.74069",
                    "46.58007;11.74165",
                    "46.57951;11.74228",
                    "46.57879;11.74263",
                    "46.5781;11.74266",
                    "46.57761;11.74319",
                    "46.57724;11.74409",
                    "46.5768;11.74509",
                    "46.57645;11.7458",
                    "46.57655;11.74646",
                    "46.57676;11.74651",
                    "46.57666;11.74676",
                    "46.57633;11.74748",
                    "46.57633;11.74748",
                    "46.57651;11.74837",
                    "46.57639;11.74876",
                    "46.57633;11.74894",
                    "46.57629;11.74901",
                    "46.57583;11.74856",
                    "46.57528;11.7485",
                    "46.57476;11.74858",
                    "46.57394;11.74867",
                    "46.57414;11.74951",
                    "46.57373;11.75002",
                    "46.5734;11.75004",
                    "46.57306;11.75024",
                    "46.57249;11.75005",
                    "46.57247;11.75008",
                    "46.57238;11.7507",
                    "46.57217;11.75125",
                    "46.57198;11.7512",
                    "46.57189;11.75133",
                    "46.57143;11.75144",
                    "46.57106;11.75201",
                    "46.57071;11.75249",
                    "46.57051;11.75235",
                    "46.57025;11.75217",
                    "46.57008;11.75257",
                    "46.57001;11.75252",
                    "46.56991;11.75205",
                    "46.5699;11.7519",
                    "46.5697;11.752",
                    "46.56972;11.75154",
                    "46.56952;11.75133",
                    "46.56909;11.75115",
                    "46.56854;11.75115",
                    "46.56839;11.75115",
                    "46.56802;11.7514",
                    "46.56761;11.75132",
                    "46.56745;11.75167",
                    "46.56713;11.75239",
                    "46.56685;11.75251",
                    "46.56653;11.75258",
                    "46.56613;11.75255",
                    "46.56621;11.75181",
                    "46.56615;11.75123",
                    "46.56612;11.75118",
                    "46.56577;11.75117",
                    "46.56543;11.75196",
                    "46.56499;11.75305",
                    "46.5646;11.7548",
                    "46.564;11.75554",
                    "46.56331;11.75684",
                    "46.56241;11.75796",
                    "46.56192;11.75879",
                    "46.56172;11.75991",
                    "46.56145;11.76171",
                    "46.5616;11.76354",
                    "46.56158;11.76541",
                    "46.56175;11.76639",
                    "46.56273;11.76777",
                    "46.5633;11.76859",
                    "46.56392;11.76939",
                    "46.56451;11.77054",
                    "46.56492;11.77296",
                    "46.56491;11.77369",
                    "46.56519;11.77561",
                    "46.56512;11.77693",
                    "46.56468;11.77834",
                    "46.56466;11.77799",
                    "46.56442;11.7759",
                    "46.56414;11.77461",
                    "46.56396;11.77398",
                    "46.56394;11.7735",
                    "46.5641;11.77285",
                    "46.56412;11.77179",
                    "46.56369;11.77056",
                    "46.56295;11.76968",
                    "46.56268;11.76927",
                    "46.5623;11.76862",
                    "46.56102;11.76782",
                    "46.56069;11.76664",
                    "46.56045;11.76583",
                    "46.5604;11.76492",
                    "46.55971;11.7651",
                    "46.55903;11.76489",
                    "46.5587;11.76473",
                    "46.55799;11.76397",
                    "46.55664;11.76268",
                    "46.55573;11.76258",
                    "46.5551;11.76309",
                    "46.55413;11.76342",
                    "46.55308;11.76354",
                    "46.55302;11.76338",
                    "46.55324;11.76272",
                    "46.55349;11.76164",
                    "46.55362;11.76109",
                    "46.55348;11.76093",
                    "46.55327;11.76154",
                    "46.55321;11.76169",
                    "46.53863;11.75248",
                    "46.53847;11.75167",
                    "46.53803;11.75167",
                    "46.537;11.7514",
                    "46.53633;11.75002",
                    "46.53613;11.74832",
                    "46.53596;11.74777",
                    "46.53573;11.74902",
                    "46.53522;11.74938",
                    "46.53491;11.74972",
                    "46.53397;11.74888",
                    "46.53345;11.74837",
                    "46.53298;11.74821",
                    "46.53236;11.7479",
                    "46.53158;11.74748",
                    "46.53077;11.74735",
                    "46.53008;11.74712",
                    "46.52945;11.7471",
                    "46.52901;11.74798",
                    "46.52886;11.74838",
                    "46.52826;11.74891",
                    "46.52761;11.74925",
                    "46.52702;11.7491",
                    "46.52656;11.74887",
                    "46.52631;11.74885",
                    "46.52581;11.74866",
                    "46.52544;11.74868",
                    "46.52474;11.74865",
                    "46.52379;11.74883",
                    "46.52306;11.74909",
                    "46.52259;11.74939",
                    "46.52223;11.74953",
                    "46.52163;11.74963",
                    "46.52073;11.74999",
                    "46.51957;11.75058",
                    "46.51913;11.75072",
                    "46.51865;11.75134",
                    "46.51853;11.75167",
                    "46.5188;11.75084",
                    "46.51928;11.75061",
                    "46.51938;11.75045",
                    "46.51946;11.75041",
                    "46.51939;11.75077",
                    "46.51914;11.75113",
                    "46.51918;11.75124",
                    "46.51936;11.7511",
                    "46.51942;11.75097",
                    "46.51945;11.7511",
                    "46.51932;11.75134",
                    "46.51937;11.752",
                    "46.51914;11.75276",
                    "46.51897;11.75291",
                    "46.51896;11.75329",
                    "46.51895;11.7536",
                    "46.5191;11.75375",
                    "46.51906;11.75409",
                    "46.51919;11.75447",
                    "46.51929;11.75501",
                    "46.51948;11.75545",
                    "46.52109;11.75813",
                    "46.52116;11.7572",
                    "46.52129;11.75716",
                    "46.52199;11.75791",
                    "46.52184;11.75739",
                    "46.52176;11.7569",
                    "46.52187;11.75716",
                    "46.522;11.75711",
                    "46.52256;11.75777",
                    "46.52296;11.75861",
                    "46.52323;11.75933",
                    "46.52313;11.75836",
                    "46.52297;11.75749",
                    "46.52289;11.75739",
                    "46.523;11.7574",
                    "46.52309;11.75766",
                    "46.52321;11.75757",
                    "46.52289;11.75686",
                    "46.52298;11.7567",
                    "46.52385;11.75676",
                    "46.52449;11.75556",
                    "46.52463;11.75619",
                    "46.52435;11.75695",
                    "46.52452;11.75677",
                    "46.52449;11.75707",
                    "46.52461;11.75713",
                    "46.52487;11.75723",
                    "46.5248;11.75748",
                    "46.52442;11.75756",
                    "46.5247;11.75771",
                    "46.52489;11.75828",
                    "46.52497;11.75876",
                    "46.52515;11.75904",
                    "46.52554;11.75908",
                    "46.52587;11.75901",
                    "46.52632;11.75945",
                    "46.52674;11.7587",
                    "46.52692;11.75891",
                    "46.52754;11.75986",
                    "46.5278;11.76028",
                    "46.52817;11.76102",
                    "46.52819;11.7613",
                    "46.52843;11.76144",
                    "46.52859;11.76087",
                    "46.52845;11.76072",
                    "46.52875;11.76078",
                    "46.52908;11.76194",
                    "46.52916;11.76231",
                    "46.52903;11.76283",
                    "46.52931;11.76281",
                    "46.52958;11.76163",
                    "46.52967;11.76207",
                    "46.52975;11.76311",
                    "46.52968;11.76348",
                    "46.5299;11.76301",
                    "46.52997;11.76267",
                    "46.53013;11.76377",
                    "46.53027;11.76364",
                    "46.53035;11.76264",
                    "46.53058;11.76308",
                    "46.53095;11.76386",
                    "46.53102;11.76441",
                    "46.5313;11.76601",
                    "46.53167;11.76652",
                    "46.53143;11.76716",
                    "46.5308;11.76847",
                    "46.53035;11.7694",
                    "46.53054;11.76922",
                    "46.53047;11.76941",
                    "46.53066;11.76918",
                    "46.53109;11.76954",
                    "46.53079;11.77023",
                    "46.53062;11.77099",
                    "46.53049;11.77139",
                    "46.53098;11.77097",
                    "46.53112;11.77063",
                    "46.53118;11.77091",
                    "46.53117;11.77112",
                    "46.53158;11.77074",
                    "46.53168;11.77053",
                    "46.53172;11.77029",
                    "46.53176;11.77054",
                    "46.53179;11.77072",
                    "46.53167;11.77085",
                    "46.53172;11.77097",
                    "46.53192;11.77066",
                    "46.53217;11.77027",
                    "46.53231;11.77042",
                    "46.53231;11.77042",
                    "46.5327;11.7709",
                    "46.53261;11.77142",
                    "46.53263;11.77181",
                    "46.53322;11.77175",
                    "46.53336;11.77199",
                    "46.53352;11.77232",
                    "46.53412;11.77203",
                    "46.53472;11.7717",
                    "46.53476;11.77131",
                    "46.5355;11.77079",
                    "46.53603;11.77057",
                    "46.53636;11.7701",
                    "46.53772;11.76924",
                    "46.53859;11.76953",
                    "46.53929;11.77016",
                    "46.54031;11.77015",
                    "46.5419;11.76989",
                    "46.54242;11.76986",
                    "46.54313;11.7695",
                    "46.54493;11.76881",
                    "46.54565;11.76811",
                    "46.54633;11.76749",
                    "46.54649;11.76756",
                    "46.54709;11.76758",
                    "46.54742;11.76763",
                    "46.54835;11.76715",
                    "46.54974;11.76623",
                    "46.55029;11.76571",
                    "46.55059;11.76478",
                    "46.5508;11.76426",
                    "46.55166;11.7635",
                    "46.55223;11.76347",
                    "46.55298;11.76342",
                    "46.55324;11.76274",
                    "46.55348;11.76169",
                    "46.55356;11.76135",
                    "46.55382;11.76014",
                    "46.55403;11.7592",
                    "46.55421;11.75879",
                    "46.55459;11.75815",
                    "46.55522;11.7571",
                    "46.55582;11.7561",
                    "46.5563;11.75525",
                    "46.55639;11.75497"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ad24e6dd-3ee1-42db-9de8-b05868c8c1e6.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Chiesa di San Giacomo",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/deb8aa1b-216b-4841-8bc5-554a265208a0.seced__46_573494191690635_11_694263289682569",
                        "latitude": 46.573494191690635,
                        "longitude": 11.694263289682569,
                        "description": "La Chiesa di San Giacomo, la pi\u00f9 antica della Val Gardena, sorge su un panoramico colle sopra Ortisei e custodisce preziosi affreschi gotici, offrendo una vista unica sul Sassolungo."
                    },
                    {
                        "name": "Cappella della Santa Croce ",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/efeb1bee-82f3-4fe1-bad8-b54300af7ca5.seced__46_60065166167968_11_654205420054497",
                        "latitude": 46.60065166167968,
                        "longitude": 11.654205420054497,
                        "description": "La Cappella della Santa Croce di Rasch\u00f6tz, immersa negli alpeggi di Resciesa in Val Gardena, \u00e8 un pittoresco luogo di culto alpino con vista spettacolare sulle Dolomiti."
                    },
                    {
                        "name": "Monte Seceda",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/618c753b-542f-4156-befc-d0014c529a5b.seced__46_60037256388613_11_725866207852963",
                        "latitude": 46.60037256388613,
                        "longitude": 11.725866207852963,
                        "description": "Il Monte Seceda, a **2.519 metri** di altitudine, domina Ortisei con le sue cime frastagliate ed \u00e8 una delle mete pi\u00f9 iconiche delle Dolomiti. Offre panorami spettacolari sulle vette circostanti, tra cui il Sassolungo e il Sella, e una rete di sentieri per escursionisti e percorsi MTB che attraversano pascoli alpini, boschi e creste panoramiche, rendendolo ideale per attivit\u00e0 all\u2019aria aperta in ogni stagione.\n"
                    },
                    {
                        "name": "Rifugio Malga Brogles",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d3fad6eb-3f56-4681-8bf2-161baa22ecb6.seced__46_6103094744321_11_727170620579274",
                        "latitude": 46.6103094744321,
                        "longitude": 11.727170620579274,
                        "description": "Il Rifugio Brogles, immerso tra le meravigliose montagne della Val Gardena, \u00e8 il luogo ideale per una pausa gustosa dopo escursioni o uscite in MTB. Qui potrete assaporare piatti tipici tirolesi in un\u2019atmosfera accogliente con vista spettacolare sulle Dolomiti. Non perdete l\u2019occasione di fermarvi per un pranzo o uno spuntino rilassante!\n"
                    },
                    {
                        "name": "Ortisei",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d5dbcdfd-fff2-48d1-9148-cf16cd3c2c0b.seced__46_575869447039715_11_671596674714237",
                        "latitude": 46.575869447039715,
                        "longitude": 11.671596674714237,
                        "description": "Ortisei, cuore della Val Gardena, \u00e8 un pittoresco paese alpino famoso per le sue case colorate, le botteghe artigiane di intaglio del legno e l\u2019accogliente atmosfera tirolese. Punto di partenza ideale per escursioni, MTB e sport invernali, unisce tradizione, cultura e panorami mozzafiato sulle Dolomiti.\n"
                    }
                ],
                "infos": {
                    "distance": 53964
                }
            }
        ],
        "catalogue": [
            {
                "id": 47,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 48,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1607,
        "customer": {
            "id": 438,
            "title": "eBike5 terre",
            "description": "eBike5 \u00e8 un bike rent di La Spezia specializzato nel noleggio di e-MTB Specialized e in tour guidati tra Golfo dei Poeti, Portovenere e Cinque Terre. Offre uscite di vario livello, pensate sia per biker esperti sia per chi vuole vivere il territorio in modo panoramico e accessibile grazie all\u2019e-bike. Tra i tour proposti ci sono itinerari come Tour Classico Cinque Terre, Tour Vertical, Tour Golfo Spezia Montepertico, Tour Castellana\u2013Portovenere, Tour Lerici\u2013Montemarcello, Tour Riomaggiore e Tour Isola Palmaria. Il noleggio \u00e8 disponibile per l\u2019intera giornata, con opzioni full suspended o front suspended, e include casco e accessori; \u00e8 possibile anche richiedere la guida con consigli tecnici in base al tour e al numero di partecipanti. La sede si trova in Viale Giovanni Amendola 176, a La Spezia.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/eBike5_terre.png",
            "text_logo": null,
            "contacts": {
                "address": "Viale Giovanni Amendola, 176, Viale Giovanni Amendola, 176, 19121 La Spezia SP, Italia",
                "email": "darioriccixxi@gmail.com",
                "phone": "\u202a+39\u00a039\u00a0176\u00a0054\u00a055\u202c"
            },
            "coordinate": {
                "latitude": 44.10526,
                "longitude": 9.81513
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/b74dd34b-d3b5-4af3-9edd-70a85701c449.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/305f647a-ac1c-4c2d-97b6-3e33329dc681.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/c099c70e-1d5b-403b-9efb-2539740632c4.jpg"
            ]
        },
        "title": "Cinque Terre Ebike tour & Rientro in treno",
        "description": "Tour e-bike da La Spezia a Manarola, 22 km e 750 m di dislivello, tra strada asfaltata secondaria, tornanti panoramici e sterrato in quota con vista mozzafiato sulle Cinque Terre. Dopo la salita verso La Locanda del Gallese, il percorso prosegue sospeso tra mare e colline fino a Manarola, uno dei borghi pi\u00f9 iconici della costa ligure. Rientro comodo in treno con le e-bike fino a La Spezia.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1607.png",
        "price": 25.0,
        "location": "Cinque Terre",
        "location_id": null,
        "tags": [
            "Natura",
            "Mare",
            "Citt\u00e0"
        ],
        "routes": [
            {
                "id": 1640,
                "title": "Cinque Terre Ebike tour & Rientro in treno",
                "description": "Questo tour in e-bike parte da La Spezia e conduce fino a Manarola lungo un itinerario panoramico di 22 km con circa 750 metri di dislivello, perfetto per chi vuole vivere le Cinque Terre da una prospettiva diversa, pi\u00f9 ampia e spettacolare. Dopo l\u2019uscita dalla citt\u00e0, il percorso affronta una salita su strada secondaria ricca di tornanti, immersa nel verde e sempre pi\u00f9 aperta verso il mare, fino a raggiungere la zona del Ristorante La Locanda del Gallese, ottimo punto di passaggio in un contesto davvero suggestivo.\n\nDa qui il tour continua su una strada sterrata in quota, uno dei tratti pi\u00f9 belli dell\u2019intero itinerario: si pedala sospesi tra il blu del mare e i rilievi terrazzati delle Cinque Terre, con viste panoramiche straordinarie sulla costa, sui vigneti e sui borghi arroccati. \u00c8 un percorso molto scenografico, che regala la sensazione di attraversare un balcone naturale affacciato sul mare.\n\nL\u2019arrivo a Manarola rappresenta il momento culminante del tour. Uno dei borghi pi\u00f9 celebri delle Cinque Terre, Manarola colpisce per le sue case colorate, il piccolo porto, le atmosfere autentiche e il paesaggio verticale che unisce roccia, vigneti e mare. Una volta arrivati, c\u2019\u00e8 tempo per visitare il borgo e godersi l\u2019atmosfera prima del rientro in treno insieme alle e-bike fino a La Spezia.",
                "notes": null,
                "start_address": "Viale Giovanni Amendola, 176, 19121 La Spezia SP, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1607.png",
                "track": [
                    44.10552,
                    9.815
                ],
                "preview_track": [
                    "44.10552;9.815",
                    "44.10573;9.81386",
                    "44.1053;9.81321",
                    "44.10422;9.81201",
                    "44.10257;9.81017",
                    "44.10104;9.80848",
                    "44.10105;9.80772",
                    "44.10143;9.80755",
                    "44.10252;9.80743",
                    "44.10296;9.80708",
                    "44.10327;9.80671",
                    "44.10429;9.80557",
                    "44.10486;9.80459",
                    "44.10499;9.80336",
                    "44.10342;9.80258",
                    "44.10286;9.80216",
                    "44.10247;9.80109",
                    "44.10222;9.80063",
                    "44.10201;9.79966",
                    "44.10213;9.79921",
                    "44.10228;9.79823",
                    "44.10218;9.79809",
                    "44.10167;9.7979",
                    "44.10149;9.7974",
                    "44.1011;9.79664",
                    "44.10103;9.79642",
                    "44.09993;9.79351",
                    "44.09968;9.79285",
                    "44.09917;9.79101",
                    "44.0991;9.7895",
                    "44.09913;9.78923",
                    "44.09925;9.78917",
                    "44.09947;9.78926",
                    "44.09949;9.78911",
                    "44.09904;9.78838",
                    "44.09857;9.7874",
                    "44.0984;9.7868",
                    "44.09809;9.78633",
                    "44.09755;9.78562",
                    "44.09747;9.78492",
                    "44.09745;9.78457",
                    "44.0974;9.7846",
                    "44.0972;9.78544",
                    "44.09701;9.78556",
                    "44.09674;9.78501",
                    "44.0965;9.78468",
                    "44.09652;9.78451",
                    "44.09661;9.78449",
                    "44.09671;9.78472",
                    "44.09691;9.78485",
                    "44.09702;9.7843",
                    "44.09698;9.78345",
                    "44.09664;9.78209",
                    "44.09663;9.78199",
                    "44.09685;9.78194",
                    "44.09694;9.78176",
                    "44.09667;9.78175",
                    "44.09662;9.78171",
                    "44.09665;9.78162",
                    "44.0968;9.78133",
                    "44.09674;9.78097",
                    "44.09661;9.78105",
                    "44.09649;9.78128",
                    "44.09638;9.78131",
                    "44.09637;9.78114",
                    "44.09651;9.7808",
                    "44.09648;9.78062",
                    "44.09637;9.78062",
                    "44.09614;9.78107",
                    "44.096;9.78119",
                    "44.09593;9.78114",
                    "44.09596;9.78099",
                    "44.09613;9.78068",
                    "44.09617;9.78042",
                    "44.09611;9.78036",
                    "44.09577;9.78049",
                    "44.09572;9.78039",
                    "44.09583;9.78005",
                    "44.0959;9.77945",
                    "44.0958;9.77945",
                    "44.09539;9.7797",
                    "44.09523;9.77966",
                    "44.09529;9.77947",
                    "44.09554;9.77921",
                    "44.09554;9.77904",
                    "44.09524;9.77899",
                    "44.09499;9.77897",
                    "44.09508;9.7787",
                    "44.09536;9.77818",
                    "44.09531;9.77802",
                    "44.09515;9.77806",
                    "44.09486;9.77804",
                    "44.09476;9.77795",
                    "44.09515;9.77758",
                    "44.09526;9.77708",
                    "44.09552;9.77578",
                    "44.09566;9.77566",
                    "44.09571;9.77567",
                    "44.09599;9.77584",
                    "44.09642;9.77612",
                    "44.09674;9.77618",
                    "44.09701;9.77621",
                    "44.0971;9.77677",
                    "44.09722;9.77676",
                    "44.09734;9.7759",
                    "44.09753;9.77535",
                    "44.0976;9.77546",
                    "44.09756;9.77611",
                    "44.09756;9.77673",
                    "44.0977;9.77676",
                    "44.09802;9.77617",
                    "44.09829;9.77576",
                    "44.09852;9.77543",
                    "44.09845;9.77494",
                    "44.09809;9.77411",
                    "44.09781;9.77385",
                    "44.0972;9.77325",
                    "44.09682;9.77325",
                    "44.09677;9.77318",
                    "44.09694;9.77306",
                    "44.09807;9.77273",
                    "44.09852;9.77275",
                    "44.09884;9.77276",
                    "44.09897;9.77255",
                    "44.09911;9.77205",
                    "44.09945;9.77183",
                    "44.09945;9.77164",
                    "44.09931;9.77163",
                    "44.09857;9.77192",
                    "44.09804;9.77186",
                    "44.09797;9.77175",
                    "44.0981;9.77163",
                    "44.09841;9.77155",
                    "44.09916;9.7707",
                    "44.10009;9.77029",
                    "44.10056;9.77041",
                    "44.10074;9.77033",
                    "44.10075;9.77016",
                    "44.10036;9.77004",
                    "44.09966;9.76978",
                    "44.09885;9.76985",
                    "44.09835;9.77014",
                    "44.09781;9.76991",
                    "44.09686;9.77056",
                    "44.09593;9.77097",
                    "44.09569;9.77084",
                    "44.0955;9.77003",
                    "44.09506;9.76966",
                    "44.09496;9.769",
                    "44.09529;9.76777",
                    "44.09516;9.76753",
                    "44.09509;9.76714",
                    "44.09516;9.76667",
                    "44.09487;9.7667",
                    "44.09444;9.76714",
                    "44.09392;9.76759",
                    "44.09348;9.76711",
                    "44.09305;9.76699",
                    "44.09291;9.76686",
                    "44.09295;9.7667",
                    "44.09305;9.76646",
                    "44.09322;9.76579",
                    "44.09359;9.76533",
                    "44.09424;9.7644",
                    "44.09494;9.76317",
                    "44.09555;9.76251",
                    "44.09626;9.76236",
                    "44.09653;9.76186",
                    "44.09705;9.76032",
                    "44.09748;9.75966",
                    "44.09767;9.75932",
                    "44.0977;9.75892",
                    "44.09771;9.75827",
                    "44.09765;9.75761",
                    "44.09765;9.75714",
                    "44.09773;9.75654",
                    "44.09782;9.75605",
                    "44.0978;9.75555",
                    "44.09756;9.75533",
                    "44.09738;9.75524",
                    "44.09721;9.7553",
                    "44.0972;9.75518",
                    "44.09745;9.75499",
                    "44.09743;9.75483",
                    "44.09712;9.75472",
                    "44.09741;9.7545",
                    "44.09769;9.75459",
                    "44.09745;9.75427",
                    "44.09722;9.75377",
                    "44.09717;9.75317",
                    "44.09718;9.75253",
                    "44.09719;9.752",
                    "44.09715;9.7517",
                    "44.09721;9.7517",
                    "44.0975;9.75299",
                    "44.09759;9.75301",
                    "44.09762;9.75211",
                    "44.0978;9.75144",
                    "44.09786;9.7516",
                    "44.0977;9.75244",
                    "44.09801;9.75347",
                    "44.09833;9.75394",
                    "44.09903;9.75435",
                    "44.09919;9.75586",
                    "44.09909;9.75692",
                    "44.09948;9.75738",
                    "44.10013;9.75715",
                    "44.10073;9.75786",
                    "44.10111;9.75853",
                    "44.10159;9.75883",
                    "44.10196;9.75911",
                    "44.10208;9.75892",
                    "44.1023;9.7572",
                    "44.10265;9.75565",
                    "44.1032;9.75557",
                    "44.10416;9.75636",
                    "44.1049;9.75611",
                    "44.10545;9.75549",
                    "44.10621;9.75572",
                    "44.10643;9.75643",
                    "44.10689;9.7564",
                    "44.10725;9.75674",
                    "44.10751;9.75576",
                    "44.10815;9.7558",
                    "44.10861;9.75555",
                    "44.10875;9.75501",
                    "44.10921;9.75471",
                    "44.10959;9.75415",
                    "44.10948;9.75382",
                    "44.10886;9.75334",
                    "44.1086;9.75246",
                    "44.10878;9.75153",
                    "44.10809;9.75133",
                    "44.1077;9.75079",
                    "44.10711;9.7503",
                    "44.10688;9.74932",
                    "44.10633;9.74913",
                    "44.10637;9.748",
                    "44.10594;9.74703",
                    "44.106;9.74691",
                    "44.10702;9.74765",
                    "44.10772;9.74823",
                    "44.10875;9.74845",
                    "44.10915;9.74831",
                    "44.10955;9.74705",
                    "44.10966;9.74619",
                    "44.10996;9.74621",
                    "44.11068;9.74692",
                    "44.11122;9.74761",
                    "44.1117;9.74818",
                    "44.11183;9.74816",
                    "44.11187;9.74735",
                    "44.11186;9.74583",
                    "44.11193;9.74466",
                    "44.11316;9.74404",
                    "44.1136;9.74355",
                    "44.11411;9.74373",
                    "44.11434;9.74348",
                    "44.11409;9.74256",
                    "44.11351;9.74198",
                    "44.11333;9.74166",
                    "44.11349;9.74149",
                    "44.114;9.7413",
                    "44.11465;9.74112",
                    "44.11514;9.74095",
                    "44.11564;9.74098",
                    "44.11592;9.74139",
                    "44.11629;9.74208",
                    "44.11676;9.74179",
                    "44.11702;9.74181",
                    "44.1174;9.74205",
                    "44.11765;9.74243",
                    "44.11786;9.74279",
                    "44.11807;9.74252",
                    "44.11811;9.74176",
                    "44.11804;9.74117",
                    "44.118;9.74081",
                    "44.11788;9.74025",
                    "44.11813;9.73998",
                    "44.11877;9.73968",
                    "44.11915;9.73992",
                    "44.1198;9.74058",
                    "44.12015;9.74083",
                    "44.12026;9.74053",
                    "44.11996;9.73957",
                    "44.11995;9.73852",
                    "44.12018;9.73813",
                    "44.12054;9.73824",
                    "44.12063;9.73779",
                    "44.12084;9.73731",
                    "44.12114;9.7368",
                    "44.12099;9.73656",
                    "44.12027;9.73658",
                    "44.11941;9.73651",
                    "44.11902;9.73648",
                    "44.11899;9.73618",
                    "44.11907;9.73567",
                    "44.11927;9.73536",
                    "44.11936;9.73504",
                    "44.11959;9.73446",
                    "44.11988;9.73401",
                    "44.1202;9.73292",
                    "44.12001;9.7326",
                    "44.11988;9.73243",
                    "44.11991;9.73215",
                    "44.11981;9.73208",
                    "44.11934;9.7323",
                    "44.11854;9.73269",
                    "44.11793;9.73305",
                    "44.11726;9.73339",
                    "44.11695;9.73278",
                    "44.11694;9.73145",
                    "44.11713;9.73046",
                    "44.11715;9.72952",
                    "44.11711;9.72883",
                    "44.11708;9.72874",
                    "44.11693;9.72855",
                    "44.11665;9.72859",
                    "44.11618;9.72938",
                    "44.11609;9.72968",
                    "44.11635;9.72956",
                    "44.11655;9.72973",
                    "44.11641;9.73085",
                    "44.11607;9.73237",
                    "44.11601;9.73335",
                    "44.11539;9.73461",
                    "44.11481;9.73534",
                    "44.11472;9.73547",
                    "44.11479;9.73544",
                    "44.11503;9.73558",
                    "44.11631;9.73582",
                    "44.11681;9.7363",
                    "44.11683;9.7365",
                    "44.11666;9.73652",
                    "44.11612;9.73634",
                    "44.11587;9.73661",
                    "44.11542;9.7372",
                    "44.11529;9.73753",
                    "44.11509;9.73747",
                    "44.11469;9.73728",
                    "44.11433;9.73753",
                    "44.11389;9.73782",
                    "44.11369;9.73785",
                    "44.11365;9.73772",
                    "44.11431;9.73704",
                    "44.11427;9.73683",
                    "44.11341;9.73682",
                    "44.11316;9.73646",
                    "44.11303;9.7351",
                    "44.11311;9.73443",
                    "44.1132;9.73422",
                    "44.11298;9.73413",
                    "44.11251;9.73358",
                    "44.11178;9.73281",
                    "44.11167;9.73289",
                    "44.11173;9.73325",
                    "44.11159;9.73399",
                    "44.11059;9.73508",
                    "44.11054;9.7351",
                    "44.11046;9.73501",
                    "44.11079;9.73471",
                    "44.11078;9.73442",
                    "44.11057;9.73429",
                    "44.10963;9.7337",
                    "44.10897;9.73289",
                    "44.10897;9.73268",
                    "44.10896;9.73234",
                    "44.10876;9.7323",
                    "44.10865;9.73255",
                    "44.10894;9.73314",
                    "44.10936;9.73374",
                    "44.10918;9.73393",
                    "44.1089;9.73357",
                    "44.10862;9.73296",
                    "44.10814;9.73228",
                    "44.10769;9.73173",
                    "44.10739;9.73161",
                    "44.10717;9.73138",
                    "44.10711;9.73072",
                    "44.10734;9.73013",
                    "44.10774;9.73003",
                    "44.10815;9.72984",
                    "44.10831;9.72958",
                    "44.10813;9.72924",
                    "44.10795;9.72925",
                    "44.10779;9.72943",
                    "44.10751;9.72938",
                    "44.10715;9.72904",
                    "44.10684;9.72857",
                    "44.1053;9.72915",
                    "44.10497;9.72949"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/fef2286e-6b50-4575-9da3-33d1f9a2e639.png",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/38ea8d87-db1a-4d6b-aa3b-064f02414dd3.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c56b5859-954e-4914-ba6d-2644e24e80b6.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c4ee37a5-4fa5-4c1f-aad7-36f6fd4192a3.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f4fd38c3-6601-4b11-ab96-f0d1db20aeda.jpeg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Minimarket Piera di Rossi Monica",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/3f198c7f-2f98-42b8-a1a2-c0a9c46de75c.Minim__44_09567148911994_9_775691586417343",
                        "latitude": 44.09567148911994,
                        "longitude": 9.775691586417343,
                        "description": "Il minimarket Piera di Rossi Monica \u00e8 un grazioso negozio locale situato a Biassa, La Spezia. Rinomato per la sua atmosfera cordiale e la disponibilit\u00e0 dei proprietari, offre una deliziosa selezione di prodotti fatti in casa, tra cui torte e crostate, a prezzi vantaggiosi. I clienti apprezzano i prodotti eccezionali e gli articoli essenziali disponibili, rendendolo una tappa obbligata sia per i locali che per i turisti che esplorano le Cinque Terre."
                    },
                    {
                        "name": "Manarola",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/3d44afe2-e5ab-4f9f-b15b-00c923056509.manar__44_106817718501716_9_728554588260936",
                        "latitude": 44.106817718501716,
                        "longitude": 9.728554588260936,
                        "description": "Manarola, borgo delle Cinque Terre (SP), nasce nel XII secolo dallo spostamento a valle di abitanti da Volastra, originariamente su un promontorio per difendersi dai pirati. Storicamente legato a Genova e ai Fieschi, il paese si \u00e8 sviluppato come centro vinicolo e agricolo, celebre per le case-torri colorate e il suggestivo panorama. "
                    }
                ],
                "infos": {
                    "distance": 21968
                }
            }
        ],
        "catalogue": [
            {
                "id": 116,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 117,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1589,
        "customer": {
            "id": 380,
            "title": "Biciclettaio - Gaiole in Chianti",
            "description": "Biciclettaio \u00e8 il bike rent di Gaiole in Chianti gestito da Filippo, punto di riferimento per chi vuole pedalare tra le colline del Chianti Classico. Offre noleggio di e-bike moderne e ben mantenute, ideali per affrontare sterrati e salite in totale relax. Propone tour panoramici in e-bike alla scoperta di borghi, vigneti e strade bianche, con itinerari anche ispirati a L\u2019Eroica. In negozio trovi assistenza competente, consigli sui percorsi e supporto per organizzare la giornata in sella. Disponibili servizi come regolazione bici, caschi e accessori, oltre a indicazioni su tracce e punti di interesse. Un\u2019esperienza completa, pensata per divertirsi e vivere il Chianti al ritmo giusto.",
            "color": "#ffffff",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Biciclettaio_-_Gaiole_in_Chianti.jpg",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/Progetto_senza_titolo.png"
            ],
            "contacts": {
                "address": "Via G. Marconi, 5, Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "email": "rental@bicyclesinchianti.com",
                "phone": "05771390071"
            },
            "coordinate": {
                "latitude": 43.46728,
                "longitude": 11.43466
            },
            "tours": 4,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8290a122-144d-4087-a8fb-9ab3edd8948f.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/7565c2ce-222e-4e8a-bd67-54c2940dc9a2.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/72782e04-007a-451f-9a23-2d3239ae3b48.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/099cdfa4-dcdf-4e40-9342-a33bdf177312.webp"
            ]
        },
        "title": "Chianti Grand Tour, tra strade bianche e cipressi",
        "description": "Tour spettacolare nel cuore del Chianti, ideale per e-MTB o gravel, tra castelli, borghi e strade bianche. Da Gaiole si pedala verso Meleto, Castagnoli e Brolio, con soste tra vigneti, cantine e panorami iconici. Il percorso tocca anche Villa a Sesta, San Gusm\u00e8 e il suggestivo viale di cipressi della Tenuta di Arceno, proseguendo poi verso Castelnuovo Berardenga e Pieve Asciata, prima del rientro a Gaiole tra scorci e sterrati panoramici.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1589.jpg",
        "price": 25.0,
        "location": "Chianti",
        "location_id": 35,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1622,
                "title": "Chianti Grand Tour tra Castelli, Borghi e Strade Bianche",
                "description": "Un tour ricco e spettacolare nel cuore del Chianti, pensato per chi cerca panorami iconici, borghi autentici e tappe enogastronomiche, con alcuni brevi tratti pi\u00f9 tecnici o ripidi: consigliate e-MTB o gravel.\n\nDopo pochi chilometri si raggiunge il Castello di Meleto, con la sua imponente torre circolare, i giardini e una vista magnifica sulle vigne: una prima sosta perfetta, magari con un bicchiere di vino in cantina. Il percorso prosegue tra saliscendi e strade panoramiche verso Castagnoli, dove si incontrano le cantine Rocca di Castagnoli e Cantalici, e poi verso Brolio, una delle tappe simbolo del tour.\n\nA Brolio la sosta all\u2019Agribar \u00e8 quasi d\u2019obbligo, prima di salire al castello lungo il celebre viale panoramico. Qui si trovano l\u2019Osteria di Brolio e l\u2019ingresso ai giardini, visitabili con biglietto (con calice incluso presso l\u2019enoteca).\n\nLasciata la strada de L\u2019Eroica, il tour tocca Villa a Sesta, elegante borgo con ottimi ristoranti, e San Gusm\u00e8, piccolo gioiello cinto da mura. Da qui si affronta una ripida discesa che conduce a uno dei tratti pi\u00f9 scenografici dell\u2019itinerario: il lungo viale di cipressi della Tenuta di Arceno.\n\nTra strade bianche, passaggi panoramici e atmosfera autentica, si prosegue verso Castelnuovo Berardenga (con possibilit\u00e0 di sosta pranzo), poi lungo L\u2019Eroica fino a Pieve Asciata. Dai \u201cPeperoni\u201d si rientra a Gaiole con un ultimo tratto suggestivo tra sterrato e scorci sulle colline del Chianti.\n",
                "notes": null,
                "start_address": "Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1589.jpg",
                "track": [
                    43.46716,
                    11.4345
                ],
                "preview_track": [
                    "43.46716;11.4345",
                    "43.46621;11.43579",
                    "43.46593;11.43651",
                    "43.46465;11.43532",
                    "43.46435;11.43332",
                    "43.46437;11.43311",
                    "43.46438;11.43286",
                    "43.46422;11.43252",
                    "43.46365;11.43114",
                    "43.46348;11.4308",
                    "43.46324;11.43045",
                    "43.46297;11.42995",
                    "43.46274;11.42963",
                    "43.46132;11.42793",
                    "43.45792;11.42597",
                    "43.45639;11.4255",
                    "43.45471;11.42393",
                    "43.45417;11.42486",
                    "43.4524;11.4274",
                    "43.45182;11.42658",
                    "43.45156;11.42526",
                    "43.4508;11.424",
                    "43.45057;11.42575",
                    "43.45019;11.42666",
                    "43.4501;11.425",
                    "43.44897;11.42783",
                    "43.4488;11.42959",
                    "43.44827;11.43033",
                    "43.44794;11.43134",
                    "43.44773;11.4319",
                    "43.44687;11.43395",
                    "43.44562;11.43681",
                    "43.44565;11.43705",
                    "43.44413;11.44157",
                    "43.4436;11.44333",
                    "43.44199;11.44478",
                    "43.44175;11.44606",
                    "43.44266;11.44739",
                    "43.44213;11.44897",
                    "43.44282;11.45139",
                    "43.44229;11.45305",
                    "43.44306;11.45246",
                    "43.44315;11.45219",
                    "43.4426;11.45316",
                    "43.44233;11.45368",
                    "43.44144;11.45457",
                    "43.43969;11.45323",
                    "43.4388;11.4514",
                    "43.43825;11.44996",
                    "43.43777;11.44816",
                    "43.43859;11.44719",
                    "43.43851;11.44538",
                    "43.43721;11.44355",
                    "43.43603;11.44346",
                    "43.43603;11.44128",
                    "43.43565;11.44092",
                    "43.4338;11.44076",
                    "43.43256;11.44087",
                    "43.432;11.44018",
                    "43.43034;11.4411",
                    "43.42854;11.44058",
                    "43.42686;11.43827",
                    "43.42576;11.43732",
                    "43.42591;11.435",
                    "43.42528;11.43332",
                    "43.42539;11.4322",
                    "43.42529;11.43212",
                    "43.42504;11.43226",
                    "43.42464;11.43323",
                    "43.42436;11.43437",
                    "43.42447;11.43485",
                    "43.42528;11.43553",
                    "43.42522;11.43603",
                    "43.42495;11.43746",
                    "43.42549;11.4393",
                    "43.42608;11.43968",
                    "43.42599;11.44148",
                    "43.42511;11.44214",
                    "43.42483;11.44362",
                    "43.42442;11.44438",
                    "43.42386;11.44582",
                    "43.42396;11.446",
                    "43.42447;11.44662",
                    "43.42437;11.44743",
                    "43.42386;11.44806",
                    "43.42392;11.44871",
                    "43.42392;11.4497",
                    "43.423;11.45095",
                    "43.42207;11.45135",
                    "43.42183;11.45152",
                    "43.42179;11.45213",
                    "43.42159;11.45293",
                    "43.42185;11.45367",
                    "43.42163;11.45419",
                    "43.42076;11.45518",
                    "43.4195;11.45681",
                    "43.41905;11.45709",
                    "43.41887;11.45773",
                    "43.41786;11.45842",
                    "43.41722;11.45805",
                    "43.41655;11.45797",
                    "43.41603;11.4584",
                    "43.41587;11.45896",
                    "43.41589;11.4598",
                    "43.41614;11.46111",
                    "43.41591;11.46145",
                    "43.41555;11.4608",
                    "43.41522;11.4607",
                    "43.41545;11.46095",
                    "43.41535;11.46176",
                    "43.41519;11.46137",
                    "43.41501;11.46138",
                    "43.41408;11.46177",
                    "43.41295;11.4618",
                    "43.41219;11.4618",
                    "43.41211;11.46323",
                    "43.41165;11.46393",
                    "43.41067;11.46439",
                    "43.40886;11.46456",
                    "43.40703;11.46466",
                    "43.40542;11.4638",
                    "43.4052;11.46353",
                    "43.40466;11.46331",
                    "43.40449;11.46355",
                    "43.40444;11.46457",
                    "43.40301;11.46578",
                    "43.40125;11.46568",
                    "43.40035;11.4655",
                    "43.39951;11.46562",
                    "43.39863;11.4658",
                    "43.39773;11.46586",
                    "43.39738;11.46609",
                    "43.39679;11.46612",
                    "43.39622;11.466",
                    "43.39524;11.46571",
                    "43.3933;11.46531",
                    "43.3931;11.46537",
                    "43.39282;11.46579",
                    "43.3924;11.46543",
                    "43.39194;11.46533",
                    "43.3913;11.46596",
                    "43.39059;11.4664",
                    "43.38981;11.46667",
                    "43.38982;11.46728",
                    "43.38964;11.46763",
                    "43.3888;11.46767",
                    "43.3886;11.46797",
                    "43.38844;11.46846",
                    "43.38738;11.46813",
                    "43.38719;11.46841",
                    "43.38729;11.46906",
                    "43.38688;11.46964",
                    "43.38682;11.47007",
                    "43.38755;11.47068",
                    "43.3878;11.47106",
                    "43.38785;11.4728",
                    "43.38781;11.4734",
                    "43.38731;11.4742",
                    "43.3869;11.47491",
                    "43.38631;11.47458",
                    "43.38513;11.47395",
                    "43.38516;11.47457",
                    "43.38398;11.47547",
                    "43.38334;11.47529",
                    "43.38316;11.4757",
                    "43.38328;11.47743",
                    "43.38364;11.47878",
                    "43.3838;11.47911",
                    "43.38437;11.48017",
                    "43.38471;11.48018",
                    "43.38498;11.48037",
                    "43.38487;11.48076",
                    "43.38489;11.48095",
                    "43.38502;11.48096",
                    "43.38529;11.48094",
                    "43.38545;11.48095",
                    "43.3857;11.48097",
                    "43.38586;11.481",
                    "43.38587;11.4813",
                    "43.38591;11.48149",
                    "43.386;11.48167",
                    "43.38609;11.48178",
                    "43.38622;11.48187",
                    "43.38635;11.4819",
                    "43.38656;11.48186",
                    "43.38707;11.48163",
                    "43.38753;11.48176",
                    "43.3876;11.48206",
                    "43.38737;11.48245",
                    "43.38727;11.48304",
                    "43.38738;11.4844",
                    "43.3862;11.48704",
                    "43.38546;11.48833",
                    "43.38528;11.48919",
                    "43.38517;11.49073",
                    "43.38563;11.49305",
                    "43.3861;11.49329",
                    "43.38601;11.49384",
                    "43.3854;11.49401",
                    "43.38483;11.49475",
                    "43.38422;11.49473",
                    "43.38358;11.49485",
                    "43.38318;11.49529",
                    "43.38292;11.49556",
                    "43.38293;11.4959",
                    "43.38289;11.49604",
                    "43.38343;11.4993",
                    "43.38459;11.50083",
                    "43.38476;11.50078",
                    "43.38624;11.50047",
                    "43.38641;11.50034",
                    "43.3866;11.49879",
                    "43.3871;11.49861",
                    "43.38746;11.4986",
                    "43.38741;11.49813",
                    "43.3877;11.49763",
                    "43.38784;11.49785",
                    "43.38806;11.49808",
                    "43.38787;11.4979",
                    "43.38776;11.49775",
                    "43.38742;11.49806",
                    "43.38787;11.49884",
                    "43.38841;11.49885",
                    "43.38867;11.49927",
                    "43.38893;11.50041",
                    "43.38838;11.50119",
                    "43.38826;11.50143",
                    "43.3881;11.50206",
                    "43.38769;11.50326",
                    "43.38694;11.50443",
                    "43.38644;11.50476",
                    "43.38558;11.50532",
                    "43.38461;11.50546",
                    "43.38402;11.50636",
                    "43.38368;11.50714",
                    "43.38279;11.50767",
                    "43.38261;11.50793",
                    "43.38185;11.50996",
                    "43.38116;11.51073",
                    "43.38084;11.51132",
                    "43.37958;11.51914",
                    "43.37924;11.52125",
                    "43.37907;11.52181",
                    "43.3764;11.52098",
                    "43.37398;11.5226",
                    "43.37263;11.52296",
                    "43.36893;11.52426",
                    "43.36678;11.52704",
                    "43.36642;11.52768",
                    "43.3659;11.52897",
                    "43.36511;11.52688",
                    "43.36332;11.52509",
                    "43.36239;11.52371",
                    "43.36196;11.52322",
                    "43.35986;11.52186",
                    "43.35912;11.52173",
                    "43.35815;11.52133",
                    "43.35752;11.52168",
                    "43.35654;11.52119",
                    "43.35616;11.52098",
                    "43.35568;11.51992",
                    "43.35569;11.51846",
                    "43.35524;11.51615",
                    "43.35447;11.51232",
                    "43.35416;11.51105",
                    "43.35467;11.51003",
                    "43.35427;11.50811",
                    "43.35342;11.50558",
                    "43.3529;11.50561",
                    "43.35057;11.50571",
                    "43.35035;11.50564",
                    "43.35016;11.50552",
                    "43.35007;11.50541",
                    "43.35002;11.50526",
                    "43.35001;11.50507",
                    "43.34987;11.50502",
                    "43.34977;11.50507",
                    "43.34957;11.505",
                    "43.34849;11.50411",
                    "43.34795;11.50369",
                    "43.34778;11.50359",
                    "43.34803;11.50375",
                    "43.34831;11.50409",
                    "43.34787;11.50506",
                    "43.34779;11.50515",
                    "43.34753;11.50542",
                    "43.34727;11.50553",
                    "43.34709;11.50546",
                    "43.34701;11.50556",
                    "43.34674;11.5056",
                    "43.34648;11.50558",
                    "43.34613;11.50545",
                    "43.3459;11.50526",
                    "43.34557;11.50479",
                    "43.34532;11.50458",
                    "43.34491;11.50449",
                    "43.34472;11.50445",
                    "43.34496;11.50387",
                    "43.34501;11.50365",
                    "43.34505;11.50355",
                    "43.34508;11.50347",
                    "43.3451;11.50315",
                    "43.34512;11.5028",
                    "43.34515;11.50254",
                    "43.34529;11.50233",
                    "43.34547;11.50217",
                    "43.34546;11.50212",
                    "43.34545;11.50189",
                    "43.34554;11.50147",
                    "43.34546;11.50134",
                    "43.34514;11.50068",
                    "43.34501;11.5004",
                    "43.34451;11.49908",
                    "43.34439;11.49873",
                    "43.34426;11.49831",
                    "43.34381;11.49713",
                    "43.3437;11.49695",
                    "43.34297;11.49604",
                    "43.34021;11.49273",
                    "43.33879;11.49072",
                    "43.33708;11.48899",
                    "43.3363;11.48829",
                    "43.33521;11.48645",
                    "43.33475;11.48415",
                    "43.33455;11.48229",
                    "43.33507;11.4811",
                    "43.3354;11.48055",
                    "43.3354;11.48044",
                    "43.33602;11.47815",
                    "43.33586;11.47726",
                    "43.335;11.47497",
                    "43.33495;11.47249",
                    "43.33574;11.47029",
                    "43.33554;11.46916",
                    "43.33476;11.46738",
                    "43.33515;11.46464",
                    "43.33583;11.46254",
                    "43.33601;11.46054",
                    "43.33605;11.45929",
                    "43.33605;11.45861",
                    "43.33636;11.45714",
                    "43.33635;11.45605",
                    "43.3368;11.45407",
                    "43.3365;11.45252",
                    "43.33576;11.45112",
                    "43.33542;11.4506",
                    "43.3361;11.44989",
                    "43.33646;11.44927",
                    "43.33621;11.44832",
                    "43.33617;11.44779",
                    "43.33643;11.44669",
                    "43.33575;11.44466",
                    "43.3351;11.44305",
                    "43.33528;11.44183",
                    "43.33511;11.44132",
                    "43.3351;11.44051",
                    "43.33448;11.43893",
                    "43.33384;11.43845",
                    "43.33365;11.43773",
                    "43.33349;11.43573",
                    "43.33377;11.4348",
                    "43.33379;11.43387",
                    "43.33361;11.43321",
                    "43.3339;11.43306",
                    "43.33666;11.43152",
                    "43.33814;11.4314",
                    "43.33907;11.43221",
                    "43.33948;11.43286",
                    "43.34014;11.43433",
                    "43.34069;11.43461",
                    "43.34309;11.43385",
                    "43.34396;11.43482",
                    "43.34469;11.43555",
                    "43.34568;11.43561",
                    "43.3468;11.43664",
                    "43.34804;11.43842",
                    "43.34862;11.43852",
                    "43.34943;11.43875",
                    "43.34993;11.43963",
                    "43.35051;11.44008",
                    "43.35095;11.44007",
                    "43.35141;11.43976",
                    "43.35185;11.43945",
                    "43.35225;11.43933",
                    "43.3524;11.43921",
                    "43.35303;11.43856",
                    "43.35363;11.43832",
                    "43.35437;11.43814",
                    "43.35478;11.43813",
                    "43.35497;11.43817",
                    "43.35685;11.43857",
                    "43.35714;11.43859",
                    "43.35781;11.43838",
                    "43.35825;11.43805",
                    "43.35839;11.43752",
                    "43.35834;11.4368",
                    "43.35835;11.43658",
                    "43.35841;11.43622",
                    "43.35852;11.4357",
                    "43.35892;11.43448",
                    "43.35888;11.43327",
                    "43.35891;11.43186",
                    "43.35921;11.43007",
                    "43.35886;11.4287",
                    "43.35774;11.42711",
                    "43.35651;11.42623",
                    "43.35494;11.42393",
                    "43.35521;11.42273",
                    "43.35532;11.42185",
                    "43.35543;11.42094",
                    "43.35564;11.41986",
                    "43.35581;11.41936",
                    "43.35681;11.41721",
                    "43.35683;11.41707",
                    "43.35691;11.41683",
                    "43.3569;11.41672",
                    "43.35661;11.41625",
                    "43.35632;11.41587",
                    "43.3563;11.41579",
                    "43.35678;11.41369",
                    "43.35713;11.41264",
                    "43.35756;11.41227",
                    "43.35863;11.41238",
                    "43.35899;11.41191",
                    "43.35904;11.41121",
                    "43.35943;11.41102",
                    "43.35966;11.41184",
                    "43.35994;11.41202",
                    "43.35998;11.41121",
                    "43.36075;11.41067",
                    "43.36088;11.41022",
                    "43.36035;11.4089",
                    "43.35954;11.40823",
                    "43.3595;11.40772",
                    "43.35973;11.40735",
                    "43.36085;11.40746",
                    "43.36216;11.40717",
                    "43.36231;11.40711",
                    "43.36315;11.40688",
                    "43.36451;11.406",
                    "43.36486;11.40633",
                    "43.36524;11.40644",
                    "43.36597;11.40604",
                    "43.36672;11.40446",
                    "43.36723;11.40427",
                    "43.36772;11.40474",
                    "43.36744;11.40428",
                    "43.36984;11.40449",
                    "43.37105;11.4041",
                    "43.37178;11.40236",
                    "43.37198;11.40155",
                    "43.37262;11.40088",
                    "43.37418;11.39979",
                    "43.37543;11.39852",
                    "43.3767;11.39795",
                    "43.37795;11.3971",
                    "43.38118;11.39628",
                    "43.38199;11.39621",
                    "43.38453;11.39529",
                    "43.38644;11.39264",
                    "43.388;11.39052",
                    "43.38827;11.38946",
                    "43.38892;11.38798",
                    "43.38975;11.38606",
                    "43.38987;11.38573",
                    "43.39087;11.38499",
                    "43.39173;11.3842",
                    "43.39197;11.38351",
                    "43.39228;11.38256",
                    "43.39408;11.3812",
                    "43.39543;11.38101",
                    "43.39603;11.38159",
                    "43.39769;11.38233",
                    "43.39802;11.38234",
                    "43.39818;11.38241",
                    "43.39804;11.38376",
                    "43.39849;11.38566",
                    "43.39947;11.38864",
                    "43.39982;11.38841",
                    "43.4004;11.3896",
                    "43.40157;11.39065",
                    "43.4022;11.39176",
                    "43.40367;11.39199",
                    "43.40437;11.39194",
                    "43.40473;11.39143",
                    "43.40619;11.39202",
                    "43.40664;11.39279",
                    "43.40707;11.39289",
                    "43.40813;11.39382",
                    "43.40953;11.39542",
                    "43.41015;11.39679",
                    "43.41025;11.39767",
                    "43.41147;11.39854",
                    "43.41201;11.39862",
                    "43.41319;11.39831",
                    "43.41333;11.39843",
                    "43.41342;11.39859",
                    "43.41355;11.39893",
                    "43.4136;11.39903",
                    "43.41508;11.39916",
                    "43.4178;11.39883",
                    "43.41928;11.40106",
                    "43.42003;11.40251",
                    "43.4214;11.40374",
                    "43.42251;11.405",
                    "43.4228;11.40503",
                    "43.42325;11.4044",
                    "43.42389;11.40412",
                    "43.42546;11.40437",
                    "43.42668;11.40544",
                    "43.42669;11.40669",
                    "43.42723;11.40774",
                    "43.42818;11.40835",
                    "43.429;11.40894",
                    "43.43013;11.41016",
                    "43.43062;11.4108",
                    "43.43117;11.4121",
                    "43.43169;11.41269",
                    "43.43186;11.41332",
                    "43.43158;11.41394",
                    "43.4306;11.41452",
                    "43.42966;11.41558",
                    "43.4295;11.41612",
                    "43.42982;11.41671",
                    "43.43074;11.41691",
                    "43.4313;11.41753",
                    "43.43247;11.41927",
                    "43.43322;11.42079",
                    "43.43367;11.42076",
                    "43.43531;11.41911",
                    "43.43886;11.41966",
                    "43.44121;11.42136",
                    "43.44339;11.42145",
                    "43.44556;11.41967",
                    "43.44574;11.41814",
                    "43.44636;11.41745",
                    "43.44725;11.41766",
                    "43.44862;11.41852",
                    "43.45024;11.41897",
                    "43.4512;11.41931",
                    "43.45236;11.42092",
                    "43.45423;11.42336",
                    "43.45462;11.42383",
                    "43.45629;11.42547",
                    "43.45791;11.42597",
                    "43.4607;11.42725",
                    "43.46267;11.42952",
                    "43.46293;11.42989",
                    "43.46315;11.43028",
                    "43.46344;11.43074",
                    "43.46362;11.43108",
                    "43.46407;11.43226",
                    "43.4646;11.43307",
                    "43.46492;11.43326",
                    "43.46516;11.43351",
                    "43.46545;11.43394",
                    "43.46559;11.43408",
                    "43.46575;11.43418",
                    "43.46581;11.4342",
                    "43.46616;11.43433",
                    "43.46645;11.43436",
                    "43.46677;11.43436",
                    "43.46746;11.43414",
                    "43.46716;11.4345"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/6d9b0fc7-eb9a-4682-b07b-30ea754e9ba3.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/3687ca0f-4a27-4788-9083-cbb7f47dc87b.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5641fd0f-eb56-4a49-b0aa-6a6d98a93789.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9ca4f1cd-009c-4fac-addf-4570c092088f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/97f946d4-7ea8-49fb-af89-cc2378e1da47.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/85bcf0d7-aed1-473a-8d0e-93e2da75d14c.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/cb9359a3-dbfb-4cbb-888d-d8b59ee93fd3.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Castello di Brolio",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/0c378e26-3b97-4468-a5ab-db7f07ba86c5.12_jp__43_41207777578315_11_4632032316561",
                        "latitude": 43.41207777578315,
                        "longitude": 11.4632032316561,
                        "description": "Castello di Brolio \u00e8 uno dei luoghi simbolo del Chianti Classico, storicamente legato alla famiglia Ricasoli fin dal Medioevo. Si raggiunge lungo un suggestivo viale panoramico tra vigneti, perfetto gi\u00e0 di per s\u00e9 come punto foto. \u00c8 una tappa ideale per una sosta: all\u2019Agribar si pu\u00f2 fermarsi per caff\u00e8 o panino, mentre l\u2019Osteria di Brolio \u00e8 ottima per un pranzo. I giardini del castello sono visitabili (ingresso a pagamento) e spesso il biglietto include anche un calice di vino presso l\u2019enoteca. Possibili anche degustazioni, in base alla formula disponibile e alla stagione."
                    },
                    {
                        "name": "Borgo San Gusm\u00e8",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d44c67c4-ca6d-49c3-a0c6-47396f8e5f94.San_G__43_38806572815996_11_498081110733716",
                        "latitude": 43.38806572815996,
                        "longitude": 11.498081110733716,
                        "description": "San Gusm\u00e8 \u00e8 un piccolo borgo fortificato del Chianti, circondato da mura e ricco di atmosfera autentica. Passeggiare tra le sue viuzze in pietra \u00e8 una breve ma piacevole immersione nella Toscana pi\u00f9 tradizionale. \u00c8 una tappa ideale per una sosta panoramica e qualche foto, grazie al fascino del borgo e del paesaggio circostante. All\u2019interno del paese si pu\u00f2 fare una pausa all\u2019Osteria/Bruschetteria da Sira e Remino, perfetta per uno snack o un pranzo informale. Ottimo stop lungo il tour prima di ripartire verso i tratti pi\u00f9 scenografici del percorso."
                    },
                    {
                        "name": "Castello di Meleto",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/0547830a-6c43-456f-a2cf-c2584975560a.Caste__43_450190078529175_11_426667124605993",
                        "latitude": 43.450190078529175,
                        "longitude": 11.426667124605993,
                        "description": "Il Castello di Meleto \u00e8 una delle tappe pi\u00f9 affascinanti del tour, immerso tra vigneti e colline nel cuore del Chianti. Colpisce subito per la sua imponente torre circolare e per l\u2019atmosfera elegante della tenuta. \u00c8 un ottimo punto per una sosta panoramica: dai giardini e dalla panchina si gode una splendida vista sul castello e sulle vigne circostanti. Se disponibile, si pu\u00f2 anche fare una pausa in cantina per un bicchiere di vino o un\u2019esperienza di degustazione. Una tappa perfetta per unire panorama, storia e sapori del territorio."
                    },
                    {
                        "name": "Villa a Sesta",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/c68290f4-0683-4eba-957e-2f451b0439bf.villa__43_38528986961171_11_480952033853102",
                        "latitude": 43.38528986961171,
                        "longitude": 11.480952033853102,
                        "description": "Villa a Sesta \u00e8 un piccolo borgo elegante nel cuore del Chianti, ideale per una sosta rilassante lungo il tour. Il paese ha un\u2019atmosfera curata e tranquilla, con scorci in pietra e un contesto immerso tra vigneti e campagna toscana. \u00c8 soprattutto una tappa gastronomica, grazie alla presenza di diversi ristoranti, inclusi indirizzi di alto livello. Per una pausa piacevole e pi\u00f9 accessibile, il Ristorante Enoteca Villa di Sotto \u00e8 una scelta consigliata. Ottimo stop per pranzo o per una sosta di qualit\u00e0 prima di proseguire il percorso."
                    },
                    {
                        "name": "Viale di cipressi della Tenuta di Arceno",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/ed0a078a-07cc-46e9-9d6f-f5c490731ac8.Viale__43_37944337274077_11_5197832560318",
                        "latitude": 43.37944337274077,
                        "longitude": 11.5197832560318,
                        "description": "Probabilmente il tratto pi\u00f9 scenografico del tour: lungo, iconico e super fotografabile, uno dei veri highlight del percorso."
                    }
                ],
                "infos": {
                    "distance": 59688
                }
            }
        ],
        "catalogue": [
            {
                "id": 56,
                "name": "E-bike",
                "description": "E-MTB front BOTTECCHIA HYDRON BE50",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/8feb07a0-293b-4656-89ab-252eb7b8d9f1.png"
            },
            {
                "id": 57,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1590,
        "customer": {
            "id": 431,
            "title": "La casa del ciclo Orbetello",
            "description": "l nostro territorio, in gran parte pianeggiante, si presta moltissimo per passeggiate ed escursioni all\u2019aria aperta.\r\n\r\nPresso La Casa del Ciclo a Orbetello potrai trovare una vasta scelta di biciclette in vendita e a noleggio, mountain bike o da passeggio o elettrica, piccole medie e da adulti.\r\n\r\nLe formule sono varie, affitto giornaliero, settimanale o long term.\r\n\r\nLa nostra forza \u00e8 la vasta scelta, possiamo noleggiare biciclette per gruppi anche fino a massimo 30 persone, consegnandole alla stazione ferroviaria di Orbetello o in altro luogo.\r\n\r\nOvviamente noleggiamo anche tutti gli accessori di cui possiate aver bisogno per le vostre passeggiate, come caschi, seggiolini porta bambini, cestini, borse, lucchetti, schiuma auto riparante.\r\n\r\nE se ti serve un consiglio per itinerari nel territorio chiedi a noi, siamo locals!",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/La_casa_del_ciclo_Orbetello.jpg",
            "text_logo": null,
            "contacts": {
                "address": "Via Vittorio Veneto, 2, Via Vittorio Veneto, 2, 58015 Orbetello GR, Italia",
                "email": "info@lacasadelciclo.it",
                "phone": "0564 867790"
            },
            "coordinate": {
                "latitude": 42.43877,
                "longitude": 11.21303
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8804315f-ce6a-4a21-a79a-6ced48699c2f.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/056464c1-8367-4d93-aab7-e1ee5bb50491.jpg"
            ]
        },
        "title": "Argentario Ebike tour",
        "description": "Un tour spettacolare tra laguna e mare, dove in pochi chilometri si passa dagli scorci di Orbetello alle atmosfere selvagge della Feniglia, fino al porto e ai panorami costieri di Porto Ercole. \u00c8 un itinerario ricchissimo di paesaggio, con tratti vista acqua quasi continui e un mix molto bello tra natura, borghi e costa toscana. Perfetto per una pedalata \u201cda cartolina\u201d, da vivere con calma e con tante soste foto.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1590.webp",
        "price": 25.0,
        "location": "Maremma",
        "location_id": 6,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1623,
                "title": "Argentario Ebike tour",
                "description": "Partiremo da Orbetello alla scoperta della storia di Porto Ercole e della meravigliosa natura della riserva della Feniglia. Una volta raggiunto Porto Ercole lungo una pista ciclabile percorreremo un tratto della spettacolare Strada Panoramica di Monte Argentario, facendo tappa alla famosa Rocca Spagnola e a Forte Filippo, fortificazioni costruite a strapiombo sul mare nel XV secolo durante la dominazione spagnola quando Porto ercole fu annesso al nuovo Stato dei Reali Presidi di Spagna.\n\nDopo aver visitato Piazza Santa Barbara nel cuore antico del borgo, ci avventureremo all\u2019interno della Riserva Naturale della Feniglia. Dopo una sosta nella parte pi\u00f9 suggestiva e selvaggia della spiaggia, ritorneremo a Orbetello passando per Ansedonia e chiudendo cos\u00ec l\u2019anello della laguna, magari incontrando qualche esemplare della fauna lagunare.",
                "notes": null,
                "start_address": "Via Vittorio Veneto, 2, 58015 Orbetello GR, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1590.webp",
                "track": [
                    42.43873,
                    11.21308
                ],
                "preview_track": [
                    "42.43873;11.21308",
                    "42.43791;11.21305",
                    "42.43819;11.21424",
                    "42.43858;11.21428",
                    "42.43908;11.21413",
                    "42.43968;11.21366",
                    "42.44;11.21353",
                    "42.44033;11.214",
                    "42.44058;11.21445",
                    "42.44179;11.21436",
                    "42.44198;11.21488",
                    "42.44189;11.21473",
                    "42.44183;11.21434",
                    "42.44226;11.21585",
                    "42.44251;11.21657",
                    "42.44282;11.21715",
                    "42.44317;11.21819",
                    "42.44307;11.21876",
                    "42.44365;11.22042",
                    "42.44453;11.22286",
                    "42.44571;11.22596",
                    "42.44624;11.22783",
                    "42.44661;11.23016",
                    "42.44696;11.23301",
                    "42.44751;11.2371",
                    "42.4476;11.23788",
                    "42.44759;11.2398",
                    "42.44744;11.24103",
                    "42.44693;11.24303",
                    "42.44686;11.24334",
                    "42.44678;11.24355",
                    "42.44672;11.24367",
                    "42.44646;11.24431",
                    "42.44653;11.24484",
                    "42.4461;11.24501",
                    "42.44549;11.24658",
                    "42.44461;11.24957",
                    "42.44483;11.25079",
                    "42.44528;11.25166",
                    "42.44483;11.25248",
                    "42.44401;11.25314",
                    "42.44358;11.25429",
                    "42.44328;11.25601",
                    "42.44251;11.25803",
                    "42.44195;11.25925",
                    "42.44147;11.26098",
                    "42.44072;11.26345",
                    "42.44056;11.26364",
                    "42.44037;11.2643",
                    "42.44022;11.26514",
                    "42.43845;11.2708",
                    "42.4377;11.27315",
                    "42.43724;11.274",
                    "42.43618;11.2761",
                    "42.43455;11.27805",
                    "42.43351;11.2789",
                    "42.43207;11.27967",
                    "42.43141;11.28002",
                    "42.4295;11.2803",
                    "42.42735;11.28055",
                    "42.42342;11.28073",
                    "42.42196;11.2813",
                    "42.4209;11.28228",
                    "42.42036;11.28247",
                    "42.41964;11.28209",
                    "42.41904;11.28215",
                    "42.41808;11.28175",
                    "42.41791;11.28115",
                    "42.4181;11.28114",
                    "42.41827;11.28064",
                    "42.42006;11.27635",
                    "42.42173;11.2728",
                    "42.42325;11.26333",
                    "42.42349;11.25835",
                    "42.42185;11.24448",
                    "42.42205;11.24441",
                    "42.42642;11.2425",
                    "42.42635;11.24116",
                    "42.42633;11.2395",
                    "42.42577;11.23812",
                    "42.42497;11.23544",
                    "42.42402;11.23161",
                    "42.42347;11.23128",
                    "42.41986;11.23289",
                    "42.41689;11.22091",
                    "42.41463;11.21611",
                    "42.41386;11.21493",
                    "42.4147;11.21423",
                    "42.41678;11.21362",
                    "42.41592;11.21186",
                    "42.41531;11.21149",
                    "42.41439;11.21206",
                    "42.41345;11.21152",
                    "42.41066;11.20958",
                    "42.40991;11.20904",
                    "42.40949;11.20865",
                    "42.40899;11.2079",
                    "42.408;11.20857",
                    "42.40697;11.20748",
                    "42.40532;11.2079",
                    "42.4054;11.20756",
                    "42.40579;11.20501",
                    "42.40579;11.20369",
                    "42.40551;11.20182",
                    "42.40582;11.20097",
                    "42.4059;11.20062",
                    "42.40423;11.20073",
                    "42.40379;11.20127",
                    "42.40328;11.20175",
                    "42.40347;11.20048",
                    "42.40261;11.19978",
                    "42.40157;11.19945",
                    "42.40078;11.1998",
                    "42.39951;11.20071",
                    "42.39902;11.20098",
                    "42.39806;11.20162",
                    "42.39663;11.20192",
                    "42.3958;11.20271",
                    "42.3955;11.20317",
                    "42.3955;11.20317",
                    "42.39517;11.20357",
                    "42.39474;11.20372",
                    "42.39391;11.20392",
                    "42.3935;11.20414",
                    "42.3933;11.20491",
                    "42.39244;11.20583",
                    "42.39061;11.20789",
                    "42.39029;11.20865",
                    "42.3911;11.20948",
                    "42.3911;11.20948",
                    "42.39029;11.20865",
                    "42.39061;11.20789",
                    "42.39244;11.20583",
                    "42.3933;11.20491",
                    "42.394;11.20449",
                    "42.39454;11.20453",
                    "42.39489;11.20463",
                    "42.39533;11.20487",
                    "42.39568;11.20667",
                    "42.39553;11.20838",
                    "42.39619;11.20843",
                    "42.39682;11.2081",
                    "42.39724;11.20806",
                    "42.39746;11.20829",
                    "42.39775;11.20854",
                    "42.39808;11.20866",
                    "42.39823;11.20964",
                    "42.39836;11.21026",
                    "42.39864;11.21015",
                    "42.39887;11.20948",
                    "42.3997;11.20939",
                    "42.40006;11.20896",
                    "42.40046;11.20788",
                    "42.40065;11.20707",
                    "42.40067;11.20666",
                    "42.40048;11.20544",
                    "42.39983;11.20405",
                    "42.39928;11.20347",
                    "42.39834;11.20282",
                    "42.39772;11.20287",
                    "42.39759;11.20255",
                    "42.39711;11.20235",
                    "42.39676;11.20225",
                    "42.39735;11.20211",
                    "42.39808;11.20181",
                    "42.3984;11.20148",
                    "42.39941;11.20079",
                    "42.40065;11.19988",
                    "42.40141;11.19947",
                    "42.40228;11.19961",
                    "42.40351;11.20031",
                    "42.40321;11.20177",
                    "42.40366;11.20136",
                    "42.40412;11.20085",
                    "42.40559;11.20054",
                    "42.40641;11.20065",
                    "42.40779;11.2006",
                    "42.40885;11.20077",
                    "42.40963;11.20165",
                    "42.4109;11.20304",
                    "42.41292;11.20461",
                    "42.4145;11.20488",
                    "42.41546;11.20496",
                    "42.41589;11.205",
                    "42.4161;11.20525",
                    "42.41645;11.20445",
                    "42.41741;11.20389",
                    "42.41854;11.20345",
                    "42.42055;11.20286",
                    "42.42253;11.20234",
                    "42.42379;11.20156",
                    "42.42468;11.19963",
                    "42.4252;11.19879",
                    "42.42645;11.19716",
                    "42.42837;11.19869",
                    "42.42882;11.19898",
                    "42.42898;11.19918",
                    "42.43109;11.20136",
                    "42.43281;11.2031",
                    "42.43457;11.20487",
                    "42.43546;11.20577",
                    "42.43586;11.20596",
                    "42.43596;11.206",
                    "42.43658;11.20622",
                    "42.43673;11.20639",
                    "42.43813;11.20792",
                    "42.43936;11.20952",
                    "42.43922;11.20964",
                    "42.43908;11.20955",
                    "42.43862;11.20992",
                    "42.43869;11.21014",
                    "42.43882;11.21039",
                    "42.43968;11.21248",
                    "42.43954;11.2127",
                    "42.43891;11.21308"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/77d8a6b7-c595-4cee-82ca-97f11961e375.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/52d50969-162a-44dd-8340-17916094e1ea.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/3f78014f-47dc-4c34-9644-5ebd72effd3d.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/8e32fba0-279c-4342-bb74-4031948bbd2b.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/7246cc87-dd7c-461c-9e59-5b1475f22cf8.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d5051ab6-bc3d-454d-b3d5-0e5feb6d0222.jpg"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 29688
                }
            }
        ],
        "catalogue": [
            {
                "id": 102,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 103,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1531,
        "customer": {
            "id": 378,
            "title": "Florence By Bike",
            "description": "Un ampio showroom nel cuore di Firenze. Selezioniamo solo i migliori brand per garantirti qualit\u00e0, affidabilit\u00e0 e stile. Che tu sia un ciclista esperto o alla ricerca della tua prima bici, vieni a scoprire il nostro showroom e lasciati consigliare dal nostro team.\r\nScopri Firenze e la Toscana in bici. Nel nostro punto noleggio trovi di tutto: dalle bici da citt\u00e0 alle bici da corsa. Che sia una pedalata nel centro storico o un giro tra le colline, avrai sempre mezzi affidabili. Con due officine attrezzate e due meccanici specializzati, siamo pronti a prenderci cura della tua bici. Offriamo manutenzione rapida, controlli accurati e riparazioni complete. Che si tratti di una semplice regolazione o di un intervento pi\u00f9 complesso, l\u2019esperienza dei nostri meccanici e la loro passione rimetteranno subito la tua bici in strada, pronta a pedalare ancora.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Florence_By_Bike.png",
            "text_logo": null,
            "contacts": {
                "address": "Via S. Zanobi, 54/R, Via S. Zanobi, 54/R, 50129 Firenze FI, Italia",
                "email": "info@florencebybike.it",
                "phone": "055 488992"
            },
            "coordinate": {
                "latitude": 43.77913,
                "longitude": 11.25548
            },
            "tours": 2,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/7f2fa4dc-f0e9-4cd1-bf94-9c4823cdebd0.jpeg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/acb199c7-3a9d-4b56-be83-41922b2e84b0.jpeg"
            ]
        },
        "title": "Florence Countryside Tour (long version) ",
        "description": "Tour e-bike da Firenze centro tra citt\u00e0, colline e sapori toscani. Dopo i Viali dei Colli e Piazzale Michelangelo, il percorso segue i Lungarni e raggiunge Villa Gamberaia, per poi salire verso Poggio Piano, dove \u00e8 possibile fare una degustazione con light lunch. Il rientro avviene lungo il percorso ciclabile dell\u2019Arno, con una pedalata piacevole fino al cuore di Firenze.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1531.jpg",
        "price": 25.0,
        "location": "Firenze",
        "location_id": 39,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1566,
                "title": "Florence Countryside E-Bike Tour",
                "description": "Questo tour e-bike parte dal centro di Firenze e propone un itinerario panoramico che unisce il fascino della citt\u00e0 alle colline che la circondano. Dopo l\u2019uscita dal centro, il percorso sale lungo i Viali dei Colli fino a raggiungere Piazzale Michelangelo, uno dei balconi pi\u00f9 spettacolari su Firenze, perfetto per ammirare dall\u2019alto il profilo della citt\u00e0 e l\u2019andamento dell\u2019Arno.\n\nDa qui il tour prosegue in un ambiente sempre pi\u00f9 verde e rilassato, alternando tratti urbani eleganti, Lungarni e strade secondarie che portano verso le colline fiorentine. Uno dei passaggi pi\u00f9 affascinanti \u00e8 la zona di Villa Gamberaia, storica dimora immersa nel paesaggio di Settignano, celebre per il contesto raffinato e per le splendide viste su Firenze e sulla valle.\n\nIl percorso continua poi in direzione di Poggio Piano, agriturismo circondato da vigneti e oliveti, dove i partecipanti possono concedersi una piacevole sosta con degustazione e light lunch in un\u2019atmosfera autenticamente toscana. \u00c8 il momento ideale per rallentare, godersi i sapori del territorio e vivere la campagna a pochi chilometri dalla citt\u00e0.\n\nIl rientro verso Firenze segue infine i Lungarni e il percorso ciclabile lungo l\u2019Arno, con una pedalata scorrevole e panoramica che riporta nel centro storico. Un tour perfetto per chi desidera unire cultura, paesaggio e gusto in una sola esperienza.",
                "notes": "",
                "start_address": "Piazza Nicola Demidoff",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    43.77906,
                    11.25535
                ],
                "preview_track": [
                    "43.77906;11.25535",
                    "43.77781;11.25437",
                    "43.77741;11.25364",
                    "43.7772;11.25326",
                    "43.77752;11.2526",
                    "43.77716;11.25205",
                    "43.77624;11.25045",
                    "43.77598;11.24985",
                    "43.7758;11.24994",
                    "43.7751;11.25015",
                    "43.77489;11.25021",
                    "43.77476;11.25014",
                    "43.77477;11.2499",
                    "43.7742;11.24993",
                    "43.77393;11.24982",
                    "43.77378;11.24986",
                    "43.77315;11.24963",
                    "43.77304;11.24944",
                    "43.77287;11.24934",
                    "43.77277;11.2494",
                    "43.77241;11.24903",
                    "43.77121;11.24779",
                    "43.77114;11.24762",
                    "43.77102;11.24771",
                    "43.77093;11.24763",
                    "43.77084;11.24756",
                    "43.76973;11.24687",
                    "43.76968;11.24698",
                    "43.76957;11.24694",
                    "43.76905;11.24661",
                    "43.76876;11.24641",
                    "43.7677;11.24581",
                    "43.76758;11.24576",
                    "43.76615;11.24488",
                    "43.76548;11.24448",
                    "43.76519;11.24431",
                    "43.76372;11.2435",
                    "43.76333;11.24332",
                    "43.76194;11.24253",
                    "43.76125;11.24231",
                    "43.76115;11.24232",
                    "43.76083;11.24225",
                    "43.76065;11.24254",
                    "43.76017;11.24239",
                    "43.75871;11.24489",
                    "43.75882;11.24673",
                    "43.75895;11.24738",
                    "43.7589;11.24743",
                    "43.75862;11.24789",
                    "43.75842;11.24798",
                    "43.75838;11.24821",
                    "43.7582;11.24817",
                    "43.75784;11.24791",
                    "43.75766;11.24693",
                    "43.75697;11.24686",
                    "43.75671;11.24742",
                    "43.75676;11.2482",
                    "43.75677;11.2493",
                    "43.75693;11.24972",
                    "43.75724;11.24999",
                    "43.75733;11.25017",
                    "43.75802;11.25035",
                    "43.75823;11.25087",
                    "43.75793;11.25142",
                    "43.75775;11.2515",
                    "43.75675;11.25082",
                    "43.75627;11.25044",
                    "43.75601;11.25041",
                    "43.75575;11.2504",
                    "43.75516;11.25071",
                    "43.75488;11.25136",
                    "43.75486;11.25189",
                    "43.75477;11.25278",
                    "43.75447;11.25359",
                    "43.75407;11.25509",
                    "43.75423;11.25586",
                    "43.75501;11.25602",
                    "43.75619;11.25638",
                    "43.75791;11.25836",
                    "43.75782;11.25918",
                    "43.75755;11.25998",
                    "43.758;11.26118",
                    "43.75811;11.26139",
                    "43.75823;11.26213",
                    "43.75838;11.26246",
                    "43.75833;11.26259",
                    "43.75864;11.26287",
                    "43.75954;11.26358",
                    "43.76006;11.26436",
                    "43.76021;11.26465",
                    "43.76067;11.26515",
                    "43.76099;11.26523",
                    "43.76103;11.26508",
                    "43.76147;11.26461",
                    "43.76178;11.26444",
                    "43.76217;11.26436",
                    "43.76227;11.26446",
                    "43.76216;11.26522",
                    "43.76218;11.2656",
                    "43.76218;11.2656",
                    "43.76243;11.26504",
                    "43.76243;11.26448",
                    "43.76231;11.2643",
                    "43.7621;11.26424",
                    "43.76242;11.26396",
                    "43.76266;11.26381",
                    "43.76295;11.26365",
                    "43.76316;11.26367",
                    "43.7634;11.26382",
                    "43.76345;11.2641",
                    "43.76324;11.26525",
                    "43.76317;11.26609",
                    "43.76336;11.26632",
                    "43.76342;11.26634",
                    "43.76353;11.26626",
                    "43.76356;11.2654",
                    "43.76365;11.26451",
                    "43.76362;11.26366",
                    "43.76343;11.26329",
                    "43.76329;11.26311",
                    "43.76329;11.26299",
                    "43.76344;11.263",
                    "43.76379;11.26366",
                    "43.76388;11.26475",
                    "43.76397;11.2666",
                    "43.76405;11.26693",
                    "43.76413;11.26694",
                    "43.76421;11.26678",
                    "43.76422;11.26628",
                    "43.76407;11.26557",
                    "43.76402;11.26511",
                    "43.76413;11.26521",
                    "43.76422;11.26546",
                    "43.7643;11.26488",
                    "43.76432;11.26445",
                    "43.76442;11.26431",
                    "43.76445;11.26442",
                    "43.7648;11.2646",
                    "43.76478;11.26484",
                    "43.76489;11.26517",
                    "43.76468;11.26729",
                    "43.76433;11.27002",
                    "43.76419;11.27065",
                    "43.7642;11.27084",
                    "43.76532;11.27116",
                    "43.7657;11.27138",
                    "43.76582;11.27153",
                    "43.76587;11.27181",
                    "43.76561;11.27601",
                    "43.76548;11.27733",
                    "43.7655;11.27987",
                    "43.76569;11.28146",
                    "43.76575;11.28193",
                    "43.76595;11.28346",
                    "43.76608;11.28385",
                    "43.76636;11.28627",
                    "43.7666;11.28834",
                    "43.76707;11.29243",
                    "43.76721;11.29387",
                    "43.76716;11.29434",
                    "43.7671;11.29504",
                    "43.76679;11.29607",
                    "43.76671;11.29649",
                    "43.76665;11.29653",
                    "43.76628;11.29639",
                    "43.76612;11.29649",
                    "43.7654;11.29891",
                    "43.76501;11.30017",
                    "43.76469;11.30102",
                    "43.76438;11.3022",
                    "43.76414;11.30369",
                    "43.76402;11.30427",
                    "43.76424;11.30409",
                    "43.76484;11.30426",
                    "43.76529;11.30438",
                    "43.7654;11.3045",
                    "43.76538;11.30436",
                    "43.7655;11.30421",
                    "43.7655;11.30411",
                    "43.7656;11.30331",
                    "43.76565;11.30329",
                    "43.76553;11.30501",
                    "43.76542;11.30563",
                    "43.76537;11.30606",
                    "43.76501;11.30862",
                    "43.76499;11.30878",
                    "43.76514;11.30879",
                    "43.76579;11.30887",
                    "43.76623;11.30898",
                    "43.76672;11.30918",
                    "43.76682;11.3092",
                    "43.76788;11.3094",
                    "43.76793;11.31029",
                    "43.76807;11.31171",
                    "43.7695;11.31251",
                    "43.77081;11.31322",
                    "43.77079;11.31435",
                    "43.77132;11.31957",
                    "43.77148;11.32036",
                    "43.77143;11.32231",
                    "43.77165;11.32305",
                    "43.77294;11.32264",
                    "43.77388;11.32301",
                    "43.77548;11.32325",
                    "43.77768;11.32635",
                    "43.77888;11.32778",
                    "43.7789;11.3285",
                    "43.77942;11.32871",
                    "43.78008;11.32941",
                    "43.77995;11.33114",
                    "43.7798;11.3318",
                    "43.77945;11.33185",
                    "43.77869;11.33283",
                    "43.77826;11.33331",
                    "43.77836;11.33352",
                    "43.77919;11.33526",
                    "43.77932;11.33564",
                    "43.77906;11.33689",
                    "43.77937;11.33712",
                    "43.77946;11.33742",
                    "43.7791;11.33839",
                    "43.77928;11.3388",
                    "43.77978;11.34016",
                    "43.77954;11.34075",
                    "43.77944;11.34168",
                    "43.77994;11.34244",
                    "43.78017;11.34291",
                    "43.78006;11.34361",
                    "43.78037;11.34452",
                    "43.78064;11.34696",
                    "43.78049;11.35058",
                    "43.7801;11.3515",
                    "43.7802;11.3524",
                    "43.77947;11.35235",
                    "43.77815;11.35138",
                    "43.77707;11.34994",
                    "43.77702;11.34966",
                    "43.77748;11.34951",
                    "43.77701;11.34971",
                    "43.77704;11.35005",
                    "43.77581;11.34881",
                    "43.77464;11.34782",
                    "43.77368;11.34702",
                    "43.77312;11.34631",
                    "43.77369;11.34466",
                    "43.774;11.34422",
                    "43.77291;11.34394",
                    "43.77227;11.34372",
                    "43.77145;11.34386",
                    "43.77113;11.34384",
                    "43.77092;11.34204",
                    "43.77063;11.34073",
                    "43.77052;11.34071",
                    "43.77042;11.34061",
                    "43.77025;11.34042",
                    "43.77006;11.34036",
                    "43.76977;11.34034",
                    "43.76964;11.34036",
                    "43.7695;11.34019",
                    "43.76933;11.33978",
                    "43.76925;11.33913",
                    "43.76884;11.33918",
                    "43.76836;11.33816",
                    "43.76911;11.33738",
                    "43.76925;11.33716",
                    "43.76927;11.3354",
                    "43.76929;11.33496",
                    "43.76963;11.33458",
                    "43.7698;11.33429",
                    "43.77002;11.33361",
                    "43.77004;11.33207",
                    "43.76912;11.32929",
                    "43.76804;11.3266",
                    "43.76728;11.32552",
                    "43.76633;11.32433",
                    "43.76597;11.32401",
                    "43.76525;11.32264",
                    "43.76369;11.31814",
                    "43.7635;11.31413",
                    "43.76296;11.31342",
                    "43.76333;11.31006",
                    "43.76381;11.30678",
                    "43.76385;11.30655",
                    "43.76369;11.30621",
                    "43.76389;11.30497",
                    "43.76414;11.30369",
                    "43.7644;11.30209",
                    "43.76481;11.30065",
                    "43.76507;11.29998",
                    "43.76558;11.29833",
                    "43.76615;11.29645",
                    "43.76632;11.2964",
                    "43.76667;11.29653",
                    "43.76671;11.29648",
                    "43.76681;11.29608",
                    "43.76711;11.29493",
                    "43.76717;11.29405",
                    "43.76712;11.2937",
                    "43.76647;11.28799",
                    "43.76635;11.28711",
                    "43.76628;11.28647",
                    "43.76611;11.28492",
                    "43.7658;11.28229",
                    "43.76575;11.28187",
                    "43.76561;11.2808",
                    "43.76541;11.27856",
                    "43.76557;11.2763",
                    "43.76573;11.27423",
                    "43.76586;11.27163",
                    "43.76578;11.27147",
                    "43.76546;11.2712",
                    "43.76423;11.27088",
                    "43.76418;11.27077",
                    "43.76421;11.27052",
                    "43.76435;11.26945",
                    "43.7645;11.26845",
                    "43.76462;11.26787",
                    "43.76489;11.26517",
                    "43.76496;11.26381",
                    "43.76502;11.26318",
                    "43.76517;11.26169",
                    "43.76542;11.25907",
                    "43.7656;11.25846",
                    "43.76678;11.25908",
                    "43.7668;11.25914",
                    "43.76693;11.2591",
                    "43.76762;11.25943",
                    "43.76765;11.25957",
                    "43.76791;11.25965",
                    "43.76896;11.26054",
                    "43.76928;11.26088",
                    "43.76936;11.26087",
                    "43.77019;11.26162",
                    "43.77025;11.2616",
                    "43.7707;11.26204",
                    "43.77107;11.26231",
                    "43.77143;11.26259",
                    "43.77158;11.2626",
                    "43.77162;11.26253",
                    "43.77203;11.2615",
                    "43.77264;11.26048",
                    "43.77292;11.25995",
                    "43.77331;11.25931",
                    "43.7741;11.25793",
                    "43.77417;11.25789",
                    "43.77449;11.25683",
                    "43.77563;11.25767",
                    "43.77632;11.25815",
                    "43.77639;11.25819",
                    "43.77676;11.2574",
                    "43.77702;11.25746",
                    "43.77804;11.25824",
                    "43.77847;11.25722",
                    "43.77876;11.25656",
                    "43.77878;11.25647",
                    "43.77898;11.25603",
                    "43.77911;11.25539"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/960f1812-f556-4a1e-aefa-6e5d3c7b0801.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/af41a47e-65a1-4d18-baf9-e1111490286f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/7a02d666-c5b7-4853-9bf5-4280260ed5fa.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/6a485198-1cf4-48b6-a4d5-83b0c41142f5.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Chiesa di San Miniato al Monte",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/797d602f-b50d-4aa9-8af5-ca8b04967072.Chies__43_760038401795526_11_264327878598126",
                        "latitude": 43.760038401795526,
                        "longitude": 11.264327878598126,
                        "description": "La basilica di San Miniato al Monte si trova in una delle posizioni pi\u00f9 alte di Firenze ed \u00e8 uno dei pi\u00f9 importanti esempi di romanico fiorentino. Dedicata a San Miniato, primo martire della citt\u00e0, secondo la tradizione sorge sul colle dove il santo arriv\u00f2 portando in mano la propria testa dopo il martirio. La costruzione della chiesa inizi\u00f2 nel 1018 sotto il vescovo Alibrando e prosegu\u00ec con l\u2019imperatore Enrico II. Dal 1373 \u00e8 affidata ai monaci olivetani, ancora oggi noti per la produzione di liquori, miele e tisane. Accanto alla basilica si trova il celebre Cimitero delle Porte Sante."
                    },
                    {
                        "name": "Piazzale Michelangelo",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/73e1737a-aec0-4bb2-be61-fd11ba75b993.piazz__43_76220497628715_11_265601487830283",
                        "latitude": 43.76220497628715,
                        "longitude": 11.265601487830283,
                        "description": "Piazzale Michelangelo \u00e8 il punto panoramico pi\u00f9 celebre di Firenze, meta immancabile per chi visita la citt\u00e0. Fu realizzato nel 1869 su progetto di Giuseppe Poggi, durante il periodo in cui Firenze era capitale d\u2019Italia e interessata da un importante rinnovamento urbanistico. La piazza, dedicata a Michelangelo, ospita copie in bronzo del David e delle quattro allegorie delle Cappelle Medicee di San Lorenzo, mentre gli originali sono in marmo bianco."
                    },
                    {
                        "name": "Villa Gamberaia",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/e1335560-5ae1-4896-9f06-3511c1d75b60.villa__43_77944934166863_11_328673800453545",
                        "latitude": 43.77944934166863,
                        "longitude": 11.328673800453545,
                        "description": "Villa Gamberaia sorge sulle colline di Settignano, con una splendida vista su Firenze e sulla Valle dell\u2019Arno. Costruita all\u2019inizio del Seicento da Zanobi Lapi, mercante fiorentino vicino alla corte medicea, si svilupp\u00f2 insieme ai suoi celebri giardini.\nNel tempo pass\u00f2 a diverse propriet\u00e0, attraversando fasi di splendore, abbandono e restauro. Alla fine dell\u2019Ottocento colp\u00ec i visitatori per la sua atmosfera poetica e misteriosa, e nel 1896 fu acquistata dalla principessa rumena Catherine Jeanne Ghyka.\nDopo le vicende del Novecento, dal 1994 la villa e i giardini sono stati valorizzati dagli eredi di Marcello Marchi, diventando anche sede di eventi privati e iniziative culturali."
                    },
                    {
                        "name": "Fattoria di Poggiopiano",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/c4974f86-d437-4b24-90ca-403d8f563d36.Fatto__43_77749427416172_11_349780187010765",
                        "latitude": 43.77749427416172,
                        "longitude": 11.349780187010765,
                        "description": "Sulle colline di Fiesole, nel Chianti fiorentino, la famiglia Galardi acquist\u00f2 la Tenuta di Poggiopiano nel 1935, dopo il lungo passato legato ai Medici. Oggi la propriet\u00e0 comprende un agriturismo ricavato da un casale toscano seicentesco e una fattoria che produce olio extravergine e vini biologici di alta qualit\u00e0.\nI vini nascono esclusivamente dai vigneti di propriet\u00e0, coltivati secondo i principi dell\u2019agricoltura biologica, e hanno ottenuto nel tempo numerosi premi e riconoscimenti."
                    }
                ],
                "infos": {
                    "distance": 28975
                }
            }
        ],
        "catalogue": [
            {
                "id": 52,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 53,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1591,
        "customer": {
            "id": 432,
            "title": "Magona bike garage",
            "description": "Noleggio E-Bike\r\nE-Bike pronte per farti esplorare la ValdiCecina...Vi aspettano decine di km di percorsi mtb e strade bianche e tanti panorami mozzafiato\r\n\r\nOfficina\r\nRiparazioni, revisioni e manutenzioni complete per ogni tipo di bici, officina specializzata per E-Bike, aggiornamenti, diagnosi e interventi per ogni tipo di motore. Avinox, Bafang, Brose,Bosch,Fazua,FSA,Mahle,OLI, Panasonic,Hyena,Polini,Shimano, TQ,Yamaha e molti altri! La lista \u00e8 in continuo aggiornamento!\r\n\r\nRistoro\r\nArea relax con caffetteria e snack per rilassarti e ricaricare anche te, non solo la tua bici!\r\n\r\nTour e Corsi\r\nLe nostre guide certificate vi accompagneranno nelle vostre avventure e potranno insegnarvi le tecniche di guida pi\u00f9 adatte per poter viaggiare in totale sicurezza.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Magona_bike_garage.png",
            "text_logo": null,
            "contacts": {
                "address": "Magona Bike Garage, Via del Mandorlo, 1, 57020 Bibbona LI, Italia",
                "email": "vitiellomanuel1985@gmail.com",
                "phone": "+39 331 345 3207"
            },
            "coordinate": {
                "latitude": 43.26614,
                "longitude": 10.59472
            },
            "tours": 1,
            "gallery": []
        },
        "title": "Ebike tour Bibbona bolgheri ",
        "description": "Un anello tra Bibbona, la Magona e l\u2019area di Bolgheri/San Guido, dove in pochi chilometri si passa da tratti nel verde a strade panoramiche tipicamente toscane. \u00c8 un tour compatto ma ricco, con salite che danno carattere al percorso e bei tratti scorrevoli per godersi il paesaggio. Perfetto per chi cerca una pedalata intensa il giusto, con vibe autentica tra collina, bosco e campagna.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1591.jpg",
        "price": 25.0,
        "location": "Bibbona",
        "location_id": null,
        "tags": [
            "Natura",
            "Mare",
            "Citt\u00e0"
        ],
        "routes": [
            {
                "id": 1624,
                "title": "Ebike tour Bibbona bolgheri ",
                "description": "Partenza / arrivo: zona Bibbona (area Bibbona\u2013La California), percorso ad anello.\n\nDati principali: sviluppo totale di circa 26 km e dislivello positivo di circa 446 m; giro corto ma collinare, con andamento mosso e ritmo variabile.\n\nTracciato e paesaggio: l\u2019itinerario alterna tratti pi\u00f9 chiusi e ombreggiati nella Macchia della Magona a sezioni pi\u00f9 aperte verso Bolgheri/San Guido, con paesaggio collinare e strade panoramiche; questo rende il percorso vario, con cambi di scenario frequenti e alcuni punti panoramici lungo il tracciato.\n\nNote utili: lungo il percorso si pedala in tratti molto tranquilli e immersi nella natura, quindi \u00e8 una buona idea partire con acqua, uno snack e telefono carico/GPS attivo per godersi il tour in totale serenit\u00e0.",
                "notes": null,
                "start_address": "Via del Mandorlo, 1, 57020 Bibbona LI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1591.jpg",
                "track": [
                    43.26628,
                    10.59449
                ],
                "preview_track": [
                    "43.26628;10.59449",
                    "43.26588;10.59573",
                    "43.26586;10.59581",
                    "43.26534;10.59586",
                    "43.26532;10.59742",
                    "43.26549;10.59814",
                    "43.26561;10.59852",
                    "43.26647;10.599",
                    "43.26612;10.60028",
                    "43.26625;10.60102",
                    "43.26582;10.60114",
                    "43.26573;10.60281",
                    "43.26635;10.6041",
                    "43.26727;10.60522",
                    "43.26784;10.60695",
                    "43.26834;10.60777",
                    "43.26779;10.60844",
                    "43.26749;10.60979",
                    "43.26698;10.61094",
                    "43.26667;10.61215",
                    "43.26661;10.61386",
                    "43.26638;10.61554",
                    "43.2666;10.61605",
                    "43.2667;10.61662",
                    "43.26693;10.61751",
                    "43.26712;10.61895",
                    "43.26808;10.62264",
                    "43.26851;10.62451",
                    "43.26892;10.62549",
                    "43.26867;10.62636",
                    "43.2692;10.62652",
                    "43.2693;10.62734",
                    "43.26846;10.6273",
                    "43.26763;10.62775",
                    "43.26719;10.62825",
                    "43.26685;10.62882",
                    "43.26635;10.62868",
                    "43.26583;10.62851",
                    "43.26494;10.6279",
                    "43.26448;10.62827",
                    "43.2641;10.62947",
                    "43.26351;10.63099",
                    "43.26305;10.63079",
                    "43.26237;10.63079",
                    "43.26184;10.62979",
                    "43.26103;10.62902",
                    "43.26079;10.62734",
                    "43.2597;10.6266",
                    "43.25979;10.62754",
                    "43.25972;10.62855",
                    "43.25971;10.62951",
                    "43.2591;10.63011",
                    "43.25829;10.62986",
                    "43.25722;10.62813",
                    "43.25631;10.62688",
                    "43.2557;10.62682",
                    "43.25556;10.62726",
                    "43.25535;10.62882",
                    "43.255;10.63002",
                    "43.25446;10.62974",
                    "43.25425;10.62934",
                    "43.25378;10.62915",
                    "43.25358;10.62973",
                    "43.25366;10.63027",
                    "43.25315;10.63032",
                    "43.25095;10.62889",
                    "43.25015;10.63114",
                    "43.24916;10.63056",
                    "43.24845;10.62835",
                    "43.24899;10.62507",
                    "43.24882;10.62307",
                    "43.24833;10.62181",
                    "43.24753;10.61822",
                    "43.24774;10.61596",
                    "43.24793;10.61481",
                    "43.24839;10.61085",
                    "43.24828;10.60825",
                    "43.24812;10.60534",
                    "43.24954;10.59736",
                    "43.24953;10.59617",
                    "43.24859;10.59625",
                    "43.2483;10.59608",
                    "43.24803;10.59569",
                    "43.24771;10.59541",
                    "43.2474;10.59502",
                    "43.2469;10.59482",
                    "43.246;10.5947",
                    "43.24573;10.59486",
                    "43.24546;10.59403",
                    "43.24494;10.59248",
                    "43.24462;10.59235",
                    "43.2437;10.59241",
                    "43.2436;10.59213",
                    "43.24334;10.59204",
                    "43.24304;10.58853",
                    "43.2426;10.5881",
                    "43.24252;10.58726",
                    "43.24283;10.587",
                    "43.24285;10.58598",
                    "43.24243;10.58239",
                    "43.23852;10.58313",
                    "43.23835;10.57949",
                    "43.23822;10.5792",
                    "43.2381;10.57898",
                    "43.23722;10.57243",
                    "43.23692;10.57018",
                    "43.23572;10.56149",
                    "43.23488;10.55552",
                    "43.23394;10.55557",
                    "43.23337;10.55602",
                    "43.2327;10.55676",
                    "43.2305;10.55767",
                    "43.22861;10.55847",
                    "43.22601;10.55999",
                    "43.22636;10.56241",
                    "43.22769;10.57183",
                    "43.22934;10.58327",
                    "43.23018;10.58921",
                    "43.2318;10.6007",
                    "43.23285;10.60802",
                    "43.23351;10.61259",
                    "43.23393;10.61673",
                    "43.23326;10.617",
                    "43.23289;10.61807",
                    "43.23287;10.61822",
                    "43.2329;10.61864",
                    "43.23276;10.6197",
                    "43.23284;10.61976",
                    "43.23382;10.61913",
                    "43.23369;10.61898",
                    "43.23387;10.61892",
                    "43.23406;10.61886",
                    "43.23413;10.61818",
                    "43.23417;10.61739",
                    "43.23407;10.61728",
                    "43.23398;10.6172",
                    "43.23395;10.61709",
                    "43.23393;10.61673",
                    "43.23333;10.61131",
                    "43.23353;10.61039",
                    "43.23531;10.6107",
                    "43.23579;10.61071",
                    "43.23643;10.60981",
                    "43.23704;10.60903",
                    "43.23782;10.60856",
                    "43.23932;10.60812",
                    "43.24132;10.60593",
                    "43.24166;10.6051",
                    "43.24222;10.60457",
                    "43.24341;10.60315",
                    "43.24388;10.60242",
                    "43.24453;10.60198",
                    "43.24509;10.60112",
                    "43.24527;10.60035",
                    "43.2454;10.59918",
                    "43.24542;10.59851",
                    "43.24577;10.59708",
                    "43.24587;10.59633",
                    "43.24572;10.59492",
                    "43.24589;10.59472",
                    "43.24666;10.5948",
                    "43.24726;10.59493",
                    "43.24757;10.59517",
                    "43.24785;10.59556",
                    "43.24819;10.59588",
                    "43.24844;10.59622",
                    "43.24889;10.59625",
                    "43.25035;10.59623",
                    "43.25074;10.5962",
                    "43.25128;10.59602",
                    "43.25252;10.59577",
                    "43.2529;10.59572",
                    "43.25336;10.59516",
                    "43.25423;10.59473",
                    "43.25517;10.59449",
                    "43.25579;10.59432",
                    "43.2567;10.59355",
                    "43.25729;10.59345",
                    "43.25797;10.59385",
                    "43.25928;10.595",
                    "43.25959;10.59499",
                    "43.26006;10.59454",
                    "43.26054;10.59545",
                    "43.2605;10.59597",
                    "43.26057;10.59668",
                    "43.2617;10.59806",
                    "43.26313;10.59906",
                    "43.2646;10.59859",
                    "43.2654;10.59857",
                    "43.26561;10.59852",
                    "43.26549;10.59814",
                    "43.26532;10.59742",
                    "43.26534;10.59586",
                    "43.26586;10.59581",
                    "43.26588;10.59573",
                    "43.26608;10.59454"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/23cfc97a-e4c3-4d81-8dd5-221455b47227.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/3eaa37a0-1975-4ac3-8fd1-a92b6d3e043c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b8646203-cca9-4cbc-a234-083e305f540d.jpeg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c74bca34-4dc3-42cc-961d-5b02233e1493.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ef8ffc24-7a0e-4c6b-aeb9-e30ea3a9a34e.jpg"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 26712
                }
            }
        ],
        "catalogue": [
            {
                "id": 104,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 105,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1354,
        "customer": {
            "id": 34,
            "title": "Padbike",
            "description": "Padbike, a tour operator based in Florence, specialized in designing and organizing E-Bike travel experiences.\r\nIn 2024 it opened an in-house Software & Development division for the development of Outdoora.",
            "color": "#404040",
            "theme_dark": true,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Padbike.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/provaRisorsa_1.png"
            ],
            "contacts": {
                "address": "Via dei Renai, 13, Via dei Renai, 13, 50125 Firenze FI, Italia",
                "email": "padbikeapp@gmail.com",
                "phone": "+393888353749"
            },
            "coordinate": {
                "latitude": 43.76491,
                "longitude": 11.25982
            },
            "tours": 12,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/21851540-c174-42ce-9ec2-d50341a79f83.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/389e886d-2941-43cc-bc89-86cfd16f0c82.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8aa350b2-3694-4348-ac22-b832c90da9c1.jpg"
            ]
        },
        "title": "Sellaronda Bike Tour",
        "description": "Il Sellaronda in MTB \u00e8 uno dei tour pi\u00f9 spettacolari delle Dolomiti, un anello panoramico che gira attorno al massiccio del Sella, attraversando quattro passi alpini: Gardena, Campolongo, Pordoi e Sella. Il percorso pu\u00f2 essere affrontato in senso orario o antiorario e combina tratti pedalati con l'utilizzo di impianti di risalita (bikepass necessario), rendendolo accessibile anche ai biker meno allenati.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1354.jpg",
        "price": 25.0,
        "location": "Dolomiti",
        "location_id": 2,
        "tags": [
            "Natura",
            "Montagne"
        ],
        "routes": [
            {
                "id": 1387,
                "title": "Sellaronda Bike Tour",
                "description": "Il Sellaronda in MTB \u00e8 uno dei tour pi\u00f9 spettacolari delle Dolomiti, un anello panoramico che gira attorno al massiccio del Sella, attraversando quattro passi alpini: Gardena, Campolongo, Pordoi e Sella.",
                "notes": "",
                "start_address": "BikeRS",
                "difficulty": "Hard",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    46.55642,
                    11.7547
                ],
                "preview_track": [
                    "46.55642;11.7547",
                    "46.55652;11.75449",
                    "46.55667;11.75388",
                    "46.55665;11.75431",
                    "46.55663;11.75483",
                    "46.55716;11.75633",
                    "46.55775;11.75727",
                    "46.55784;11.75786",
                    "46.55771;11.75842",
                    "46.55749;11.7587",
                    "46.55697;11.75893",
                    "46.55597;11.75908",
                    "46.55538;11.75926",
                    "46.5552;11.75935",
                    "46.5548;11.7598",
                    "46.55402;11.76128",
                    "46.55386;11.76181",
                    "46.55381;11.7623",
                    "46.55373;11.76322",
                    "46.55371;11.76354",
                    "46.5548;11.76315",
                    "46.55572;11.76349",
                    "46.55602;11.76476",
                    "46.55609;11.76652",
                    "46.55619;11.76724",
                    "46.55603;11.76771",
                    "46.5561;11.76793",
                    "46.55601;11.76815",
                    "46.55565;11.76798",
                    "46.55395;11.79992",
                    "46.55408;11.80047",
                    "46.55402;11.80105",
                    "46.55434;11.80136",
                    "46.55439;11.80167",
                    "46.55429;11.80221",
                    "46.55421;11.80249",
                    "46.55408;11.80241",
                    "46.55395;11.80206",
                    "46.55406;11.80169",
                    "46.5538;11.8021",
                    "46.55379;11.80181",
                    "46.55363;11.80165",
                    "46.55361;11.80237",
                    "46.55373;11.80282",
                    "46.5536;11.80268",
                    "46.55366;11.80313",
                    "46.55347;11.8033",
                    "46.55333;11.803",
                    "46.55333;11.80364",
                    "46.55323;11.80392",
                    "46.55274;11.80321",
                    "46.55265;11.80337",
                    "46.5525;11.80321",
                    "46.55239;11.80282",
                    "46.55208;11.80232",
                    "46.55174;11.80244",
                    "46.55215;11.80291",
                    "46.55216;11.80303",
                    "46.55208;11.80336",
                    "46.55215;11.80373",
                    "46.55209;11.80407",
                    "46.55206;11.8042",
                    "46.55195;11.80438",
                    "46.55188;11.80455",
                    "46.55186;11.80426",
                    "46.55165;11.80409",
                    "46.55129;11.80426",
                    "46.55095;11.80455",
                    "46.55075;11.80491",
                    "46.55059;11.80515",
                    "46.55074;11.80522",
                    "46.55065;11.80534",
                    "46.55074;11.80559",
                    "46.55086;11.80586",
                    "46.55071;11.80613",
                    "46.5505;11.80594",
                    "46.5504;11.80634",
                    "46.55019;11.80674",
                    "46.55009;11.80662",
                    "46.55005;11.80718",
                    "46.55;11.80798",
                    "46.54981;11.80843",
                    "46.54987;11.80883",
                    "46.55022;11.8093",
                    "46.55035;11.80946",
                    "46.55061;11.80981",
                    "46.55037;11.81024",
                    "46.54983;11.81092",
                    "46.5496;11.81148",
                    "46.54964;11.81192",
                    "46.55002;11.81221",
                    "46.55019;11.81275",
                    "46.55043;11.81315",
                    "46.54995;11.81319",
                    "46.54924;11.81355",
                    "46.54898;11.81415",
                    "46.54892;11.81437",
                    "46.54891;11.81496",
                    "46.54856;11.8163",
                    "46.54842;11.81687",
                    "46.54829;11.81693",
                    "46.54818;11.81709",
                    "46.54804;11.81702",
                    "46.54793;11.81714",
                    "46.54784;11.81719",
                    "46.54777;11.81793",
                    "46.54722;11.81887",
                    "46.54722;11.81887",
                    "46.54699;11.81948",
                    "46.54665;11.82003",
                    "46.54681;11.82063",
                    "46.5469;11.8211",
                    "46.54713;11.82145",
                    "46.54747;11.8219",
                    "46.54782;11.82211",
                    "46.54767;11.82238",
                    "46.54773;11.82244",
                    "46.54773;11.82258",
                    "46.54739;11.82264",
                    "46.54737;11.82293",
                    "46.54762;11.82319",
                    "46.54779;11.82331",
                    "46.54772;11.8234",
                    "46.54769;11.82358",
                    "46.54797;11.8239",
                    "46.54837;11.8243",
                    "46.54851;11.82429",
                    "46.54875;11.8244",
                    "46.54916;11.82475",
                    "46.54948;11.82487",
                    "46.54924;11.82525",
                    "46.54907;11.82536",
                    "46.54889;11.82553",
                    "46.54924;11.82584",
                    "46.54918;11.82602",
                    "46.54927;11.82639",
                    "46.54935;11.82678",
                    "46.54881;11.82675",
                    "46.54797;11.82687",
                    "46.54796;11.82733",
                    "46.54841;11.82824",
                    "46.54847;11.82841",
                    "46.54849;11.82886",
                    "46.54847;11.82903",
                    "46.54858;11.82926",
                    "46.54881;11.82992",
                    "46.54877;11.83073",
                    "46.54886;11.83154",
                    "46.54871;11.83205",
                    "46.5485;11.83207",
                    "46.54855;11.83244",
                    "46.54869;11.83286",
                    "46.54882;11.83337",
                    "46.54884;11.83405",
                    "46.54873;11.83445",
                    "46.5487;11.83498",
                    "46.54875;11.83579",
                    "46.54872;11.83729",
                    "46.5487;11.83761",
                    "46.54863;11.83827",
                    "46.54862;11.83876",
                    "46.54855;11.83956",
                    "46.5484;11.83923",
                    "46.54791;11.84005",
                    "46.54742;11.84017",
                    "46.54744;11.84049",
                    "46.54747;11.84102",
                    "46.54763;11.84154",
                    "46.54823;11.84231",
                    "46.54926;11.8439",
                    "46.54989;11.84457",
                    "46.54988;11.84504",
                    "46.55003;11.84532",
                    "46.55048;11.84575",
                    "46.55109;11.84762",
                    "46.55063;11.85105",
                    "46.5506;11.85175",
                    "46.55018;11.8525",
                    "46.55005;11.85306",
                    "46.55018;11.8537",
                    "46.5502;11.85444",
                    "46.55023;11.85481",
                    "46.55053;11.85558",
                    "46.55055;11.85586",
                    "46.55039;11.85617",
                    "46.55047;11.85662",
                    "46.55048;11.85712",
                    "46.55047;11.8575",
                    "46.55048;11.85819",
                    "46.55068;11.8588",
                    "46.55083;11.85941",
                    "46.5508;11.85979",
                    "46.55067;11.85959",
                    "46.55049;11.85939",
                    "46.55034;11.85927",
                    "46.55023;11.85894",
                    "46.55005;11.85878",
                    "46.5498;11.85869",
                    "46.54978;11.85887",
                    "46.54976;11.85909",
                    "46.54946;11.85994",
                    "46.5493;11.86153",
                    "46.54912;11.86337",
                    "46.5487;11.86547",
                    "46.54859;11.86686",
                    "46.54851;11.86742",
                    "46.5484;11.86762",
                    "46.54831;11.86805",
                    "46.54846;11.86797",
                    "46.54828;11.86937",
                    "46.54808;11.87034",
                    "46.54793;11.87101",
                    "46.54775;11.87189",
                    "46.5478;11.87207",
                    "46.54705;11.87326",
                    "46.54699;11.87349",
                    "46.5468;11.87454",
                    "46.54689;11.87513",
                    "46.54721;11.87514",
                    "46.54766;11.87534",
                    "46.54797;11.8761",
                    "46.54763;11.87636",
                    "46.55296;11.88668",
                    "46.55354;11.88746",
                    "46.55343;11.88768",
                    "46.55299;11.88767",
                    "46.55205;11.88771",
                    "46.55175;11.88787",
                    "46.5514;11.88853",
                    "46.55171;11.88914",
                    "46.55228;11.8894",
                    "46.55277;11.88955",
                    "46.5534;11.89009",
                    "46.55366;11.89068",
                    "46.5521;11.90683",
                    "46.55182;11.90668",
                    "46.55118;11.90628",
                    "46.55113;11.90688",
                    "46.55081;11.90733",
                    "46.55077;11.90772",
                    "46.55084;11.90843",
                    "46.55067;11.90837",
                    "46.55021;11.90822",
                    "46.54992;11.90819",
                    "46.54941;11.90803",
                    "46.54896;11.90816",
                    "46.54854;11.90858",
                    "46.54822;11.9088",
                    "46.54815;11.90912",
                    "46.54768;11.90922",
                    "46.54754;11.90963",
                    "46.54747;11.90987",
                    "46.54751;11.91019",
                    "46.54732;11.91004",
                    "46.54712;11.91015",
                    "46.54683;11.9101",
                    "46.54608;11.91083",
                    "46.54564;11.91165",
                    "46.5454;11.91276",
                    "46.54486;11.91343",
                    "46.54356;11.91428",
                    "46.54305;11.91477",
                    "46.54237;11.91488",
                    "46.54207;11.9149",
                    "46.5417;11.91462",
                    "46.54127;11.91464",
                    "46.54063;11.91484",
                    "46.5398;11.91554",
                    "46.53889;11.91643",
                    "46.5386;11.9168",
                    "46.53802;11.91719",
                    "46.53767;11.91689",
                    "46.53693;11.91687",
                    "46.5365;11.9169",
                    "46.53602;11.91661",
                    "46.53544;11.91611",
                    "46.53508;11.91613",
                    "46.53462;11.91634",
                    "46.5341;11.91626",
                    "46.53392;11.9162",
                    "46.53387;11.91663",
                    "46.53373;11.91683",
                    "46.53384;11.91625",
                    "46.53395;11.91623",
                    "46.53406;11.91575",
                    "46.53374;11.91522",
                    "46.53371;11.91484",
                    "46.5337;11.91429",
                    "46.53396;11.91373",
                    "46.53405;11.91352",
                    "46.53344;11.91173",
                    "46.53349;11.91084",
                    "46.53333;11.91015",
                    "46.53294;11.90975",
                    "46.53383;11.90778",
                    "46.53379;11.90751",
                    "46.53365;11.9077",
                    "46.53349;11.90772",
                    "46.53349;11.90763",
                    "46.5336;11.90746",
                    "46.53356;11.90706",
                    "46.53348;11.90697",
                    "46.53336;11.90727",
                    "46.53317;11.90706",
                    "46.53304;11.90684",
                    "46.53295;11.90678",
                    "46.53282;11.90697",
                    "46.53269;11.9068",
                    "46.53266;11.90659",
                    "46.53283;11.90632",
                    "46.53273;11.90634",
                    "46.53282;11.90608",
                    "46.53263;11.90603",
                    "46.53266;11.90585",
                    "46.53256;11.90547",
                    "46.53262;11.90512",
                    "46.53253;11.90496",
                    "46.53245;11.9048",
                    "46.53227;11.90462",
                    "46.53228;11.90436",
                    "46.53216;11.90435",
                    "46.53192;11.90434",
                    "46.53171;11.90432",
                    "46.53145;11.90439",
                    "46.53141;11.90431",
                    "46.53133;11.90425",
                    "46.53136;11.90405",
                    "46.53136;11.90399",
                    "46.53105;11.90376",
                    "46.53069;11.90357",
                    "46.53055;11.90361",
                    "46.53047;11.90373",
                    "46.53037;11.90331",
                    "46.53026;11.90292",
                    "46.53008;11.90259",
                    "46.52994;11.90207",
                    "46.52985;11.90199",
                    "46.52969;11.90182",
                    "46.53002;11.90116",
                    "46.53031;11.90068",
                    "46.53045;11.90026",
                    "46.53054;11.90037",
                    "46.53056;11.90057",
                    "46.53076;11.90044",
                    "46.53085;11.90032",
                    "46.53075;11.90014",
                    "46.53094;11.90022",
                    "46.53089;11.89998",
                    "46.53079;11.89989",
                    "46.53107;11.89977",
                    "46.53111;11.89955",
                    "46.53116;11.89942",
                    "46.53115;11.89928",
                    "46.53078;11.89801",
                    "46.53091;11.89732",
                    "46.53061;11.89694",
                    "46.53066;11.8965",
                    "46.53079;11.89623",
                    "46.53054;11.8959",
                    "46.53054;11.89564",
                    "46.53059;11.89524",
                    "46.53082;11.89517",
                    "46.53085;11.89483",
                    "46.53092;11.89447",
                    "46.53078;11.89414",
                    "46.53068;11.89367",
                    "46.53064;11.89402",
                    "46.53058;11.89392",
                    "46.53047;11.89416",
                    "46.5303;11.89349",
                    "46.52997;11.89305",
                    "46.52994;11.89266",
                    "46.52945;11.89272",
                    "46.5294;11.89233",
                    "46.5295;11.89151",
                    "46.52867;11.88982",
                    "46.52848;11.88798",
                    "46.52791;11.88625",
                    "46.52749;11.88554",
                    "46.52717;11.88475",
                    "46.52617;11.88452",
                    "46.52527;11.88387",
                    "46.52468;11.88351",
                    "46.52442;11.88312",
                    "46.52391;11.88174",
                    "46.52309;11.88084",
                    "46.52254;11.87983",
                    "46.52205;11.87864",
                    "46.52158;11.8777",
                    "46.52109;11.87686",
                    "46.52095;11.87624",
                    "46.52043;11.87505",
                    "46.52024;11.87514",
                    "46.52034;11.87489",
                    "46.52024;11.87468",
                    "46.5201;11.87413",
                    "46.52003;11.87405",
                    "46.51932;11.87387",
                    "46.5193;11.87377",
                    "46.51925;11.87341",
                    "46.51925;11.87249",
                    "46.51964;11.87175",
                    "46.5129;11.86384",
                    "46.51244;11.86381",
                    "46.51213;11.86378",
                    "46.51231;11.86361",
                    "46.51211;11.86342",
                    "46.51222;11.86322",
                    "46.51186;11.86334",
                    "46.51182;11.86312",
                    "46.51204;11.86249",
                    "46.51209;11.862",
                    "46.51227;11.86137",
                    "46.51228;11.86063",
                    "46.5123;11.86021",
                    "46.51239;11.86005",
                    "46.51233;11.85992",
                    "46.51227;11.85973",
                    "46.51235;11.85944",
                    "46.51234;11.85942",
                    "46.51228;11.85944",
                    "46.5122;11.85937",
                    "46.51204;11.85892",
                    "46.51203;11.85859",
                    "46.512;11.85822",
                    "46.51185;11.85765",
                    "46.51158;11.85772",
                    "46.51118;11.85751",
                    "46.51091;11.85763",
                    "46.51084;11.8579",
                    "46.51079;11.85822",
                    "46.51069;11.85788",
                    "46.51059;11.85834",
                    "46.51052;11.85847",
                    "46.51043;11.85866",
                    "46.50983;11.85972",
                    "46.50962;11.85917",
                    "46.50935;11.85953",
                    "46.509;11.8595",
                    "46.50861;11.85894",
                    "46.50843;11.8587",
                    "46.50832;11.85922",
                    "46.50821;11.85935",
                    "46.50813;11.85879",
                    "46.50795;11.85879",
                    "46.50777;11.85886",
                    "46.5077;11.85898",
                    "46.50765;11.85913",
                    "46.50753;11.85929",
                    "46.50736;11.85975",
                    "46.50731;11.85997",
                    "46.50715;11.85971",
                    "46.50699;11.85982",
                    "46.50693;11.85986",
                    "46.50688;11.8599",
                    "46.50683;11.85979",
                    "46.50664;11.85969",
                    "46.50664;11.85969",
                    "46.50621;11.86046",
                    "46.50592;11.86087",
                    "46.50607;11.86161",
                    "46.50574;11.86291",
                    "46.5054;11.86477",
                    "46.50551;11.86499",
                    "46.50495;11.866",
                    "46.50461;11.86664",
                    "46.50428;11.86715",
                    "46.50385;11.86837",
                    "46.5038;11.86903",
                    "46.50283;11.87",
                    "46.5022;11.87089",
                    "46.50159;11.87231",
                    "46.50062;11.87315",
                    "46.50054;11.87398",
                    "46.501;11.87434",
                    "46.49954;11.87458",
                    "46.49897;11.87485",
                    "46.49872;11.87472",
                    "46.49813;11.87447",
                    "46.49784;11.8745",
                    "46.49729;11.87423",
                    "46.49715;11.87376",
                    "46.49654;11.87335",
                    "46.49641;11.87306",
                    "46.49584;11.87311",
                    "46.49595;11.87355",
                    "46.49575;11.87389",
                    "46.49566;11.87417",
                    "46.49556;11.8746",
                    "46.47301;11.86721",
                    "46.47278;11.86728",
                    "46.47275;11.86618",
                    "46.47353;11.86549",
                    "46.47373;11.8668",
                    "46.47425;11.8677",
                    "46.47501;11.86899",
                    "46.47516;11.86856",
                    "46.47546;11.86663",
                    "46.47562;11.86633",
                    "46.4754;11.86545",
                    "46.47566;11.86538",
                    "46.47602;11.8655",
                    "46.47659;11.86581",
                    "46.47669;11.86621",
                    "46.47686;11.86752",
                    "46.47683;11.86837",
                    "46.47744;11.86982",
                    "46.47798;11.87033",
                    "46.47814;11.87053",
                    "46.47877;11.86949",
                    "46.47902;11.86881",
                    "46.47918;11.86873",
                    "46.47934;11.86805",
                    "46.47958;11.86786",
                    "46.47982;11.86749",
                    "46.48037;11.86732",
                    "46.48061;11.86711",
                    "46.48093;11.86622",
                    "46.48125;11.86662",
                    "46.48134;11.86676",
                    "46.48153;11.86641",
                    "46.48167;11.86661",
                    "46.48196;11.86612",
                    "46.4821;11.86598",
                    "46.48243;11.86633",
                    "46.483;11.8665",
                    "46.48373;11.86624",
                    "46.48373;11.86653",
                    "46.4836;11.86597",
                    "46.48344;11.86298",
                    "46.48287;11.86047",
                    "46.48304;11.85967",
                    "46.48415;11.85664",
                    "46.48587;11.856",
                    "46.48605;11.85518",
                    "46.48596;11.85471",
                    "46.48554;11.8527",
                    "46.48549;11.85169",
                    "46.4855;11.85109",
                    "46.48576;11.85054",
                    "46.48601;11.84821",
                    "46.48583;11.84711",
                    "46.48626;11.84613",
                    "46.48672;11.84477",
                    "46.48737;11.84525",
                    "46.48787;11.84511",
                    "46.4881;11.84446",
                    "46.488;11.81486",
                    "46.48764;11.81404",
                    "46.48741;11.81355",
                    "46.48742;11.81296",
                    "46.48742;11.81296",
                    "46.48754;11.81223",
                    "46.48764;11.81202",
                    "46.48736;11.81127",
                    "46.4874;11.81043",
                    "46.48753;11.80977",
                    "46.48772;11.8092",
                    "46.48779;11.80899",
                    "46.48776;11.80776",
                    "46.48768;11.80715",
                    "46.48763;11.80656",
                    "46.48763;11.80562",
                    "46.48769;11.8049",
                    "46.48771;11.80473",
                    "46.48773;11.80413",
                    "46.48783;11.80338",
                    "46.48808;11.8022",
                    "46.48774;11.80113",
                    "46.48672;11.80074",
                    "46.48619;11.80069",
                    "46.48601;11.80069",
                    "46.48535;11.80094",
                    "46.48504;11.80065",
                    "46.48499;11.80044",
                    "46.48499;11.79975",
                    "46.48487;11.7995",
                    "46.48493;11.79915",
                    "46.48469;11.79911",
                    "46.48481;11.79897",
                    "46.48468;11.79882",
                    "46.48459;11.79865",
                    "46.48449;11.79765",
                    "46.48441;11.79679",
                    "46.48441;11.79679",
                    "46.48354;11.79504",
                    "46.48391;11.79431",
                    "46.48396;11.79354",
                    "46.48379;11.79249",
                    "46.48393;11.79137",
                    "46.48402;11.79055",
                    "46.48392;11.79071",
                    "46.48418;11.79081",
                    "46.485;11.79164",
                    "46.48575;11.79091",
                    "46.48586;11.79073",
                    "46.48627;11.79123",
                    "46.48645;11.79086",
                    "46.48639;11.79059",
                    "46.48633;11.79019",
                    "46.48648;11.78983",
                    "46.48669;11.78981",
                    "46.48667;11.78948",
                    "46.4863;11.78897",
                    "46.48612;11.7886",
                    "46.4863;11.7883",
                    "46.48704;11.78837",
                    "46.48826;11.7886",
                    "46.48906;11.78803",
                    "46.48926;11.78799",
                    "46.48985;11.78785",
                    "46.4908;11.78773",
                    "46.49146;11.78692",
                    "46.49173;11.78684",
                    "46.49342;11.78683",
                    "46.49277;11.78612",
                    "46.49154;11.78504",
                    "46.49062;11.7851",
                    "46.49075;11.78422",
                    "46.49101;11.7826",
                    "46.49137;11.78255",
                    "46.49151;11.78219",
                    "46.49185;11.78196",
                    "46.49289;11.782",
                    "46.4927;11.78159",
                    "46.49231;11.78125",
                    "46.49237;11.78104",
                    "46.50255;11.75186",
                    "46.50291;11.75157",
                    "46.50334;11.75181",
                    "46.50389;11.75203",
                    "46.50438;11.75289",
                    "46.50517;11.75459",
                    "46.50591;11.75587",
                    "46.50603;11.75647",
                    "46.50607;11.7568",
                    "46.50626;11.75703",
                    "46.50665;11.75719",
                    "46.50678;11.75716",
                    "46.5066;11.75707",
                    "46.50691;11.75705",
                    "46.50754;11.7563",
                    "46.50811;11.7557",
                    "46.50831;11.75529",
                    "46.50857;11.75503",
                    "46.50925;11.75459",
                    "46.5094;11.75409",
                    "46.50987;11.75351",
                    "46.51036;11.75274",
                    "46.51077;11.75221",
                    "46.51175;11.7513",
                    "46.51233;11.75182",
                    "46.51288;11.75252",
                    "46.51325;11.75259",
                    "46.51388;11.75264",
                    "46.51485;11.75282",
                    "46.51576;11.75291",
                    "46.51633;11.75255",
                    "46.51696;11.75213",
                    "46.51749;11.75216",
                    "46.51803;11.75202",
                    "46.51853;11.75167",
                    "46.51872;11.75097",
                    "46.51913;11.75067",
                    "46.5194;11.75043",
                    "46.51947;11.75048",
                    "46.51929;11.75102",
                    "46.51914;11.75118",
                    "46.51923;11.75123",
                    "46.51939;11.751",
                    "46.51945;11.751",
                    "46.5194;11.75122",
                    "46.51934;11.75149",
                    "46.51935;11.75215",
                    "46.51919;11.75271",
                    "46.51899;11.75286",
                    "46.51897;11.75324",
                    "46.51894;11.75353",
                    "46.51909;11.75372",
                    "46.51906;11.75403",
                    "46.51918;11.75433",
                    "46.51932;11.75489",
                    "46.51948;11.75545",
                    "46.51945;11.75641",
                    "46.51966;11.75659",
                    "46.5198;11.75732",
                    "46.52015;11.75755",
                    "46.52013;11.75714",
                    "46.52097;11.75793",
                    "46.52115;11.75724",
                    "46.52124;11.75714",
                    "46.52159;11.75741",
                    "46.52199;11.75791",
                    "46.52184;11.75739",
                    "46.52176;11.7569",
                    "46.52187;11.75716",
                    "46.522;11.75711",
                    "46.52256;11.75777",
                    "46.52296;11.75861",
                    "46.52323;11.75933",
                    "46.52313;11.75836",
                    "46.52297;11.75749",
                    "46.52289;11.75739",
                    "46.523;11.7574",
                    "46.52309;11.75766",
                    "46.52321;11.75757",
                    "46.52289;11.75686",
                    "46.52298;11.7567",
                    "46.52385;11.75676",
                    "46.52449;11.75556",
                    "46.52463;11.75619",
                    "46.52435;11.75695",
                    "46.52452;11.75677",
                    "46.52449;11.75707",
                    "46.52461;11.75713",
                    "46.52487;11.75723",
                    "46.5248;11.75748",
                    "46.52442;11.75756",
                    "46.5247;11.75771",
                    "46.52489;11.75828",
                    "46.5251;11.75896",
                    "46.52538;11.75916",
                    "46.52554;11.75908",
                    "46.52587;11.75901",
                    "46.52632;11.75945",
                    "46.52674;11.7587",
                    "46.52692;11.75891",
                    "46.52754;11.75986",
                    "46.5278;11.76028",
                    "46.52817;11.76102",
                    "46.52819;11.7613",
                    "46.52818;11.76135",
                    "46.5285;11.76136",
                    "46.52856;11.76081",
                    "46.52846;11.76069",
                    "46.52884;11.76093",
                    "46.52909;11.76198",
                    "46.52921;11.76251",
                    "46.52905;11.76289",
                    "46.52938;11.76267",
                    "46.52959;11.7616",
                    "46.5297;11.76223",
                    "46.52977;11.76322",
                    "46.52972;11.76351",
                    "46.52989;11.76272",
                    "46.53004;11.76297",
                    "46.53014;11.76382",
                    "46.53029;11.76336",
                    "46.5304;11.7626",
                    "46.53064;11.76321",
                    "46.53101;11.76387",
                    "46.53103;11.76449",
                    "46.53135;11.76611",
                    "46.53168;11.7666",
                    "46.53134;11.76731",
                    "46.53064;11.76877",
                    "46.53039;11.7694",
                    "46.53055;11.76926",
                    "46.53049;11.76946",
                    "46.53071;11.76912",
                    "46.53108;11.76961",
                    "46.53072;11.77035",
                    "46.53063;11.77064",
                    "46.53045;11.77124",
                    "46.53077;11.77109",
                    "46.53104;11.77079",
                    "46.5312;11.77066",
                    "46.53109;11.77096",
                    "46.53126;11.77101",
                    "46.53159;11.77062",
                    "46.5317;11.77042",
                    "46.53179;11.77033",
                    "46.53177;11.77062",
                    "46.53167;11.77085",
                    "46.53172;11.77097",
                    "46.53192;11.77066",
                    "46.53217;11.77027",
                    "46.53231;11.77042",
                    "46.53241;11.77061",
                    "46.53278;11.77097",
                    "46.53255;11.77154",
                    "46.53263;11.77181",
                    "46.53326;11.77177",
                    "46.53338;11.77214",
                    "46.53367;11.77227",
                    "46.53424;11.77196",
                    "46.53472;11.7717",
                    "46.53472;11.77148",
                    "46.53534;11.77101",
                    "46.53573;11.77066",
                    "46.536;11.77058",
                    "46.53636;11.7701",
                    "46.53675;11.76954",
                    "46.5369;11.76929",
                    "46.53697;11.76935",
                    "46.53718;11.76917",
                    "46.53728;11.76897",
                    "46.53732;11.76887",
                    "46.5374;11.7688",
                    "46.53772;11.76924",
                    "46.53812;11.76956",
                    "46.53837;11.76961",
                    "46.53904;11.77003",
                    "46.53994;11.77027",
                    "46.54111;11.76987",
                    "46.54232;11.76995",
                    "46.54258;11.76969",
                    "46.54423;11.76916",
                    "46.54456;11.76896",
                    "46.54555;11.7683",
                    "46.54615;11.76755",
                    "46.54659;11.76791",
                    "46.54733;11.76744",
                    "46.54745;11.76773",
                    "46.54902;11.76671",
                    "46.55012;11.76596",
                    "46.55036;11.76552",
                    "46.55065;11.76459",
                    "46.55145;11.76359",
                    "46.55195;11.76348",
                    "46.55247;11.76346",
                    "46.55307;11.76334",
                    "46.55329;11.7625",
                    "46.5535;11.76158",
                    "46.55363;11.761",
                    "46.55384;11.76005",
                    "46.55406;11.7591",
                    "46.55434;11.75856",
                    "46.5548;11.7578",
                    "46.55545;11.75671",
                    "46.55605;11.75569",
                    "46.55635;11.75512",
                    "46.55642;11.7547"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9895224b-fa6d-4c2d-bf6e-3f96d63a32e1.JPG",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c42e0420-1d5b-4dd0-9045-eee323868529.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9d80a354-c798-4422-be1b-a4aac789a4bf.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5cc5753c-b0f8-414c-ad26-bf5334048d00.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Passo Gardena",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/18a50595-c704-4dcd-922e-72dd9f16421e.downl__46_55034626619222_11_809459179639818",
                        "latitude": 46.55034626619222,
                        "longitude": 11.809459179639818,
                        "description": "Il Passo Gardena, a 2.136 metri, collega la Val Gardena con l\u2019Alta Badia, offrendo panorami spettacolari sulle Dolomiti"
                    },
                    {
                        "name": "Passo Pordoi",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/8be2cd7d-56c7-4b9c-a116-89d191113cc7.downl__46_48741645583951_11_812908835709097",
                        "latitude": 46.48741645583951,
                        "longitude": 11.812908835709097,
                        "description": "Il Passo Pordoi, a 2.239 metri, collega la Val di Fassa con Arabba, regalando viste mozzafiato sul Gruppo del Sella e le Dolomiti circostanti."
                    },
                    {
                        "name": "Rifugio Ciampolin",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/7e0c7ab2-4a99-440f-9679-dc20aa6c9111.downl__46_48382225291293_11_79059931077063",
                        "latitude": 46.48382225291293,
                        "longitude": 11.79059931077063,
                        "description": "In questo rifugio di montagna potrete gustare numerose specialit\u00e0 alto adesine! Consigliamo lo Stinco di Maiele come secondo o le tagliatelle ai finferli o di cervo"
                    }
                ],
                "infos": {
                    "distance": 58560
                }
            }
        ],
        "catalogue": [
            {
                "id": 47,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 48,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1519,
        "customer": {
            "id": 364,
            "title": "BYE BIKE",
            "description": "Byebike \u00e8 un noleggio bici a Montepulciano specializzato in e-bike (trekking ed e-mtb) e gravel, ideale per esplorare la Val d\u2019Orcia e le colline senesi \u201ca portata di pedale\u201d. Oltre al rent, propone itinerari fai-da-te con descrizione e mappa, e tour assistiti/ con guida per vivere la giornata senza pensieri, anche con percorsi personalizzati. Su richiesta offre consegna e ritiro nelle zone circostanti, recupero anticipato in caso di imprevisti, e accessori; casco, lucchetto e kit riparazione sono inclusi.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/BYE_BIKE.jpeg",
            "text_logo": null,
            "contacts": {
                "address": "Via delle Lettere, 18, Via delle Lettere, 18, 53045 Montepulciano SI, Italia",
                "email": "info@bye.bike",
                "phone": "392 2142493"
            },
            "coordinate": {
                "latitude": 43.09706,
                "longitude": 11.78775
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/20c55365-3a52-41b0-bb81-80f738470000.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/514fd4aa-b432-4b01-ad57-2ac4ddb0dab9.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/bafca40e-1622-4c40-951e-55a38280d836.jpg"
            ]
        },
        "title": "Montepulciano & Val d'Orcia E-Bike Tour",
        "description": "Anello facile in e-bike da Montepulciano di circa 31 km, tra strade bianche in buone condizioni, vigneti e colline della Val d\u2019Orcia.\nTappe highlight: Chiesa di San Biagio, punto panoramico con vista fino al Monte Amiata e discesa scenografica tra cipressi verso Monticchiello.\nTour modulabile: poche ore oppure giornata intera con soste nel borgo, pranzo e degustazioni (Podere Il Casale, Cantine Capitoni e Fabbrica) e rientro via Poggiano.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1519.png",
        "price": 25.0,
        "location": "Val d'Orcia",
        "location_id": 36,
        "tags": [
            "Natura",
            "Citt\u00e0"
        ],
        "routes": [
            {
                "id": 1552,
                "title": "Montepulciano & Monticchiello E-bike Tour",
                "description": "* Dopo la prenotazione: scarica l\u2019app Outdoora e sblocca il tour (troverai traccia, navigazione e punti di interesse).\n\n* Giorno del tour: arrivo al nostro e-bike rental a Montepulciano, consegna e-bike + breve briefing su comandi, assistenza e sicurezza.\n\n* Partenza: anello facile e panoramico di circa 31 km su strade bianche carrabili in buone condizioni e brevi tratti di provinciale (varianti pi\u00f9 ripide evitate).\n\n* Prime tappe: Chiesa di San Biagio + pedalata tra cipressi e vigneti lungo Via della Montagna fino a un bel punto panoramico su Val d\u2019Orcia e Monte Amiata.\n\n* Discesa e borghi: discesa scenografica verso Monticchiello (tornanti e filari di cipressi) con sosta consigliata nel borgo (La Guardiola).\n\n* Rientro gourmet: risalita in Val d\u2019Orcia con tappe facoltative (Podere Il Casale, cantine Capitoni/Fabbrica), passaggio da Poggiano con vista su Montepulciano e, se vuoi, ultimo stop al Caseificio Cugusi prima del rientro.\n",
                "notes": "",
                "start_address": "Via delle Lettere, 18, 53045 Montepulciano SI",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1519.png",
                "track": [
                    43.09646,
                    11.78813
                ],
                "preview_track": [
                    "43.09646;11.78813",
                    "43.09663;11.78805",
                    "43.0968;11.78779",
                    "43.09701;11.78737",
                    "43.09704;11.78717",
                    "43.09744;11.78711",
                    "43.09761;11.78711",
                    "43.09812;11.7872",
                    "43.09836;11.78724",
                    "43.09841;11.78731",
                    "43.09847;11.78726",
                    "43.09856;11.78727",
                    "43.09884;11.78717",
                    "43.09921;11.78679",
                    "43.09984;11.78607",
                    "43.10009;11.78589",
                    "43.10042;11.78581",
                    "43.10106;11.78572",
                    "43.10079;11.78591",
                    "43.10046;11.78603",
                    "43.10031;11.78605",
                    "43.10029;11.785",
                    "43.10003;11.7847",
                    "43.09945;11.78423",
                    "43.09907;11.78411",
                    "43.09886;11.78402",
                    "43.0986;11.78377",
                    "43.09852;11.78357",
                    "43.09853;11.7834",
                    "43.09865;11.78324",
                    "43.0989;11.78301",
                    "43.09894;11.78286",
                    "43.0989;11.78269",
                    "43.09859;11.78231",
                    "43.09829;11.78202",
                    "43.09753;11.78088",
                    "43.09712;11.77821",
                    "43.09612;11.77611",
                    "43.09455;11.77461",
                    "43.09226;11.77448",
                    "43.09199;11.77464",
                    "43.09174;11.7747",
                    "43.09153;11.77466",
                    "43.09138;11.77457",
                    "43.09114;11.77422",
                    "43.09102;11.77408",
                    "43.0906;11.77411",
                    "43.09048;11.7742",
                    "43.09043;11.77437",
                    "43.09043;11.77497",
                    "43.09043;11.77501",
                    "43.08742;11.77598",
                    "43.08733;11.77598",
                    "43.08725;11.77608",
                    "43.08684;11.77639",
                    "43.08617;11.77705",
                    "43.08583;11.77743",
                    "43.08488;11.77818",
                    "43.08425;11.77879",
                    "43.08401;11.77898",
                    "43.08376;11.77904",
                    "43.08291;11.77899",
                    "43.08246;11.77907",
                    "43.0821;11.77925",
                    "43.08181;11.77952",
                    "43.08142;11.7801",
                    "43.08077;11.78092",
                    "43.08004;11.78164",
                    "43.07896;11.78211",
                    "43.07764;11.78264",
                    "43.07694;11.78372",
                    "43.07666;11.78462",
                    "43.07614;11.78597",
                    "43.07564;11.7866",
                    "43.07546;11.78691",
                    "43.07522;11.78713",
                    "43.07504;11.78721",
                    "43.07429;11.78549",
                    "43.07327;11.78292",
                    "43.07244;11.78228",
                    "43.07119;11.78258",
                    "43.06916;11.78273",
                    "43.06702;11.78321",
                    "43.06582;11.78399",
                    "43.06073;11.7845",
                    "43.05994;11.78461",
                    "43.05437;11.78199",
                    "43.054;11.78036",
                    "43.05407;11.7774",
                    "43.05293;11.77582",
                    "43.05197;11.77518",
                    "43.05175;11.77393",
                    "43.0513;11.77124",
                    "43.05092;11.76949",
                    "43.05041;11.76351",
                    "43.04992;11.76254",
                    "43.04983;11.76229",
                    "43.0498;11.76098",
                    "43.05023;11.7606",
                    "43.05035;11.7603",
                    "43.05019;11.75916",
                    "43.05036;11.75788",
                    "43.05051;11.75705",
                    "43.05097;11.75614",
                    "43.05159;11.75524",
                    "43.05156;11.75457",
                    "43.05186;11.75345",
                    "43.05297;11.75204",
                    "43.05404;11.74973",
                    "43.05406;11.74829",
                    "43.05562;11.7459",
                    "43.05673;11.74412",
                    "43.05686;11.74338",
                    "43.05718;11.74305",
                    "43.05797;11.74302",
                    "43.05896;11.74182",
                    "43.05961;11.74059",
                    "43.05988;11.73984",
                    "43.06081;11.73833",
                    "43.062;11.73633",
                    "43.06292;11.73497",
                    "43.06272;11.73424",
                    "43.06304;11.73413",
                    "43.06312;11.73372",
                    "43.06253;11.73356",
                    "43.0624;11.73329",
                    "43.06288;11.73259",
                    "43.06338;11.73269",
                    "43.06337;11.73243",
                    "43.06283;11.73142",
                    "43.06288;11.72939",
                    "43.06265;11.72885",
                    "43.06284;11.72804",
                    "43.06271;11.72776",
                    "43.06245;11.72754",
                    "43.06281;11.72718",
                    "43.06284;11.72697",
                    "43.06241;11.72649",
                    "43.06239;11.72564",
                    "43.06311;11.72537",
                    "43.06426;11.7244",
                    "43.06463;11.72274",
                    "43.06559;11.72348",
                    "43.06671;11.7243",
                    "43.06691;11.72457",
                    "43.06709;11.72519",
                    "43.06715;11.72523",
                    "43.06783;11.7246",
                    "43.06722;11.72519",
                    "43.0671;11.72521",
                    "43.06706;11.72513",
                    "43.06686;11.72447",
                    "43.06662;11.72422",
                    "43.06505;11.72306",
                    "43.06429;11.72249",
                    "43.06271;11.72122",
                    "43.06225;11.72036",
                    "43.06223;11.71897",
                    "43.06236;11.71615",
                    "43.06207;11.71499",
                    "43.06143;11.71436",
                    "43.06083;11.71346",
                    "43.05995;11.70914",
                    "43.05978;11.7084",
                    "43.05906;11.70744",
                    "43.05792;11.70358",
                    "43.0568;11.70233",
                    "43.05597;11.70154",
                    "43.05544;11.69948",
                    "43.05419;11.6973",
                    "43.0539;11.69606",
                    "43.053;11.69524",
                    "43.05266;11.6946",
                    "43.05418;11.6951",
                    "43.05583;11.69625",
                    "43.05786;11.69698",
                    "43.05918;11.69803",
                    "43.06109;11.70069",
                    "43.06241;11.70125",
                    "43.06367;11.70172",
                    "43.0666;11.705",
                    "43.06807;11.70616",
                    "43.06795;11.70841",
                    "43.06922;11.71042",
                    "43.07028;11.71205",
                    "43.07094;11.71229",
                    "43.07177;11.71169",
                    "43.07217;11.7107",
                    "43.07265;11.70962",
                    "43.0739;11.70922",
                    "43.07439;11.7078",
                    "43.07543;11.70668",
                    "43.07595;11.70688",
                    "43.07604;11.70767",
                    "43.07668;11.70761",
                    "43.07731;11.70769",
                    "43.07793;11.70748",
                    "43.07865;11.7083",
                    "43.07919;11.70823",
                    "43.07918;11.70912",
                    "43.07905;11.70993",
                    "43.07956;11.70987",
                    "43.07957;11.7106",
                    "43.08002;11.71081",
                    "43.08057;11.71008",
                    "43.08128;11.7096",
                    "43.08256;11.70952",
                    "43.0833;11.70993",
                    "43.0841;11.71014",
                    "43.08537;11.71037",
                    "43.08672;11.71031",
                    "43.08611;11.70903",
                    "43.08577;11.70832",
                    "43.08675;11.71031",
                    "43.08753;11.71047",
                    "43.08908;11.70916",
                    "43.09083;11.70903",
                    "43.09201;11.70891",
                    "43.0929;11.71096",
                    "43.0936;11.71334",
                    "43.09416;11.71417",
                    "43.09519;11.71461",
                    "43.09565;11.7155",
                    "43.09622;11.71624",
                    "43.09754;11.71834",
                    "43.09876;11.71953",
                    "43.10038;11.72037",
                    "43.10095;11.72177",
                    "43.10198;11.72379",
                    "43.1014;11.72549",
                    "43.10097;11.72743",
                    "43.09872;11.73196",
                    "43.09835;11.73475",
                    "43.09853;11.73644",
                    "43.0989;11.73848",
                    "43.09882;11.73943",
                    "43.09881;11.74142",
                    "43.09966;11.74193",
                    "43.10075;11.74338",
                    "43.10063;11.74546",
                    "43.09988;11.74573",
                    "43.09954;11.74615",
                    "43.09846;11.74769",
                    "43.09744;11.74882",
                    "43.09655;11.74892",
                    "43.09576;11.74948",
                    "43.09505;11.75018",
                    "43.09444;11.75165",
                    "43.09323;11.75233",
                    "43.09391;11.75236",
                    "43.09585;11.75158",
                    "43.09855;11.75145",
                    "43.10027;11.75333",
                    "43.10027;11.75333",
                    "43.09855;11.75145",
                    "43.09585;11.75158",
                    "43.09391;11.75236",
                    "43.09323;11.75233",
                    "43.09444;11.75165",
                    "43.09505;11.75018",
                    "43.09576;11.74948",
                    "43.09655;11.74892",
                    "43.0965;11.74851",
                    "43.09667;11.74821",
                    "43.09639;11.74806",
                    "43.09655;11.74789",
                    "43.0964;11.74762",
                    "43.09456;11.74746",
                    "43.09334;11.74743",
                    "43.092;11.74792",
                    "43.09124;11.74819",
                    "43.08997;11.74961",
                    "43.0882;11.75103",
                    "43.08792;11.75308",
                    "43.08791;11.75447",
                    "43.08704;11.75535",
                    "43.08688;11.75666",
                    "43.08693;11.75783",
                    "43.08699;11.75871",
                    "43.08652;11.75996",
                    "43.08694;11.76226",
                    "43.08637;11.76839",
                    "43.08632;11.76897",
                    "43.08636;11.76946",
                    "43.08646;11.77035",
                    "43.08654;11.77186",
                    "43.0865;11.77232",
                    "43.08648;11.77281",
                    "43.08653;11.77319",
                    "43.08661;11.77348",
                    "43.08666;11.77366",
                    "43.08694;11.77444",
                    "43.0871;11.77493",
                    "43.08727;11.77558",
                    "43.08732;11.77585",
                    "43.08731;11.77597",
                    "43.08735;11.77606",
                    "43.08739;11.77622",
                    "43.08746;11.77665",
                    "43.08754;11.77709",
                    "43.08767;11.77747",
                    "43.08777;11.77776",
                    "43.08786;11.77838",
                    "43.08792;11.77866",
                    "43.08812;11.77911",
                    "43.0889;11.78023",
                    "43.08913;11.78065",
                    "43.08924;11.78093",
                    "43.08936;11.78141",
                    "43.08938;11.78189",
                    "43.08943;11.78225",
                    "43.08957;11.78245",
                    "43.08979;11.78255",
                    "43.09017;11.78256",
                    "43.09052;11.78269",
                    "43.09075;11.78286",
                    "43.09108;11.78317",
                    "43.09142;11.78334",
                    "43.0918;11.78348",
                    "43.09231;11.78376",
                    "43.09261;11.7839",
                    "43.09291;11.78397",
                    "43.09318;11.78391",
                    "43.09339;11.78374",
                    "43.09365;11.78345",
                    "43.09383;11.78325",
                    "43.09399;11.78318",
                    "43.09435;11.78329",
                    "43.09464;11.78348",
                    "43.09498;11.78383",
                    "43.0951;11.78409",
                    "43.09516;11.78465",
                    "43.0952;11.78505",
                    "43.09529;11.78522",
                    "43.09535;11.78539",
                    "43.09544;11.78555",
                    "43.09622;11.78636",
                    "43.09665;11.78687",
                    "43.09684;11.78706",
                    "43.09704;11.78717",
                    "43.097;11.78741",
                    "43.09674;11.7879",
                    "43.09661;11.78806",
                    "43.09646;11.78813"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/8289fd63-b361-40ec-94e6-52f388ee2753.png",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c38f31f6-2ca0-4004-a699-94d4067989d1.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/33199569-57f9-42f9-b260-4bcce28c2739.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/0df1b511-0e7b-4885-a5f2-2f650083ee81.jpeg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f78a1ca3-84a8-4732-8460-df2a91147280.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Il Tempio di San Biagio",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/4008711c-6604-4349-8ab4-9af7468c244d.downl__43_09041159480033_11_774991544371007",
                        "latitude": 43.09041159480033,
                        "longitude": 11.774991544371007,
                        "description": "Il Tempio di San Biagio a Montepulciano nasce da un episodio che accese la devozione popolare: nel 1518 un affresco trecentesco della Madonna col Bambino e san Francesco, rimasto su un muro della vecchia pieve, fu ritenuto miracoloso. Su quel luogo, legato a una pieve di origini antiche, la comunit\u00e0 decise di costruire un grande tempio rinascimentale affidandolo ad Antonio da Sangallo il Vecchio, con il sostegno di papa Leone X. Ne usc\u00ec un capolavoro del Cinquecento toscano: pianta a croce greca, equilibrio geometrico e una cupola imponente che domina il paesaggio, isolata in un prato appena fuori dalle mura. Curiosit\u00e0: la facciata avrebbe dovuto avere due campanili gemelli, ma ne fu completato solo uno, dettaglio che racconta quanto l\u2019impresa fosse ambiziosa. E al centro della storia resta sempre quell\u2019immagine venerata, oggi custodita all\u2019interno come cuore simbolico del santuario.\n"
                    },
                    {
                        "name": "Ristorante/Bar la Guardiola",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/f7be3d99-68e7-46d6-a040-808868b38eaa.downl__43_06782891723208_11_724598250839335",
                        "latitude": 43.06782891723208,
                        "longitude": 11.724598250839335,
                        "description": "Da qui parte la bellissima discesa verso Monticchiello: una sequenza di tornanti fiancheggiati da doppie file di cipressi, perfetta per la vostra foto \u201cda cartolina\u201d. Arrivati al borgo medievale, vera terrazza sulla Val d\u2019Orcia, vale la pena fermarsi per una breve pausa al ristorante La Guardiola, con terrazza panoramica. \u00c8 il posto ideale per godersi la vista, rilassarsi e concedersi un calice di vino con qualcosa di buono, prima di riprendere il percorso."
                    },
                    {
                        "name": "Capitoni Wine Tasting & light lunch",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/58f542c1-fd65-4583-916d-0d16f2d4af40.downl__43_085766888968664_11_708324736064244",
                        "latitude": 43.085766888968664,
                        "longitude": 11.708324736064244,
                        "description": "Da Capitoni la degustazione \u00e8 pensata come un incontro vero, senza formalit\u00e0: vi accolgono in cantina per assaggiare i vini dell\u2019annata e, se vi va, anche qualche \u201cvecchia annata\u201d o un campione ancora in affinamento direttamente dalle botti. Se di interesse, \u00e8 possibile fare anche una breve passeggiata tra i filari per vedere da vicino il lavoro in vigna, immersi nei paesaggi della Val d\u2019Orcia. Su richiesta, l\u2019esperienza pu\u00f2 diventare un light lunch semplice ma curato, con prodotti del territorio in abbinamento ai calici. Il tutto in un contesto autentico, dove il bello \u00e8 prendersi tempo, fare domande e lasciarsi guidare dai racconti di chi il vino lo fa davvero, ogni giorno."
                    },
                    {
                        "name": "Degustazione in Caseificio Cagusi",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/708e312d-c814-474d-8afe-49a9eab9b6d1.downl__43_10082672578029_11_753976345062258",
                        "latitude": 43.10082672578029,
                        "longitude": 11.753976345062258,
                        "description": "Al Caseificio Cugusi l\u2019esperienza \u00e8 tutta dedicata al Pecorino di Pienza, con una degustazione informale ma curata, pensata per assaggiare diverse stagionature e abbinamenti del territorio (miele/confetture e, volendo, salumi). La degustazione dura circa 45 minuti e si svolge in azienda, con spiegazioni sulla lavorazione e sulla filosofia produttiva, anche se per motivi igienico-sanitari non sono previsti tour all\u2019interno della produzione. Il plus pi\u00f9 bello \u00e8 il pic-nic: si ritira un cesto, si scelgono i prodotti e ci si accomoda all\u2019aperto, tra campagna e viste iconiche su Montepulciano e sul Tempio di San Biagio. Un momento semplice, autentico, perfetto per una pausa golosa in Val d\u2019Orcia."
                    }
                ],
                "infos": {
                    "distance": 35574
                }
            }
        ],
        "catalogue": [
            {
                "id": 21,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 22,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1488,
        "customer": {
            "id": 34,
            "title": "Padbike",
            "description": "Padbike, a tour operator based in Florence, specialized in designing and organizing E-Bike travel experiences.\r\nIn 2024 it opened an in-house Software & Development division for the development of Outdoora.",
            "color": "#404040",
            "theme_dark": true,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Padbike.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/provaRisorsa_1.png"
            ],
            "contacts": {
                "address": "Via dei Renai, 13, Via dei Renai, 13, 50125 Firenze FI, Italia",
                "email": "padbikeapp@gmail.com",
                "phone": "+393888353749"
            },
            "coordinate": {
                "latitude": 43.76491,
                "longitude": 11.25982
            },
            "tours": 12,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/21851540-c174-42ce-9ec2-d50341a79f83.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/389e886d-2941-43cc-bc89-86cfd16f0c82.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8aa350b2-3694-4348-ac22-b832c90da9c1.jpg"
            ]
        },
        "title": "Capoliveri Bike Park",
        "description": "Un anello spettacolare sul Monte Calamita, tra single trail vista mare, strade bianche panoramiche e il fascino ruvido delle antiche miniere di ferro dell\u2019Isola d\u2019Elba. Questo tour in e-bike ti porta nel cuore del Capoliveri Bike Park, sulle tracce delle grandi gare internazionali come la Capoliveri Legend Cup, che hanno reso questi sentieri un riferimento mondiale per la MTB. \r\n\r\nDal borgo di Capoliveri si pedala tra macchia mediterranea e scorci sul Canale di Piombino, raggiungendo le aree minerarie storiche: vecchie gallerie, piazzali di carico e terra rossa affacciata su un mare turchese raccontano secoli di estrazione del ferro, oggi trasformati in uno scenario unico per il cicloturismo.\r\n\r\nCon i suoi 35 km e 800 m di dislivello, il percorso richiede una buona forma fisica e capacit\u00e0 di guida intermedie: si affrontano sentieri stretti, qualche rampa ripida e brevi discese pi\u00f9 decise, ma senza passaggi tecnici estremi. Ideale per chi vuole vivere l\u2019atmosfera \u201crace\u201d del  Bike Park",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1488.jpg",
        "price": 25.0,
        "location": "Capoliveri, Isola d'Elba",
        "location_id": null,
        "tags": [
            "Natura",
            "Mare",
            "Storia"
        ],
        "routes": [
            {
                "id": 860,
                "title": "Capoliveri Bike Park",
                "description": "E-bike tour ad anello sul Monte Calamita, tra i trail del Capoliveri Bike Park e i paesaggi lunari delle antiche miniere di ferro affacciate sul mare. Si pedala sui percorsi delle grandi gare come la Capoliveri Legend Cup, tra panorami mozzafiato e storia industriale. Richieste capacit\u00e0 di guida intermedie: sentieri stretti, qualche salita e discesa ripida, ma senza tratti tecnici estremi.",
                "notes": "Richiede esperienza su single trail e passaggi tecnici poco impegnativi",
                "start_address": "Capoliveri, Provincia di Livorno",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1488.jpg",
                "track": [
                    42.7564,
                    10.37921
                ],
                "preview_track": [
                    "42.7564;10.37921",
                    "42.75731;10.3802",
                    "42.75747;10.38186",
                    "42.75712;10.38244",
                    "42.75655;10.38315",
                    "42.75757;10.38679",
                    "42.75768;10.38709",
                    "42.7578;10.38786",
                    "42.75766;10.38896",
                    "42.75776;10.38961",
                    "42.75785;10.39047",
                    "42.75743;10.39145",
                    "42.75664;10.392",
                    "42.75618;10.39219",
                    "42.75653;10.39264",
                    "42.75738;10.39458",
                    "42.75693;10.3955",
                    "42.75645;10.39586",
                    "42.75623;10.39612",
                    "42.75592;10.39635",
                    "42.75526;10.39481",
                    "42.75498;10.39436",
                    "42.75417;10.3925",
                    "42.75306;10.39022",
                    "42.75292;10.38994",
                    "42.75198;10.38817",
                    "42.75029;10.3868",
                    "42.7498;10.38463",
                    "42.74918;10.38324",
                    "42.74833;10.38316",
                    "42.74817;10.38296",
                    "42.74802;10.38252",
                    "42.74742;10.38276",
                    "42.74662;10.38168",
                    "42.74541;10.38144",
                    "42.74458;10.38153",
                    "42.74377;10.38198",
                    "42.74303;10.38222",
                    "42.74281;10.38196",
                    "42.74286;10.38154",
                    "42.74322;10.38108",
                    "42.74325;10.38077",
                    "42.74301;10.38064",
                    "42.7429;10.38048",
                    "42.74278;10.38051",
                    "42.74277;10.38063",
                    "42.74262;10.3806",
                    "42.74107;10.38001",
                    "42.73998;10.37885",
                    "42.73965;10.37897",
                    "42.73901;10.37977",
                    "42.73813;10.38007",
                    "42.73761;10.38083",
                    "42.73746;10.38084",
                    "42.73667;10.38052",
                    "42.73581;10.38036",
                    "42.73473;10.3802",
                    "42.7343;10.38065",
                    "42.73425;10.38216",
                    "42.73417;10.38286",
                    "42.73413;10.38335",
                    "42.73396;10.38342",
                    "42.73321;10.38263",
                    "42.73253;10.38201",
                    "42.73205;10.38208",
                    "42.73185;10.38181",
                    "42.73119;10.38056",
                    "42.73073;10.38064",
                    "42.72992;10.38065",
                    "42.72923;10.38099",
                    "42.72829;10.38188",
                    "42.7282;10.38207",
                    "42.72816;10.3825",
                    "42.72801;10.38311",
                    "42.72801;10.38334",
                    "42.72816;10.38391",
                    "42.72818;10.38423",
                    "42.72806;10.38469",
                    "42.72801;10.38511",
                    "42.72798;10.38552",
                    "42.72777;10.38626",
                    "42.72755;10.38671",
                    "42.72742;10.38713",
                    "42.72731;10.38757",
                    "42.72734;10.38776",
                    "42.72742;10.38798",
                    "42.72735;10.38812",
                    "42.72716;10.38812",
                    "42.72696;10.38791",
                    "42.72685;10.38769",
                    "42.72672;10.38724",
                    "42.72651;10.38662",
                    "42.72651;10.38615",
                    "42.72642;10.38547",
                    "42.72629;10.38514",
                    "42.72608;10.38466",
                    "42.72594;10.38422",
                    "42.72569;10.38385",
                    "42.72534;10.38315",
                    "42.72522;10.38273",
                    "42.72515;10.38238",
                    "42.72496;10.38188",
                    "42.72465;10.3821",
                    "42.72414;10.38295",
                    "42.72361;10.38349",
                    "42.72308;10.38418",
                    "42.72308;10.38492",
                    "42.72334;10.38584",
                    "42.72337;10.38653",
                    "42.72355;10.38702",
                    "42.72384;10.38459",
                    "42.72487;10.38396",
                    "42.72578;10.38481",
                    "42.72551;10.3864",
                    "42.72475;10.38549",
                    "42.72514;10.38761",
                    "42.72532;10.38873",
                    "42.72502;10.3921",
                    "42.72539;10.39464",
                    "42.72533;10.39741",
                    "42.72603;10.40029",
                    "42.72611;10.40089",
                    "42.72588;10.40192",
                    "42.72567;10.40253",
                    "42.72572;10.40301",
                    "42.7258;10.40318",
                    "42.72607;10.40327",
                    "42.72673;10.40283",
                    "42.72711;10.40294",
                    "42.72716;10.40327",
                    "42.72709;10.40396",
                    "42.72728;10.40418",
                    "42.72748;10.40439",
                    "42.72673;10.40522",
                    "42.7265;10.40528",
                    "42.72636;10.40556",
                    "42.72641;10.40572",
                    "42.72673;10.40588",
                    "42.72681;10.40598",
                    "42.72619;10.40642",
                    "42.72604;10.40679",
                    "42.726;10.40718",
                    "42.72619;10.40791",
                    "42.72642;10.40843",
                    "42.72643;10.40869",
                    "42.72611;10.40905",
                    "42.72595;10.40925",
                    "42.72596;10.40966",
                    "42.72642;10.41019",
                    "42.72684;10.41054",
                    "42.72685;10.41086",
                    "42.72667;10.41126",
                    "42.72633;10.41129",
                    "42.72616;10.41074",
                    "42.72544;10.40984",
                    "42.72525;10.40898",
                    "42.72538;10.40861",
                    "42.72506;10.40843",
                    "42.72411;10.40937",
                    "42.72365;10.40997",
                    "42.72341;10.40943",
                    "42.72275;10.4091",
                    "42.72193;10.40872",
                    "42.72133;10.40804",
                    "42.72069;10.40686",
                    "42.72035;10.40584",
                    "42.71999;10.40508",
                    "42.71986;10.40502",
                    "42.71941;10.40458",
                    "42.71921;10.40335",
                    "42.7189;10.40207",
                    "42.719;10.40074",
                    "42.71899;10.39996",
                    "42.71918;10.39927",
                    "42.71964;10.39788",
                    "42.72001;10.39793",
                    "42.72019;10.39762",
                    "42.72014;10.39813",
                    "42.72016;10.39847",
                    "42.72021;10.3987",
                    "42.72031;10.39877",
                    "42.72023;10.39903",
                    "42.7203;10.39981",
                    "42.72057;10.40004",
                    "42.72052;10.40041",
                    "42.72062;10.40099",
                    "42.72067;10.40187",
                    "42.72075;10.40328",
                    "42.72074;10.40404",
                    "42.72103;10.40436",
                    "42.72173;10.40413",
                    "42.72201;10.40455",
                    "42.7222;10.40489",
                    "42.72259;10.40548",
                    "42.72311;10.4058",
                    "42.72405;10.40609",
                    "42.72469;10.40644",
                    "42.72562;10.40575",
                    "42.7263;10.40523",
                    "42.72695;10.40444",
                    "42.72671;10.40365",
                    "42.72634;10.40387",
                    "42.72499;10.40458",
                    "42.72457;10.40449",
                    "42.7244;10.40405",
                    "42.72444;10.40203",
                    "42.72428;10.40138",
                    "42.72447;10.40113",
                    "42.72465;10.401",
                    "42.72454;10.4004",
                    "42.72457;10.39924",
                    "42.7243;10.39885",
                    "42.72439;10.39827",
                    "42.72434;10.39754",
                    "42.72377;10.39591",
                    "42.72378;10.39539",
                    "42.72426;10.3945",
                    "42.72363;10.39271",
                    "42.72314;10.39164",
                    "42.72329;10.39121",
                    "42.72313;10.39105",
                    "42.72274;10.39172",
                    "42.72316;10.39307",
                    "42.72332;10.39411",
                    "42.72273;10.39421",
                    "42.72228;10.39457",
                    "42.72278;10.39577",
                    "42.72306;10.39711",
                    "42.7232;10.39752",
                    "42.72286;10.39808",
                    "42.72278;10.39843",
                    "42.72292;10.39907",
                    "42.72252;10.3993",
                    "42.72235;10.3998",
                    "42.72234;10.40035",
                    "42.7223;10.40059",
                    "42.72256;10.40105",
                    "42.72272;10.40149",
                    "42.72263;10.40149",
                    "42.72189;10.40097",
                    "42.7217;10.40031",
                    "42.72145;10.39887",
                    "42.7213;10.3985",
                    "42.72126;10.39776",
                    "42.72084;10.39678",
                    "42.72052;10.39636",
                    "42.72027;10.39573",
                    "42.72017;10.39547",
                    "42.72001;10.3956",
                    "42.7197;10.3955",
                    "42.71966;10.39484",
                    "42.71906;10.39524",
                    "42.7184;10.3953",
                    "42.71814;10.39533",
                    "42.71811;10.3952",
                    "42.7179;10.39492",
                    "42.71739;10.39514",
                    "42.71732;10.39506",
                    "42.71672;10.39477",
                    "42.71658;10.39477",
                    "42.71627;10.39544",
                    "42.716;10.3955",
                    "42.71611;10.3946",
                    "42.71566;10.39433",
                    "42.71548;10.3941",
                    "42.71512;10.39456",
                    "42.71503;10.39542",
                    "42.71521;10.39596",
                    "42.71543;10.39602",
                    "42.71616;10.39652",
                    "42.71673;10.39716",
                    "42.71646;10.39825",
                    "42.71635;10.39925",
                    "42.71635;10.39756",
                    "42.71614;10.39749",
                    "42.71591;10.39812",
                    "42.71571;10.39891",
                    "42.71568;10.39857",
                    "42.71581;10.39768",
                    "42.71576;10.39714",
                    "42.71461;10.39652",
                    "42.71448;10.39593",
                    "42.71434;10.39537",
                    "42.71432;10.39466",
                    "42.71465;10.39389",
                    "42.71505;10.39353",
                    "42.71526;10.39232",
                    "42.7156;10.39178",
                    "42.71569;10.39083",
                    "42.7157;10.39049",
                    "42.7159;10.38977",
                    "42.71648;10.38911",
                    "42.71698;10.38811",
                    "42.7173;10.38809",
                    "42.7174;10.38876",
                    "42.71804;10.38941",
                    "42.71878;10.38962",
                    "42.71875;10.38924",
                    "42.71818;10.38843",
                    "42.71811;10.38711",
                    "42.71748;10.38589",
                    "42.71683;10.38501",
                    "42.71721;10.38418",
                    "42.71826;10.38226",
                    "42.71873;10.38165",
                    "42.71962;10.38005",
                    "42.72071;10.37905",
                    "42.72169;10.37758",
                    "42.72172;10.37771",
                    "42.72107;10.37915",
                    "42.72064;10.38043",
                    "42.71939;10.38125",
                    "42.72006;10.38155",
                    "42.7198;10.3817",
                    "42.71932;10.38229",
                    "42.71999;10.38235",
                    "42.72075;10.38303",
                    "42.72156;10.38251",
                    "42.72225;10.38255",
                    "42.72171;10.38384",
                    "42.72191;10.38461",
                    "42.72271;10.38317",
                    "42.72431;10.38243",
                    "42.72439;10.38214",
                    "42.72482;10.38165",
                    "42.72499;10.38192",
                    "42.72521;10.38266",
                    "42.72531;10.38308",
                    "42.72565;10.38378",
                    "42.72591;10.38417",
                    "42.72606;10.3846",
                    "42.72618;10.38493",
                    "42.72641;10.38541",
                    "42.72651;10.38609",
                    "42.72649;10.38652",
                    "42.72666;10.38711",
                    "42.72683;10.38762",
                    "42.72694;10.38788",
                    "42.7271;10.38807",
                    "42.72734;10.38812",
                    "42.72742;10.388",
                    "42.72739;10.38788",
                    "42.72731;10.3876",
                    "42.7274;10.38722",
                    "42.72753;10.38677",
                    "42.72775;10.38632",
                    "42.72796;10.38559",
                    "42.72801;10.38526",
                    "42.72804;10.38476",
                    "42.72817;10.3843",
                    "42.72817;10.38397",
                    "42.72802;10.3834",
                    "42.728;10.38315",
                    "42.72815;10.38256",
                    "42.72819;10.38213",
                    "42.72827;10.38191",
                    "42.72887;10.38132",
                    "42.72982;10.38063",
                    "42.73055;10.38077",
                    "42.7311;10.38051",
                    "42.73177;10.38153",
                    "42.73205;10.38208",
                    "42.73241;10.38195",
                    "42.73298;10.38237",
                    "42.73378;10.38328",
                    "42.7341;10.38339",
                    "42.73414;10.38301",
                    "42.73429;10.3823",
                    "42.73431;10.38108",
                    "42.73452;10.38023",
                    "42.73563;10.3803",
                    "42.73656;10.38052",
                    "42.73738;10.38078",
                    "42.73761;10.38083",
                    "42.73813;10.38007",
                    "42.73901;10.37977",
                    "42.73965;10.37897",
                    "42.73998;10.37885",
                    "42.74107;10.38001",
                    "42.74262;10.3806",
                    "42.74277;10.38063",
                    "42.74284;10.3807",
                    "42.74307;10.38074",
                    "42.74325;10.38077",
                    "42.74326;10.38085",
                    "42.74315;10.3812",
                    "42.7428;10.38169",
                    "42.74288;10.3821",
                    "42.74313;10.38223",
                    "42.74398;10.38189",
                    "42.74473;10.38146",
                    "42.74634;10.38148",
                    "42.74703;10.38247",
                    "42.74773;10.38272",
                    "42.74821;10.38224",
                    "42.74826;10.38122",
                    "42.74818;10.38021",
                    "42.74828;10.37988",
                    "42.74855;10.3798",
                    "42.74887;10.37978",
                    "42.75258;10.38086",
                    "42.75326;10.38105",
                    "42.75383;10.38109",
                    "42.7542;10.38101",
                    "42.75469;10.3812",
                    "42.75498;10.38104",
                    "42.7558;10.37985",
                    "42.75612;10.37957",
                    "42.7559;10.37919",
                    "42.75581;10.3791",
                    "42.7564;10.37921"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/303e5ec0-1f19-4646-b3a1-e57bd60fa14c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9344c006-f203-4325-a6d1-6e05dad3c121.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b485b0c2-6d26-4fb0-90d6-6c165dcff069.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/a68dea96-15ba-405d-b7b9-2ef816e62580.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Punto Panoramico",
                        "type": "photo",
                        "latitude": 43.076012,
                        "longitude": 11.679305,
                        "description": "Qui puoi scrivere quello che vuoi"
                    },
                    {
                        "name": "Miniere di Capoliveri",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/78aec5c1-a1ec-4300-8f6d-e9d12fad5b12.downl__42_71666580775739_10_394787148106847",
                        "latitude": 42.71666580775739,
                        "longitude": 10.394787148106847,
                        "description": " Le miniere di Capoliveri, sul Monte Calamita, sono sfruttate fin dall\u2019epoca etrusca e romana per la ricchissima magnetite, tra i migliori minerali di ferro del Mediterraneo. Tra Ottocento e Novecento diventano un importante polo industriale, con gallerie a picco sul mare, impianti di estrazione moderni e cantieri come il Ginevro, poi dismessi negli anni \u201980. Oggi l\u2019area mineraria \u00e8 parte del Parco Nazionale dell\u2019Arcipelago Toscano ed \u00e8 un affascinante paesaggio di archeologia industriale con viste spettacolari sulla costa. "
                    }
                ],
                "infos": {
                    "distance": 29887
                }
            }
        ],
        "catalogue": [
            {
                "id": 47,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 48,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1529,
        "customer": {
            "id": 377,
            "title": "Cicli Valentini",
            "description": "Cicli Valentini \u00e8 un bike rental a Castiglione del Lago, sul Lago Trasimeno, con negozio, officina e servizio noleggio.\r\nNasce dalla passione e dall\u2019esperienza nel ciclismo, con un approccio competente e orientato all\u2019accoglienza di turisti e sportivi.\r\nL\u2019offerta include e-bike, mountain bike, bici tradizionali e bici da corsa, con supporto e assistenza tecnica in caso di necessit\u00e0.\r\n\u00c8 possibile ritirare le bici rapidamente in zona Trasimeno e, su richiesta, riceverle anche con consegna.\r\nIl servizio copre il lago e i principali itinerari nei dintorni, fino all\u2019area tra Umbria e bassa Toscana.\r\nUna soluzione completa per scoprire il Trasimeno e i suoi borghi su due ruote, in libert\u00e0 e sicurezza.",
            "color": "#182783",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Cicli_Valentini.jpg",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/logo_cicli_valentini.png"
            ],
            "contacts": {
                "address": "Via Firenze, 68, Via Firenze, 68, 06061 Castiglione del Lago PG, Italia",
                "email": "info@ciclivalentini.it",
                "phone": "+39 075951663"
            },
            "coordinate": {
                "latitude": 43.13062,
                "longitude": 12.04269
            },
            "tours": 2,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/bf66cfd3-1fd5-4208-bc1b-12719903b4d6.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/89d148fa-1919-407a-b4db-d4b7e1560c47.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/08641b96-a8d9-4e1e-a4c3-70e0a7462a4a.jpg"
            ]
        },
        "title": "Lago Trasimeno Bike Tour",
        "description": "Un grande anello attorno al Lago Trasimeno, perfetto per una pedalata panoramica tra lungolago, canneti, piccoli borghi e campagna umbra. Il percorso scorre bene e regala un contatto quasi continuo con l\u2019acqua, alternando tratti rilassanti a passaggi pi\u00f9 vari che rendono il giro sempre piacevole. \u00c8 un itinerario ideale da vivere con calma, con tante occasioni per fermarsi lungo il lago e godersi il paesaggio.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1529.jpeg",
        "price": 25.0,
        "location": "Lago Trasimeno",
        "location_id": null,
        "tags": [
            "Natura",
            "Montagne",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1564,
                "title": "Giro del Lago Trasimeno",
                "description": "Partenza / arrivo: area Castiglione del Lago, percorso ad anello con rientro nello stesso punto.\n\nDati principali: sviluppo totale di circa 61 km e dislivello positivo contenuto, intorno ai 300\u2013350 m; giro lungo ma scorrevole, con andamento perlopi\u00f9 pianeggiante e brevi ondulazioni.\n\nTracciato e paesaggio: il percorso segue il perimetro del Trasimeno alternando tratti vicini alla riva, passaggi nei centri abitati e sezioni pi\u00f9 aperte nella campagna circostante. Il paesaggio cambia spesso ma resta sempre molto leggibile, con un mix continuo tra lago, vegetazione e borghi.\n\nNote utili: tour adatto a essere affrontato con ritmo regolare, prevedendo qualche sosta lungo il lago o nei paesi del percorso. In alcuni tratti si pedala in contesti tranquilli e poco ombreggiati, quindi \u00e8 una buona idea partire con acqua, uno snack e telefono carico/GPS attivo per godersi il giro in totale serenit\u00e0.",
                "notes": null,
                "start_address": "Via Firenze, 68, 06061 Castiglione del Lago PG, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    43.13049,
                    12.04253
                ],
                "preview_track": [
                    "43.13049;12.04253",
                    "43.13068;12.04205",
                    "43.13144;12.04239",
                    "43.13236;12.04326",
                    "43.13236;12.04343",
                    "43.13252;12.04342",
                    "43.13354;12.04431",
                    "43.13352;12.0444",
                    "43.13083;12.04759",
                    "43.12922;12.05003",
                    "43.12913;12.05125",
                    "43.12923;12.05434",
                    "43.12828;12.05723",
                    "43.12678;12.05783",
                    "43.12568;12.05694",
                    "43.12576;12.05573",
                    "43.12583;12.0544",
                    "43.12571;12.05445",
                    "43.12452;12.05472",
                    "43.12405;12.05278",
                    "43.124;12.05132",
                    "43.12376;12.04976",
                    "43.12241;12.0468",
                    "43.1208;12.04395",
                    "43.11967;12.0422",
                    "43.11963;12.04061",
                    "43.11967;12.03989",
                    "43.11978;12.03962",
                    "43.1197;12.03941",
                    "43.11957;12.03941",
                    "43.11931;12.03957",
                    "43.11814;12.03952",
                    "43.11627;12.03952",
                    "43.11226;12.03953",
                    "43.10949;12.03952",
                    "43.10808;12.03963",
                    "43.10486;12.04214",
                    "43.10379;12.04297",
                    "43.10093;12.04527",
                    "43.09999;12.04641",
                    "43.09922;12.04793",
                    "43.09782;12.05084",
                    "43.09715;12.05221",
                    "43.09609;12.05431",
                    "43.09472;12.05601",
                    "43.0946;12.05598",
                    "43.09437;12.05611",
                    "43.09431;12.05645",
                    "43.09445;12.0567",
                    "43.09471;12.05713",
                    "43.09435;12.05818",
                    "43.09059;12.06594",
                    "43.08711;12.0731",
                    "43.08371;12.0801",
                    "43.08197;12.08366",
                    "43.07972;12.08834",
                    "43.08112;12.09038",
                    "43.08456;12.09194",
                    "43.08469;12.0922",
                    "43.08517;12.09263",
                    "43.08466;12.09434",
                    "43.08229;12.10188",
                    "43.08184;12.1025",
                    "43.07835;12.10095",
                    "43.07737;12.10625",
                    "43.07623;12.10683",
                    "43.07647;12.10923",
                    "43.07629;12.11136",
                    "43.07622;12.11403",
                    "43.07635;12.11517",
                    "43.07648;12.11749",
                    "43.07756;12.12685",
                    "43.07889;12.13282",
                    "43.07913;12.13382",
                    "43.07916;12.13408",
                    "43.07968;12.13458",
                    "43.08147;12.13524",
                    "43.08039;12.13834",
                    "43.08012;12.13889",
                    "43.07991;12.13986",
                    "43.08002;12.14073",
                    "43.08092;12.14214",
                    "43.08117;12.14292",
                    "43.08131;12.14352",
                    "43.08138;12.14365",
                    "43.08208;12.14768",
                    "43.0823;12.1487",
                    "43.08408;12.1471",
                    "43.08482;12.14776",
                    "43.08527;12.14891",
                    "43.08525;12.15",
                    "43.08576;12.15169",
                    "43.0862;12.15316",
                    "43.085;12.15524",
                    "43.08557;12.15698",
                    "43.08594;12.15777",
                    "43.08742;12.15722",
                    "43.08767;12.15835",
                    "43.08778;12.15878",
                    "43.08773;12.15924",
                    "43.08673;12.16001",
                    "43.08667;12.16011",
                    "43.08966;12.16301",
                    "43.09025;12.16379",
                    "43.09076;12.16615",
                    "43.09029;12.16875",
                    "43.09018;12.17038",
                    "43.08994;12.17243",
                    "43.09001;12.17282",
                    "43.09015;12.17343",
                    "43.08826;12.17473",
                    "43.088;12.17772",
                    "43.08777;12.18011",
                    "43.08767;12.18155",
                    "43.08745;12.18394",
                    "43.08756;12.18626",
                    "43.08777;12.18792",
                    "43.08834;12.18764",
                    "43.08908;12.18758",
                    "43.09;12.18989",
                    "43.09134;12.19055",
                    "43.09436;12.19153",
                    "43.09612;12.19181",
                    "43.09793;12.1919",
                    "43.0994;12.19251",
                    "43.10047;12.19268",
                    "43.10134;12.19222",
                    "43.10312;12.18893",
                    "43.10461;12.188",
                    "43.10585;12.18822",
                    "43.10613;12.18845",
                    "43.10677;12.18803",
                    "43.10803;12.18722",
                    "43.10932;12.18587",
                    "43.11022;12.18366",
                    "43.11173;12.18116",
                    "43.11218;12.18024",
                    "43.11289;12.17774",
                    "43.11315;12.17651",
                    "43.1139;12.17453",
                    "43.11407;12.17348",
                    "43.11458;12.17223",
                    "43.11519;12.17068",
                    "43.11652;12.16859",
                    "43.11633;12.16763",
                    "43.11707;12.16688",
                    "43.11775;12.16688",
                    "43.11804;12.16651",
                    "43.11944;12.16609",
                    "43.12134;12.16608",
                    "43.12285;12.16658",
                    "43.12462;12.16712",
                    "43.12805;12.16777",
                    "43.12962;12.16775",
                    "43.13119;12.16738",
                    "43.13241;12.16662",
                    "43.13302;12.16625",
                    "43.13534;12.16601",
                    "43.13738;12.16623",
                    "43.138;12.16607",
                    "43.13904;12.16542",
                    "43.14032;12.16494",
                    "43.14134;12.16456",
                    "43.14278;12.1633",
                    "43.14353;12.16123",
                    "43.14378;12.16063",
                    "43.14503;12.16",
                    "43.14568;12.16017",
                    "43.14616;12.16314",
                    "43.14778;12.16773",
                    "43.14901;12.16925",
                    "43.14916;12.17014",
                    "43.14965;12.171",
                    "43.14978;12.17212",
                    "43.14987;12.17582",
                    "43.15141;12.17866",
                    "43.152;12.18004",
                    "43.1527;12.18201",
                    "43.1546;12.18447",
                    "43.15596;12.1853",
                    "43.15632;12.18546",
                    "43.15904;12.18691",
                    "43.16004;12.18604",
                    "43.16056;12.18643",
                    "43.16096;12.18743",
                    "43.16102;12.18864",
                    "43.16529;12.1885",
                    "43.16922;12.18806",
                    "43.17173;12.18702",
                    "43.17394;12.18535",
                    "43.17518;12.18412",
                    "43.17645;12.18295",
                    "43.17707;12.18231",
                    "43.17884;12.1801",
                    "43.17973;12.17831",
                    "43.18029;12.17668",
                    "43.18069;12.17473",
                    "43.18131;12.17035",
                    "43.18124;12.16842",
                    "43.18126;12.16838",
                    "43.1815;12.16802",
                    "43.18177;12.16727",
                    "43.18132;12.16691",
                    "43.18137;12.16634",
                    "43.18192;12.16552",
                    "43.18221;12.16407",
                    "43.18261;12.16131",
                    "43.18255;12.16041",
                    "43.18323;12.15689",
                    "43.1836;12.1544",
                    "43.18392;12.15216",
                    "43.18385;12.15106",
                    "43.18391;12.14948",
                    "43.18478;12.14622",
                    "43.18508;12.14432",
                    "43.18516;12.14113",
                    "43.18502;12.13998",
                    "43.18442;12.13981",
                    "43.18411;12.14048",
                    "43.18354;12.139",
                    "43.1832;12.13818",
                    "43.18303;12.13784",
                    "43.18296;12.13756",
                    "43.18296;12.13739",
                    "43.1832;12.13682",
                    "43.18361;12.13651",
                    "43.1841;12.13626",
                    "43.18436;12.13619",
                    "43.18476;12.13608",
                    "43.18531;12.13542",
                    "43.18561;12.13477",
                    "43.18546;12.13358",
                    "43.18568;12.13317",
                    "43.18632;12.13225",
                    "43.18629;12.13146",
                    "43.18743;12.13062",
                    "43.18867;12.13016",
                    "43.18918;12.12953",
                    "43.18969;12.12998",
                    "43.19062;12.13021",
                    "43.19148;12.1257",
                    "43.19208;12.12145",
                    "43.19271;12.11646",
                    "43.1928;12.11307",
                    "43.19242;12.11127",
                    "43.19228;12.11006",
                    "43.19344;12.108",
                    "43.19391;12.10814",
                    "43.19479;12.10199",
                    "43.19525;12.09867",
                    "43.19601;12.0931",
                    "43.19654;12.08904",
                    "43.19701;12.08507",
                    "43.19682;12.08153",
                    "43.19613;12.07786",
                    "43.19581;12.07765",
                    "43.19459;12.07765",
                    "43.1945;12.07761",
                    "43.19447;12.07752",
                    "43.19442;12.07684",
                    "43.19437;12.07674",
                    "43.1943;12.07672",
                    "43.19214;12.07658",
                    "43.19204;12.07647",
                    "43.19188;12.07646",
                    "43.19182;12.07651",
                    "43.1916;12.07621",
                    "43.1914;12.07624",
                    "43.19121;12.07617",
                    "43.19113;12.07603",
                    "43.19095;12.07582",
                    "43.18998;12.07627",
                    "43.18989;12.07621",
                    "43.18948;12.07592",
                    "43.18861;12.07555",
                    "43.18708;12.07633",
                    "43.18551;12.07677",
                    "43.18477;12.07593",
                    "43.18443;12.07583",
                    "43.18486;12.07573",
                    "43.18896;12.07396",
                    "43.19022;12.07313",
                    "43.19081;12.07283",
                    "43.1913;12.07254",
                    "43.19208;12.07211",
                    "43.1935;12.07143",
                    "43.19445;12.07093",
                    "43.19458;12.0687",
                    "43.19423;12.06683",
                    "43.1923;12.056",
                    "43.19108;12.05212",
                    "43.19055;12.0519",
                    "43.1896;12.05066",
                    "43.18924;12.04954",
                    "43.18891;12.04871",
                    "43.18876;12.04727",
                    "43.1876;12.04263",
                    "43.18641;12.03826",
                    "43.18594;12.03655",
                    "43.18518;12.03618",
                    "43.18432;12.03368",
                    "43.18461;12.03141",
                    "43.18492;12.02914",
                    "43.18499;12.02853",
                    "43.18508;12.0258",
                    "43.18453;12.02454",
                    "43.1864;12.02374",
                    "43.18638;12.02315",
                    "43.18572;12.02071",
                    "43.18545;12.02005",
                    "43.18432;12.01906",
                    "43.18255;12.01745",
                    "43.18163;12.01556",
                    "43.18138;12.01523",
                    "43.18111;12.01556",
                    "43.18049;12.01592",
                    "43.18012;12.01593",
                    "43.17905;12.01569",
                    "43.17743;12.0155",
                    "43.1768;12.01534",
                    "43.17638;12.01537",
                    "43.17611;12.01578",
                    "43.17585;12.01748",
                    "43.17505;12.01734",
                    "43.17434;12.01687",
                    "43.17302;12.0167",
                    "43.17194;12.01733",
                    "43.17118;12.0176",
                    "43.17051;12.01773",
                    "43.17007;12.01747",
                    "43.16963;12.01734",
                    "43.16922;12.01737",
                    "43.1685;12.01738",
                    "43.16814;12.01764",
                    "43.16782;12.01741",
                    "43.16722;12.01746",
                    "43.16638;12.01724",
                    "43.16576;12.01737",
                    "43.1654;12.01734",
                    "43.16529;12.0176",
                    "43.16444;12.01797",
                    "43.16385;12.01806",
                    "43.16349;12.01801",
                    "43.16325;12.01845",
                    "43.16315;12.01889",
                    "43.16236;12.01925",
                    "43.16174;12.01898",
                    "43.16119;12.01932",
                    "43.16078;12.0193",
                    "43.1603;12.01957",
                    "43.1598;12.01975",
                    "43.15869;12.02029",
                    "43.15785;12.02106",
                    "43.15771;12.02169",
                    "43.15724;12.02173",
                    "43.15674;12.02181",
                    "43.15634;12.02186",
                    "43.15568;12.02211",
                    "43.15535;12.02209",
                    "43.15473;12.02258",
                    "43.15417;12.02311",
                    "43.15364;12.02346",
                    "43.15323;12.02367",
                    "43.15311;12.0243",
                    "43.15214;12.02443",
                    "43.15162;12.02316",
                    "43.15055;12.02387",
                    "43.14954;12.02472",
                    "43.14919;12.02504",
                    "43.14952;12.02624",
                    "43.14928;12.02647",
                    "43.14897;12.02682",
                    "43.14859;12.02746",
                    "43.14771;12.02814",
                    "43.14714;12.02868",
                    "43.14676;12.02893",
                    "43.14627;12.0294",
                    "43.14573;12.03004",
                    "43.14533;12.03068",
                    "43.14487;12.03113",
                    "43.1445;12.03159",
                    "43.14421;12.03147",
                    "43.14344;12.03016",
                    "43.14197;12.03107",
                    "43.1407;12.03335",
                    "43.13997;12.0361",
                    "43.13956;12.03578",
                    "43.13587;12.03724",
                    "43.13504;12.03916",
                    "43.13475;12.03914",
                    "43.13499;12.03959",
                    "43.13389;12.0408",
                    "43.13376;12.04221",
                    "43.1337;12.04273",
                    "43.13369;12.04331",
                    "43.13358;12.04412",
                    "43.13279;12.04348",
                    "43.13248;12.04323",
                    "43.13229;12.04306",
                    "43.13115;12.04214",
                    "43.13081;12.04179",
                    "43.13054;12.04232"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/00293472-a3a7-4cea-8fa8-61de9f1db118.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b120fb96-9da6-4361-ba12-9969743207dd.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/cf81e221-0062-42e2-9746-b2ca7a459b48.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b086bd28-dd53-4d72-8dfb-eb1312a8075c.jpeg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Trattoria del pescatore",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/b24ba6e0-6234-49ed-9298-256e20b60212.tratt__43_184072946630735_12_14044672925978",
                        "latitude": 43.184072946630735,
                        "longitude": 12.14044672925978,
                        "description": "Benvenuti a Passignano, qui troverete una delle trattorie pi\u00f9 storiche del lago: Nel cuore dell'antica piazzetta, sotto il castello di Passignano, la Trattoria del Pescatore ospita, nel vecchio frantoio dei Cappuccini, turisti e visitatori, come una volta accoglieva pescatori reduci da una giornata di fatica e speranze. Sono pi\u00f9 di cinquant'anni che, prima Emma e poi Renata, studiano e propongono golosit\u00e0 di lago e di terra, per ospiti accolti con simpatia ed immutata cordialit\u00e0 dall'intera famiglia."
                    }
                ],
                "infos": {
                    "distance": 60901
                }
            }
        ],
        "catalogue": [
            {
                "id": 49,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 50,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1523,
        "customer": {
            "id": 374,
            "title": "Dory Hotel e Suite Riccione",
            "description": "Hotel Dory & Suite \u00e8 un 4 stelle nel centro di Riccione, a pochi passi dal mare, ideale per unire lavoro e relax. Per chi viaggia per business offre servizi pratici come Wi-Fi, room service, parcheggio/garage e supporto per l\u2019organizzazione di meeting su misura. Dopo le sessioni di lavoro puoi concederti piscina e SPA, oppure un momento al ristorante con proposte adatte anche a pranzi e cene aziendali. Inoltre sono disponibili attivit\u00e0 ed esperienze pensate per gruppi, utili anche per team building.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Dory_Hotel_e_Suite_Riccione.jpg",
            "text_logo": null,
            "contacts": {
                "address": "Viale G. Puccini, 4, Viale G. Puccini, 4, 47838 Riccione RN, Italia",
                "email": "alessandro@hoteldory.it",
                "phone": "3805219868"
            },
            "coordinate": {
                "latitude": 44.00706,
                "longitude": 12.6534
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/bb81cbf3-c43a-4ff5-b2f1-75c9e059e441.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8924f2d5-df4b-49ca-895a-81c31ebb63eb.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/ac653679-b3d9-46fa-8810-52cfa9be92d6.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/9069b089-62ee-4c22-9ed1-c48f83c98e30.webp"
            ]
        },
        "title": "Rimini - Marecchia Touristic e-bike",
        "description": "Anello cicloturistico con partenza e arrivo a Rimini, pensato per e-bike e ritmo tranquillo, che porta dall\u2019area urbana verso l\u2019entroterra lungo la valle del Marecchia. \u00c8 un percorso scorrevole e panoramico, adatto a mezza giornata (o giornata easy) grazie a pendenze generalmente dolci e numerosi punti di sosta lungo il tragitto",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1523.webp",
        "price": 25.0,
        "location": "Riviera Romagnola",
        "location_id": 5,
        "tags": [
            "Mare",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1556,
                "title": "Rimini - Marecchia Tour",
                "description": "Descrizione pi\u00f9 dettagliata del tracciato: circa 48 km totali, quasi tutto su terreno facile, con dislivello complessivo contenuto (circa 220 m) e quota massima intorno ai 78 m. Prima parte prevalentemente pianeggiante, con uscita da Rimini e tratto di raccordo su strade/ciclabilit\u00e0 urbana verso l\u2019asta del fiume; la sezione centrale resta molto regolare. Le uniche variazioni altimetriche pi\u00f9 percepibili arrivano nella seconda met\u00e0, con 2\u20133 brevi rampe tra circa km 26 e km 33 (pendenze medie su brevi tratti fino a ~6\u20137%), seguite da discese altrettanto brevi e rientro progressivo verso la citt\u00e0",
                "notes": "",
                "start_address": "Viale G. Puccini, 4, 47838 Riccione",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    44.00693,
                    12.65355
                ],
                "preview_track": [
                    "44.00693;12.65355",
                    "44.00766;12.65465",
                    "44.00847;12.65359",
                    "44.01;12.65137",
                    "44.01153;12.64911",
                    "44.01224;12.64802",
                    "44.01213;12.64767",
                    "44.01212;12.64752",
                    "44.01241;12.64704",
                    "44.01421;12.64455",
                    "44.01444;12.64413",
                    "44.01479;12.64362",
                    "44.01556;12.64255",
                    "44.01607;12.64184",
                    "44.01654;12.64119",
                    "44.01689;12.6407",
                    "44.01755;12.63991",
                    "44.01792;12.63939",
                    "44.01839;12.63876",
                    "44.01989;12.63676",
                    "44.02095;12.63529",
                    "44.02237;12.63337",
                    "44.02244;12.63338",
                    "44.02252;12.63339",
                    "44.0226;12.63331",
                    "44.02263;12.63319",
                    "44.02262;12.63306",
                    "44.02275;12.63284",
                    "44.02375;12.63155",
                    "44.02514;12.62977",
                    "44.02627;12.62829",
                    "44.02709;12.62723",
                    "44.02758;12.62662",
                    "44.02752;12.62661",
                    "44.02775;12.62623",
                    "44.02794;12.62597",
                    "44.02818;12.626",
                    "44.03078;12.62327",
                    "44.03224;12.62141",
                    "44.03316;12.62026",
                    "44.03448;12.61866",
                    "44.035;12.6182",
                    "44.03804;12.61448",
                    "44.04005;12.61201",
                    "44.04059;12.61161",
                    "44.04123;12.6109",
                    "44.04334;12.60847",
                    "44.04375;12.60779",
                    "44.04408;12.60761",
                    "44.045;12.6068",
                    "44.04666;12.60489",
                    "44.04871;12.60252",
                    "44.05022;12.60088",
                    "44.05505;12.5957",
                    "44.05849;12.59202",
                    "44.06002;12.59075",
                    "44.05992;12.5905",
                    "44.06072;12.58946",
                    "44.06179;12.58835",
                    "44.06232;12.58772",
                    "44.06301;12.58708",
                    "44.06359;12.58661",
                    "44.06391;12.58684",
                    "44.06433;12.58626",
                    "44.06436;12.58585",
                    "44.06554;12.5845",
                    "44.06736;12.58284",
                    "44.06761;12.58253",
                    "44.06765;12.58229",
                    "44.06755;12.58199",
                    "44.06737;12.58177",
                    "44.06705;12.58163",
                    "44.06686;12.58143",
                    "44.06624;12.58105",
                    "44.06509;12.58084",
                    "44.06448;12.58082",
                    "44.06381;12.58066",
                    "44.06251;12.58006",
                    "44.06134;12.57925",
                    "44.06031;12.57804",
                    "44.05967;12.57703",
                    "44.05909;12.57592",
                    "44.05874;12.57548",
                    "44.05694;12.57263",
                    "44.05672;12.57165",
                    "44.05672;12.57155",
                    "44.05675;12.57135",
                    "44.05708;12.57097",
                    "44.0569;12.57055",
                    "44.05682;12.57028",
                    "44.05682;12.56957",
                    "44.05718;12.56837",
                    "44.05774;12.56742",
                    "44.05806;12.5681",
                    "44.05782;12.5687",
                    "44.05797;12.56937",
                    "44.05803;12.56949",
                    "44.05841;12.56945",
                    "44.05883;12.56898",
                    "44.05986;12.56785",
                    "44.06095;12.56666",
                    "44.06108;12.56652",
                    "44.06122;12.56543",
                    "44.06111;12.5646",
                    "44.06143;12.56405",
                    "44.0615;12.56393",
                    "44.06276;12.56398",
                    "44.06282;12.5639",
                    "44.06286;12.56384",
                    "44.06321;12.56399",
                    "44.0632;12.56419",
                    "44.06321;12.56469",
                    "44.06353;12.56596",
                    "44.06369;12.56634",
                    "44.06329;12.56414",
                    "44.06366;12.56379",
                    "44.06409;12.56291",
                    "44.06396;12.56273",
                    "44.06357;12.56209",
                    "44.06309;12.56252",
                    "44.06298;12.56248",
                    "44.06312;12.56174",
                    "44.06311;12.56139",
                    "44.06354;12.56116",
                    "44.06372;12.56121",
                    "44.06392;12.5601",
                    "44.06368;12.55888",
                    "44.0636;12.55561",
                    "44.06358;12.55535",
                    "44.0635;12.5544",
                    "44.06368;12.55288",
                    "44.06371;12.55262",
                    "44.0638;12.55181",
                    "44.06402;12.55146",
                    "44.06416;12.55146",
                    "44.06453;12.55164",
                    "44.06478;12.55154",
                    "44.06532;12.55055",
                    "44.06389;12.54663",
                    "44.06255;12.54331",
                    "44.06211;12.54167",
                    "44.06192;12.54079",
                    "44.06122;12.53785",
                    "44.06178;12.5353",
                    "44.06205;12.53374",
                    "44.06228;12.53277",
                    "44.06321;12.53069",
                    "44.06435;12.52823",
                    "44.06483;12.52762",
                    "44.06467;12.52652",
                    "44.06498;12.52508",
                    "44.06634;12.52206",
                    "44.06642;12.51945",
                    "44.06664;12.51594",
                    "44.06772;12.51281",
                    "44.06758;12.50985",
                    "44.06763;12.50736",
                    "44.06708;12.50607",
                    "44.06581;12.5044",
                    "44.06352;12.50191",
                    "44.06194;12.50143",
                    "44.061;12.50064",
                    "44.06055;12.50346",
                    "44.05918;12.50308",
                    "44.05706;12.50177",
                    "44.05543;12.5013",
                    "44.05381;12.50067",
                    "44.05128;12.49848",
                    "44.05108;12.49706",
                    "44.04975;12.49282",
                    "44.04915;12.49142",
                    "44.04959;12.49116",
                    "44.0508;12.48715",
                    "44.05171;12.48237",
                    "44.05215;12.48036",
                    "44.05207;12.47781",
                    "44.05138;12.47479",
                    "44.05107;12.47282",
                    "44.0513;12.47229",
                    "44.05085;12.46984",
                    "44.05057;12.46828",
                    "44.0495;12.46649",
                    "44.0494;12.46588",
                    "44.04916;12.46519",
                    "44.04913;12.46478",
                    "44.04697;12.467",
                    "44.04591;12.4684",
                    "44.04572;12.46918",
                    "44.0454;12.47225",
                    "44.04481;12.47583",
                    "44.04389;12.47648",
                    "44.04309;12.4774",
                    "44.04239;12.47875",
                    "44.04154;12.47983",
                    "44.04024;12.48209",
                    "44.03917;12.48416",
                    "44.03865;12.48425",
                    "44.03845;12.48425",
                    "44.03834;12.4843",
                    "44.0381;12.48431",
                    "44.03647;12.4857",
                    "44.03506;12.48646",
                    "44.03442;12.48671",
                    "44.03412;12.48684",
                    "44.03338;12.48814",
                    "44.03329;12.48912",
                    "44.03327;12.49003",
                    "44.03255;12.49095",
                    "44.03226;12.49062",
                    "44.03202;12.49092",
                    "44.03232;12.49176",
                    "44.03223;12.4922",
                    "44.03215;12.49237",
                    "44.03336;12.49377",
                    "44.03438;12.496",
                    "44.03487;12.49592",
                    "44.0356;12.49665",
                    "44.03704;12.49687",
                    "44.03788;12.49849",
                    "44.03785;12.49946",
                    "44.03704;12.49974",
                    "44.0356;12.5009",
                    "44.03552;12.50196",
                    "44.03566;12.50463",
                    "44.03711;12.50679",
                    "44.03836;12.51014",
                    "44.03969;12.51306",
                    "44.04047;12.51432",
                    "44.03909;12.5156",
                    "44.03805;12.51668",
                    "44.03644;12.51811",
                    "44.03422;12.51986",
                    "44.03301;12.52203",
                    "44.03226;12.52299",
                    "44.03168;12.52326",
                    "44.03074;12.5232",
                    "44.02949;12.52203",
                    "44.02807;12.52107",
                    "44.0259;12.52115",
                    "44.02516;12.52161",
                    "44.02405;12.52316",
                    "44.02293;12.52415",
                    "44.02212;12.52452",
                    "44.0215;12.52538",
                    "44.02279;12.5263",
                    "44.02327;12.52688",
                    "44.02261;12.5275",
                    "44.02137;12.52732",
                    "44.01913;12.52779",
                    "44.01893;12.52783",
                    "44.01589;12.52697",
                    "44.01395;12.5294",
                    "44.01251;12.53048",
                    "44.01194;12.53253",
                    "44.01287;12.5338",
                    "44.01423;12.53582",
                    "44.01461;12.53723",
                    "44.01495;12.53864",
                    "44.01505;12.54458",
                    "44.01414;12.54379",
                    "44.01335;12.54495",
                    "44.01226;12.54638",
                    "44.01043;12.5479",
                    "44.0095;12.54894",
                    "44.00866;12.55025",
                    "44.00908;12.55132",
                    "44.00892;12.55193",
                    "44.00777;12.55285",
                    "44.00598;12.55457",
                    "44.00442;12.55584",
                    "44.00283;12.55699",
                    "44.00133;12.55792",
                    "44.00025;12.55897",
                    "43.99818;12.56038",
                    "43.99727;12.56027",
                    "43.99681;12.56234",
                    "43.99759;12.56368",
                    "43.99655;12.56434",
                    "43.99624;12.56467",
                    "43.99633;12.56579",
                    "43.99582;12.56612",
                    "43.99507;12.56776",
                    "43.9958;12.57213",
                    "43.99685;12.57297",
                    "43.9977;12.57531",
                    "43.99997;12.57746",
                    "44.00058;12.57964",
                    "43.9993;12.57932",
                    "43.99947;12.58127",
                    "44.00003;12.58217",
                    "43.99816;12.58424",
                    "43.99848;12.58564",
                    "43.99917;12.58694",
                    "43.999;12.58813",
                    "43.99978;12.58954",
                    "43.99983;12.59052",
                    "43.99771;12.59282",
                    "43.99669;12.59496",
                    "43.99739;12.59702",
                    "43.99742;12.5992",
                    "43.99704;12.60075",
                    "43.9965;12.60276",
                    "43.99637;12.60306",
                    "43.99709;12.60642",
                    "43.99745;12.60778",
                    "43.9985;12.60881",
                    "43.99982;12.61006",
                    "44.00021;12.61109",
                    "44.00019;12.61168",
                    "44.00013;12.61181",
                    "44.00021;12.61191",
                    "44.00048;12.61258",
                    "44.00109;12.6139",
                    "44.00185;12.61618",
                    "44.00224;12.61739",
                    "44.00277;12.61966",
                    "44.00317;12.62015",
                    "44.00313;12.6205",
                    "44.00263;12.62103",
                    "44.00481;12.62536",
                    "44.00485;12.62548",
                    "44.0051;12.62561",
                    "44.00499;12.62589",
                    "44.00468;12.62641",
                    "44.00425;12.62779",
                    "44.00393;12.62896",
                    "44.00324;12.63005",
                    "44.00295;12.63078",
                    "44.00364;12.63198",
                    "44.00367;12.63339",
                    "44.00379;12.63379",
                    "44.00324;12.63404",
                    "44.00357;12.63436",
                    "44.00454;12.6343",
                    "44.00492;12.63498",
                    "44.00507;12.6356",
                    "44.00494;12.63559",
                    "44.00503;12.63552",
                    "44.00542;12.63642",
                    "44.00555;12.63682",
                    "44.00421;12.63795",
                    "44.00522;12.6406",
                    "44.00535;12.64089",
                    "44.0065;12.64342",
                    "44.00698;12.64459",
                    "44.0071;12.64476",
                    "44.00682;12.64517",
                    "44.00556;12.64705",
                    "44.00455;12.64855",
                    "44.00393;12.64938",
                    "44.00365;12.64974",
                    "44.00493;12.65156",
                    "44.00519;12.65112",
                    "44.00543;12.65131",
                    "44.00634;12.65267"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/2ad1a112-1751-439f-b86e-c44181c8c599.jpeg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5bb39c75-0b6f-42f4-919d-25869700bd6b.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/fa3fb93f-0efa-4953-886e-a221ec4e26ca.jpg"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 47432
                }
            }
        ],
        "catalogue": [
            {
                "id": 35,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 36,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1532,
        "customer": {
            "id": 378,
            "title": "Florence By Bike",
            "description": "Un ampio showroom nel cuore di Firenze. Selezioniamo solo i migliori brand per garantirti qualit\u00e0, affidabilit\u00e0 e stile. Che tu sia un ciclista esperto o alla ricerca della tua prima bici, vieni a scoprire il nostro showroom e lasciati consigliare dal nostro team.\r\nScopri Firenze e la Toscana in bici. Nel nostro punto noleggio trovi di tutto: dalle bici da citt\u00e0 alle bici da corsa. Che sia una pedalata nel centro storico o un giro tra le colline, avrai sempre mezzi affidabili. Con due officine attrezzate e due meccanici specializzati, siamo pronti a prenderci cura della tua bici. Offriamo manutenzione rapida, controlli accurati e riparazioni complete. Che si tratti di una semplice regolazione o di un intervento pi\u00f9 complesso, l\u2019esperienza dei nostri meccanici e la loro passione rimetteranno subito la tua bici in strada, pronta a pedalare ancora.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Florence_By_Bike.png",
            "text_logo": null,
            "contacts": {
                "address": "Via S. Zanobi, 54/R, Via S. Zanobi, 54/R, 50129 Firenze FI, Italia",
                "email": "info@florencebybike.it",
                "phone": "055 488992"
            },
            "coordinate": {
                "latitude": 43.77913,
                "longitude": 11.25548
            },
            "tours": 2,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/7f2fa4dc-f0e9-4cd1-bf94-9c4823cdebd0.jpeg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/acb199c7-3a9d-4b56-be83-41922b2e84b0.jpeg"
            ]
        },
        "title": "Florence Countryside Tour  (Short Version) ",
        "description": "Tour e-bike da Firenze tra citt\u00e0, colline e panorami iconici. Dal centro si sale verso Pian dei Giullari e Piazzale Michelangelo, per poi attraversare la zona di Santa Maria a Montici e rientrare lungo l\u2019Arno. Il finale regala uno degli scorci pi\u00f9 suggestivi della citt\u00e0, con la discesa dalle Rampe verso San Niccol\u00f2 e il ritorno nel cuore di Firenze.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1532.jpg",
        "price": 20.0,
        "location": "Firenze",
        "location_id": 39,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1567,
                "title": "Florence Countryside Easy Tour",
                "description": "Questo tour e-bike parte dal centro di Firenze e propone un itinerario panoramico che unisce l\u2019eleganza della citt\u00e0 ai suoi versanti collinari pi\u00f9 celebri. Dopo i primi tratti urbani, il percorso sale verso Pian dei Giullari, una delle zone pi\u00f9 affascinanti delle colline fiorentine, immersa in un paesaggio fatto di ville, giardini, oliveti e splendide vedute sulla citt\u00e0.\n\nIl tour prosegue poi verso Piazzale Michelangelo, il punto panoramico per eccellenza, da cui si apre una vista straordinaria sul centro storico di Firenze, sull\u2019Arno e sui principali monumenti. Da qui il percorso continua in direzione di Santa Maria a Montici, attraversando un contesto pi\u00f9 tranquillo e residenziale, dove il ritmo si fa rilassato e la pedalata resta piacevole e scorrevole.\n\nLa seconda parte del tour accompagna nuovamente verso il fiume, seguendo i Lungarni in un tratto molto suggestivo che permette di vivere Firenze da una prospettiva diversa, tra palazzi storici, scorci sull\u2019acqua e angoli meno frenetici della citt\u00e0. Il rientro in centro \u00e8 reso ancora pi\u00f9 speciale dal passaggio alle Rampe che scendono verso San Niccol\u00f2, uno dei luoghi pi\u00f9 caratteristici e amati di Firenze, perfetto per chiudere il giro con un tocco scenografico.\n\n\u00c8 un tour ideale per chi desidera scoprire Firenze in e-bike in modo dinamico ma rilassato, alternando salite accessibili, panorami iconici e tratti urbani di grande fascino.",
                "notes": "",
                "start_address": "Via dei Renai 13, Firenze",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1532.jpg",
                "track": [
                    43.7789,
                    11.25519
                ],
                "preview_track": [
                    "43.7789;11.25519",
                    "43.77788;11.25423",
                    "43.77721;11.25324",
                    "43.77752;11.2526",
                    "43.77716;11.25205",
                    "43.77624;11.25045",
                    "43.77598;11.24985",
                    "43.7758;11.24994",
                    "43.7751;11.25015",
                    "43.77489;11.25021",
                    "43.77476;11.25014",
                    "43.77477;11.2499",
                    "43.7742;11.24993",
                    "43.77393;11.24982",
                    "43.77378;11.24986",
                    "43.77315;11.24963",
                    "43.77304;11.24944",
                    "43.77287;11.24934",
                    "43.77277;11.24949",
                    "43.77224;11.24943",
                    "43.77222;11.24941",
                    "43.77173;11.24886",
                    "43.77105;11.24808",
                    "43.77098;11.2481",
                    "43.77078;11.2479",
                    "43.77072;11.24785",
                    "43.77074;11.2478",
                    "43.77077;11.24765",
                    "43.76972;11.24691",
                    "43.76964;11.24704",
                    "43.76907;11.2466",
                    "43.76904;11.2466",
                    "43.76865;11.24635",
                    "43.76803;11.24599",
                    "43.76766;11.24581",
                    "43.76758;11.24573",
                    "43.76591;11.24473",
                    "43.76522;11.24433",
                    "43.76419;11.24375",
                    "43.76339;11.24333",
                    "43.76266;11.24292",
                    "43.76127;11.24217",
                    "43.76122;11.24238",
                    "43.76089;11.24219",
                    "43.76069;11.24222",
                    "43.7604;11.2425",
                    "43.76017;11.24239",
                    "43.75997;11.242",
                    "43.75966;11.24214",
                    "43.75735;11.24337",
                    "43.75729;11.24332",
                    "43.75661;11.24369",
                    "43.75581;11.24411",
                    "43.75479;11.24464",
                    "43.75317;11.24542",
                    "43.75298;11.24556",
                    "43.75294;11.24563",
                    "43.75262;11.24587",
                    "43.75151;11.24647",
                    "43.75019;11.24716",
                    "43.75021;11.24727",
                    "43.75017;11.24782",
                    "43.74988;11.24819",
                    "43.74998;11.24872",
                    "43.75022;11.24925",
                    "43.74967;11.24951",
                    "43.74877;11.24926",
                    "43.74786;11.24991",
                    "43.74751;11.2509",
                    "43.74709;11.2499",
                    "43.7468;11.24929",
                    "43.7461;11.24854",
                    "43.74519;11.24762",
                    "43.7448;11.24702",
                    "43.74318;11.24548",
                    "43.74281;11.24526",
                    "43.74324;11.24662",
                    "43.74409;11.24739",
                    "43.74465;11.24859",
                    "43.74442;11.24906",
                    "43.7454;11.25159",
                    "43.74584;11.25259",
                    "43.74595;11.25367",
                    "43.74625;11.25483",
                    "43.74637;11.25653",
                    "43.74674;11.25758",
                    "43.74707;11.25808",
                    "43.74659;11.25857",
                    "43.74546;11.25937",
                    "43.74482;11.26079",
                    "43.74429;11.26167",
                    "43.74392;11.2625",
                    "43.74366;11.26331",
                    "43.74398;11.26422",
                    "43.74434;11.26607",
                    "43.74467;11.26706",
                    "43.74508;11.26813",
                    "43.74538;11.26888",
                    "43.74548;11.26993",
                    "43.74571;11.27128",
                    "43.74717;11.27348",
                    "43.749;11.27229",
                    "43.74955;11.2723",
                    "43.75074;11.27338",
                    "43.75118;11.27406",
                    "43.75183;11.27462",
                    "43.75274;11.27601",
                    "43.75328;11.27621",
                    "43.75445;11.27585",
                    "43.75514;11.27563",
                    "43.75596;11.27577",
                    "43.75677;11.27599",
                    "43.75762;11.27583",
                    "43.75793;11.27535",
                    "43.75811;11.27536",
                    "43.75822;11.27684",
                    "43.75861;11.27743",
                    "43.75905;11.2778",
                    "43.76042;11.27782",
                    "43.76073;11.27761",
                    "43.76093;11.27722",
                    "43.76117;11.27643",
                    "43.7616;11.27549",
                    "43.76174;11.27511",
                    "43.76155;11.27504",
                    "43.76189;11.27441",
                    "43.76195;11.27422",
                    "43.76207;11.27418",
                    "43.76201;11.27406",
                    "43.76203;11.2739",
                    "43.76205;11.27309",
                    "43.76205;11.27261",
                    "43.76205;11.27261",
                    "43.76148;11.27258",
                    "43.76033;11.27221",
                    "43.75867;11.27168",
                    "43.75812;11.27147",
                    "43.7573;11.2707",
                    "43.75648;11.26961",
                    "43.75643;11.26959",
                    "43.75642;11.26925",
                    "43.75647;11.26885",
                    "43.75676;11.26836",
                    "43.75711;11.26818",
                    "43.75765;11.26832",
                    "43.75861;11.26905",
                    "43.76008;11.27015",
                    "43.76064;11.27026",
                    "43.76102;11.27",
                    "43.76129;11.26945",
                    "43.76131;11.26887",
                    "43.76125;11.26813",
                    "43.76145;11.26713",
                    "43.76184;11.26643",
                    "43.76228;11.26569",
                    "43.76251;11.26519",
                    "43.76258;11.26459",
                    "43.76245;11.26425",
                    "43.76216;11.26409",
                    "43.76255;11.26388",
                    "43.76287;11.26366",
                    "43.76312;11.26366",
                    "43.76326;11.26372",
                    "43.76342;11.26386",
                    "43.76345;11.26418",
                    "43.76312;11.26602",
                    "43.76318;11.26614",
                    "43.76329;11.26628",
                    "43.76342;11.26634",
                    "43.76354;11.26623",
                    "43.76358;11.26502",
                    "43.76367;11.2643",
                    "43.7636;11.26358",
                    "43.7633;11.26314",
                    "43.76328;11.26301",
                    "43.76314;11.26298",
                    "43.76331;11.26296",
                    "43.76346;11.26303",
                    "43.76381;11.26373",
                    "43.76391;11.26542",
                    "43.76399;11.26673",
                    "43.76406;11.26693",
                    "43.76415;11.26692",
                    "43.76422;11.26659",
                    "43.76419;11.26605",
                    "43.76404;11.26544",
                    "43.76405;11.26511",
                    "43.76415;11.26546",
                    "43.76424;11.2654",
                    "43.76429;11.26482",
                    "43.76436;11.26436",
                    "43.76446;11.26431",
                    "43.76488;11.26454",
                    "43.76496;11.26381",
                    "43.76506;11.26344",
                    "43.76546;11.25908",
                    "43.76547;11.25856",
                    "43.7656;11.25846",
                    "43.76679;11.2591",
                    "43.76689;11.25916",
                    "43.76727;11.25927",
                    "43.7676;11.25953",
                    "43.7678;11.25959",
                    "43.76893;11.26052",
                    "43.76893;11.26061",
                    "43.76934;11.26093",
                    "43.76989;11.26132",
                    "43.77022;11.26163",
                    "43.7707;11.26199",
                    "43.77083;11.26211",
                    "43.77126;11.26246",
                    "43.77142;11.26263",
                    "43.77161;11.26261",
                    "43.77181;11.2618",
                    "43.7726;11.26052",
                    "43.77264;11.26044",
                    "43.77317;11.25957",
                    "43.77386;11.25835",
                    "43.77413;11.25793",
                    "43.77415;11.25787",
                    "43.7745;11.25681",
                    "43.7763;11.2582",
                    "43.77635;11.25816",
                    "43.77669;11.25733",
                    "43.77708;11.25617",
                    "43.77711;11.25613",
                    "43.7774;11.25533",
                    "43.77782;11.25438",
                    "43.77894;11.25526"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/0a848ace-fe6c-4c2b-b93f-48cdf6904914.JPG",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/4197d311-08c2-4d4c-9156-7e3c1b14311d.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/92420fc6-618d-4849-9779-38c250729996.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/e0dead85-0361-4050-9174-0fb3d8f5f7df.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d1a872e1-90e1-4126-b7c6-27d77cd28350.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Villa Poggio Imperiale",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/10dd5c31-4670-41a8-9e97-f1c164885f1b.Villa__43_750187699927295_11_247124671936035",
                        "latitude": 43.750187699927295,
                        "longitude": 11.247124671936035,
                        "description": "Villa Poggio Imperiale \u00e8 una storica villa di Firenze, costruita nel XVI secolo dalla potente famiglia Strozzi.\n Fu progettata inizialmente da Giorgio Vasari e ampliata nei secoli successivi da altri architetti.\n Situata su una collina, offre splendide viste sulla citt\u00e0 e sul paesaggio circostante.\n Nel tempo \u00e8 stata residenza reale dei Granduchi di Toscana e poi sede dell\u2019Istituto delle Suore di San Giuseppe per l\u2019educazione femminile.\n Oggi \u00e8 aperta al pubblico e famosa per i suoi giardini, la grande architettura e il valore storico legato al Rinascimento fiorentino."
                    },
                    {
                        "name": "Piazzale Michelangelo",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/37eeb74f-61c0-47e6-b9d4-2c9529be4bea.Piazz__43_762160407008984_11_264097690582277",
                        "latitude": 43.762160407008984,
                        "longitude": 11.264097690582277,
                        "description": "Piazzale Michelangelo \u00e8 il punto panoramico pi\u00f9 celebre di Firenze, meta immancabile per chi visita la citt\u00e0. Fu realizzato nel 1869 su progetto di Giuseppe Poggi, durante il periodo in cui Firenze era capitale d\u2019Italia e interessata da un importante rinnovamento urbanistico. La piazza, dedicata a Michelangelo, ospita copie in bronzo del David e delle quattro allegorie delle Cappelle Medicee di San Lorenzo, mentre gli originali sono in marmo bianco."
                    },
                    {
                        "name": "Giardino delle Rose",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/952f06bf-e47b-4181-9133-fb88ff8ac2e6.Giard__43_76315221315189_11_262987256050112",
                        "latitude": 43.76315221315189,
                        "longitude": 11.262987256050112,
                        "description": "Il Giardino delle Rose \u00e8 un terrazzo verde sull\u2019Oltrarno, sotto Piazzale Michelangelo, con una vista spettacolare sul centro storico di Firenze.\n Ospita circa 400 variet\u00e0 di rose e oltre 1.200 piante tra limoni, tillandsie e specie rare.\n Fu progettato nel 1865 dall\u2019architetto Giuseppe Poggi, nell\u2019ambito dei lavori per Firenze capitale.\n Negli ultimi anni si \u00e8 arricchito con dieci sculture in bronzo dell\u2019artista belga Jean-Michel Folon.\n All\u2019interno si trova anche l\u2019oasi giapponese Shorai, donata dalla citt\u00e0 gemellata di Ky\u014dto e dal tempio zen Kodai-ji."
                    }
                ],
                "infos": {
                    "distance": 16441
                }
            }
        ],
        "catalogue": [
            {
                "id": 52,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 53,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1555,
        "customer": {
            "id": 201,
            "title": "E-Bike Tuscany",
            "description": "descrizione da cambiare",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/E-Bike_Tuscany_Pienza.png",
            "text_logo": null,
            "contacts": {
                "address": "Via della Buca, 23, Via della Buca, 23, 53026 Pienza SI, Italia",
                "email": "info@e-biketuscany.com",
                "phone": "3478815780"
            },
            "coordinate": {
                "latitude": 43.07724,
                "longitude": 11.67845
            },
            "tours": 2,
            "gallery": []
        },
        "title": "Val d'Orcia & Pienza E-Bike Tour (Long Version) ",
        "description": "Tour in E-Bike alla scoperta della Val d'Orcia, Pienza, Bagno Vignoni e San Quirico d'Orcia della durata di circa 4 ore. In questo tour andremo a vedere la Strada del Gladiatore, la Cappella di Vitaleta, Terme di Bagno Vignoni e molti altri posti magnifici.\n",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1555.jpeg",
        "price": 25.0,
        "location": "Val d'Orcia",
        "location_id": 36,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1588,
                "title": "Val D'Orcia E-bike Tour Long",
                "description": "Tour in e-bike con partenza da Pienza alla scoperta di alcuni dei luoghi pi\u00f9 iconici della Val d\u2019Orcia, in un itinerario panoramico di circa 4 ore circa. Il percorso attraversa uno dei paesaggi pi\u00f9 celebri della Toscana, tra colline, cipressi, strade bianche e tratti di asfalto poco trafficato.\n\nDal centro di Pienza, gioiello rinascimentale patrimonio UNESCO, il tour si sviluppa su un tracciato generalmente facile, ideale per chi vuole godersi il paesaggio senza particolari difficolt\u00e0 tecniche. Il fondo \u00e8 prevalentemente scorrevole, con qualche breve salita un po\u2019 pi\u00f9 ripida, ma facilmente gestibile in e-bike usando correttamente cambio e livelli di assistenza.\n\nL\u2019itinerario tocca luoghi simbolo come la famosa Strada del Gladiatore, la suggestiva Cappella di Vitaleta, Bagno Vignoni con la sua storica vasca termale e i dintorni di San Quirico d\u2019Orcia, tra vigneti, oliveti, poderi storici e scorci spettacolari.\n\nNei mesi estivi \u00e8 consigliabile partire la mattina presto o nel tardo pomeriggio, evitando le ore pi\u00f9 calde della giornata. Lungo il percorso si attraversano diversi paesini, quindi non mancano punti acqua utili per una sosta e per rifornirsi facilmente.\n\n",
                "notes": "",
                "start_address": "Via della Buca, 23, 53026 Pienza SI, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1555.jpeg",
                "track": [
                    43.07758,
                    11.68082
                ],
                "preview_track": [
                    "43.07758;11.68082",
                    "43.07722;11.68068",
                    "43.07709;11.68106",
                    "43.07705;11.68132",
                    "43.07701;11.68163",
                    "43.07697;11.68171",
                    "43.07689;11.68177",
                    "43.07639;11.68182",
                    "43.07625;11.68176",
                    "43.07613;11.68155",
                    "43.07605;11.68117",
                    "43.07596;11.68063",
                    "43.07606;11.67981",
                    "43.07607;11.67972",
                    "43.07601;11.67931",
                    "43.07593;11.67843",
                    "43.07616;11.67699",
                    "43.07671;11.67512",
                    "43.07693;11.6744",
                    "43.07698;11.67417",
                    "43.07694;11.67384",
                    "43.07694;11.67341",
                    "43.07692;11.67327",
                    "43.07684;11.67322",
                    "43.07673;11.67328",
                    "43.07635;11.674",
                    "43.07541;11.67483",
                    "43.07457;11.67549",
                    "43.07398;11.67702",
                    "43.07337;11.67839",
                    "43.0724;11.68004",
                    "43.07204;11.68018",
                    "43.07219;11.67905",
                    "43.07197;11.67857",
                    "43.06949;11.67885",
                    "43.06902;11.67964",
                    "43.0686;11.67991",
                    "43.06845;11.67946",
                    "43.06855;11.67872",
                    "43.06851;11.67854",
                    "43.06846;11.67847",
                    "43.06852;11.67843",
                    "43.0686;11.67829",
                    "43.06906;11.67699",
                    "43.06785;11.67525",
                    "43.06674;11.67442",
                    "43.06648;11.6735",
                    "43.06672;11.67287",
                    "43.06637;11.6725",
                    "43.06578;11.67187",
                    "43.06544;11.67211",
                    "43.06471;11.6719",
                    "43.06122;11.66937",
                    "43.06089;11.66864",
                    "43.06059;11.66745",
                    "43.0604;11.66611",
                    "43.06094;11.66606",
                    "43.06217;11.66705",
                    "43.06314;11.66659",
                    "43.06452;11.66646",
                    "43.06513;11.66701",
                    "43.06571;11.66712",
                    "43.06643;11.66628",
                    "43.06697;11.66592",
                    "43.06783;11.6665",
                    "43.06867;11.66749",
                    "43.06984;11.66756",
                    "43.07083;11.6674",
                    "43.07153;11.66754",
                    "43.07097;11.66741",
                    "43.07015;11.66752",
                    "43.0688;11.66754",
                    "43.06805;11.66676",
                    "43.06724;11.66607",
                    "43.06647;11.66609",
                    "43.06584;11.66703",
                    "43.06524;11.6671",
                    "43.06461;11.66648",
                    "43.06329;11.66653",
                    "43.06239;11.66701",
                    "43.06153;11.6668",
                    "43.06052;11.66601",
                    "43.05996;11.66587",
                    "43.05727;11.66223",
                    "43.05638;11.66156",
                    "43.05521;11.66127",
                    "43.05421;11.66035",
                    "43.05292;11.65782",
                    "43.05161;11.65692",
                    "43.05026;11.65699",
                    "43.04913;11.65595",
                    "43.04792;11.65473",
                    "43.04649;11.6547",
                    "43.04573;11.65359",
                    "43.04448;11.65172",
                    "43.04365;11.65014",
                    "43.04229;11.64839",
                    "43.04005;11.64828",
                    "43.03842;11.648",
                    "43.03693;11.64685",
                    "43.03541;11.64573",
                    "43.03496;11.64522",
                    "43.03483;11.64503",
                    "43.03481;11.6448",
                    "43.03451;11.6432",
                    "43.03362;11.63845",
                    "43.03344;11.63586",
                    "43.0336;11.6338",
                    "43.03337;11.63062",
                    "43.03334;11.63005",
                    "43.03335;11.62949",
                    "43.03341;11.62866",
                    "43.03346;11.62791",
                    "43.03346;11.62773",
                    "43.0334;11.62751",
                    "43.03256;11.62714",
                    "43.031;11.62665",
                    "43.03073;11.62657",
                    "43.03047;11.62651",
                    "43.03013;11.62644",
                    "43.02993;11.62634",
                    "43.0296;11.62613",
                    "43.02934;11.626",
                    "43.02899;11.62587",
                    "43.02882;11.62576",
                    "43.02852;11.62537",
                    "43.0284;11.62531",
                    "43.02833;11.62519",
                    "43.02805;11.62448",
                    "43.02802;11.62435",
                    "43.02794;11.62389",
                    "43.02792;11.62346",
                    "43.02799;11.62302",
                    "43.02814;11.62245",
                    "43.02831;11.62131",
                    "43.0284;11.62072",
                    "43.02851;11.61976",
                    "43.02851;11.61953",
                    "43.02847;11.61938",
                    "43.02839;11.61934",
                    "43.02815;11.61926",
                    "43.02757;11.61913",
                    "43.02752;11.61912",
                    "43.02753;11.61899",
                    "43.02761;11.61883",
                    "43.0278;11.61857",
                    "43.02817;11.61824",
                    "43.02816;11.61821",
                    "43.02791;11.61845",
                    "43.02768;11.61872",
                    "43.02755;11.61895",
                    "43.02751;11.61906",
                    "43.02747;11.61911",
                    "43.02739;11.61907",
                    "43.02731;11.61898",
                    "43.02727;11.61889",
                    "43.02732;11.619",
                    "43.02741;11.61908",
                    "43.02749;11.61912",
                    "43.02757;11.61913",
                    "43.02815;11.61926",
                    "43.02839;11.61934",
                    "43.02847;11.61938",
                    "43.02851;11.61953",
                    "43.02851;11.61976",
                    "43.0285;11.62019",
                    "43.02864;11.62028",
                    "43.02885;11.62054",
                    "43.02915;11.62059",
                    "43.02939;11.62066",
                    "43.02993;11.62062",
                    "43.03019;11.62062",
                    "43.0304;11.62076",
                    "43.03048;11.62071",
                    "43.03059;11.62048",
                    "43.03061;11.62014",
                    "43.0305;11.61975",
                    "43.03042;11.61945",
                    "43.03045;11.61917",
                    "43.03056;11.61893",
                    "43.03072;11.61879",
                    "43.03125;11.61866",
                    "43.03136;11.6189",
                    "43.03145;11.61905",
                    "43.03168;11.61906",
                    "43.03186;11.61891",
                    "43.03191;11.61872",
                    "43.03191;11.61844",
                    "43.03196;11.61822",
                    "43.03203;11.61811",
                    "43.03219;11.61795",
                    "43.0323;11.61773",
                    "43.03258;11.61719",
                    "43.03273;11.61721",
                    "43.03362;11.61691",
                    "43.03361;11.61661",
                    "43.03347;11.61644",
                    "43.03327;11.61632",
                    "43.03331;11.61606",
                    "43.03347;11.61573",
                    "43.03345;11.61558",
                    "43.03347;11.61533",
                    "43.03376;11.61476",
                    "43.03385;11.61449",
                    "43.0338;11.61418",
                    "43.03383;11.61317",
                    "43.03388;11.61208",
                    "43.03409;11.61065",
                    "43.03422;11.61048",
                    "43.03467;11.60996",
                    "43.03501;11.60968",
                    "43.03517;11.60935",
                    "43.03521;11.60901",
                    "43.03513;11.60846",
                    "43.0351;11.60796",
                    "43.03517;11.60775",
                    "43.03539;11.60729",
                    "43.03581;11.6064",
                    "43.03592;11.60619",
                    "43.03612;11.60584",
                    "43.03631;11.60572",
                    "43.03643;11.60587",
                    "43.03644;11.6061",
                    "43.03643;11.60646",
                    "43.03651;11.60691",
                    "43.03667;11.60682",
                    "43.03674;11.60664",
                    "43.03695;11.60641",
                    "43.03714;11.6064",
                    "43.03729;11.60646",
                    "43.03749;11.60627",
                    "43.03799;11.60612",
                    "43.03822;11.60602",
                    "43.03835;11.60583",
                    "43.03846;11.60509",
                    "43.03854;11.6045",
                    "43.03864;11.60405",
                    "43.03914;11.60328",
                    "43.03936;11.6029",
                    "43.03951;11.60252",
                    "43.03964;11.60184",
                    "43.03961;11.60169",
                    "43.03953;11.60138",
                    "43.03935;11.60111",
                    "43.039;11.60099",
                    "43.03884;11.60084",
                    "43.03872;11.60066",
                    "43.03871;11.60027",
                    "43.03865;11.6",
                    "43.03864;11.59955",
                    "43.03865;11.59914",
                    "43.03861;11.59884",
                    "43.03861;11.59838",
                    "43.03877;11.59819",
                    "43.03906;11.59808",
                    "43.03856;11.59665",
                    "43.03833;11.59579",
                    "43.03749;11.59201",
                    "43.03744;11.59155",
                    "43.03737;11.59127",
                    "43.03694;11.59081",
                    "43.0365;11.59048",
                    "43.03608;11.59027",
                    "43.0355;11.58975",
                    "43.03501;11.5891",
                    "43.03477;11.58871",
                    "43.0346;11.58833",
                    "43.03443;11.58807",
                    "43.03419;11.5879",
                    "43.03384;11.58771",
                    "43.03341;11.58767",
                    "43.0332;11.58764",
                    "43.03297;11.58751",
                    "43.03262;11.58714",
                    "43.03235;11.58675",
                    "43.03145;11.58536",
                    "43.03112;11.58493",
                    "43.03095;11.58484",
                    "43.03103;11.58487",
                    "43.03119;11.585",
                    "43.03222;11.58648",
                    "43.03242;11.58687",
                    "43.03278;11.58733",
                    "43.03306;11.58758",
                    "43.03328;11.58766",
                    "43.0337;11.58768",
                    "43.03392;11.58775",
                    "43.03432;11.58799",
                    "43.03449;11.58815",
                    "43.03469;11.58852",
                    "43.03485;11.58884",
                    "43.03534;11.58955",
                    "43.03573;11.58997",
                    "43.03619;11.59033",
                    "43.03664;11.59058",
                    "43.03726;11.59112",
                    "43.03741;11.59137",
                    "43.03745;11.59178",
                    "43.0378;11.59345",
                    "43.03845;11.59626",
                    "43.03866;11.59695",
                    "43.03921;11.59851",
                    "43.03942;11.59886",
                    "43.03991;11.59928",
                    "43.04023;11.59944",
                    "43.0406;11.59953",
                    "43.04142;11.59963",
                    "43.04193;11.5998",
                    "43.04281;11.60045",
                    "43.0431;11.60058",
                    "43.04462;11.6006",
                    "43.04512;11.6007",
                    "43.04638;11.60132",
                    "43.047;11.60152",
                    "43.04748;11.60139",
                    "43.04841;11.60075",
                    "43.04963;11.59995",
                    "43.05078;11.59954",
                    "43.05148;11.59938",
                    "43.05189;11.59953",
                    "43.05241;11.59992",
                    "43.05266;11.60032",
                    "43.05273;11.60044",
                    "43.05309;11.60087",
                    "43.05409;11.60167",
                    "43.05454;11.60185",
                    "43.05489;11.60205",
                    "43.05522;11.60239",
                    "43.0555;11.60269",
                    "43.05648;11.60381",
                    "43.05662;11.60401",
                    "43.05678;11.60434",
                    "43.05709;11.60478",
                    "43.05739;11.60562",
                    "43.0575;11.60608",
                    "43.05777;11.60676",
                    "43.05777;11.60676",
                    "43.05792;11.60653",
                    "43.05809;11.6061",
                    "43.05788;11.60577",
                    "43.05842;11.60519",
                    "43.05923;11.60437",
                    "43.05943;11.60457",
                    "43.0594;11.60462",
                    "43.05912;11.60498",
                    "43.05867;11.60542",
                    "43.0584;11.60566",
                    "43.05809;11.6061",
                    "43.05792;11.60653",
                    "43.05777;11.60676",
                    "43.05723;11.60768",
                    "43.05668;11.60859",
                    "43.05648;11.60897",
                    "43.05625;11.6094",
                    "43.05601;11.60978",
                    "43.05531;11.61113",
                    "43.05485;11.612",
                    "43.05461;11.6123",
                    "43.05419;11.61274",
                    "43.05303;11.61387",
                    "43.05263;11.61411",
                    "43.05242;11.61437",
                    "43.05256;11.61514",
                    "43.05312;11.6158",
                    "43.05314;11.61593",
                    "43.05307;11.61632",
                    "43.05295;11.61697",
                    "43.05291;11.61731",
                    "43.05283;11.61755",
                    "43.05259;11.61808",
                    "43.05236;11.61867",
                    "43.05222;11.61908",
                    "43.05206;11.61943",
                    "43.05174;11.62",
                    "43.05163;11.62013",
                    "43.05147;11.62023",
                    "43.05122;11.62032",
                    "43.05048;11.62047",
                    "43.0501;11.62056",
                    "43.04996;11.62067",
                    "43.04986;11.62083",
                    "43.04979;11.62102",
                    "43.04966;11.62154",
                    "43.04955;11.62207",
                    "43.04948;11.6224",
                    "43.04938;11.62255",
                    "43.04927;11.62287",
                    "43.0491;11.62334",
                    "43.04881;11.62394",
                    "43.04831;11.62496",
                    "43.04814;11.62527",
                    "43.04803;11.6254",
                    "43.04789;11.62549",
                    "43.04769;11.62551",
                    "43.04717;11.62558",
                    "43.04714;11.62563",
                    "43.04709;11.62585",
                    "43.04707;11.62628",
                    "43.04717;11.62658",
                    "43.04793;11.62716",
                    "43.04815;11.62717",
                    "43.04842;11.62709",
                    "43.04951;11.62659",
                    "43.05159;11.62727",
                    "43.05394;11.62627",
                    "43.05584;11.62618",
                    "43.0569;11.62644",
                    "43.05695;11.62679",
                    "43.05684;11.62772",
                    "43.05656;11.62881",
                    "43.05639;11.63115",
                    "43.05665;11.633",
                    "43.05625;11.63481",
                    "43.05602;11.63628",
                    "43.05614;11.63856",
                    "43.05655;11.64018",
                    "43.05732;11.64164",
                    "43.05782;11.64234",
                    "43.05817;11.64236",
                    "43.05895;11.64199",
                    "43.06022;11.64194",
                    "43.06058;11.64225",
                    "43.06281;11.64578",
                    "43.06396;11.64794",
                    "43.06496;11.6485",
                    "43.06573;11.6483",
                    "43.06729;11.64809",
                    "43.06819;11.64737",
                    "43.06757;11.64554",
                    "43.06756;11.64433",
                    "43.06897;11.64297",
                    "43.07018;11.6422",
                    "43.06995;11.64164",
                    "43.06958;11.64108",
                    "43.06953;11.64051",
                    "43.07001;11.63866",
                    "43.07032;11.63666",
                    "43.07042;11.63485",
                    "43.0707;11.63438",
                    "43.07059;11.63469",
                    "43.07034;11.63502",
                    "43.07028;11.63713",
                    "43.0699;11.63896",
                    "43.06953;11.64065",
                    "43.0696;11.64118",
                    "43.07023;11.64192",
                    "43.07072;11.64218",
                    "43.07226;11.6432",
                    "43.07486;11.64767",
                    "43.07723;11.64742",
                    "43.07832;11.6466",
                    "43.08108;11.64642",
                    "43.08172;11.64604",
                    "43.08199;11.64605",
                    "43.08339;11.64846",
                    "43.08449;11.65023",
                    "43.08575;11.65142",
                    "43.08715;11.65247",
                    "43.08786;11.65352",
                    "43.08846;11.65552",
                    "43.0877;11.65767",
                    "43.08632;11.66021",
                    "43.08583;11.66186",
                    "43.08521;11.6641",
                    "43.08503;11.66472",
                    "43.08402;11.66664",
                    "43.08271;11.66684",
                    "43.08166;11.66798",
                    "43.08103;11.66921",
                    "43.08096;11.66961",
                    "43.08084;11.66982",
                    "43.07946;11.67076",
                    "43.07923;11.67152",
                    "43.07808;11.67371",
                    "43.07847;11.6729",
                    "43.07906;11.67349",
                    "43.07934;11.67422",
                    "43.07899;11.67483",
                    "43.0779;11.67652",
                    "43.07772;11.67685",
                    "43.0774;11.67646",
                    "43.07735;11.67648",
                    "43.07719;11.67687",
                    "43.0772;11.67714",
                    "43.07727;11.67726",
                    "43.07752;11.67744",
                    "43.07762;11.67743",
                    "43.0776;11.6775",
                    "43.07758;11.67788",
                    "43.07752;11.67877",
                    "43.07748;11.67935",
                    "43.07739;11.6798",
                    "43.07719;11.68063",
                    "43.07724;11.68071"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/77462b6c-c64c-49dd-8610-ad59b4b3fad2.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/13ff09d1-7cd9-4394-a360-f8ff9ebebd0e.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/2807ce4c-a16d-45e1-94b2-95316c11fb91.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/11e45a1b-71f5-46f0-b2b5-b5439f803629.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b05f233a-0edf-437f-8f94-771b6e3da663.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Bagno Vignoni",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/a56f176f-b599-4ab4-9a85-0e85545710de.bagno__43_028171047135196_11_6181988385506",
                        "latitude": 43.028171047135196,
                        "longitude": 11.6181988385506,
                        "description": "Bagno Vignoni \u00e8 un piccolo borgo termale in Val d\u2019Orcia, famoso per la sua piazza centrale occupata da una grande vasca di acqua calda sorgiva. Frequentato fin dai tempi dei Romani, ha conservato un\u2019atmosfera medievale e suggestiva. Le acque termali sono ancora oggi utilizzate in strutture benessere locali. Nei dintorni si trovano i Mulini medievali e splendidi paesaggi toscani.\n"
                    },
                    {
                        "name": "San Quirico d'Orcia",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d52d7435-c540-4bbe-a3ee-a5191554a96a.san_q__43_05943282578289_11_604519509710373",
                        "latitude": 43.05943282578289,
                        "longitude": 11.604519509710373,
                        "description": "San Quirico d'Orcia \u00e8 un affascinante borgo medievale situato nel cuore della Val d\u2019Orcia, in Toscana. Caratterizzato da strette vie lastricate, chiese romaniche e antiche mura, offre un\u2019atmosfera tranquilla e autentica. Tra i luoghi d\u2019interesse spiccano la Collegiata dei Santi Quirico e Giulitta e gli Horti Leonini, uno dei primi esempi di giardino all\u2019italiana. Il borgo \u00e8 anche un\u2019importante tappa della Via Francigena.\n"
                    },
                    {
                        "name": "La Cappella della Madonna di Vitaleta",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/34dcb75c-6c16-4e34-ad8f-d91a2ff390cd.vital__43_07066557525845_11_63435384631157",
                        "latitude": 43.07066557525845,
                        "longitude": 11.63435384631157,
                        "description": "La Cappella della Madonna di Vitaleta \u00e8 una piccola chiesa iconica situata tra San Quirico d'Orcia e Pienza, nel cuore della Val d\u2019Orcia. Immersa tra dolci colline e cipressi, \u00e8 uno dei luoghi pi\u00f9 fotografati della Toscana. Risalente al XIX secolo, fu costruita in stile neorinascimentale sul sito di una chiesa pi\u00f9 antica. La cappella \u00e8 raggiungibile solo a piedi, il che ne accresce il fascino e la quiete."
                    },
                    {
                        "name": "Campi Elisi ",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/c155e061-7ef9-4a43-b4f8-45ed5f2669ae.valo__43_0715203513903_11_667601503431799",
                        "latitude": 43.0715203513903,
                        "longitude": 11.667601503431799,
                        "description": "Vi ricordate il film Il Gladiatore con la famosa scena in cui Massimo Decimo Meridio cammina in mezzo ai Campi Elisi?\nEbbene la location utilizzata per le riprese si trova proprio in Val d\u2019Orcia: esattamente a 3 km a sud di Pienza lungo la strada di Terrapille. Seguite le indicazioni che conducono all\u2019agriturismo Terrapille e percorrete il noto viale dei cipressi circondato dallo stupendo panorama dei campi di grano dove \u00e8 stata girata una delle scene pi\u00f9 suggestive del film.\n\n"
                    },
                    {
                        "name": "Pienza",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/c5da824d-c022-48f4-a057-013aa0486cad.pienz__43_076066078347175_11_679719765670598",
                        "latitude": 43.076066078347175,
                        "longitude": 11.679719765670598,
                        "description": "Pienza \u00e8 un incantevole borgo rinascimentale situato nella Val d\u2019Orcia, in Toscana. Fu progettata nel XV secolo da Bernardo Rossellino per volere di Papa Pio II, con l\u2019intento di creare la \u201ccitt\u00e0 ideale\u201d del Rinascimento. Il centro storico, Patrimonio UNESCO, \u00e8 famoso per la sua armonia architettonica e per prodotti tipici come il pecorino. Tra i luoghi simbolo ci sono Piazza Pio II, il Duomo e Palazzo Piccolomini, con affacci mozzafiato sulla campagna toscana."
                    },
                    {
                        "name": "",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/f7f46fa4-a6f7-49a4-b8e4-4a232440279c.poder__43_030948699629214_11_584850682411343",
                        "latitude": 43.030948699629214,
                        "longitude": 11.584850682411343,
                        "description": ""
                    }
                ],
                "infos": {
                    "distance": 36661
                }
            }
        ],
        "catalogue": [
            {
                "id": 33,
                "name": "E-bike + Casco",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/3df4f2f3-1ae0-4da7-b811-479b2b27b755.jpg"
            }
        ]
    },
    {
        "id": 1595,
        "customer": {
            "id": 433,
            "title": "Bestwind bike rental",
            "description": "Il vostro punto di riferimento per il noleggio e la vendita di biciclette elettriche e muscolari, situato nella splendida Marina di Scarlino, a pochi passi dal parco delle Costiere e dalla meravigliosa spiaggia di Cala Violina.\r\n\r\nIl nostro titolare, Giuseppe, vanta un\u2019esperienza trentennale nel mondo degli sport attivi. La sua avventura \u00e8 iniziata con il windsurf, dove ha coltivato una passione che lo ha portato a costruire vele e accessori per questo sport. Nel corso degli anni, Giuseppe ha ampliato le sue competenze e si \u00e8 trasferito nella Marina di Scarlino, dove ha continuato a promuovere gli sport nautici, ma ha anche scoperto una nuova passione per le mountain bike.\r\n\r\nOggi, Best Wind \u00e8 sinonimo di professionalit\u00e0 e competenza nel settore, offrendo un\u2019ampia gamma di biciclette per soddisfare le esigenze di tutti. Che siate in cerca di un\u2019avventura sulle colline o di una passeggiata lungo la costa, siamo qui per aiutarvi a vivere al meglio la vostra esperienza.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Bestwind_bike_rental.png",
            "text_logo": null,
            "contacts": {
                "address": "BESTWIND BIKE RENTAL, Lungomare Giuseppe Garibaldi, 58020 Portiglioni GR, Italia",
                "email": "info@bestwind.com",
                "phone": "3288951260"
            },
            "coordinate": {
                "latitude": 42.88525,
                "longitude": 10.78518
            },
            "tours": 1,
            "gallery": []
        },
        "title": "Cala Violina e Puntone di Scarlino ",
        "description": "Un anello costiero tra macchia mediterranea, sterrati vista mare e calette da cartolina. \n\nDal Puntone imbocchiamo le piste della Riserva delle Bandite di Scarlino, tra sughere e corbezzoli, con panorami aperti sul Golfo di Follonica. Sosta breve ai chioschetti stagionali lungo traccia per rifornirsi d\u2019acqua e una bibita fresca, poi si prosegue verso Cala Violina e Cala Civette per un tuffo di colori turchesi.\n\nCala Violina: sabbia chiara e i celebri granelli \u201cche suonano\u201d, accessibile solo a piedi o in bici. In estate (1 giugno\u201330 settembre) l\u2019accesso \u00e8 su prenotazione con contingente giornaliero (700 persone) e piccolo contributo: si prenota dall\u2019ufficiale portale. \n\nCala Civette: pi\u00f9 selvaggia, ai piedi della torre cinquecentesca; accesso libero.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1595.jpg",
        "price": 25.0,
        "location": "Maremma",
        "location_id": 6,
        "tags": [
            "Natura",
            "Mare"
        ],
        "routes": [
            {
                "id": 1628,
                "title": "Ebike Tour Cala Violina",
                "description": "Anello costiero di 18 km / 400 m+ su sterrati tra macchia mediterranea e viste mozzafiato sul litorale. Partenza dal Puntone di Scarlino: check-in al nostro noleggio, bike check e briefing. Prima di partire, scarica l\u2019app Outdoora (navigazione passo-passo, 5 lingue) e seleziona il tour \u201cPuntone\u2013Cala Violina\u2013Cala Civette\u201d.\n\nIl percorso \u00e8 scorrevole con brevi rampe ripide, ideale per e-MTB e rider con un minimo di confidenza sullo sterrato. Soste consigliate ai chioschetti lungo traccia per acqua e bibite.\nDal Puntone imbocchiamo le piste della Riserva delle Bandite di Scarlino, tra sughere e corbezzoli, con panorami aperti sul Golfo di Follonica. Sosta breve ai chioschetti stagionali lungo traccia per rifornirsi d\u2019acqua e una bibita fresca, poi si prosegue verso Cala Violina e Cala Civette per un tuffo di colori turchesi.\n\nCala Violina: sabbia chiara e i celebri granelli \u201cche suonano\u201d, accessibile solo a piedi o in bici. In estate (1 giugno\u201330 settembre) l\u2019accesso \u00e8 su prenotazione con contingente giornaliero (700 persone) e piccolo contributo: si prenota dall\u2019ufficiale portale. \nCala Civette: pi\u00f9 selvaggia e tranquilla, perfetta per una pausa relax.\nRientro al Puntone su strade bianche panoramiche.",
                "notes": "",
                "start_address": "Puntone di Scarlino",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    42.88513,
                    10.78529
                ],
                "preview_track": [
                    "42.88513;10.78529",
                    "42.88424;10.7845",
                    "42.88382;10.78411",
                    "42.88349;10.78386",
                    "42.88317;10.78336",
                    "42.88295;10.78194",
                    "42.88294;10.78158",
                    "42.88247;10.78104",
                    "42.88212;10.7808",
                    "42.88113;10.78036",
                    "42.88037;10.77966",
                    "42.88006;10.7794",
                    "42.87986;10.77895",
                    "42.87949;10.77816",
                    "42.87918;10.77805",
                    "42.87874;10.77814",
                    "42.87839;10.7783",
                    "42.8777;10.77813",
                    "42.87755;10.77782",
                    "42.87727;10.77754",
                    "42.87671;10.77745",
                    "42.87538;10.77767",
                    "42.87488;10.77785",
                    "42.87443;10.7779",
                    "42.87473;10.77719",
                    "42.87501;10.77668",
                    "42.87516;10.77581",
                    "42.87521;10.77533",
                    "42.87457;10.77491",
                    "42.87408;10.77476",
                    "42.87348;10.77495",
                    "42.87304;10.77496",
                    "42.87267;10.77443",
                    "42.87224;10.77434",
                    "42.87158;10.77479",
                    "42.87126;10.77485",
                    "42.8714;10.77424",
                    "42.87163;10.77343",
                    "42.8718;10.7729",
                    "42.87173;10.7725",
                    "42.87146;10.77224",
                    "42.87114;10.77188",
                    "42.8708;10.77145",
                    "42.87045;10.77104",
                    "42.86994;10.77081",
                    "42.86949;10.77038",
                    "42.86898;10.76985",
                    "42.86867;10.76968",
                    "42.86851;10.76967",
                    "42.8684;10.77006",
                    "42.86827;10.77096",
                    "42.86796;10.77172",
                    "42.86766;10.77221",
                    "42.86724;10.77224",
                    "42.86651;10.77198",
                    "42.86614;10.77231",
                    "42.86556;10.77252",
                    "42.86494;10.77215",
                    "42.86449;10.77165",
                    "42.86394;10.77145",
                    "42.86348;10.77126",
                    "42.86291;10.77103",
                    "42.86251;10.7706",
                    "42.86209;10.77021",
                    "42.86168;10.76988",
                    "42.86112;10.76941",
                    "42.86071;10.76903",
                    "42.86024;10.76885",
                    "42.85988;10.76905",
                    "42.8596;10.76973",
                    "42.85943;10.77072",
                    "42.85949;10.77171",
                    "42.85989;10.77266",
                    "42.85961;10.77308",
                    "42.85919;10.7734",
                    "42.85878;10.77377",
                    "42.85837;10.77405",
                    "42.85784;10.77448",
                    "42.85748;10.7749",
                    "42.85696;10.77482",
                    "42.85655;10.77491",
                    "42.85627;10.77495",
                    "42.85576;10.77525",
                    "42.85513;10.77531",
                    "42.85458;10.77495",
                    "42.85404;10.7748",
                    "42.85346;10.77484",
                    "42.85305;10.77443",
                    "42.85265;10.77404",
                    "42.8523;10.77356",
                    "42.85191;10.77321",
                    "42.85182;10.77321",
                    "42.85144;10.77364",
                    "42.85097;10.77405",
                    "42.85046;10.77446",
                    "42.85016;10.77499",
                    "42.85;10.77567",
                    "42.85021;10.77621",
                    "42.85044;10.77683",
                    "42.8502;10.77749",
                    "42.85033;10.7783",
                    "42.85006;10.77938",
                    "42.84991;10.78045",
                    "42.84943;10.7807",
                    "42.84893;10.78075",
                    "42.84816;10.78051",
                    "42.84788;10.7806",
                    "42.84877;10.78231",
                    "42.84903;10.78291",
                    "42.8482;10.78379",
                    "42.84773;10.78438",
                    "42.84601;10.78416",
                    "42.84558;10.78381",
                    "42.84483;10.78209",
                    "42.84427;10.78087",
                    "42.84384;10.78",
                    "42.84354;10.77967",
                    "42.84338;10.77944",
                    "42.84322;10.77926",
                    "42.84305;10.77896",
                    "42.84292;10.77879",
                    "42.84256;10.77839",
                    "42.8421;10.77752",
                    "42.84191;10.77674",
                    "42.8422;10.77672",
                    "42.84214;10.77654",
                    "42.8419;10.77709",
                    "42.84223;10.77777",
                    "42.84283;10.77854",
                    "42.8429;10.77885",
                    "42.84305;10.77905",
                    "42.84321;10.77938",
                    "42.8432;10.77955",
                    "42.84341;10.77966",
                    "42.84359;10.77972",
                    "42.84395;10.7803",
                    "42.84447;10.78113",
                    "42.84522;10.783",
                    "42.84557;10.78423",
                    "42.84599;10.78676",
                    "42.84637;10.78879",
                    "42.84658;10.78971",
                    "42.84734;10.79134",
                    "42.84764;10.79262",
                    "42.84773;10.79497",
                    "42.84763;10.79574",
                    "42.84822;10.79798",
                    "42.85145;10.80106",
                    "42.85142;10.80103",
                    "42.85289;10.79841",
                    "42.85323;10.79832",
                    "42.85363;10.79795",
                    "42.85398;10.79759",
                    "42.85437;10.79717",
                    "42.85468;10.79669",
                    "42.85506;10.79613",
                    "42.85557;10.79592",
                    "42.8561;10.79576",
                    "42.85642;10.79566",
                    "42.85654;10.79552",
                    "42.8567;10.79462",
                    "42.85669;10.79401",
                    "42.85687;10.79316",
                    "42.85702;10.79234",
                    "42.85738;10.79138",
                    "42.85772;10.78939",
                    "42.85781;10.7889",
                    "42.85808;10.78711",
                    "42.85841;10.78546",
                    "42.85903;10.78399",
                    "42.85897;10.78308",
                    "42.85817;10.78199",
                    "42.85787;10.78076",
                    "42.85728;10.77991",
                    "42.85691;10.77937",
                    "42.85659;10.77883",
                    "42.85623;10.77836",
                    "42.85582;10.77838",
                    "42.85534;10.77808",
                    "42.85525;10.77768",
                    "42.85541;10.77718",
                    "42.85589;10.77652",
                    "42.85606;10.77585",
                    "42.8564;10.77531",
                    "42.85651;10.77492",
                    "42.85688;10.77482",
                    "42.85739;10.77488",
                    "42.85777;10.77456",
                    "42.85825;10.77413",
                    "42.8587;10.77379",
                    "42.8591;10.77349",
                    "42.85953;10.77315",
                    "42.85989;10.77274",
                    "42.85955;10.77192",
                    "42.85943;10.77094",
                    "42.85953;10.76995",
                    "42.85983;10.76914",
                    "42.86017;10.76886",
                    "42.86062;10.76898",
                    "42.86106;10.76933",
                    "42.86157;10.7698",
                    "42.862;10.77016",
                    "42.86243;10.77045",
                    "42.86282;10.771",
                    "42.86338;10.77121",
                    "42.86387;10.77143",
                    "42.8644;10.7716",
                    "42.86483;10.77201",
                    "42.86538;10.77252",
                    "42.86598;10.77243",
                    "42.86645;10.77201",
                    "42.86708;10.7722",
                    "42.8676;10.77224",
                    "42.86788;10.77189",
                    "42.86826;10.77098",
                    "42.86836;10.77023",
                    "42.86851;10.76967",
                    "42.86864;10.76966",
                    "42.86892;10.76981",
                    "42.8694;10.77027",
                    "42.86985;10.77074",
                    "42.87034;10.77097",
                    "42.87075;10.77135",
                    "42.87103;10.77179",
                    "42.87144;10.77222",
                    "42.87179;10.77263",
                    "42.87174;10.77315",
                    "42.87151;10.77374",
                    "42.87127;10.77463",
                    "42.87144;10.77494",
                    "42.872;10.77446",
                    "42.87252;10.77434",
                    "42.8729;10.77476",
                    "42.87333;10.77501",
                    "42.87378;10.77484",
                    "42.87427;10.77472",
                    "42.87507;10.77515",
                    "42.87529;10.77559",
                    "42.87536;10.77639",
                    "42.87554;10.77693",
                    "42.87559;10.77728",
                    "42.87621;10.7773",
                    "42.87685;10.77745",
                    "42.87736;10.77759",
                    "42.87759;10.77796",
                    "42.87789;10.77823",
                    "42.87845;10.77827",
                    "42.87882;10.77811",
                    "42.87927;10.77803",
                    "42.87952;10.77821",
                    "42.87993;10.77918",
                    "42.8801;10.77944",
                    "42.88055;10.77985",
                    "42.88121;10.78043",
                    "42.88223;10.78085",
                    "42.8825;10.78108",
                    "42.88295;10.78163",
                    "42.88297;10.78214",
                    "42.88321;10.78345",
                    "42.88359;10.78394",
                    "42.88385;10.78418",
                    "42.88463;10.78494",
                    "42.8851;10.78536"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/4576e5f6-23e3-4ff8-8896-18c2682d3e70.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/6bba2dd1-7768-4d84-9fb9-7b4fcf898f26.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ea042671-077a-4d98-8ba5-9aec4495b603.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5de47d5f-6c39-475a-9ea4-0b286a2ac7ad.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/de447f6b-772b-4f69-b245-1c5fda80a78c.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Spiaggia Cala Violina ",
                        "type": "funny",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/887c3357-9b14-4d43-bb90-9dd208ee4014.downl__42_85625551968834_10_774820102378728",
                        "latitude": 42.85625551968834,
                        "longitude": 10.774820102378728,
                        "description": "Cala Violina \u00e8 una spiaggia di sabbia chiara nella Riserva delle Bandite di Scarlino, tra Follonica e Punta Ala. Deve il nome ai granelli quarzosi che, calpestati, \u201csuonano\u201d. Acqua cristallina, fondale che degrada dolcemente e macchia mediterranea tutto intorno. Si raggiunge solo a piedi o in bici su sentieri sterrati; in estate l\u2019accesso \u00e8 contingentato e pu\u00f2 richiedere prenotazione."
                    },
                    {
                        "name": "Bar Camping Puntala",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/3e021a12-30da-47b1-828a-5dd5272ddbb6.downl__42_842288078737525_10_77661701478064",
                        "latitude": 42.842288078737525,
                        "longitude": 10.77661701478064,
                        "description": "Il bar del Camping PuntAla \u00e8 un punto di ritrovo sul lungomare, con terrazza panoramica affacciata sul litorale: perfetto per colazioni vista mare, pranzi leggeri, gelati e aperitivi al tramonto. L\u2019atmosfera \u00e8 informale, circondata dalla pineta e dalla brezza della Maremma, ideale come sosta durante un tour in e-bike o dopo una giornata di spiaggia.\nAccesso: il bar \u00e8 aperto anche a chi non soggiorna al campeggio; si pu\u00f2 entrare dal lungomare per godersi un caff\u00e8 o un drink con vista.\n (Nota: orari e modalit\u00e0 d\u2019accesso possono variare in base alla stagione; verifica sempre le info aggiornate in loco.)"
                    },
                    {
                        "name": "La Riserva Naturale delle Bandite di Scarlino",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/5ee378b9-8bdb-464e-874c-c1259788e876.downl__42_85779278252599_10_788896083831789",
                        "latitude": 42.85779278252599,
                        "longitude": 10.788896083831789,
                        "description": "La Riserva Naturale delle Bandite di Scarlino \u00e8 un mosaico di macchia mediterranea che scende dalle colline al mare, con sentieri per trekking ed e-MTB e panorami sul Golfo di Follonica.\n Sulla costa custodisce calette raggiungibili solo a piedi o in bici, tra cui Cala Violina, Cala Martina e Cala Civette.\n In estate l\u2019accesso a Cala Violina \u00e8 contingentato e pu\u00f2 richiedere prenotazione.\n Il Puntone di Scarlino, con la sua Marina, \u00e8 la porta d\u2019ingresso ideale agli sterrati costieri."
                    }
                ],
                "infos": {
                    "distance": 17787
                }
            }
        ],
        "catalogue": [
            {
                "id": 106,
                "name": "E-bike + casco",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/bf4b2a0a-e899-4c6e-9d99-a13d95eb2934.jpg"
            }
        ]
    },
    {
        "id": 1553,
        "customer": {
            "id": 397,
            "title": "PressBike",
            "description": "Riscopri il piacere di pedalare, potrai vedere il mondo con occhi diversi,\u00a0un punto di partenza per provare a vedere le cose pi\u00f9 lentamente, l'aria che ti scorre sul viso, il panorama vivo senza vetri di un'auto, senza radio, solo tu e il tuo percorso.\r\nL' Ebike\u00a0ha dato la possibilit\u00e0 a tutti di poter riassaporare quei momenti che ci accompagnavano da bambini, la bicicletta un mezzo che magari non utilizzavamo da anni, ed ora torna in punta di piedi nella nostra vita. Provatela da soli, oppure accompagnati,per assaporare questa nuova opportunit\u00e0, magari una giornata in compagnia dei vostri amici, oppure con la vostra famiglia.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/PressBike.png",
            "text_logo": null,
            "contacts": {
                "address": "PressBike Noleggio E Bike, Via Cerri, 19, 54011 Aulla MS, Italia",
                "email": "bicicletta@pressbike.it",
                "phone": "393 885 5662"
            },
            "coordinate": {
                "latitude": 44.21847,
                "longitude": 9.97187
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/86692f8f-13f0-4a5f-8f7e-464344da0bcf.webp"
            ]
        },
        "title": "Ebike tour castelli lunigianesi",
        "description": "Un tour ad anello nel cuore della Lunigiana, tra Aulla e i suoi castelli, pensato per una pedalata rilassante ma ricca di fascino storico. Il percorso attraversa borghi, campagne e strade secondarie con continui richiami al Medioevo, tra fortificazioni, pievi e paesaggi verdi tipici della valle. \u00c8 un itinerario molto piacevole da vivere con calma, perfetto per chi cerca un giro panoramico e culturale senza un impegno eccessivo.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1553.jpg",
        "price": 25.0,
        "location": "Massa",
        "location_id": null,
        "tags": [
            "Natura",
            "Montagne",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1586,
                "title": "I castelli Lunigianesi ",
                "description": "Partenza / arrivo: Aulla, percorso ad anello con rientro nello stesso punto.\n\nDati principali: sviluppo totale di circa 36 km e dislivello positivo intorno ai 470 m; giro collinare facile-intermedio, con andamento regolare e mai troppo impegnativo.\n\nTracciato e paesaggio: il percorso alterna tratti di fondovalle pi\u00f9 semplici a salite brevi verso borghi e castelli della Lunigiana, con continui cambi di scenario tra centri storici, campagna e strade panoramiche.\n\nNote utili: tour adatto a essere affrontato con ritmo tranquillo, prevedendo qualche sosta nei borghi lungo il percorso; utile partire con acqua, uno snack e telefono carico/GPS attivo per godersi il giro in totale serenit\u00e0.",
                "notes": null,
                "start_address": "Via Cerri, 19, 54011 Aulla MS, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1553.jpg",
                "track": [
                    44.21841,
                    9.97178
                ],
                "preview_track": [
                    "44.21841;9.97178",
                    "44.21824;9.97148",
                    "44.21807;9.97078",
                    "44.21787;9.97021",
                    "44.21813;9.96982",
                    "44.21872;9.97",
                    "44.21929;9.96989",
                    "44.21969;9.96942",
                    "44.21942;9.96896",
                    "44.21836;9.96849",
                    "44.21753;9.96836",
                    "44.21704;9.96825",
                    "44.21671;9.96772",
                    "44.21657;9.96749",
                    "44.21634;9.96711",
                    "44.21628;9.96684",
                    "44.21668;9.9665",
                    "44.21789;9.9662",
                    "44.21844;9.96609",
                    "44.21875;9.96609",
                    "44.2191;9.96625",
                    "44.21943;9.9666",
                    "44.22063;9.9691",
                    "44.22124;9.96942",
                    "44.22183;9.96985",
                    "44.22254;9.96985",
                    "44.22464;9.96888",
                    "44.22517;9.96846",
                    "44.22536;9.96826",
                    "44.22589;9.96755",
                    "44.22937;9.96213",
                    "44.23074;9.96096",
                    "44.23095;9.96037",
                    "44.23185;9.96",
                    "44.23227;9.95877",
                    "44.233;9.95676",
                    "44.23317;9.95591",
                    "44.23462;9.95253",
                    "44.23531;9.9519",
                    "44.2358;9.95178",
                    "44.23798;9.95155",
                    "44.24017;9.94999",
                    "44.24113;9.94912",
                    "44.24153;9.94776",
                    "44.24182;9.94607",
                    "44.24206;9.94576",
                    "44.2427;9.94623",
                    "44.24286;9.94576",
                    "44.24382;9.94475",
                    "44.24655;9.94471",
                    "44.24704;9.94455",
                    "44.24736;9.94321",
                    "44.24765;9.94238",
                    "44.24859;9.9425",
                    "44.24919;9.9427",
                    "44.25024;9.94275",
                    "44.25218;9.94326",
                    "44.25562;9.94625",
                    "44.2589;9.94871",
                    "44.26006;9.94894",
                    "44.2605;9.94852",
                    "44.26117;9.94819",
                    "44.26153;9.94772",
                    "44.26173;9.94773",
                    "44.26182;9.94748",
                    "44.26212;9.94764",
                    "44.26219;9.94719",
                    "44.26236;9.94744",
                    "44.26282;9.94689",
                    "44.2634;9.94664",
                    "44.26414;9.94602",
                    "44.26474;9.94641",
                    "44.26569;9.94689",
                    "44.2656;9.94758",
                    "44.26566;9.94793",
                    "44.266;9.94822",
                    "44.26687;9.94709",
                    "44.26863;9.94667",
                    "44.27004;9.94535",
                    "44.27028;9.9457",
                    "44.26974;9.94699",
                    "44.27056;9.94814",
                    "44.27166;9.94849",
                    "44.27292;9.94866",
                    "44.27343;9.94837",
                    "44.27374;9.9489",
                    "44.27506;9.94861",
                    "44.27586;9.94765",
                    "44.2771;9.94699",
                    "44.27769;9.94668",
                    "44.27833;9.94568",
                    "44.27931;9.94432",
                    "44.27983;9.94407",
                    "44.28085;9.94355",
                    "44.28199;9.94381",
                    "44.28326;9.94304",
                    "44.28489;9.94295",
                    "44.28522;9.94222",
                    "44.28671;9.9416",
                    "44.28707;9.94154",
                    "44.28771;9.94182",
                    "44.2886;9.94226",
                    "44.28936;9.94199",
                    "44.29029;9.9422",
                    "44.29132;9.9416",
                    "44.29222;9.94134",
                    "44.29292;9.94159",
                    "44.29385;9.94346",
                    "44.29418;9.94474",
                    "44.2943;9.94736",
                    "44.2942;9.94782",
                    "44.29328;9.94804",
                    "44.29328;9.94869",
                    "44.29341;9.95039",
                    "44.29341;9.95059",
                    "44.29468;9.94954",
                    "44.29539;9.95083",
                    "44.296;9.95242",
                    "44.29683;9.95407",
                    "44.29893;9.9573",
                    "44.30052;9.95964",
                    "44.30113;9.96059",
                    "44.30168;9.96146",
                    "44.30266;9.96326",
                    "44.30435;9.96591",
                    "44.30649;9.96733",
                    "44.30699;9.96774",
                    "44.30792;9.96908",
                    "44.30947;9.9705",
                    "44.31054;9.97232",
                    "44.31065;9.97315",
                    "44.31039;9.97648",
                    "44.31055;9.97817",
                    "44.31096;9.98193",
                    "44.31153;9.98532",
                    "44.31173;9.98626",
                    "44.31274;9.98836",
                    "44.31304;9.98891",
                    "44.31331;9.98986",
                    "44.31379;9.99246",
                    "44.31395;9.99325",
                    "44.31413;9.99387",
                    "44.31432;9.9943",
                    "44.3146;9.99438",
                    "44.31475;9.99444",
                    "44.31533;9.99424",
                    "44.31568;9.99411",
                    "44.31601;9.99387",
                    "44.31714;9.99316",
                    "44.31723;9.9931",
                    "44.31732;9.99309",
                    "44.31778;9.99298",
                    "44.31777;9.99351",
                    "44.31808;9.99439",
                    "44.31731;9.99453",
                    "44.31578;9.99542",
                    "44.31548;9.99567",
                    "44.31534;9.99572",
                    "44.31524;9.99536",
                    "44.31506;9.99514",
                    "44.31478;9.99491",
                    "44.31437;9.99438",
                    "44.31418;9.994",
                    "44.31401;9.99353",
                    "44.31382;9.9927",
                    "44.31354;9.99109",
                    "44.31307;9.98897",
                    "44.31299;9.98883",
                    "44.31206;9.98717",
                    "44.31166;9.98602",
                    "44.31067;9.98533",
                    "44.30982;9.98567",
                    "44.30922;9.98595",
                    "44.30773;9.98467",
                    "44.30521;9.98253",
                    "44.30072;9.9785",
                    "44.29952;9.97558",
                    "44.29855;9.97347",
                    "44.29623;9.9694",
                    "44.29609;9.96872",
                    "44.29578;9.96821",
                    "44.29505;9.9666",
                    "44.29426;9.96569",
                    "44.29314;9.96343",
                    "44.29232;9.96232",
                    "44.29177;9.96158",
                    "44.29101;9.95897",
                    "44.29127;9.96091",
                    "44.29113;9.96227",
                    "44.2911;9.96415",
                    "44.29108;9.96474",
                    "44.29113;9.96508",
                    "44.29132;9.97136",
                    "44.29261;9.97448",
                    "44.29306;9.97576",
                    "44.29312;9.97769",
                    "44.29394;9.9792",
                    "44.29424;9.98038",
                    "44.29192;9.98461",
                    "44.29062;9.98546",
                    "44.28723;9.98684",
                    "44.28569;9.98667",
                    "44.28373;9.98716",
                    "44.2842;9.98987",
                    "44.28335;9.99104",
                    "44.28111;9.99197",
                    "44.27966;9.99255",
                    "44.27892;9.99287",
                    "44.27813;9.99355",
                    "44.27718;9.99404",
                    "44.2758;9.99392",
                    "44.27249;9.99379",
                    "44.27004;9.99275",
                    "44.26892;9.99015",
                    "44.2676;9.98963",
                    "44.26676;9.98911",
                    "44.26527;9.98912",
                    "44.26399;9.99011",
                    "44.26301;9.99182",
                    "44.26232;9.99287",
                    "44.26042;9.99306",
                    "44.25886;9.99267",
                    "44.25734;9.99351",
                    "44.25599;9.99647",
                    "44.2557;9.99722",
                    "44.25586;9.99859",
                    "44.25566;9.99921",
                    "44.25462;10.00033",
                    "44.25361;9.99996",
                    "44.25287;9.99987",
                    "44.25253;9.99901",
                    "44.25203;9.99816",
                    "44.2511;9.99909",
                    "44.25056;9.99894",
                    "44.25038;9.99813",
                    "44.25002;9.99781",
                    "44.24983;9.99826",
                    "44.24986;9.99942",
                    "44.24954;9.99984",
                    "44.2481;9.9991",
                    "44.24734;9.99916",
                    "44.24674;9.99804",
                    "44.24547;9.99522",
                    "44.24471;9.99388",
                    "44.24388;9.99253",
                    "44.24297;9.99089",
                    "44.24139;9.98833",
                    "44.24103;9.98777",
                    "44.24077;9.98702",
                    "44.24048;9.98618",
                    "44.23938;9.98639",
                    "44.23898;9.98604",
                    "44.23917;9.98512",
                    "44.23803;9.98295",
                    "44.23733;9.98264",
                    "44.23587;9.98377",
                    "44.23498;9.98362",
                    "44.23453;9.98288",
                    "44.23408;9.98203",
                    "44.23339;9.98192",
                    "44.23196;9.98051",
                    "44.22891;9.97545",
                    "44.22808;9.97412",
                    "44.22728;9.97281",
                    "44.22719;9.97249",
                    "44.22721;9.97185",
                    "44.22739;9.97058",
                    "44.22631;9.96982",
                    "44.22578;9.96942",
                    "44.22522;9.96854",
                    "44.22329;9.96972",
                    "44.22384;9.97193",
                    "44.22334;9.97241",
                    "44.22315;9.9743",
                    "44.22264;9.97475",
                    "44.22142;9.97479",
                    "44.22031;9.97485",
                    "44.22008;9.97487",
                    "44.2195;9.97468",
                    "44.21898;9.97402",
                    "44.2187;9.97334",
                    "44.21839;9.97221"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9e828c74-b764-42e5-8bf1-1f89c7356f77.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/a6c35fae-115f-48b4-9798-aa548b621a8a.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f2174c08-568a-4e36-aebc-5a1c9697de01.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b686f232-27ae-46bb-964a-10fc5794dee7.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b054b856-872a-4a98-affe-3b7db5ae45dd.webp"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 36440
                }
            }
        ],
        "catalogue": [
            {
                "id": 67,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 68,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1535,
        "customer": {
            "id": 379,
            "title": "Smile & Ride",
            "description": "Smile & Ride nasce dall\u2019idea di mettere a disposizione le nostre competenze maturate come cicloturisti per farvi vivere delle esperienze uniche ed esclusive portandovi a scoprire questo incantevole territorio, ricco di cultura, arte e ottimo cibo. Abbiamo deciso di metterci in gioco attivamente mossi dall\u2019idea che chiunque voglia realizzare qualsiasi progetto deve trovare la giusta motivazione e passione per farlo, per noi un\u2019attivit\u00e0 di business dovrebbe avere anche il compito di rendere migliore il mondo in cui opera.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Smile__Ride.png",
            "text_logo": null,
            "contacts": {
                "address": "Smile & Ride - Tuscany e-Bike rental and tours, Piazza della Stazione, 7, 56121 Pisa PI, Italia",
                "email": "info@smileandride.com",
                "phone": "375 561 7631"
            },
            "coordinate": {
                "latitude": 43.70844,
                "longitude": 10.39915
            },
            "tours": 3,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/754c9abe-ebc3-47b7-8b13-51aad3839644.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/d11b3457-3a40-40f9-a563-513382e0d4df.webp"
            ]
        },
        "title": "Tour Pisa - Lago di Massaciuccoli ",
        "description": "Un anello tra Pisa e il Lago di Massaciuccoli, perfetto per una pedalata immersa nella natura tra campagna, canali e tratti di ciclabile. Si parte dalla citt\u00e0 e, lasciandosi alle spalle il traffico, si entra in un ambiente sempre pi\u00f9 verde fino a raggiungere l\u2019area del lago, con scorci tranquilli e ritmo regolare. Un tour ideale da mezza giornata, da vivere con calma con qualche sosta panoramica prima del rientro su Pisa.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1535.jpg",
        "price": 25.0,
        "location": "Pisa",
        "location_id": 3,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1570,
                "title": "Tour Pisa - Massaciuccoli",
                "description": "Percorso ad anello con partenza/arrivo a Pisa, circa 51 km totali, dislivello complessivo moderato (circa 180 m D+), quote da circa -4 m a ~111 m: andamento generalmente facile con qualche breve ondulazione nella parte nord verso Massaciuccoli. Tempo registrato in traccia circa 3h15 in movimento (variabile con soste), quindi perfetto come uscita easy/endurace tranquilla. Tracciato tipicamente scorrevole su viabilit\u00e0 secondaria e tratti ciclabili, con possibili raccordi su fondo misto",
                "notes": null,
                "start_address": "Piazza della Stazione, 7, 56121 Pisa PI, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1535.jpg",
                "track": [
                    43.70838,
                    10.39952
                ],
                "preview_track": [
                    "43.70838;10.39952",
                    "43.70856;10.40008",
                    "43.7099;10.40098",
                    "43.70997;10.40252",
                    "43.70987;10.40332",
                    "43.70964;10.40492",
                    "43.70953;10.40562",
                    "43.70955;10.4058",
                    "43.70964;10.4059",
                    "43.71027;10.40559",
                    "43.71044;10.40542",
                    "43.71044;10.4053",
                    "43.71053;10.40511",
                    "43.71143;10.40549",
                    "43.71179;10.40551",
                    "43.71274;10.40512",
                    "43.71318;10.40474",
                    "43.71366;10.40404",
                    "43.71414;10.40292",
                    "43.71444;10.40224",
                    "43.71454;10.40203",
                    "43.71477;10.40197",
                    "43.71529;10.40203",
                    "43.71551;10.40181",
                    "43.71621;10.40211",
                    "43.71628;10.40215",
                    "43.71583;10.40373",
                    "43.71518;10.40564",
                    "43.71476;10.4066",
                    "43.71497;10.40718",
                    "43.7152;10.40696",
                    "43.71645;10.40719",
                    "43.71652;10.40718",
                    "43.71665;10.40705",
                    "43.71854;10.4073",
                    "43.71849;10.40748",
                    "43.71859;10.40882",
                    "43.71871;10.41035",
                    "43.71874;10.41057",
                    "43.71879;10.41105",
                    "43.71882;10.41125",
                    "43.71889;10.41229",
                    "43.71899;10.4123",
                    "43.71952;10.41223",
                    "43.71966;10.41398",
                    "43.71981;10.4162",
                    "43.71987;10.41728",
                    "43.72013;10.41916",
                    "43.72033;10.42009",
                    "43.72079;10.4213",
                    "43.72066;10.42159",
                    "43.7206;10.42166",
                    "43.72056;10.42177",
                    "43.7206;10.42189",
                    "43.72068;10.42192",
                    "43.72104;10.42233",
                    "43.72144;10.423",
                    "43.72187;10.4237",
                    "43.72268;10.42494",
                    "43.7228;10.42577",
                    "43.72276;10.42588",
                    "43.72305;10.42656",
                    "43.72323;10.42666",
                    "43.72384;10.42758",
                    "43.72446;10.42851",
                    "43.72502;10.42943",
                    "43.72787;10.43359",
                    "43.72967;10.43659",
                    "43.72997;10.43694",
                    "43.73017;10.43719",
                    "43.73038;10.43768",
                    "43.73076;10.4383",
                    "43.73609;10.44593",
                    "43.73634;10.44569",
                    "43.73673;10.44014",
                    "43.73677;10.4394",
                    "43.7371;10.43283",
                    "43.73732;10.42819",
                    "43.73737;10.42673",
                    "43.73728;10.42567",
                    "43.74127;10.42936",
                    "43.74427;10.43219",
                    "43.74616;10.43396",
                    "43.74945;10.43769",
                    "43.75226;10.44089",
                    "43.75486;10.44386",
                    "43.75663;10.4438",
                    "43.75726;10.44372",
                    "43.75756;10.44362",
                    "43.75777;10.4435",
                    "43.75785;10.44351",
                    "43.75792;10.44344",
                    "43.75798;10.44333",
                    "43.75868;10.44273",
                    "43.75924;10.44219",
                    "43.75937;10.44186",
                    "43.75968;10.44186",
                    "43.76077;10.44141",
                    "43.76184;10.4409",
                    "43.76246;10.4406",
                    "43.7642;10.43911",
                    "43.76444;10.43885",
                    "43.76503;10.43777",
                    "43.76576;10.43835",
                    "43.76766;10.43855",
                    "43.76928;10.43737",
                    "43.76994;10.43643",
                    "43.77058;10.43523",
                    "43.77069;10.43504",
                    "43.77153;10.4342",
                    "43.77205;10.43391",
                    "43.77316;10.43347",
                    "43.77413;10.43297",
                    "43.77454;10.43276",
                    "43.77492;10.43212",
                    "43.7752;10.4313",
                    "43.77548;10.43071",
                    "43.7759;10.43024",
                    "43.77672;10.42882",
                    "43.77713;10.42835",
                    "43.77789;10.42781",
                    "43.77872;10.42791",
                    "43.77908;10.42785",
                    "43.7795;10.42752",
                    "43.78048;10.42682",
                    "43.78176;10.42582",
                    "43.78243;10.42488",
                    "43.7827;10.42437",
                    "43.78294;10.42374",
                    "43.78328;10.42334",
                    "43.78388;10.423",
                    "43.78532;10.4222",
                    "43.78619;10.42199",
                    "43.78714;10.42199",
                    "43.78816;10.42265",
                    "43.78867;10.42293",
                    "43.78917;10.42285",
                    "43.79009;10.42193",
                    "43.79059;10.42166",
                    "43.79186;10.42115",
                    "43.79235;10.42105",
                    "43.79322;10.42154",
                    "43.79442;10.42225",
                    "43.79536;10.42255",
                    "43.79644;10.42269",
                    "43.79689;10.4226",
                    "43.79833;10.42167",
                    "43.79978;10.42074",
                    "43.8005;10.42051",
                    "43.80234;10.42033",
                    "43.80398;10.41999",
                    "43.80495;10.4196",
                    "43.80643;10.41897",
                    "43.80725;10.41772",
                    "43.80759;10.41692",
                    "43.80817;10.41539",
                    "43.80823;10.4149",
                    "43.80827;10.41401",
                    "43.80845;10.41361",
                    "43.80921;10.41224",
                    "43.80935;10.41216",
                    "43.80996;10.41209",
                    "43.81131;10.41202",
                    "43.81225;10.4121",
                    "43.8144;10.41312",
                    "43.81515;10.41337",
                    "43.81594;10.41396",
                    "43.8172;10.41491",
                    "43.81752;10.41498",
                    "43.81767;10.41484",
                    "43.81815;10.41457",
                    "43.81869;10.41463",
                    "43.81911;10.41478",
                    "43.81923;10.4144",
                    "43.81946;10.41447",
                    "43.81962;10.4144",
                    "43.8194;10.413",
                    "43.81954;10.41232",
                    "43.81982;10.41178",
                    "43.82042;10.41128",
                    "43.82069;10.41015",
                    "43.82227;10.41055",
                    "43.82339;10.41007",
                    "43.82393;10.41047",
                    "43.82476;10.41105",
                    "43.82545;10.41085",
                    "43.82614;10.41017",
                    "43.82703;10.40985",
                    "43.82755;10.41049",
                    "43.82784;10.41096",
                    "43.82874;10.41246",
                    "43.82961;10.41504",
                    "43.82978;10.4154",
                    "43.82996;10.4157",
                    "43.83104;10.41575",
                    "43.83285;10.41596",
                    "43.83325;10.41645",
                    "43.83356;10.41701",
                    "43.83434;10.41681",
                    "43.83496;10.41613",
                    "43.83543;10.41577",
                    "43.83563;10.41506",
                    "43.83567;10.41482",
                    "43.83567;10.41427",
                    "43.83586;10.41401",
                    "43.83628;10.4139",
                    "43.83638;10.41367",
                    "43.83615;10.41295",
                    "43.83615;10.41248",
                    "43.83617;10.41113",
                    "43.8363;10.40957",
                    "43.83659;10.40754",
                    "43.83597;10.40672",
                    "43.835;10.40532",
                    "43.83382;10.40256",
                    "43.83278;10.40084",
                    "43.83193;10.39879",
                    "43.83165;10.3974",
                    "43.83137;10.39595",
                    "43.83136;10.39487",
                    "43.83175;10.39368",
                    "43.83196;10.39248",
                    "43.83189;10.3916",
                    "43.83167;10.39033",
                    "43.83245;10.38838",
                    "43.83292;10.38731",
                    "43.83301;10.38577",
                    "43.83327;10.38491",
                    "43.83387;10.38315",
                    "43.83406;10.38261",
                    "43.83483;10.3819",
                    "43.83528;10.38055",
                    "43.83528;10.37956",
                    "43.83543;10.37875",
                    "43.83577;10.3775",
                    "43.83606;10.37621",
                    "43.83609;10.37514",
                    "43.83584;10.37287",
                    "43.83568;10.3709",
                    "43.83547;10.36976",
                    "43.83604;10.36764",
                    "43.83589;10.36594",
                    "43.83482;10.36537",
                    "43.83488;10.3652",
                    "43.8359;10.36548",
                    "43.83483;10.3649",
                    "43.83323;10.36533",
                    "43.83282;10.3649",
                    "43.83251;10.36492",
                    "43.83282;10.3649",
                    "43.83353;10.36514",
                    "43.83615;10.36432",
                    "43.83659;10.36437",
                    "43.83652;10.36362",
                    "43.8368;10.36296",
                    "43.83662;10.36189",
                    "43.8365;10.36225",
                    "43.83646;10.36202",
                    "43.83601;10.36086",
                    "43.83633;10.36041",
                    "43.83675;10.35936",
                    "43.83712;10.35859",
                    "43.83727;10.35794",
                    "43.83713;10.35758",
                    "43.83657;10.35752",
                    "43.83634;10.35805",
                    "43.83607;10.35852",
                    "43.83584;10.35881",
                    "43.83539;10.35893",
                    "43.8347;10.35842",
                    "43.8342;10.35755",
                    "43.83354;10.35781",
                    "43.83299;10.35855",
                    "43.83235;10.35915",
                    "43.83109;10.36014",
                    "43.83107;10.36029",
                    "43.83117;10.36105",
                    "43.83051;10.36165",
                    "43.83054;10.36217",
                    "43.83015;10.36221",
                    "43.8297;10.36166",
                    "43.82925;10.36122",
                    "43.82885;10.36144",
                    "43.82848;10.36226",
                    "43.82828;10.36074",
                    "43.82664;10.35231",
                    "43.82526;10.34578",
                    "43.82386;10.34195",
                    "43.82308;10.34142",
                    "43.82162;10.33729",
                    "43.82113;10.33637",
                    "43.81881;10.3427",
                    "43.81861;10.34464",
                    "43.81831;10.34523",
                    "43.81824;10.34608",
                    "43.81647;10.3484",
                    "43.81565;10.35728",
                    "43.81524;10.35862",
                    "43.81351;10.35793",
                    "43.80493;10.36959",
                    "43.80442;10.37024",
                    "43.80391;10.37129",
                    "43.80258;10.37242",
                    "43.80214;10.37258",
                    "43.80197;10.3725",
                    "43.8009;10.37087",
                    "43.80004;10.36961",
                    "43.79662;10.3742",
                    "43.79212;10.37906",
                    "43.79074;10.37875",
                    "43.7903;10.37863",
                    "43.78983;10.37956",
                    "43.78925;10.37998",
                    "43.78902;10.38141",
                    "43.7885;10.38285",
                    "43.78735;10.38396",
                    "43.78642;10.38362",
                    "43.78546;10.38327",
                    "43.78493;10.3851",
                    "43.78464;10.3859",
                    "43.78393;10.38718",
                    "43.78356;10.38797",
                    "43.78341;10.38786",
                    "43.78266;10.38722",
                    "43.78193;10.38696",
                    "43.7813;10.38749",
                    "43.78114;10.38852",
                    "43.78111;10.38923",
                    "43.78097;10.39037",
                    "43.78077;10.39214",
                    "43.78022;10.39211",
                    "43.7802;10.39256",
                    "43.7805;10.39407",
                    "43.78103;10.39593",
                    "43.78146;10.39727",
                    "43.7815;10.39762",
                    "43.78141;10.39781",
                    "43.78131;10.39771",
                    "43.78106;10.39734",
                    "43.78123;10.39762",
                    "43.78137;10.39786",
                    "43.78094;10.39843",
                    "43.78044;10.39906",
                    "43.77997;10.39968",
                    "43.77928;10.40066",
                    "43.77902;10.40115",
                    "43.77848;10.40232",
                    "43.77838;10.40225",
                    "43.77824;10.40219",
                    "43.77756;10.40176",
                    "43.77633;10.40093",
                    "43.77597;10.40075",
                    "43.77575;10.40116",
                    "43.77553;10.40138",
                    "43.7747;10.40208",
                    "43.77438;10.40275",
                    "43.77403;10.40371",
                    "43.77382;10.404",
                    "43.77351;10.404",
                    "43.77325;10.40391",
                    "43.77308;10.40413",
                    "43.77261;10.40513",
                    "43.77229;10.4055",
                    "43.7719;10.40553",
                    "43.77165;10.40618",
                    "43.77133;10.40629",
                    "43.77113;10.40662",
                    "43.7704;10.40842",
                    "43.77022;10.40897",
                    "43.77046;10.40949",
                    "43.7707;10.41101",
                    "43.76955;10.41161",
                    "43.76729;10.41232",
                    "43.76694;10.41228",
                    "43.76403;10.4114",
                    "43.75828;10.40971",
                    "43.75798;10.40961",
                    "43.75556;10.4074",
                    "43.75309;10.40577",
                    "43.7525;10.40549",
                    "43.75138;10.40511",
                    "43.74763;10.40389",
                    "43.7458;10.40329",
                    "43.74218;10.40206",
                    "43.74022;10.40153",
                    "43.73923;10.40117",
                    "43.73877;10.40114",
                    "43.73746;10.40099",
                    "43.73691;10.40093",
                    "43.73669;10.40074",
                    "43.73664;10.40082",
                    "43.73527;10.40068",
                    "43.73386;10.40053",
                    "43.73278;10.39923",
                    "43.73167;10.39799",
                    "43.72987;10.39573",
                    "43.72792;10.39341",
                    "43.72762;10.39319",
                    "43.72751;10.39295",
                    "43.72734;10.39263",
                    "43.72577;10.39081",
                    "43.72532;10.39092",
                    "43.72498;10.39117",
                    "43.72494;10.39115",
                    "43.72489;10.39117",
                    "43.72486;10.39123",
                    "43.72486;10.3913",
                    "43.72443;10.39152",
                    "43.72399;10.39175",
                    "43.72362;10.39194",
                    "43.72295;10.39222",
                    "43.72271;10.39222",
                    "43.72208;10.39196",
                    "43.72145;10.39171",
                    "43.72018;10.39085",
                    "43.71889;10.39",
                    "43.71678;10.38859",
                    "43.71603;10.38806",
                    "43.71575;10.38788",
                    "43.71543;10.38789",
                    "43.71366;10.38866",
                    "43.71344;10.38876",
                    "43.71339;10.38889",
                    "43.71368;10.38972",
                    "43.71369;10.38974",
                    "43.7137;10.38993",
                    "43.71368;10.38996",
                    "43.71361;10.39012",
                    "43.71335;10.39035",
                    "43.71236;10.39115",
                    "43.71248;10.39131",
                    "43.71257;10.39183",
                    "43.71245;10.39134",
                    "43.71237;10.39125",
                    "43.7118;10.39143",
                    "43.71175;10.39157",
                    "43.71167;10.39185",
                    "43.7114;10.39173",
                    "43.71116;10.39194",
                    "43.71109;10.39289",
                    "43.71084;10.3971",
                    "43.71094;10.39745",
                    "43.71089;10.39767",
                    "43.71082;10.39766",
                    "43.71074;10.39766",
                    "43.71044;10.39763",
                    "43.71022;10.39766",
                    "43.71013;10.39764",
                    "43.71006;10.3978",
                    "43.71001;10.39838",
                    "43.70997;10.3988",
                    "43.70986;10.39884",
                    "43.70933;10.39876",
                    "43.70905;10.3988",
                    "43.70895;10.39907"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d00984e2-60b5-413b-94ad-aef043297d57.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5214bd2b-99a2-4b17-8e8c-f663b9b779ed.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f1214305-49e7-4834-9e14-87d981d29a78.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9f3cff6a-ea0a-4ba1-9777-7dd6f29b554d.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/2276363d-f309-4f05-9614-7fe1b604cddc.jpg"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 50533
                }
            }
        ],
        "catalogue": [
            {
                "id": 54,
                "name": "E-bike",
                "description": "Lombardo E-MTB front con freni a disco",
                "price": 55.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/6923496a-333b-48b1-958a-ed1a84b26eb3.png"
            },
            {
                "id": 55,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1533,
        "customer": {
            "id": 379,
            "title": "Smile & Ride",
            "description": "Smile & Ride nasce dall\u2019idea di mettere a disposizione le nostre competenze maturate come cicloturisti per farvi vivere delle esperienze uniche ed esclusive portandovi a scoprire questo incantevole territorio, ricco di cultura, arte e ottimo cibo. Abbiamo deciso di metterci in gioco attivamente mossi dall\u2019idea che chiunque voglia realizzare qualsiasi progetto deve trovare la giusta motivazione e passione per farlo, per noi un\u2019attivit\u00e0 di business dovrebbe avere anche il compito di rendere migliore il mondo in cui opera.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Smile__Ride.png",
            "text_logo": null,
            "contacts": {
                "address": "Smile & Ride - Tuscany e-Bike rental and tours, Piazza della Stazione, 7, 56121 Pisa PI, Italia",
                "email": "info@smileandride.com",
                "phone": "375 561 7631"
            },
            "coordinate": {
                "latitude": 43.70844,
                "longitude": 10.39915
            },
            "tours": 3,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/754c9abe-ebc3-47b7-8b13-51aad3839644.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/d11b3457-3a40-40f9-a563-513382e0d4df.webp"
            ]
        },
        "title": "City Tour Pisa",
        "description": "Un city tour ad anello nel cuore di Pisa, perfetto per vedere il meglio della citt\u00e0 in poco tempo. Dalla zona di Pisa Centrale si pedala tra i Lungarni e il centro storico. Giro breve, super scorrevole e ideale da vivere con calma, fermandosi per foto e pause nei punti pi\u00f9 iconici.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1533.jpg",
        "price": 25.0,
        "location": "Pisa",
        "location_id": 3,
        "tags": [
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1568,
                "title": "City Tour Pisa",
                "description": "Percorso urbano ad anello di circa 14 km con dislivello praticamente nullo (circa 25 m D+), quindi adatto a tutti e ideale anche in e-bike. Partenza/arrivo in zona Stazione Pisa Centrale, sviluppo su viabilit\u00e0 cittadina con tratti ciclabili e attraversamenti frequenti (incroci, semafori, rotatorie). Tempo indicativo 45\u201360 minuti in sella, molto variabile in base a traffico e soste. Attenzione a zone pedonali e momenti di maggiore affollamento.",
                "notes": null,
                "start_address": "Piazza della Stazione, 7, 56121 Pisa PI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1533.jpg",
                "track": [
                    43.70838,
                    10.39952
                ],
                "preview_track": [
                    "43.70838;10.39952",
                    "43.70856;10.40008",
                    "43.70926;10.40055",
                    "43.7099;10.40098",
                    "43.70997;10.40252",
                    "43.70987;10.40332",
                    "43.70964;10.40492",
                    "43.70953;10.40562",
                    "43.70955;10.4058",
                    "43.70964;10.4059",
                    "43.70981;10.40586",
                    "43.71001;10.4059",
                    "43.71015;10.4061",
                    "43.71008;10.40743",
                    "43.71003;10.40745",
                    "43.70998;10.40751",
                    "43.70996;10.4076",
                    "43.71003;10.40774",
                    "43.71007;10.40786",
                    "43.70998;10.40978",
                    "43.7099;10.41006",
                    "43.70987;10.41009",
                    "43.70984;10.41013",
                    "43.70975;10.41009",
                    "43.70962;10.41004",
                    "43.7093;10.40974",
                    "43.70892;10.41012",
                    "43.70718;10.41265",
                    "43.70665;10.41396",
                    "43.70614;10.41634",
                    "43.70572;10.41878",
                    "43.70562;10.41924",
                    "43.70561;10.42062",
                    "43.70554;10.42304",
                    "43.70522;10.42464",
                    "43.7047;10.42587",
                    "43.70151;10.43119",
                    "43.70129;10.43133",
                    "43.70115;10.43134",
                    "43.70106;10.43147",
                    "43.70106;10.4317",
                    "43.70119;10.43184",
                    "43.70134;10.4318",
                    "43.70138;10.43175",
                    "43.70142;10.43155",
                    "43.70231;10.42986",
                    "43.70487;10.42552",
                    "43.70532;10.42431",
                    "43.70556;10.42266",
                    "43.70561;10.42053",
                    "43.70562;10.41924",
                    "43.70582;10.41812",
                    "43.70615;10.41627",
                    "43.70672;10.41373",
                    "43.70726;10.41249",
                    "43.70754;10.41198",
                    "43.70714;10.4126",
                    "43.70699;10.41291",
                    "43.70637;10.41483",
                    "43.70625;10.41548",
                    "43.70566;10.41886",
                    "43.70572;10.41878",
                    "43.70614;10.41634",
                    "43.70665;10.41396",
                    "43.70718;10.41265",
                    "43.70754;10.41198",
                    "43.70904;10.40986",
                    "43.7091;10.40978",
                    "43.70929;10.40964",
                    "43.70935;10.40968",
                    "43.70943;10.40969",
                    "43.70983;10.41016",
                    "43.70982;10.41021",
                    "43.70982;10.41027",
                    "43.70984;10.41033",
                    "43.70986;10.41038",
                    "43.70989;10.41041",
                    "43.70993;10.41043",
                    "43.70996;10.41044",
                    "43.70999;10.41044",
                    "43.71003;10.41043",
                    "43.71006;10.4104",
                    "43.71008;10.41036",
                    "43.7101;10.41032",
                    "43.71011;10.41027",
                    "43.71011;10.41022",
                    "43.7101;10.41017",
                    "43.71009;10.41013",
                    "43.71006;10.41009",
                    "43.71002;10.41005",
                    "43.70999;10.40958",
                    "43.71007;10.40776",
                    "43.71014;10.40774",
                    "43.71018;10.40769",
                    "43.71031;10.40767",
                    "43.71089;10.40771",
                    "43.71127;10.40781",
                    "43.71186;10.40792",
                    "43.71265;10.40789",
                    "43.71303;10.40782",
                    "43.71311;10.40782",
                    "43.71421;10.40873",
                    "43.7151;10.40901",
                    "43.71607;10.40907",
                    "43.71653;10.40886",
                    "43.71683;10.40872",
                    "43.71749;10.40822",
                    "43.7179;10.40793",
                    "43.71851;10.4077",
                    "43.71862;10.4077",
                    "43.72025;10.40918",
                    "43.7209;10.40925",
                    "43.72157;10.40904",
                    "43.72145;10.40887",
                    "43.72186;10.40861",
                    "43.72186;10.40809",
                    "43.7219;10.40734",
                    "43.72239;10.40713",
                    "43.72272;10.40686",
                    "43.72215;10.40578",
                    "43.72167;10.40413",
                    "43.72147;10.40387",
                    "43.72132;10.40373",
                    "43.72114;10.4033",
                    "43.71996;10.40299",
                    "43.71969;10.40271",
                    "43.71967;10.40225",
                    "43.71968;10.40171",
                    "43.71949;10.40092",
                    "43.71936;10.40032",
                    "43.71968;10.39999",
                    "43.72011;10.39917",
                    "43.71982;10.39891",
                    "43.71991;10.39776",
                    "43.71988;10.39736",
                    "43.72035;10.39712",
                    "43.72093;10.39708",
                    "43.72154;10.39713",
                    "43.72232;10.39657",
                    "43.72247;10.39605",
                    "43.72207;10.39586",
                    "43.72151;10.39668",
                    "43.71985;10.3967",
                    "43.71988;10.39736",
                    "43.71925;10.39746",
                    "43.71857;10.39719",
                    "43.71796;10.39742",
                    "43.71791;10.39813",
                    "43.7176;10.39932",
                    "43.71758;10.39979",
                    "43.71811;10.39989",
                    "43.718;10.40038",
                    "43.71772;10.40138",
                    "43.71785;10.40184",
                    "43.7169;10.40212",
                    "43.7169;10.40212",
                    "43.71714;10.40231",
                    "43.71692;10.40241",
                    "43.71663;10.40214",
                    "43.71635;10.40205",
                    "43.71635;10.40205",
                    "43.71628;10.40215",
                    "43.71559;10.40155",
                    "43.71576;10.40067",
                    "43.71583;10.39998",
                    "43.71576;10.39879",
                    "43.71542;10.39746",
                    "43.71508;10.39645",
                    "43.71468;10.3956",
                    "43.71349;10.39326",
                    "43.71299;10.39233",
                    "43.71269;10.39236",
                    "43.71251;10.39159",
                    "43.71239;10.39126",
                    "43.71191;10.39139",
                    "43.71176;10.39148",
                    "43.71173;10.3919",
                    "43.7116;10.39179",
                    "43.71118;10.39161",
                    "43.71114;10.39218",
                    "43.71091;10.39618",
                    "43.71085;10.39698",
                    "43.71097;10.39725",
                    "43.71089;10.39767",
                    "43.71083;10.39765",
                    "43.71076;10.39766",
                    "43.71052;10.39763",
                    "43.71022;10.39766",
                    "43.71016;10.39764",
                    "43.71006;10.39775",
                    "43.71004;10.39805",
                    "43.70997;10.3988",
                    "43.70988;10.39882",
                    "43.70977;10.39888",
                    "43.70908;10.39875",
                    "43.70891;10.3992"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/de864326-9031-4f50-941b-3f5ca5d3fa0a.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5c7cea67-182c-4be4-b390-411a18de4bb9.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/78a84b54-6598-4ac0-aa77-b2a098a95b99.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/0eb73fe1-bd13-4fd0-b2c5-e862b301c6d2.JPG",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/cf36a3b7-20b2-4d64-9d6a-2c16718ef9a4.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5cc9a7bb-b0f5-4675-a3e1-7b07c5bae20d.jpg"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 13548
                }
            }
        ],
        "catalogue": [
            {
                "id": 54,
                "name": "E-bike",
                "description": "Lombardo E-MTB front con freni a disco",
                "price": 55.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/6923496a-333b-48b1-958a-ed1a84b26eb3.png"
            },
            {
                "id": 55,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1586,
        "customer": {
            "id": 380,
            "title": "Biciclettaio - Gaiole in Chianti",
            "description": "Biciclettaio \u00e8 il bike rent di Gaiole in Chianti gestito da Filippo, punto di riferimento per chi vuole pedalare tra le colline del Chianti Classico. Offre noleggio di e-bike moderne e ben mantenute, ideali per affrontare sterrati e salite in totale relax. Propone tour panoramici in e-bike alla scoperta di borghi, vigneti e strade bianche, con itinerari anche ispirati a L\u2019Eroica. In negozio trovi assistenza competente, consigli sui percorsi e supporto per organizzare la giornata in sella. Disponibili servizi come regolazione bici, caschi e accessori, oltre a indicazioni su tracce e punti di interesse. Un\u2019esperienza completa, pensata per divertirsi e vivere il Chianti al ritmo giusto.",
            "color": "#ffffff",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Biciclettaio_-_Gaiole_in_Chianti.jpg",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/Progetto_senza_titolo.png"
            ],
            "contacts": {
                "address": "Via G. Marconi, 5, Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "email": "rental@bicyclesinchianti.com",
                "phone": "05771390071"
            },
            "coordinate": {
                "latitude": 43.46728,
                "longitude": 11.43466
            },
            "tours": 4,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8290a122-144d-4087-a8fb-9ab3edd8948f.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/7565c2ce-222e-4e8a-bd67-54c2940dc9a2.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/72782e04-007a-451f-9a23-2d3239ae3b48.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/099cdfa4-dcdf-4e40-9342-a33bdf177312.webp"
            ]
        },
        "title": "Chianti storico tra borghi e castelli",
        "description": "Un percorso facile e panoramico, quasi tutto su asfalto, ideale per tutti i tipi di bici. Da Gaiole in Chianti si raggiungono il Castello di Castagnoli e Madonna a Brolio, con sosta all\u2019Agribar e salita al suggestivo Castello di Brolio. Il tour prosegue tra vigneti e colline verso Monti, San Sano e Lecchi in Chianti, perfetti per una pausa. Dopo Radda in Chianti, un tratto de L\u2019Eroica conduce al Castello di San Donato in Perano e al borgo di Vertine, tra i luoghi pi\u00f9 affascinanti della zona.\n",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1586.jpg",
        "price": 25.0,
        "location": "Chianti",
        "location_id": 35,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1619,
                "title": "Sulle tracce dell'Eroica!",
                "description": "Percorso facile e panoramico da Gaiole in Chianti, ideale per tutti i tipi di bici e quasi interamente su asfalto, con solo brevi tratti di strada bianca.\n\nDopo i primi chilometri si raggiunge il Castello di Castagnoli, immerso nelle colline del Chianti e circondato da cantine storiche con possibilit\u00e0 di degustazioni su appuntamento.Si prosegue verso Madonna a Brolio, tappa perfetta per una sosta, prima della salita al suggestivo Castello di Brolio lungo il suo splendido viale panoramico.\n\nQui si possono visitare i giardini del castello e godere di uno dei luoghi pi\u00f9 iconici del territorio. L\u2019itinerario continua tra vigneti e dolci colline in direzione di Monti in Chianti e San Sano, con bellissimi scorci panoramici.\n\nSi raggiunge poi Lecchi in Chianti, ideale per una pausa pranzo o un aperitivo, e successivamente Radda in Chianti, borgo vivace ricco di locali. Seguendo un tratto del percorso de L\u2019Eroica si arriva infine al Castello di San Donato in Perano e al borgo di Vertine, tra i punti pi\u00f9 affascinanti e fotografati della zona.\n\nUn tour rilassante e ricco di fascino, perfetto per vivere il Chianti tra paesaggi, borghi storici e soste enogastronomiche.\n",
                "notes": null,
                "start_address": "",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1586.jpg",
                "track": [
                    43.46754,
                    11.43427
                ],
                "preview_track": [
                    "43.46754;11.43427",
                    "43.46691;11.43433",
                    "43.46659;11.43436",
                    "43.46625;11.43434",
                    "43.46601;11.43427",
                    "43.46569;11.43415",
                    "43.46553;11.43404",
                    "43.46539;11.43385",
                    "43.46508;11.4334",
                    "43.46491;11.4332",
                    "43.46465;11.43301",
                    "43.46448;11.43285",
                    "43.4643;11.43265",
                    "43.46368;11.43121",
                    "43.46352;11.43086",
                    "43.46328;11.43051",
                    "43.46301;11.43004",
                    "43.46275;11.42963",
                    "43.46166;11.4283",
                    "43.45799;11.426",
                    "43.45661;11.42551",
                    "43.45471;11.42393",
                    "43.45457;11.42418",
                    "43.45257;11.4272",
                    "43.45111;11.42816",
                    "43.45104;11.42951",
                    "43.45075;11.43063",
                    "43.45044;11.43196",
                    "43.45034;11.43372",
                    "43.45034;11.43472",
                    "43.44945;11.43593",
                    "43.44842;11.43575",
                    "43.44913;11.43421",
                    "43.44864;11.43396",
                    "43.44671;11.43509",
                    "43.44539;11.43731",
                    "43.44368;11.4383",
                    "43.44339;11.43893",
                    "43.44359;11.44015",
                    "43.44283;11.44135",
                    "43.44284;11.44301",
                    "43.44222;11.4445",
                    "43.4417;11.44581",
                    "43.44262;11.44729",
                    "43.44214;11.44891",
                    "43.44282;11.4512",
                    "43.44227;11.45269",
                    "43.44234;11.45347",
                    "43.44228;11.45401",
                    "43.44129;11.45456",
                    "43.43957;11.45306",
                    "43.43877;11.45118",
                    "43.43806;11.44966",
                    "43.43781;11.44793",
                    "43.43865;11.44699",
                    "43.43821;11.44491",
                    "43.43684;11.44356",
                    "43.4359;11.44302",
                    "43.43601;11.44115",
                    "43.43412;11.4415",
                    "43.43373;11.44057",
                    "43.43242;11.44081",
                    "43.43174;11.44068",
                    "43.42974;11.44096",
                    "43.42841;11.44041",
                    "43.42672;11.43812",
                    "43.42576;11.43706",
                    "43.42547;11.43435",
                    "43.42539;11.43294",
                    "43.42541;11.43283",
                    "43.42538;11.43208",
                    "43.42525;11.43218",
                    "43.42496;11.43238",
                    "43.42445;11.43378",
                    "43.42438;11.43468",
                    "43.42467;11.43504",
                    "43.42534;11.43576",
                    "43.42508;11.43627",
                    "43.42524;11.43895",
                    "43.42589;11.43935",
                    "43.42616;11.44112",
                    "43.42537;11.44182",
                    "43.42492;11.44272",
                    "43.42476;11.44388",
                    "43.42392;11.44552",
                    "43.42387;11.44583",
                    "43.42434;11.4463",
                    "43.42446;11.44704",
                    "43.42421;11.44762",
                    "43.42383;11.44831",
                    "43.424;11.44913",
                    "43.42359;11.45027",
                    "43.42268;11.45119",
                    "43.42195;11.45139",
                    "43.4218;11.45165",
                    "43.4217;11.45241",
                    "43.42166;11.45313",
                    "43.4218;11.45392",
                    "43.42109;11.45462",
                    "43.41974;11.45662",
                    "43.41922;11.45689",
                    "43.41899;11.45745",
                    "43.41815;11.45831",
                    "43.41771;11.45837",
                    "43.41712;11.45802",
                    "43.4164;11.45803",
                    "43.41594;11.45857",
                    "43.41587;11.45914",
                    "43.4159;11.46062",
                    "43.41614;11.46125",
                    "43.41575;11.46142",
                    "43.41532;11.46056",
                    "43.41525;11.46072",
                    "43.41546;11.46125",
                    "43.41525;11.46175",
                    "43.41507;11.46133",
                    "43.41496;11.46161",
                    "43.41468;11.46225",
                    "43.41453;11.46278",
                    "43.41448;11.46352",
                    "43.41421;11.46434",
                    "43.41342;11.46463",
                    "43.41309;11.46447",
                    "43.41287;11.46438",
                    "43.4123;11.46445",
                    "43.41173;11.46482",
                    "43.41151;11.4648",
                    "43.41096;11.46445",
                    "43.41055;11.46438",
                    "43.41156;11.46401",
                    "43.41214;11.46313",
                    "43.41233;11.46148",
                    "43.41314;11.46188",
                    "43.41487;11.46148",
                    "43.41504;11.46134",
                    "43.41523;11.46165",
                    "43.4154;11.46146",
                    "43.4153;11.46076",
                    "43.41524;11.46057",
                    "43.41571;11.46132",
                    "43.41608;11.46135",
                    "43.41594;11.46073",
                    "43.41587;11.45929",
                    "43.41594;11.45857",
                    "43.41599;11.45826",
                    "43.41639;11.45679",
                    "43.41597;11.45588",
                    "43.41521;11.45545",
                    "43.41489;11.45464",
                    "43.41544;11.45261",
                    "43.41563;11.45136",
                    "43.41486;11.4486",
                    "43.41424;11.44727",
                    "43.41477;11.44459",
                    "43.41557;11.44177",
                    "43.41606;11.4398",
                    "43.41601;11.43736",
                    "43.41602;11.43693",
                    "43.41535;11.435",
                    "43.41417;11.4338",
                    "43.41351;11.43123",
                    "43.41253;11.4294",
                    "43.4122;11.42794",
                    "43.41075;11.42643",
                    "43.4106;11.4255",
                    "43.40967;11.42503",
                    "43.40824;11.42391",
                    "43.40771;11.4222",
                    "43.40723;11.42262",
                    "43.40707;11.42368",
                    "43.4051;11.42457",
                    "43.4033;11.42536",
                    "43.40107;11.42499",
                    "43.40033;11.42418",
                    "43.3997;11.42339",
                    "43.3992;11.4223",
                    "43.39845;11.42082",
                    "43.3977;11.41985",
                    "43.39676;11.42",
                    "43.39513;11.41878",
                    "43.39451;11.41783",
                    "43.3933;11.41653",
                    "43.39264;11.41531",
                    "43.39215;11.41478",
                    "43.39075;11.41426",
                    "43.39073;11.41416",
                    "43.39146;11.41398",
                    "43.39227;11.41326",
                    "43.39379;11.40964",
                    "43.39788;11.40333",
                    "43.39921;11.40337",
                    "43.40047;11.40505",
                    "43.40241;11.40611",
                    "43.40459;11.40491",
                    "43.40636;11.40463",
                    "43.40856;11.40377",
                    "43.41086;11.40063",
                    "43.41224;11.39898",
                    "43.41328;11.39899",
                    "43.41337;11.39888",
                    "43.41342;11.39874",
                    "43.41342;11.39859",
                    "43.41333;11.39843",
                    "43.41319;11.39831",
                    "43.4117;11.39749",
                    "43.41077;11.39707",
                    "43.41037;11.39537",
                    "43.4113;11.39289",
                    "43.41248;11.39136",
                    "43.41449;11.39017",
                    "43.41546;11.3896",
                    "43.41674;11.38901",
                    "43.41778;11.38975",
                    "43.41952;11.38993",
                    "43.42127;11.38905",
                    "43.42223;11.3892",
                    "43.42254;11.38959",
                    "43.42331;11.39099",
                    "43.42305;11.39226",
                    "43.42244;11.39371",
                    "43.42308;11.39569",
                    "43.42471;11.39592",
                    "43.42554;11.39549",
                    "43.42696;11.39445",
                    "43.42825;11.39441",
                    "43.42848;11.39486",
                    "43.42765;11.39535",
                    "43.42886;11.39541",
                    "43.42836;11.39555",
                    "43.42801;11.39596",
                    "43.42898;11.39586",
                    "43.43036;11.39651",
                    "43.43205;11.39868",
                    "43.43346;11.40015",
                    "43.43431;11.40113",
                    "43.43471;11.40265",
                    "43.43498;11.4028",
                    "43.43545;11.40233",
                    "43.43683;11.40276",
                    "43.43851;11.40195",
                    "43.43962;11.40071",
                    "43.44102;11.40037",
                    "43.44217;11.40041",
                    "43.44223;11.39842",
                    "43.44262;11.39731",
                    "43.44208;11.39637",
                    "43.44218;11.39468",
                    "43.44392;11.39376",
                    "43.44518;11.39482",
                    "43.44634;11.39388",
                    "43.4474;11.39367",
                    "43.44855;11.39127",
                    "43.44897;11.39124",
                    "43.44998;11.39174",
                    "43.45124;11.39115",
                    "43.45181;11.38978",
                    "43.45203;11.38644",
                    "43.45318;11.38618",
                    "43.45394;11.3858",
                    "43.45432;11.38383",
                    "43.45482;11.38347",
                    "43.45613;11.38394",
                    "43.45687;11.38448",
                    "43.45731;11.38509",
                    "43.45736;11.38596",
                    "43.45864;11.38686",
                    "43.45977;11.38658",
                    "43.45993;11.3863",
                    "43.46045;11.38566",
                    "43.46079;11.38526",
                    "43.46141;11.38515",
                    "43.46184;11.38441",
                    "43.46289;11.38436",
                    "43.46354;11.3837",
                    "43.46382;11.38309",
                    "43.46415;11.3827",
                    "43.46427;11.3823",
                    "43.46434;11.38177",
                    "43.4649;11.38191",
                    "43.46512;11.38139",
                    "43.46549;11.38031",
                    "43.46655;11.37672",
                    "43.46676;11.37495",
                    "43.46729;11.37367",
                    "43.46732;11.37311",
                    "43.46751;11.37306",
                    "43.46861;11.37374",
                    "43.46943;11.37425",
                    "43.4717;11.37403",
                    "43.47327;11.37437",
                    "43.47378;11.37416",
                    "43.47442;11.3735",
                    "43.47493;11.37392",
                    "43.47651;11.37356",
                    "43.47685;11.37186",
                    "43.47767;11.372",
                    "43.47819;11.37166",
                    "43.47796;11.37015",
                    "43.47818;11.36978",
                    "43.47925;11.369",
                    "43.48033;11.36763",
                    "43.48077;11.36766",
                    "43.48129;11.36712",
                    "43.48182;11.36699",
                    "43.48245;11.36638",
                    "43.48305;11.3665",
                    "43.48343;11.36619",
                    "43.48383;11.36563",
                    "43.48422;11.3656",
                    "43.48442;11.3659",
                    "43.48434;11.36664",
                    "43.48449;11.36729",
                    "43.48469;11.36845",
                    "43.48487;11.36934",
                    "43.4853;11.36981",
                    "43.48573;11.36997",
                    "43.48592;11.37025",
                    "43.48619;11.37111",
                    "43.48639;11.37264",
                    "43.48642;11.37299",
                    "43.48637;11.37334",
                    "43.48613;11.37422",
                    "43.48623;11.37474",
                    "43.48649;11.37518",
                    "43.4868;11.37568",
                    "43.48691;11.37604",
                    "43.4868;11.37767",
                    "43.48747;11.3794",
                    "43.48785;11.38013",
                    "43.48817;11.38162",
                    "43.48961;11.38355",
                    "43.48999;11.38418",
                    "43.49011;11.38481",
                    "43.49029;11.3852",
                    "43.49024;11.38601",
                    "43.49003;11.38632",
                    "43.48988;11.3863",
                    "43.48982;11.3862",
                    "43.4897;11.38619",
                    "43.48966;11.38634",
                    "43.48966;11.38648",
                    "43.48956;11.38691",
                    "43.48939;11.38862",
                    "43.48927;11.38913",
                    "43.48928;11.3893",
                    "43.48958;11.39018",
                    "43.49003;11.39104",
                    "43.49017;11.39209",
                    "43.49041;11.3933",
                    "43.49028;11.39389",
                    "43.4901;11.39494",
                    "43.4901;11.39586",
                    "43.48993;11.39646",
                    "43.4895;11.39717",
                    "43.48819;11.39966",
                    "43.48764;11.3998",
                    "43.48755;11.40071",
                    "43.48749;11.40122",
                    "43.48763;11.40126",
                    "43.48798;11.40073",
                    "43.48878;11.40119",
                    "43.4889;11.40177",
                    "43.48874;11.40298",
                    "43.48873;11.40375",
                    "43.48893;11.40516",
                    "43.48923;11.4064",
                    "43.48996;11.40777",
                    "43.48998;11.40979",
                    "43.48944;11.41101",
                    "43.48952;11.41178",
                    "43.49017;11.41261",
                    "43.4906;11.41356",
                    "43.49014;11.41613",
                    "43.49007;11.4166",
                    "43.49041;11.41787",
                    "43.49098;11.41849",
                    "43.49122;11.42026",
                    "43.49131;11.42119",
                    "43.4903;11.4214",
                    "43.48929;11.42187",
                    "43.48853;11.42204",
                    "43.48826;11.42266",
                    "43.48807;11.42278",
                    "43.48713;11.42188",
                    "43.4853;11.41987",
                    "43.48432;11.41944",
                    "43.48307;11.41999",
                    "43.48066;11.42184",
                    "43.4795;11.42292",
                    "43.47884;11.42404",
                    "43.47836;11.42427",
                    "43.47825;11.4246",
                    "43.47804;11.42469",
                    "43.47624;11.42259",
                    "43.475;11.42259",
                    "43.47423;11.42243",
                    "43.47342;11.42221",
                    "43.47217;11.42123",
                    "43.47066;11.41919",
                    "43.47008;11.4182",
                    "43.47021;11.41846",
                    "43.46969;11.41939",
                    "43.47023;11.42075",
                    "43.4703;11.42138",
                    "43.46821;11.42295",
                    "43.4677;11.42315",
                    "43.46768;11.42349",
                    "43.46932;11.42439",
                    "43.46983;11.4249",
                    "43.4698;11.42703",
                    "43.46891;11.4287",
                    "43.46758;11.4301",
                    "43.46661;11.43081",
                    "43.46754;11.43155",
                    "43.46844;11.43263",
                    "43.46858;11.4332",
                    "43.46778;11.43384",
                    "43.46754;11.43427"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d31cf612-88c9-4f28-a89f-ff0e0da86deb.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/810580a5-feb8-44b7-9b43-eee7191d554c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c52a4cfa-9315-468a-8f79-c6866e2d6c13.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/a6fa9520-f34b-41f1-853f-e7ba425dcb44.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9ddc5465-cd6c-443e-b4c8-9449161bcfd1.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/1476be7b-6365-4ba7-82dc-c96523663f1b.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9dcad8b4-796a-41b3-86dc-d1bd01a1f4ed.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Castello di Brolio",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d4bdf9d0-d9ae-4965-bc28-b74cf688f5b0.Proge__43_41308429294438_11_464486910531738",
                        "latitude": 43.41308429294438,
                        "longitude": 11.464486910531738,
                        "description": "Uno dei luoghi simbolo del Chianti Classico, il Castello di Brolio \u00e8 legato da secoli alla famiglia Ricasoli, presente qui fin dal Medioevo. Oltre al grande valore storico e paesaggistico, \u00e8 una tappa ideale per chi ama vino e cultura: \u00e8 possibile visitare il castello e i giardini (con modalit\u00e0 che possono variare in base alla stagione) e sono disponibili degustazioni di vini Ricasoli. In alcune esperienze la visita \u00e8 guidata, in altre \u00e8 prevista una formula pi\u00f9 libera con tasting incluso."
                    },
                    {
                        "name": "Rocca di Castagnoli",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/b22e3713-cb6a-4d1f-98c6-36048ef29fd9.6_jpg__43_44232791071072_11_453424642063045",
                        "latitude": 43.44232791071072,
                        "longitude": 11.453424642063045,
                        "description": "La Rocca di Castagnoli nasce come antica fortezza medievale, attorno alla quale si \u00e8 sviluppato il borgo di Castagnoli. Nel tempo \u00e8 passata a importanti famiglie nobiliari ed \u00e8 oggi una tenuta di riferimento del Chianti Classico. Qui \u00e8 possibile fare degustazioni ed esperienze legate al vino (generalmente su prenotazione), con percorsi che uniscono la storia della rocca alla tradizione enologica del territorio."
                    },
                    {
                        "name": "Radda in Chianti",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/e02f2cb8-4a46-4cad-88fe-226d44cbcd3f.radda__43_48646954218788_11_375129876803255",
                        "latitude": 43.48646954218788,
                        "longitude": 11.375129876803255,
                        "description": "Radda \u00e8 uno dei borghi storici pi\u00f9 rappresentativi del Chianti, con origini antiche (anche etrusche, come testimoniano i ritrovamenti archeologici) e un impianto medievale ancora ben riconoscibile. Fu anche un centro importante della Lega del Chianti, e ancora oggi il suo centro storico conserva piazze, palazzi e scorci di grande fascino."
                    },
                    {
                        "name": "Borgo di Vertine",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/5e857815-cea2-4097-b694-d0f903f7731c.gaiol__43_47001087900543_11_418111131278645",
                        "latitude": 43.47001087900543,
                        "longitude": 11.418111131278645,
                        "description": "Vertine \u00e8 un piccolo borgo fortificato di grande atmosfera, tra i pi\u00f9 suggestivi nei dintorni di Gaiole. Le fonti locali lo ricordano come insediamento molto antico, gi\u00e0 noto in epoca medievale, e in seguito legato ai Ricasoli: passeggiare tra le sue mura e le case in pietra significa entrare in una delle immagini pi\u00f9 autentiche del Chianti storico."
                    }
                ],
                "infos": {
                    "distance": 47156
                }
            }
        ],
        "catalogue": [
            {
                "id": 56,
                "name": "E-bike",
                "description": "E-MTB front BOTTECCHIA HYDRON BE50",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/8feb07a0-293b-4656-89ab-252eb7b8d9f1.png"
            },
            {
                "id": 57,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1522,
        "customer": {
            "id": 373,
            "title": "Bike Tour Rimini",
            "description": "Noleggio biciclette tradizionali e city bike a pedalata assistita, Mountain Bike elettriche per ciclovisite cittadine ed escursioni. Officina e riparazione bici",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Bike_Tour_Rimini.png",
            "text_logo": null,
            "contacts": {
                "address": "Viale Regina Elena, 54, Viale Regina Elena, 54, 47921 Rimini RN, Italia",
                "email": "biketourrimini@gmail.com",
                "phone": "3271638550"
            },
            "coordinate": {
                "latitude": 44.05743,
                "longitude": 12.59233
            },
            "tours": 1,
            "gallery": []
        },
        "title": "Rimini - Santarcangelo Bike Tour",
        "description": "Tour in bici da Bike Tour Rimini a Santarcangelo di Romagna, pedalando verso l\u2019entroterra su un percorso scorrevole e perlopi\u00f9 asfaltato: circa 39 km con dislivello contenuto, livello semplice, ideale per una mezza giornata. Perfetto per unire mare e campagna romagnola, con arrivo nel borgo e nel centro storico di Santarcangelo.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1522.jpg",
        "price": 25.0,
        "location": "Riviera Romagnola",
        "location_id": 5,
        "tags": [
            "Mare",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1554,
                "title": "Da Bike Tour Rimini a Santarcangelo",
                "description": "Tracciato lineare di circa 39 km con dislivello molto contenuto (intorno ai 100 m), sostanzialmente pianeggiante e scorrevole. Si esce da Rimini con un primo tratto urbano (incroci/rotatorie) e poi si procede su viabilit\u00e0 pi\u00f9 tranquilla verso l\u2019entroterra, a prevalenza asfaltata, con ritmo costante e pochissime variazioni altimetriche",
                "notes": "",
                "start_address": "Viale Regina Elena, 54, 47921 Rimini",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    44.05739,
                    12.59199
                ],
                "preview_track": [
                    "44.05739;12.59199",
                    "44.05763;12.59165",
                    "44.05888;12.59039",
                    "44.05921;12.59005",
                    "44.06055;12.58866",
                    "44.06109;12.58812",
                    "44.06199;12.58719",
                    "44.06273;12.58643",
                    "44.06307;12.58607",
                    "44.06339;12.58574",
                    "44.06336;12.58556",
                    "44.06341;12.58535",
                    "44.06353;12.58529",
                    "44.06367;12.58541",
                    "44.06373;12.58538",
                    "44.06416;12.58494",
                    "44.06461;12.58441",
                    "44.06548;12.5834",
                    "44.06671;12.58193",
                    "44.06705;12.58163",
                    "44.06737;12.58177",
                    "44.06755;12.58199",
                    "44.06765;12.58229",
                    "44.06775;12.58245",
                    "44.06813;12.58195",
                    "44.0686;12.58151",
                    "44.06954;12.58072",
                    "44.07022;12.58015",
                    "44.07098;12.57942",
                    "44.0717;12.57895",
                    "44.0723;12.57849",
                    "44.07304;12.57842",
                    "44.07371;12.57736",
                    "44.07587;12.57605",
                    "44.07754;12.5753",
                    "44.07772;12.57504",
                    "44.07592;12.5747",
                    "44.07511;12.57456",
                    "44.07296;12.57357",
                    "44.07177;12.5732",
                    "44.07105;12.5728",
                    "44.06968;12.57183",
                    "44.0687;12.57102",
                    "44.06847;12.57105",
                    "44.0675;12.57028",
                    "44.06748;12.57016",
                    "44.06742;12.57012",
                    "44.06686;12.5696",
                    "44.06581;12.56856",
                    "44.06576;12.56848",
                    "44.06516;12.56769",
                    "44.06518;12.56749",
                    "44.06556;12.56663",
                    "44.06464;12.56505",
                    "44.06453;12.56458",
                    "44.06398;12.56291",
                    "44.06383;12.56256",
                    "44.06355;12.562",
                    "44.06375;12.5618",
                    "44.06372;12.56121",
                    "44.06393;12.56001",
                    "44.06364;12.55838",
                    "44.06361;12.55633",
                    "44.06358;12.55535",
                    "44.0635;12.5544",
                    "44.06368;12.55288",
                    "44.064;12.55218",
                    "44.06433;12.55203",
                    "44.0647;12.55184",
                    "44.06478;12.55154",
                    "44.06541;12.55067",
                    "44.06402;12.54704",
                    "44.06258;12.54336",
                    "44.0622;12.54198",
                    "44.06196;12.54093",
                    "44.06125;12.53837",
                    "44.06165;12.53587",
                    "44.06209;12.5336",
                    "44.06217;12.53318",
                    "44.06311;12.53088",
                    "44.06426;12.52833",
                    "44.0648;12.52783",
                    "44.06467;12.52685",
                    "44.06491;12.52518",
                    "44.06594;12.52319",
                    "44.06638;12.52031",
                    "44.06655;12.51621",
                    "44.06775;12.51297",
                    "44.06758;12.51027",
                    "44.06767;12.50874",
                    "44.06763;12.50736",
                    "44.06708;12.50607",
                    "44.06369;12.50201",
                    "44.06203;12.50141",
                    "44.061;12.50064",
                    "44.05961;12.5",
                    "44.05503;12.49794",
                    "44.05312;12.49569",
                    "44.05273;12.4932",
                    "44.05263;12.49191",
                    "44.05288;12.49035",
                    "44.05298;12.48711",
                    "44.05356;12.48312",
                    "44.05366;12.48253",
                    "44.05383;12.47992",
                    "44.05457;12.47959",
                    "44.05465;12.47825",
                    "44.0549;12.47698",
                    "44.05477;12.47455",
                    "44.05457;12.46944",
                    "44.05324;12.46598",
                    "44.05209;12.4637",
                    "44.05096;12.46135",
                    "44.05003;12.45991",
                    "44.04943;12.45871",
                    "44.04882;12.45772",
                    "44.04883;12.45746",
                    "44.04948;12.45674",
                    "44.04921;12.45498",
                    "44.04846;12.45385",
                    "44.04799;12.45384",
                    "44.04757;12.45356",
                    "44.04701;12.45219",
                    "44.04664;12.45083",
                    "44.04717;12.45026",
                    "44.04792;12.44971",
                    "44.04933;12.44872",
                    "44.05029;12.44676",
                    "44.05168;12.44508",
                    "44.05374;12.44397",
                    "44.05458;12.4437",
                    "44.0555;12.4433",
                    "44.05684;12.4427",
                    "44.05761;12.44211",
                    "44.05839;12.44163",
                    "44.05852;12.44174",
                    "44.0587;12.44167",
                    "44.05865;12.44143",
                    "44.05871;12.44137",
                    "44.0591;12.44187",
                    "44.0595;12.44236",
                    "44.05987;12.44282",
                    "44.05992;12.44288",
                    "44.06048;12.44357",
                    "44.06065;12.44379",
                    "44.06092;12.44412",
                    "44.06129;12.44457",
                    "44.06157;12.44491",
                    "44.06102;12.44424",
                    "44.06086;12.44404",
                    "44.06051;12.44361",
                    "44.06009;12.44309",
                    "44.05987;12.44282",
                    "44.05954;12.44242",
                    "44.05938;12.44221",
                    "44.05886;12.44175",
                    "44.05877;12.44194",
                    "44.0585;12.44189",
                    "44.05828;12.4422",
                    "44.05818;12.44175",
                    "44.05738;12.44226",
                    "44.05643;12.44299",
                    "44.05404;12.44395",
                    "44.0527;12.44341",
                    "44.05107;12.4459",
                    "44.04963;12.44785",
                    "44.04908;12.44897",
                    "44.04723;12.45014",
                    "44.04708;12.45061",
                    "44.04643;12.45088",
                    "44.04641;12.45097",
                    "44.04728;12.45308",
                    "44.04796;12.45385",
                    "44.04872;12.45442",
                    "44.04949;12.45606",
                    "44.04919;12.45699",
                    "44.04882;12.45772",
                    "44.04943;12.45871",
                    "44.04954;12.45902",
                    "44.05019;12.46001",
                    "44.05105;12.46157",
                    "44.0525;12.46475",
                    "44.05324;12.46598",
                    "44.05465;12.47012",
                    "44.05492;12.47604",
                    "44.05481;12.47721",
                    "44.05459;12.47838",
                    "44.05454;12.47976",
                    "44.05376;12.48",
                    "44.0536;12.48292",
                    "44.05298;12.48711",
                    "44.05302;12.48971",
                    "44.05285;12.49126",
                    "44.0526;12.49203",
                    "44.05285;12.49387",
                    "44.0532;12.4957",
                    "44.05753;12.49949",
                    "44.05989;12.50021",
                    "44.061;12.50064",
                    "44.06203;12.50141",
                    "44.06369;12.50201",
                    "44.06708;12.50607",
                    "44.06763;12.50736",
                    "44.06758;12.50985",
                    "44.06772;12.51281",
                    "44.06664;12.51594",
                    "44.06642;12.51945",
                    "44.06634;12.52206",
                    "44.0655;12.52425",
                    "44.06491;12.52518",
                    "44.06467;12.52685",
                    "44.0648;12.52783",
                    "44.06426;12.52833",
                    "44.06311;12.53088",
                    "44.06217;12.53318",
                    "44.06178;12.5353",
                    "44.06122;12.53776",
                    "44.06125;12.53837",
                    "44.06196;12.54093",
                    "44.06211;12.54167",
                    "44.06255;12.54331",
                    "44.06389;12.54663",
                    "44.06532;12.55055",
                    "44.06478;12.55154",
                    "44.0647;12.55184",
                    "44.06445;12.55197",
                    "44.06398;12.5522",
                    "44.06376;12.55219",
                    "44.0637;12.55178",
                    "44.06352;12.55194",
                    "44.06337;12.55427",
                    "44.0632;12.55495",
                    "44.06308;12.55622",
                    "44.06296;12.55739",
                    "44.06292;12.55871",
                    "44.06311;12.56079",
                    "44.06327;12.56166",
                    "44.06355;12.562",
                    "44.06383;12.56256",
                    "44.06398;12.56291",
                    "44.06407;12.56319",
                    "44.06518;12.56749",
                    "44.06501;12.56753",
                    "44.06489;12.56754",
                    "44.06464;12.56707",
                    "44.06433;12.56631",
                    "44.06417;12.56586",
                    "44.06475;12.56723",
                    "44.06503;12.56746",
                    "44.06525;12.56752",
                    "44.06546;12.56802",
                    "44.06571;12.56833",
                    "44.06619;12.56892",
                    "44.06647;12.56912",
                    "44.06665;12.5693",
                    "44.06732;12.56999",
                    "44.06747;12.57004",
                    "44.06809;12.57064",
                    "44.0687;12.57102",
                    "44.06968;12.57183",
                    "44.07105;12.5728",
                    "44.07177;12.5732",
                    "44.07296;12.57357",
                    "44.07511;12.57456",
                    "44.07592;12.5747",
                    "44.07678;12.5747",
                    "44.07767;12.5751",
                    "44.07638;12.5758",
                    "44.0738;12.57729",
                    "44.07306;12.57839",
                    "44.07243;12.5786",
                    "44.07172;12.57898",
                    "44.07125;12.57921",
                    "44.07035;12.58004",
                    "44.06969;12.58058",
                    "44.06873;12.58143",
                    "44.06823;12.58188",
                    "44.06784;12.58235",
                    "44.06751;12.58264",
                    "44.06699;12.58319",
                    "44.06511;12.58494",
                    "44.06429;12.58604",
                    "44.06422;12.58659",
                    "44.06369;12.58676",
                    "44.06363;12.58669",
                    "44.06312;12.587",
                    "44.06272;12.58736",
                    "44.06203;12.58798",
                    "44.06132;12.58883",
                    "44.06086;12.58931",
                    "44.06005;12.59028",
                    "44.05995;12.59055",
                    "44.05971;12.59108",
                    "44.05797;12.59257",
                    "44.05744;12.59312"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/1de61ebd-c7f6-446b-95d6-aafe7950212f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/85f6167f-0f65-4f0a-8353-8c62d52f276e.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/13e07330-2d44-4cfe-83a1-130eb3c475b9.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/10c437f6-e00c-4c29-bf5b-978475de81b6.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/2226b5f6-c53d-4529-aff5-313206af37fa.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ae75afbb-5ddb-44ba-afb7-7fbdd8230eac.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Porto canale di Rimini",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/ff904d26-3ea9-4058-8f72-2d41edee6455.porto__44_06747930728345_12_570158403832467",
                        "latitude": 44.06747930728345,
                        "longitude": 12.570158403832467,
                        "description": "Il porto canale di Rimini coincide con l\u2019antica foce del fiume Marecchia: un canale con banchine su entrambi i lati che arriva al mare tra due moli, oggi usato da pesca e diporto. La sua forma attuale deriva dalle opere in epoca malatestiana (iniziate nel Quattrocento) e, dopo la deviazione del Marecchia pi\u00f9 a nord nel 1972, il tratto storico \u00e8 rimasto come porto-canale e passeggiata sul mare"
                    },
                    {
                        "name": "Faro Bianco di Rimini",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/09f0dd50-4dba-46c6-8911-211050881a82.faro___44_07672654978573_12_574656615033746",
                        "latitude": 44.07672654978573,
                        "longitude": 12.574656615033746,
                        "description": "Il Faro Bianco di Rimini, all\u2019imboccatura del porto-canale in Largo Boscovich, \u00e8 una torre storica alta oltre 27 metri: costruita nel 1754 su progetto di Giovan Francesco Buonamici, ha l\u2019ottica rotante attiva dal 1862; danneggiato durante la Seconda guerra mondiale, \u00e8 stato ricostruito e rimesso in funzione nel 1946."
                    },
                    {
                        "name": "Ponte di Tiberio ",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/e98f6ba1-91a6-4bca-8818-25bf391f05cb.ponte__44_06405054101405_12_563203771132978",
                        "latitude": 44.06405054101405,
                        "longitude": 12.563203771132978,
                        "description": "Il Ponte sul fiume Marecchia di Rimini \u00e8 il celebre Ponte di Augusto e Tiberio (detto Ponte di Tiberio): iniziato da Augusto nel 14 d.C. e completato nel 21 d.C., \u00e8 costruito in pietra d\u2019Istria e formato da cinque arcate, ancora oggi collegamento storico tra il centro e Borgo San Giuliano"
                    },
                    {
                        "name": "Passarella di Legno ",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/885dd7c9-b35c-41f8-aa02-1d887505de90.Ponte__44_064325050186646_12_552015229593964",
                        "latitude": 44.064325050186646,
                        "longitude": 12.552015229593964,
                        "description": "Poco pi\u00f9 avanti, una passerella ciclopedonale moderna sul fiume Marecchia: un ponte in acciaio e legno, pensato per pedoni e biciclette, che collega le due sponde lungo i percorsi verdi del Parco del Marecchia e della rete ciclabile riminese. \u00c8 un punto comodo per attraversare il fiume in sicurezza e un bel belvedere sul corso d\u2019acqua e sulla campagna appena fuori dal centro"
                    },
                    {
                        "name": "Santarcangelo",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/9982a5f4-a6e2-490c-b98d-ff0082119ded.santa__44_06191409610905_12_444365965202453",
                        "latitude": 44.06191409610905,
                        "longitude": 12.444365965202453,
                        "description": "Santarcangelo di Romagna \u00e8 un borgo collinare a pochi chilometri da Rimini, famoso per il centro storico medievale e l\u2019atmosfera vivace tutto l\u2019anno. Tra i punti pi\u00f9 belli ci sono la Rocca Malatestiana, le piazze e le vie con case antiche e scorci panoramici sulla Valmarecchia. Sotto il paese si estende un fitto sistema di grotte e cavit\u00e0 scavate nel tufo, legate a storie e usi ancora in parte misteriosi. \u00c8 anche la citt\u00e0 di Tonino Guerra e di festival ed eventi che la rendono una delle tappe pi\u00f9 amate della zona"
                    },
                    {
                        "name": "Il Parco Artistico Mutonia",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/76c4026c-81ba-41e5-a5a7-b52142d03e6c.Muton__44_049529915580706_12_45902666822076",
                        "latitude": 44.049529915580706,
                        "longitude": 12.45902666822076,
                        "description": "Il Parco Artistico Mutonia \u00e8 un villaggio-laboratorio d\u2019arte a cielo aperto sulle rive del Marecchia, a Santarcangelo di Romagna (nell\u2019entroterra riminese). Nato nel 1991 quando la Mutoid Waste Company, collettivo inglese, si stabil\u00ec in un\u2019ex cava dopo il Festival dei Teatri, oggi \u00e8 famoso per le grandi sculture e installazioni create con rottami e materiali di recupero, dallo stile post-industriale/steampunk, visitabili liberamente lungo la ciclabile"
                    }
                ],
                "infos": {
                    "distance": 36620
                }
            }
        ],
        "catalogue": [
            {
                "id": 27,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 28,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1538,
        "customer": {
            "id": 382,
            "title": "Bicipedia",
            "description": "Bicipedia nasce nel 2013 con l\u2019obiettivo di essere un punto di riferimento non solo per il singolo ciclista appassionato ma anche per tutti coloro che utilizzano la bicicletta sia per recarsi a lavoro, sia per divertimento o semplicemente per mantenersi in forma.\r\n\r\nDa Bicipedia siamo attenti alle esigenze di tutti! La nostra mission \u00e8 quella di offrire prodotti di qualit\u00e0, curare le esigenze degli appassionati della bicicletta ed avvicinare le persone alla gioia del ciclismo!",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Bicipedia.png",
            "text_logo": null,
            "contacts": {
                "address": "Bicipedia, Via Luigi Einaudi, 6/B, 50065 Sieci FI, Italia",
                "email": "info@bicipedia.it",
                "phone": "+39 055 8328562"
            },
            "coordinate": {
                "latitude": 43.78633,
                "longitude": 11.39913
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/3930b5df-f4a9-444b-851c-5abd9d1abc0c.webp"
            ]
        },
        "title": "Chianti Rufina E-Bike Tour ",
        "description": "Giro collinare nel Chianti Rufina con andamento fluido: qualche salita breve per cambiare ritmo e belle discese scorrevoli su strade secondarie panoramiche. Fondo principalmente asfaltato, con qualche tratto rurale dove pu\u00f2 esserci un po\u2019 di brecciolino. Ideale in e-bike\n\nDopo la consegna delle E-Bike e aver fatto conoscenza del nostro staff, sarete istruiti sul funzionamento dell'App di navigazione, si parte! \n\nPedaleremo lungo strade secondare immerse nel verde e con una vista mozzafiato delle colline toscane! Come servizio EXTRA \u00e8 previsto un Light Lunch & Wine Tasting presso le cantine di Villa Bossi.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1538.jpg",
        "price": 25.0,
        "location": "Chianti",
        "location_id": 35,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1573,
                "title": "Chianti Rufina E-Bike Tour",
                "description": "Un tour in e-bike tra le colline del Chianti Rufina, dove vigneti, oliveti e piccoli borghi si alternano a strade panoramiche e scorci tipicamente toscani. \u00c8 una pedalata \u201cgustosa\u201d e rilassante, perfetta per vivere l\u2019entroterra con ritmo regolare e qualche sosta tra cantine e punti vista. \n\n",
                "notes": "",
                "start_address": "Via Luigi Einaudi, 6/B, 50065 Sieci FI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1538.jpg",
                "track": [
                    43.78651,
                    11.39857
                ],
                "preview_track": [
                    "43.78651;11.39857",
                    "43.78668;11.3983",
                    "43.7868;11.39843",
                    "43.78831;11.39983",
                    "43.78904;11.40099",
                    "43.78962;11.40201",
                    "43.7907;11.40323",
                    "43.79299;11.40364",
                    "43.79305;11.40417",
                    "43.79372;11.40459",
                    "43.79308;11.40479",
                    "43.79298;11.40498",
                    "43.79311;11.40603",
                    "43.79392;11.4073",
                    "43.79384;11.40763",
                    "43.79295;11.4075",
                    "43.79266;11.40795",
                    "43.79342;11.40848",
                    "43.79366;11.40993",
                    "43.79502;11.41114",
                    "43.79617;11.41191",
                    "43.79567;11.41195",
                    "43.79649;11.41263",
                    "43.79746;11.41235",
                    "43.79833;11.41427",
                    "43.7982;11.41697",
                    "43.79818;11.41736",
                    "43.799;11.41882",
                    "43.79979;11.42083",
                    "43.80038;11.42105",
                    "43.80177;11.42039",
                    "43.80272;11.42025",
                    "43.8033;11.42157",
                    "43.80349;11.42188",
                    "43.80448;11.42243",
                    "43.80451;11.42237",
                    "43.80495;11.42111",
                    "43.8053;11.4208",
                    "43.80548;11.42214",
                    "43.80537;11.4242",
                    "43.80541;11.42611",
                    "43.80611;11.42799",
                    "43.80633;11.42995",
                    "43.80632;11.43261",
                    "43.80694;11.43371",
                    "43.80774;11.43424",
                    "43.80834;11.43438",
                    "43.80894;11.43542",
                    "43.80961;11.43662",
                    "43.8105;11.43832",
                    "43.81202;11.44024",
                    "43.81238;11.44161",
                    "43.81303;11.4435",
                    "43.81367;11.44416",
                    "43.81441;11.44497",
                    "43.8159;11.44694",
                    "43.8165;11.44675",
                    "43.81668;11.44675",
                    "43.81695;11.44685",
                    "43.8173;11.44691",
                    "43.81671;11.44675",
                    "43.81634;11.44678",
                    "43.81696;11.44779",
                    "43.81648;11.44869",
                    "43.8157;11.44985",
                    "43.81624;11.45047",
                    "43.81729;11.45105",
                    "43.81771;11.45218",
                    "43.81835;11.45275",
                    "43.81886;11.45365",
                    "43.8192;11.45388",
                    "43.81911;11.45699",
                    "43.81953;11.45861",
                    "43.81994;11.46039",
                    "43.82068;11.46168",
                    "43.82024;11.46333",
                    "43.8192;11.46517",
                    "43.81923;11.46656",
                    "43.82093;11.46725",
                    "43.82069;11.47001",
                    "43.81933;11.47133",
                    "43.8181;11.4727",
                    "43.81776;11.47312",
                    "43.81696;11.47369",
                    "43.81575;11.47511",
                    "43.81474;11.4744",
                    "43.81393;11.47337",
                    "43.81363;11.47343",
                    "43.813;11.47276",
                    "43.81243;11.47226",
                    "43.81134;11.47149",
                    "43.81084;11.47083",
                    "43.80999;11.47027",
                    "43.80954;11.47002",
                    "43.80868;11.46985",
                    "43.80822;11.47022",
                    "43.80771;11.46992",
                    "43.80465;11.46884",
                    "43.80274;11.46834",
                    "43.80126;11.4659",
                    "43.80017;11.46285",
                    "43.80009;11.46231",
                    "43.79978;11.46167",
                    "43.79855;11.46056",
                    "43.79715;11.45993",
                    "43.79436;11.45984",
                    "43.79306;11.46042",
                    "43.79259;11.46082",
                    "43.79169;11.46116",
                    "43.79096;11.46124",
                    "43.79002;11.45966",
                    "43.78963;11.45909",
                    "43.7888;11.4586",
                    "43.7886;11.45831",
                    "43.78813;11.45688",
                    "43.7872;11.45261",
                    "43.78517;11.44988",
                    "43.78393;11.4484",
                    "43.78338;11.44736",
                    "43.78286;11.44664",
                    "43.78154;11.44593",
                    "43.78114;11.44601",
                    "43.7806;11.44545",
                    "43.77986;11.44428",
                    "43.77947;11.44413",
                    "43.77849;11.44357",
                    "43.77822;11.44336",
                    "43.77835;11.44368",
                    "43.77819;11.44434",
                    "43.77806;11.44478",
                    "43.77709;11.44435",
                    "43.77549;11.44382",
                    "43.77535;11.44368",
                    "43.77554;11.44251",
                    "43.77535;11.44169",
                    "43.77506;11.4411",
                    "43.77561;11.4414",
                    "43.77596;11.44125",
                    "43.77571;11.4401",
                    "43.7756;11.43929",
                    "43.77554;11.43836",
                    "43.77558;11.43825",
                    "43.77545;11.43728",
                    "43.7754;11.43626",
                    "43.77538;11.43587",
                    "43.77497;11.43564",
                    "43.77498;11.43443",
                    "43.7752;11.43193",
                    "43.77569;11.42865",
                    "43.77612;11.42618",
                    "43.77618;11.42582",
                    "43.77629;11.42541",
                    "43.77637;11.42508",
                    "43.77649;11.42437",
                    "43.77657;11.42382",
                    "43.77659;11.4235",
                    "43.7766;11.42317",
                    "43.7766;11.42149",
                    "43.77662;11.42128",
                    "43.77669;11.42097",
                    "43.77702;11.42023",
                    "43.77709;11.41998",
                    "43.77711;11.41976",
                    "43.77708;11.41953",
                    "43.77699;11.41932",
                    "43.77663;11.41848",
                    "43.77665;11.41658",
                    "43.77678;11.41581",
                    "43.77693;11.4153",
                    "43.77809;11.41247",
                    "43.77939;11.41071",
                    "43.78028;11.40956",
                    "43.78267;11.40643",
                    "43.78319;11.40597",
                    "43.78352;11.40571",
                    "43.78357;11.40535",
                    "43.78527;11.40307",
                    "43.78777;11.39973",
                    "43.78868;11.40042",
                    "43.78774;11.39927",
                    "43.78683;11.39836",
                    "43.78665;11.39837",
                    "43.78651;11.39857"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/101b7d85-4fa2-4966-8124-dcf1fe4e586e.avif",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ef99446d-3c79-4cba-9fe1-f5710ef2789f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/49c81a62-589d-4048-b463-c9cd50f7727a.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f7dd485d-954c-45e8-ae06-68eb09dbae55.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Fattoria Lavacchio Bar",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/732e2f50-dba7-40da-a9d7-6e6607fd3a34.fatto__43_816675_11_446748",
                        "latitude": 43.816675,
                        "longitude": 11.446748,
                        "description": "COnsigliamo di fare una pausa alla Fattoria di Lavacchio, situata di fianco al mulino a vento. Qui potrete frae uno spuntino con dei deliziosi piatti tipici della cucina toscana"
                    },
                    {
                        "name": "Mulino a Vento",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/4be03278-724a-4636-8c06-494ee007bd91.mulin__43_817293453914544_11_447048736736178",
                        "latitude": 43.817293453914544,
                        "longitude": 11.447048736736178,
                        "description": "Questo Mulino a Vento, risale alla prima met\u00e0 dell\u2018800 (XIX secolo), ma era completamente distrutto, prima che la Fattoria Lavacchio ed il Comune di Pontassieve ne promuovessero il recupero funzionale ed il restauro della muratura.\n\nAdesso \u00e8 possibili visitare gratuitamente il mulino chiedendo le chiaci allo staff del Bar Lavacchio!"
                    },
                    {
                        "name": "Tenuta Bossi Gondi",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/e1f0d350-5666-4e5b-beb3-230ca7a3dbf3.tenut__43_80450134678884_11_42236943822354",
                        "latitude": 43.80450134678884,
                        "longitude": 11.42236943822354,
                        "description": "Tenuta Bossi, di propriet\u00e0 della famiglia Gondi dal 1592, \u00e8 sempre stata famosa per il suo vino. Situata sulle boscose colline a Nord-Est di Firenze, nel cuore del Chianti Rufina. Se il cancello \u00e8 aperto, \u00e8 possibile visitare i giardini all?italiana che si trovano davanti alla facciata principale della Villa."
                    },
                    {
                        "name": "Ponte Mediceo Di Pontassieve",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/7a4dbd65-8a4b-4041-ba9d-5e68cfc79c49.ponte__43_77827963739345_11_4439357817173",
                        "latitude": 43.77827963739345,
                        "longitude": 11.4439357817173,
                        "description": "L\u2019origine del Ponte Mediceo, che collega lo storico borgo di Pontassieve con la frazione di San Francesco di Pelago, risale al 1555, quando Cosimo I de\u2019 Medici ne commission\u00f2 a Stefano di San Piero a Ponti e al figlio Tommaso la costruzione, probabilmente su progetto di Bartolomeo Ammannati.\n\nIl Ponte Mediceo fu restaurato nel 1788 su ordine del Granduca Pietro Leopoldo di Lorena e successivamente ricostruito parzialmente dopo i danni provocati dai bombardamenti durante la II\u00aa Guerra Mondiale."
                    }
                ],
                "infos": {
                    "distance": 20951
                }
            }
        ],
        "catalogue": [
            {
                "id": 60,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 61,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1534,
        "customer": {
            "id": 379,
            "title": "Smile & Ride",
            "description": "Smile & Ride nasce dall\u2019idea di mettere a disposizione le nostre competenze maturate come cicloturisti per farvi vivere delle esperienze uniche ed esclusive portandovi a scoprire questo incantevole territorio, ricco di cultura, arte e ottimo cibo. Abbiamo deciso di metterci in gioco attivamente mossi dall\u2019idea che chiunque voglia realizzare qualsiasi progetto deve trovare la giusta motivazione e passione per farlo, per noi un\u2019attivit\u00e0 di business dovrebbe avere anche il compito di rendere migliore il mondo in cui opera.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Smile__Ride.png",
            "text_logo": null,
            "contacts": {
                "address": "Smile & Ride - Tuscany e-Bike rental and tours, Piazza della Stazione, 7, 56121 Pisa PI, Italia",
                "email": "info@smileandride.com",
                "phone": "375 561 7631"
            },
            "coordinate": {
                "latitude": 43.70844,
                "longitude": 10.39915
            },
            "tours": 3,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/754c9abe-ebc3-47b7-8b13-51aad3839644.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/d11b3457-3a40-40f9-a563-513382e0d4df.webp"
            ]
        },
        "title": "Tour Pisa-Lucca ",
        "description": "Pedalata tra due citt\u00e0 simbolo della Toscana, da Pisa a Lucca, seguendo un percorso scorrevole e rilassante immerso nella pianura tra fiume, campagna e piccoli abitati. \u00c8 il classico giro \u201csenza stress\u201d: tanti chilometri facili, ritmo regolare e arrivo in una delle citt\u00e0 pi\u00f9 belle da vivere in sella, perfetta per una pausa sulle Mura e un caff\u00e8 in centro prima di rientrare.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1534.jpg",
        "price": 25.0,
        "location": "Pisa",
        "location_id": 3,
        "tags": [
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1569,
                "title": "Tour Pisa-Lucca ",
                "description": "Traccia ad anello/andata-ritorno con partenza e arrivo a Pisa, sviluppo totale circa 65 km. Dislivello molto contenuto (circa 60\u201365 m D+), quota massima intorno ai 53 m: percorso praticamente pianeggiante con lievi ondulazioni. Tempo registrato circa 3h48 (senza soste significative), velocit\u00e0 media intorno a 16,5 km/h: ideale come uscita di mezza giornata. Fondo complessivamente facile e scorrevole, adatto a bici da strada, gravel e Ebike, con attenzione ai tratti urbani/attraversamenti e ai possibili cambi di fondo nei raccordi.",
                "notes": null,
                "start_address": "Piazza della Stazione, 7, 56121 Pisa PI, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1534.jpg",
                "track": [
                    43.70886,
                    10.39933
                ],
                "preview_track": [
                    "43.70886;10.39933",
                    "43.7086;10.40011",
                    "43.70996;10.40101",
                    "43.70997;10.40259",
                    "43.70975;10.40422",
                    "43.70961;10.40508",
                    "43.70953;10.40566",
                    "43.70956;10.40583",
                    "43.70967;10.40591",
                    "43.71037;10.40552",
                    "43.71044;10.40539",
                    "43.71044;10.40518",
                    "43.71062;10.40515",
                    "43.71158;10.40555",
                    "43.71211;10.40537",
                    "43.71274;10.40512",
                    "43.71322;10.40469",
                    "43.7138;10.40376",
                    "43.71417;10.40286",
                    "43.71449;10.40213",
                    "43.71477;10.40197",
                    "43.71508;10.40197",
                    "43.71535;10.4021",
                    "43.71555;10.40168",
                    "43.71628;10.40215",
                    "43.71583;10.40373",
                    "43.71518;10.40564",
                    "43.71476;10.4066",
                    "43.71497;10.40718",
                    "43.7152;10.40696",
                    "43.71645;10.40719",
                    "43.71658;10.40707",
                    "43.71841;10.40671",
                    "43.71854;10.4073",
                    "43.71849;10.40748",
                    "43.71859;10.40882",
                    "43.71871;10.41035",
                    "43.71874;10.41057",
                    "43.71879;10.41105",
                    "43.71882;10.41125",
                    "43.71889;10.41229",
                    "43.71899;10.4123",
                    "43.71952;10.41223",
                    "43.71966;10.41398",
                    "43.71981;10.4162",
                    "43.71987;10.41728",
                    "43.72013;10.41916",
                    "43.72033;10.42009",
                    "43.72079;10.4213",
                    "43.72066;10.42159",
                    "43.7206;10.42166",
                    "43.72056;10.42177",
                    "43.7206;10.42189",
                    "43.72068;10.42192",
                    "43.72104;10.42233",
                    "43.72144;10.423",
                    "43.72187;10.4237",
                    "43.72268;10.42494",
                    "43.7228;10.42577",
                    "43.72276;10.42588",
                    "43.72305;10.42656",
                    "43.72323;10.42666",
                    "43.72384;10.42758",
                    "43.72446;10.42851",
                    "43.72502;10.42943",
                    "43.72787;10.43359",
                    "43.72967;10.43659",
                    "43.72997;10.43694",
                    "43.73002;10.43715",
                    "43.72988;10.43747",
                    "43.73003;10.43733",
                    "43.73151;10.43962",
                    "43.73401;10.44345",
                    "43.73461;10.44426",
                    "43.73545;10.44551",
                    "43.73654;10.44726",
                    "43.73843;10.45025",
                    "43.73943;10.45184",
                    "43.7417;10.4553",
                    "43.74237;10.45624",
                    "43.74535;10.46094",
                    "43.74717;10.46391",
                    "43.7472;10.46402",
                    "43.74737;10.46391",
                    "43.74764;10.4635",
                    "43.74776;10.46327",
                    "43.74781;10.46322",
                    "43.74788;10.46312",
                    "43.74804;10.46266",
                    "43.74826;10.46189",
                    "43.7486;10.46071",
                    "43.74891;10.45966",
                    "43.74962;10.45724",
                    "43.7505;10.45426",
                    "43.75078;10.45339",
                    "43.75094;10.45313",
                    "43.75144;10.45263",
                    "43.75188;10.45221",
                    "43.75206;10.45191",
                    "43.75248;10.4505",
                    "43.75279;10.44868",
                    "43.75279;10.44801",
                    "43.75271;10.44698",
                    "43.75273;10.44667",
                    "43.75291;10.44599",
                    "43.75322;10.44507",
                    "43.75345;10.4446",
                    "43.75368;10.44437",
                    "43.75412;10.44414",
                    "43.75495;10.44399",
                    "43.75669;10.44379",
                    "43.75734;10.44371",
                    "43.7576;10.44359",
                    "43.75777;10.4435",
                    "43.75787;10.4435",
                    "43.75792;10.44342",
                    "43.75806;10.44325",
                    "43.75902;10.44243",
                    "43.75925;10.44216",
                    "43.75937;10.44186",
                    "43.75968;10.44186",
                    "43.76133;10.44115",
                    "43.76196;10.44085",
                    "43.76255;10.44053",
                    "43.7643;10.43901",
                    "43.76447;10.43881",
                    "43.76514;10.43746",
                    "43.76533;10.43699",
                    "43.76546;10.43644",
                    "43.76595;10.43436",
                    "43.76629;10.43307",
                    "43.76743;10.43138",
                    "43.76778;10.43099",
                    "43.76881;10.43032",
                    "43.76987;10.42997",
                    "43.77031;10.42971",
                    "43.77083;10.42946",
                    "43.77105;10.42959",
                    "43.7712;10.42936",
                    "43.77117;10.42911",
                    "43.77131;10.42865",
                    "43.77193;10.42782",
                    "43.77242;10.42663",
                    "43.77283;10.42587",
                    "43.7741;10.42584",
                    "43.77473;10.42572",
                    "43.77529;10.42489",
                    "43.77555;10.42421",
                    "43.77603;10.42278",
                    "43.77617;10.42216",
                    "43.77657;10.42004",
                    "43.77691;10.4192",
                    "43.77746;10.41849",
                    "43.77823;10.41772",
                    "43.77841;10.41705",
                    "43.77856;10.4169",
                    "43.77927;10.4172",
                    "43.77985;10.41775",
                    "43.78092;10.41892",
                    "43.78118;10.41927",
                    "43.78243;10.41807",
                    "43.78277;10.4186",
                    "43.78351;10.41932",
                    "43.78442;10.41998",
                    "43.78583;10.42006",
                    "43.78697;10.41987",
                    "43.78783;10.41959",
                    "43.78911;10.41881",
                    "43.79029;10.4176",
                    "43.79108;10.41696",
                    "43.79147;10.41678",
                    "43.79178;10.4166",
                    "43.7916;10.41621",
                    "43.79119;10.41618",
                    "43.79112;10.41601",
                    "43.7915;10.41496",
                    "43.7942;10.41057",
                    "43.79519;10.40926",
                    "43.79637;10.4078",
                    "43.79909;10.40396",
                    "43.8015;10.40065",
                    "43.80218;10.39979",
                    "43.8026;10.3995",
                    "43.80382;10.39999",
                    "43.80626;10.4043",
                    "43.80806;10.40716",
                    "43.81241;10.41042",
                    "43.81268;10.4107",
                    "43.81217;10.41049",
                    "43.81197;10.41098",
                    "43.8117;10.41176",
                    "43.81188;10.41204",
                    "43.81364;10.41281",
                    "43.81494;10.41334",
                    "43.81541;10.41348",
                    "43.81701;10.41481",
                    "43.81743;10.41498",
                    "43.81757;10.41496",
                    "43.81796;10.41466",
                    "43.81842;10.41452",
                    "43.81909;10.41484",
                    "43.82012;10.41539",
                    "43.82177;10.41632",
                    "43.8269;10.4192",
                    "43.82881;10.42042",
                    "43.8293;10.4213",
                    "43.83037;10.42485",
                    "43.83132;10.42769",
                    "43.83144;10.42788",
                    "43.83153;10.42824",
                    "43.83168;10.42858",
                    "43.83161;10.42889",
                    "43.83125;10.42911",
                    "43.8309;10.42807",
                    "43.83044;10.42804",
                    "43.82951;10.42943",
                    "43.82947;10.43105",
                    "43.82909;10.43253",
                    "43.82893;10.43324",
                    "43.82835;10.43329",
                    "43.82789;10.43332",
                    "43.82771;10.43368",
                    "43.82739;10.43376",
                    "43.82736;10.43517",
                    "43.82755;10.43611",
                    "43.8279;10.43734",
                    "43.82789;10.43877",
                    "43.82844;10.44081",
                    "43.82928;10.44172",
                    "43.82966;10.44173",
                    "43.8304;10.44245",
                    "43.83055;10.44294",
                    "43.83044;10.44444",
                    "43.83037;10.44555",
                    "43.83083;10.4463",
                    "43.83126;10.44729",
                    "43.83114;10.44796",
                    "43.83202;10.4483",
                    "43.83238;10.44987",
                    "43.83167;10.45204",
                    "43.83149;10.4534",
                    "43.83071;10.45407",
                    "43.83052;10.45553",
                    "43.83039;10.45637",
                    "43.83044;10.45678",
                    "43.83116;10.45732",
                    "43.8314;10.45782",
                    "43.83108;10.4582",
                    "43.8309;10.45913",
                    "43.83026;10.46004",
                    "43.82981;10.46095",
                    "43.82951;10.46199",
                    "43.82948;10.46338",
                    "43.82901;10.46396",
                    "43.82829;10.46506",
                    "43.82838;10.46612",
                    "43.82815;10.46716",
                    "43.82632;10.46655",
                    "43.82596;10.46723",
                    "43.82568;10.4676",
                    "43.82583;10.46854",
                    "43.82578;10.46907",
                    "43.82534;10.47025",
                    "43.8254;10.47089",
                    "43.82547;10.47187",
                    "43.82528;10.47309",
                    "43.82427;10.4744",
                    "43.82384;10.47594",
                    "43.82355;10.47636",
                    "43.82331;10.47707",
                    "43.82271;10.47722",
                    "43.82268;10.47807",
                    "43.82262;10.47955",
                    "43.82239;10.48026",
                    "43.82228;10.48126",
                    "43.82209;10.48347",
                    "43.82201;10.48407",
                    "43.82163;10.48541",
                    "43.82103;10.48715",
                    "43.82081;10.48878",
                    "43.82061;10.48934",
                    "43.82058;10.49036",
                    "43.82092;10.49139",
                    "43.82104;10.49223",
                    "43.82113;10.49278",
                    "43.82138;10.49296",
                    "43.82196;10.49326",
                    "43.82244;10.49349",
                    "43.82335;10.49401",
                    "43.82431;10.49454",
                    "43.82584;10.49527",
                    "43.82675;10.49568",
                    "43.82811;10.49623",
                    "43.82982;10.49706",
                    "43.83108;10.49772",
                    "43.83116;10.49799",
                    "43.83129;10.49817",
                    "43.83144;10.498",
                    "43.83221;10.49825",
                    "43.83402;10.4991",
                    "43.83635;10.50016",
                    "43.83732;10.50061",
                    "43.83774;10.50096",
                    "43.83803;10.5009",
                    "43.83819;10.50037",
                    "43.83906;10.49737",
                    "43.83974;10.49562",
                    "43.8415;10.4948",
                    "43.84196;10.49525",
                    "43.84224;10.49557",
                    "43.84238;10.49575",
                    "43.84259;10.49615",
                    "43.84295;10.49638",
                    "43.84322;10.49662",
                    "43.84319;10.49562",
                    "43.84204;10.49607",
                    "43.84041;10.49716",
                    "43.83891;10.50121",
                    "43.8388;10.50169",
                    "43.83895;10.5028",
                    "43.83961;10.50626",
                    "43.84071;10.51046",
                    "43.84273;10.51392",
                    "43.84382;10.5143",
                    "43.84511;10.5145",
                    "43.84635;10.51384",
                    "43.84754;10.51363",
                    "43.8483;10.51267",
                    "43.8482;10.51205",
                    "43.84852;10.50971",
                    "43.84841;10.50919",
                    "43.84814;10.50831",
                    "43.84774;10.50754",
                    "43.84767;10.50738",
                    "43.84798;10.50723",
                    "43.84821;10.50712",
                    "43.84852;10.5073",
                    "43.8488;10.50735",
                    "43.84898;10.50715",
                    "43.84905;10.50707",
                    "43.84919;10.50697",
                    "43.84905;10.50676",
                    "43.84901;10.50634",
                    "43.84882;10.50607",
                    "43.84886;10.50586",
                    "43.8493;10.50494",
                    "43.84954;10.50426",
                    "43.84992;10.50338",
                    "43.85039;10.5025",
                    "43.8517;10.5031",
                    "43.85237;10.50339",
                    "43.85242;10.5031",
                    "43.8525;10.50288",
                    "43.85254;10.50238",
                    "43.85277;10.50274",
                    "43.85288;10.50282",
                    "43.85266;10.50232",
                    "43.85242;10.50151",
                    "43.85252;10.5018",
                    "43.85281;10.50236",
                    "43.85308;10.5026",
                    "43.85358;10.50254",
                    "43.85363;10.50086",
                    "43.85235;10.49512",
                    "43.8522;10.49299",
                    "43.85228;10.49007",
                    "43.85243;10.48717",
                    "43.85256;10.48577",
                    "43.85246;10.48571",
                    "43.8523;10.48578",
                    "43.85246;10.48562",
                    "43.8543;10.48606",
                    "43.85476;10.48618",
                    "43.85459;10.48632",
                    "43.85424;10.4862",
                    "43.8545;10.48068",
                    "43.85519;10.47609",
                    "43.8572;10.47087",
                    "43.85837;10.46726",
                    "43.85874;10.46352",
                    "43.85804;10.45738",
                    "43.85789;10.45669",
                    "43.8574;10.45529",
                    "43.85453;10.45001",
                    "43.8541;10.44919",
                    "43.85422;10.4491",
                    "43.85447;10.44924",
                    "43.85446;10.4488",
                    "43.8561;10.44724",
                    "43.85591;10.447",
                    "43.85602;10.44657",
                    "43.85631;10.44591",
                    "43.85634;10.44457",
                    "43.85585;10.44536",
                    "43.85326;10.44663",
                    "43.85273;10.44803",
                    "43.85217;10.44749",
                    "43.85115;10.4468",
                    "43.84973;10.44579",
                    "43.84994;10.4452",
                    "43.85025;10.44319",
                    "43.85031;10.44148",
                    "43.85037;10.43882",
                    "43.85019;10.43766",
                    "43.84987;10.43712",
                    "43.84928;10.4355",
                    "43.84883;10.43318",
                    "43.84929;10.4313",
                    "43.84957;10.42987",
                    "43.84964;10.42858",
                    "43.84838;10.42742",
                    "43.84769;10.42615",
                    "43.84675;10.42477",
                    "43.84564;10.42443",
                    "43.8436;10.42512",
                    "43.84278;10.4242",
                    "43.84246;10.42324",
                    "43.84256;10.42108",
                    "43.84294;10.41958",
                    "43.84359;10.41918",
                    "43.84389;10.4174",
                    "43.84258;10.41647",
                    "43.84146;10.41629",
                    "43.84073;10.4148",
                    "43.84027;10.41481",
                    "43.83937;10.41489",
                    "43.83775;10.41433",
                    "43.83628;10.4139",
                    "43.83581;10.41404",
                    "43.83566;10.41434",
                    "43.83565;10.41496",
                    "43.83543;10.41577",
                    "43.83496;10.41613",
                    "43.83434;10.41681",
                    "43.83356;10.41701",
                    "43.83325;10.41645",
                    "43.83285;10.41596",
                    "43.83125;10.41577",
                    "43.83072;10.41575",
                    "43.82991;10.41565",
                    "43.82961;10.41504",
                    "43.82874;10.41246",
                    "43.82784;10.41096",
                    "43.82755;10.41049",
                    "43.82703;10.40985",
                    "43.82614;10.41017",
                    "43.82545;10.41085",
                    "43.82476;10.41105",
                    "43.82393;10.41047",
                    "43.82339;10.41007",
                    "43.82227;10.41055",
                    "43.82069;10.41015",
                    "43.81998;10.40972",
                    "43.8185;10.40982",
                    "43.81774;10.40988",
                    "43.81738;10.40964",
                    "43.81692;10.40866",
                    "43.81623;10.408",
                    "43.81551;10.40758",
                    "43.81454;10.40753",
                    "43.81379;10.40695",
                    "43.81062;10.40199",
                    "43.80997;10.4012",
                    "43.8094;10.40105",
                    "43.80794;10.39938",
                    "43.80705;10.39756",
                    "43.80529;10.39757",
                    "43.80433;10.39728",
                    "43.80361;10.39683",
                    "43.80276;10.39685",
                    "43.80169;10.39786",
                    "43.80053;10.39952",
                    "43.79875;10.40201",
                    "43.79741;10.40339",
                    "43.79645;10.40374",
                    "43.79582;10.40401",
                    "43.795;10.40416",
                    "43.79244;10.4038",
                    "43.79138;10.40381",
                    "43.78858;10.40402",
                    "43.78745;10.4038",
                    "43.78681;10.40378",
                    "43.78579;10.4039",
                    "43.78545;10.40384",
                    "43.78472;10.40347",
                    "43.78368;10.40232",
                    "43.78198;10.39958",
                    "43.78182;10.39857",
                    "43.78167;10.39783",
                    "43.7817;10.39765",
                    "43.78158;10.39754",
                    "43.7815;10.39765",
                    "43.78139;10.39783",
                    "43.78094;10.39842",
                    "43.78045;10.39905",
                    "43.78018;10.39938",
                    "43.77925;10.39985",
                    "43.77893;10.40026",
                    "43.77853;10.40137",
                    "43.77808;10.4021",
                    "43.7777;10.40345",
                    "43.77733;10.40425",
                    "43.77577;10.40807",
                    "43.77561;10.40848",
                    "43.77492;10.41008",
                    "43.7745;10.41055",
                    "43.77295;10.41063",
                    "43.77101;10.41089",
                    "43.77022;10.4114",
                    "43.7674;10.41231",
                    "43.76707;10.41231",
                    "43.76644;10.41213",
                    "43.76193;10.41079",
                    "43.7581;10.40965",
                    "43.75582;10.40762",
                    "43.75391;10.40632",
                    "43.75275;10.4056",
                    "43.75166;10.40519",
                    "43.7508;10.40497",
                    "43.74639;10.40348",
                    "43.74303;10.40235",
                    "43.74105;10.40174",
                    "43.73947;10.40127",
                    "43.73887;10.40115",
                    "43.7382;10.40107",
                    "43.73707;10.40095",
                    "43.73669;10.4009",
                    "43.73664;10.40073",
                    "43.7366;10.40083",
                    "43.73424;10.40057",
                    "43.73286;10.3993",
                    "43.73177;10.39804",
                    "43.73146;10.39763",
                    "43.72923;10.39496",
                    "43.72768;10.39324",
                    "43.72754;10.39306",
                    "43.72743;10.39277",
                    "43.72582;10.39078",
                    "43.72566;10.39066",
                    "43.725;10.39115",
                    "43.72496;10.39116",
                    "43.72491;10.39116",
                    "43.72487;10.3912",
                    "43.72486;10.39127",
                    "43.72464;10.39141",
                    "43.72423;10.39162",
                    "43.72375;10.39187",
                    "43.72306;10.39219",
                    "43.72277;10.39222",
                    "43.72263;10.3922",
                    "43.72207;10.39202",
                    "43.72089;10.39132",
                    "43.71895;10.39004",
                    "43.71775;10.38924",
                    "43.71619;10.38819",
                    "43.71591;10.38796",
                    "43.71555;10.38786",
                    "43.71369;10.38874",
                    "43.71368;10.38906",
                    "43.71363;10.3892",
                    "43.71364;10.38943",
                    "43.71385;10.38989",
                    "43.71389;10.39003",
                    "43.71386;10.39005",
                    "43.71384;10.38996",
                    "43.71382;10.38991",
                    "43.71377;10.38989",
                    "43.71373;10.3899",
                    "43.71369;10.38994",
                    "43.71365;10.39005",
                    "43.71357;10.39017",
                    "43.7125;10.39105",
                    "43.71239;10.39118",
                    "43.7127;10.39177",
                    "43.71252;10.39163",
                    "43.7124;10.39127",
                    "43.71233;10.39125",
                    "43.71177;10.39146",
                    "43.71178;10.39189",
                    "43.71162;10.3918",
                    "43.71127;10.39167",
                    "43.71114;10.39214",
                    "43.71098;10.39487",
                    "43.71091;10.39618",
                    "43.71097;10.39725",
                    "43.7109;10.39765",
                    "43.71084;10.39765",
                    "43.71078;10.39767",
                    "43.71055;10.39763",
                    "43.71028;10.39765",
                    "43.71017;10.39763",
                    "43.71007;10.39772",
                    "43.71005;10.39791",
                    "43.70997;10.39873",
                    "43.70989;10.3988",
                    "43.70984;10.3989",
                    "43.70913;10.39873",
                    "43.70893;10.39913"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b2130283-33ee-41e9-b32e-eb77bec5269f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/9bacf377-9458-4866-bb43-209502c52b79.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d7ad5021-bb81-4c65-a1f8-5125def34c00.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c456778b-dd21-4dfe-9263-a2a7d29e5d98.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/bd30db55-de16-40d8-8658-431f73c3e2c8.jpg"
                ],
                "instructions": [],
                "pois": [],
                "infos": {
                    "distance": 65140
                }
            }
        ],
        "catalogue": [
            {
                "id": 54,
                "name": "E-bike",
                "description": "Lombardo E-MTB front con freni a disco",
                "price": 55.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/6923496a-333b-48b1-958a-ed1a84b26eb3.png"
            },
            {
                "id": 55,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1597,
        "customer": {
            "id": 383,
            "title": "Siena Velo",
            "description": "Siena V\u00e9lo nasce dal desiderio di offrire un servizio completo e professionale rivolto a chi sceglie la bicicletta per esplorare le zone intorno a Siena, sia su strada asfaltata che sulle strade bianche. Abbiamo deciso di intraprendere questa avventura perch\u00e9 siamo convinti che la nostra passione faccia la differenza.\r\n\r\nLa scelta delle biciclette \u00e8 orientata alla massima qualit\u00e0 possibile. In particolare, le nostre Scott Addict sono quanto di pi\u00f9 versatile si possa desiderare. Veloci e leggere su asfalto, comode e facili in gravel.\r\n\r\nInoltre, Francesco \u00e8 un biomeccanico, quindi non potrete che pedalare nel massimo comfort.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Siena_Velo.png",
            "text_logo": null,
            "contacts": {
                "address": "Siena Velo - Noleggio bici a Siena, Via Girolamo Gigli, 54, 53100 Siena SI, Italia",
                "email": "info@sienavelo.it",
                "phone": "+39 349185064"
            },
            "coordinate": {
                "latitude": 43.31289,
                "longitude": 11.34129
            },
            "tours": 2,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/bcc32ab6-482e-4c63-a7dd-3d90b78871e7.jpeg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/f1b96520-418e-465c-969a-54fdb02887ec.jpeg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/1cfb5172-2d5d-4b2e-ba60-7710a4a8de8e.jpeg"
            ]
        },
        "title": "Siena Countryside eBike tour",
        "description": "Tour e-bike ad anello nei dintorni di Siena, tra strade secondarie, strade bianche e piste ciclabili. Un percorso abbastanza facile e sempre piacevole, ideale per scoprire la campagna senese pedalando con tranquillit\u00e0. Lungo il giro si incontrano Montaperti e piccoli borghi come Pianella e Pievasciata, tra vigneti, colline, poderi e scorci tipici del Chianti senese.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1597.png",
        "price": 20.0,
        "location": "Siena",
        "location_id": 4,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1630,
                "title": "Siena Countryside eBike tour",
                "description": "Questo tour e-bike ad anello parte nei pressi di Siena e si sviluppa su un percorso abbastanza facile, ideale per chi desidera pedalare in modo rilassato tra paesaggi tipicamente toscani, storia e piccoli borghi. L\u2019itinerario si snoda prevalentemente su strade secondarie a basso traffico, strade bianche e tratti di piste ciclabili, offrendo un\u2019esperienza scorrevole e adatta anche a chi non cerca un percorso tecnico.\n\nFin dai primi chilometri si entra nella campagna senese, tra colline morbide, vigneti, campi coltivati, poderi e tratti alberati che rendono il giro molto vario e panoramico. Uno dei luoghi pi\u00f9 interessanti toccati dal percorso \u00e8 Montaperti, localit\u00e0 famosa per la storica battaglia del 1260 tra Siena e Firenze, oggi immersa in un contesto rurale di grande fascino.\n\nLungo il tragitto si incontrano anche piccoli centri e localit\u00e0 caratteristiche come Pianella, Pievasciata e la zona di Pieve a Bozzone, che arricchiscono il tour con scorci autentici, strade tranquille e un\u2019atmosfera tipicamente toscana. Pievasciata \u00e8 inoltre conosciuta per il suo legame con l\u2019arte contemporanea e con il Parco Sculture del Chianti.\n\n\u00c8 un itinerario perfetto per vivere una giornata in e-bike tra natura, cultura e paesaggi, con un fondo generalmente scorrevole e un andamento piacevole dall\u2019inizio alla fine.",
                "notes": null,
                "start_address": "Via Girolamo Gigli, 54, 53100 Siena SI, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1597.png",
                "track": [
                    43.31276,
                    11.34136
                ],
                "preview_track": [
                    "43.31276;11.34136",
                    "43.3126;11.34129",
                    "43.31255;11.34129",
                    "43.31218;11.34247",
                    "43.31203;11.34272",
                    "43.31142;11.34335",
                    "43.31088;11.34416",
                    "43.31068;11.34486",
                    "43.31064;11.34512",
                    "43.31065;11.34566",
                    "43.31069;11.34609",
                    "43.31092;11.34662",
                    "43.31113;11.34689",
                    "43.31131;11.34707",
                    "43.31146;11.34718",
                    "43.31167;11.34731",
                    "43.31188;11.34752",
                    "43.31214;11.34772",
                    "43.31226;11.34791",
                    "43.31227;11.34798",
                    "43.3121;11.34839",
                    "43.31197;11.34891",
                    "43.31182;11.34937",
                    "43.3117;11.34958",
                    "43.31151;11.34976",
                    "43.31099;11.34997",
                    "43.31054;11.35017",
                    "43.31033;11.35035",
                    "43.31007;11.35068",
                    "43.30978;11.35115",
                    "43.30963;11.35158",
                    "43.30927;11.35351",
                    "43.30923;11.35442",
                    "43.30924;11.35486",
                    "43.30947;11.35601",
                    "43.30953;11.35638",
                    "43.30947;11.35684",
                    "43.30936;11.35719",
                    "43.30912;11.3575",
                    "43.30807;11.35844",
                    "43.30691;11.35981",
                    "43.30623;11.3608",
                    "43.30608;11.36116",
                    "43.30591;11.36147",
                    "43.30566;11.36166",
                    "43.30494;11.36182",
                    "43.30433;11.36193",
                    "43.30366;11.36247",
                    "43.30349;11.36271",
                    "43.30341;11.36306",
                    "43.30332;11.36363",
                    "43.30326;11.36379",
                    "43.30313;11.36393",
                    "43.30273;11.36397",
                    "43.30245;11.36405",
                    "43.3021;11.36427",
                    "43.30189;11.36453",
                    "43.30186;11.36462",
                    "43.30171;11.36507",
                    "43.30158;11.36525",
                    "43.30084;11.36572",
                    "43.30017;11.36577",
                    "43.29979;11.36608",
                    "43.29911;11.367",
                    "43.29877;11.36784",
                    "43.29861;11.36819",
                    "43.29827;11.36847",
                    "43.29786;11.36852",
                    "43.29662;11.36804",
                    "43.29625;11.36807",
                    "43.29583;11.36826",
                    "43.29531;11.36838",
                    "43.295;11.36862",
                    "43.29487;11.36887",
                    "43.29475;11.36909",
                    "43.29413;11.36953",
                    "43.29336;11.36996",
                    "43.29291;11.37007",
                    "43.29191;11.37008",
                    "43.29165;11.37017",
                    "43.2914;11.3703",
                    "43.291;11.37058",
                    "43.29071;11.37069",
                    "43.29054;11.37084",
                    "43.29043;11.37102",
                    "43.29026;11.37136",
                    "43.28993;11.37164",
                    "43.28991;11.37193",
                    "43.28988;11.37204",
                    "43.28984;11.37211",
                    "43.28925;11.37245",
                    "43.28914;11.37258",
                    "43.2891;11.37288",
                    "43.28909;11.37345",
                    "43.28912;11.37497",
                    "43.2892;11.37681",
                    "43.28925;11.37759",
                    "43.28871;11.37813",
                    "43.28824;11.37852",
                    "43.28803;11.37883",
                    "43.288;11.37904",
                    "43.28818;11.37947",
                    "43.28846;11.37938",
                    "43.28864;11.37935",
                    "43.28932;11.37928",
                    "43.28976;11.3793",
                    "43.29006;11.37936",
                    "43.29024;11.3795",
                    "43.29028;11.37975",
                    "43.29045;11.38001",
                    "43.2907;11.37996",
                    "43.2908;11.37961",
                    "43.29077;11.37944",
                    "43.29079;11.3791",
                    "43.2908;11.37882",
                    "43.29073;11.37819",
                    "43.29053;11.37682",
                    "43.29051;11.37638",
                    "43.29064;11.37587",
                    "43.29093;11.37542",
                    "43.29176;11.37469",
                    "43.29224;11.3744",
                    "43.29253;11.37432",
                    "43.29331;11.37428",
                    "43.29387;11.37426",
                    "43.29488;11.37388",
                    "43.29518;11.37379",
                    "43.29553;11.37374",
                    "43.29584;11.37375",
                    "43.29614;11.3738",
                    "43.29672;11.37401",
                    "43.29835;11.37471",
                    "43.29864;11.37477",
                    "43.29894;11.37474",
                    "43.29929;11.37459",
                    "43.2995;11.37442",
                    "43.2997;11.37419",
                    "43.29987;11.37385",
                    "43.3004;11.37249",
                    "43.30056;11.3721",
                    "43.30089;11.37158",
                    "43.3011;11.37137",
                    "43.30131;11.3713",
                    "43.30144;11.37134",
                    "43.30156;11.37142",
                    "43.30168;11.37141",
                    "43.3018;11.37124",
                    "43.30187;11.37094",
                    "43.30185;11.37076",
                    "43.3019;11.37046",
                    "43.30223;11.3697",
                    "43.30256;11.36915",
                    "43.30379;11.36744",
                    "43.30403;11.36716",
                    "43.30434;11.36678",
                    "43.30445;11.36667",
                    "43.30455;11.36673",
                    "43.30458;11.36687",
                    "43.30448;11.36711",
                    "43.30427;11.36765",
                    "43.30391;11.36852",
                    "43.30357;11.36925",
                    "43.30317;11.37006",
                    "43.30304;11.37041",
                    "43.3023;11.3723",
                    "43.30218;11.37267",
                    "43.30211;11.37305",
                    "43.30221;11.37402",
                    "43.30231;11.37477",
                    "43.30245;11.37517",
                    "43.30283;11.37632",
                    "43.30278;11.37722",
                    "43.3027;11.37772",
                    "43.30251;11.3784",
                    "43.30203;11.37986",
                    "43.30179;11.38044",
                    "43.30174;11.38067",
                    "43.30178;11.38151",
                    "43.30179;11.38195",
                    "43.30174;11.38254",
                    "43.30161;11.38316",
                    "43.3015;11.38346",
                    "43.30134;11.38364",
                    "43.30103;11.38376",
                    "43.30062;11.38382",
                    "43.30049;11.38388",
                    "43.30034;11.384",
                    "43.29922;11.38567",
                    "43.29856;11.38665",
                    "43.29842;11.38677",
                    "43.29789;11.38716",
                    "43.29773;11.38736",
                    "43.29762;11.3877",
                    "43.29758;11.38808",
                    "43.29754;11.38849",
                    "43.29745;11.38873",
                    "43.29708;11.38922",
                    "43.29654;11.38979",
                    "43.29628;11.39007",
                    "43.29594;11.3905",
                    "43.29578;11.39074",
                    "43.29545;11.39151",
                    "43.29469;11.39333",
                    "43.2945;11.39379",
                    "43.29438;11.39407",
                    "43.29432;11.39419",
                    "43.29418;11.39439",
                    "43.29427;11.39464",
                    "43.29433;11.39483",
                    "43.29451;11.39586",
                    "43.29462;11.39663",
                    "43.29461;11.39679",
                    "43.29407;11.39698",
                    "43.29386;11.39718",
                    "43.29372;11.39753",
                    "43.29372;11.39788",
                    "43.29379;11.39889",
                    "43.29381;11.39899",
                    "43.29382;11.39932",
                    "43.29386;11.39965",
                    "43.29391;11.39975",
                    "43.29464;11.40078",
                    "43.29517;11.40149",
                    "43.29548;11.40183",
                    "43.2956;11.40208",
                    "43.29557;11.40226",
                    "43.29551;11.40238",
                    "43.29505;11.40293",
                    "43.29492;11.40313",
                    "43.29486;11.40332",
                    "43.29486;11.40354",
                    "43.29496;11.40382",
                    "43.29564;11.40534",
                    "43.29577;11.40572",
                    "43.29583;11.4061",
                    "43.29587;11.40651",
                    "43.29582;11.40676",
                    "43.29545;11.40764",
                    "43.29517;11.40827",
                    "43.29524;11.40844",
                    "43.29594;11.40969",
                    "43.29754;11.41253",
                    "43.29772;11.41291",
                    "43.29822;11.41485",
                    "43.29884;11.41736",
                    "43.29888;11.41782",
                    "43.29877;11.41942",
                    "43.29876;11.41996",
                    "43.29881;11.42041",
                    "43.2989;11.42072",
                    "43.30046;11.42259",
                    "43.30102;11.42335",
                    "43.30137;11.42386",
                    "43.30141;11.42394",
                    "43.30155;11.42435",
                    "43.30168;11.42477",
                    "43.30199;11.42489",
                    "43.30252;11.4247",
                    "43.3027;11.42473",
                    "43.30288;11.42486",
                    "43.30303;11.42509",
                    "43.30329;11.42608",
                    "43.30361;11.42708",
                    "43.30384;11.42783",
                    "43.30399;11.42779",
                    "43.30439;11.42798",
                    "43.30466;11.42807",
                    "43.30473;11.42807",
                    "43.30531;11.42799",
                    "43.30611;11.42777",
                    "43.3063;11.42767",
                    "43.30643;11.42765",
                    "43.3065;11.42742",
                    "43.30652;11.42723",
                    "43.30658;11.42709",
                    "43.30686;11.42674",
                    "43.307;11.42649",
                    "43.30768;11.42513",
                    "43.30973;11.42291",
                    "43.31009;11.42296",
                    "43.31217;11.42521",
                    "43.31512;11.42828",
                    "43.31853;11.42925",
                    "43.32231;11.43056",
                    "43.32282;11.43012",
                    "43.32336;11.42798",
                    "43.32342;11.42757",
                    "43.32315;11.42636",
                    "43.32362;11.42608",
                    "43.32446;11.42608",
                    "43.32595;11.42509",
                    "43.3262;11.42429",
                    "43.32602;11.42332",
                    "43.32593;11.42221",
                    "43.32567;11.42076",
                    "43.32549;11.41927",
                    "43.32581;11.41847",
                    "43.32592;11.4181",
                    "43.32578;11.41747",
                    "43.32574;11.41672",
                    "43.32554;11.41522",
                    "43.32536;11.41332",
                    "43.32582;11.41075",
                    "43.32584;11.41068",
                    "43.32597;11.41044",
                    "43.32606;11.41035",
                    "43.32674;11.40961",
                    "43.32846;11.40744",
                    "43.32934;11.40639",
                    "43.33065;11.40551",
                    "43.33186;11.40518",
                    "43.33284;11.40465",
                    "43.33415;11.40402",
                    "43.3342;11.40418",
                    "43.33407;11.40602",
                    "43.33435;11.40749",
                    "43.33499;11.40744",
                    "43.33529;11.40739",
                    "43.33585;11.40692",
                    "43.33622;11.40667",
                    "43.33723;11.40706",
                    "43.33808;11.40785",
                    "43.33879;11.40736",
                    "43.33962;11.40613",
                    "43.34013;11.40575",
                    "43.34097;11.40517",
                    "43.34194;11.40388",
                    "43.34283;11.4033",
                    "43.34307;11.40273",
                    "43.34322;11.40202",
                    "43.34416;11.40137",
                    "43.34521;11.40115",
                    "43.34604;11.40007",
                    "43.34695;11.3988",
                    "43.34811;11.39849",
                    "43.34839;11.39884",
                    "43.34844;11.39896",
                    "43.34996;11.39839",
                    "43.35022;11.39823",
                    "43.35031;11.39802",
                    "43.35033;11.39783",
                    "43.35045;11.39592",
                    "43.35047;11.39508",
                    "43.35027;11.39373",
                    "43.34972;11.39238",
                    "43.3487;11.39113",
                    "43.34867;11.39037",
                    "43.34935;11.38847",
                    "43.34999;11.38769",
                    "43.35045;11.38701",
                    "43.35088;11.3869",
                    "43.35096;11.38662",
                    "43.35023;11.38619",
                    "43.34882;11.38528",
                    "43.34805;11.3841",
                    "43.34751;11.38174",
                    "43.34799;11.38092",
                    "43.34836;11.38091",
                    "43.34915;11.38183",
                    "43.34941;11.38167",
                    "43.34942;11.38126",
                    "43.34789;11.37767",
                    "43.34759;11.37637",
                    "43.34761;11.37512",
                    "43.34772;11.37463",
                    "43.34792;11.37386",
                    "43.34801;11.37331",
                    "43.34841;11.37047",
                    "43.3484;11.37011",
                    "43.34798;11.36834",
                    "43.34783;11.36748",
                    "43.3477;11.3673",
                    "43.34747;11.36713",
                    "43.34731;11.36692",
                    "43.34711;11.36646",
                    "43.34709;11.3662",
                    "43.34714;11.36472",
                    "43.34723;11.36442",
                    "43.34782;11.3636",
                    "43.34803;11.36333",
                    "43.34812;11.36321",
                    "43.34818;11.36304",
                    "43.34818;11.36206",
                    "43.34819;11.36171",
                    "43.34825;11.36126",
                    "43.34825;11.36104",
                    "43.34818;11.3608",
                    "43.34806;11.36062",
                    "43.34788;11.36051",
                    "43.34772;11.36048",
                    "43.34661;11.36091",
                    "43.34643;11.36093",
                    "43.34631;11.36087",
                    "43.34623;11.36072",
                    "43.3462;11.36051",
                    "43.34616;11.36031",
                    "43.34606;11.36018",
                    "43.34539;11.35983",
                    "43.34523;11.35977",
                    "43.34507;11.3598",
                    "43.34477;11.35989",
                    "43.34464;11.35989",
                    "43.3445;11.35981",
                    "43.34439;11.35968",
                    "43.344;11.35895",
                    "43.34384;11.35878",
                    "43.34103;11.3577",
                    "43.34051;11.35749",
                    "43.34024;11.35736",
                    "43.34013;11.35729",
                    "43.33999;11.35718",
                    "43.33992;11.35711",
                    "43.3398;11.35706",
                    "43.33967;11.35705",
                    "43.33955;11.35711",
                    "43.33946;11.35725",
                    "43.33932;11.35748",
                    "43.33919;11.35763",
                    "43.33887;11.35789",
                    "43.33805;11.35857",
                    "43.33795;11.3586",
                    "43.33784;11.35854",
                    "43.33779;11.35843",
                    "43.33778;11.35819",
                    "43.33781;11.3574",
                    "43.33778;11.35698",
                    "43.3377;11.35654",
                    "43.33759;11.35604",
                    "43.33752;11.35587",
                    "43.33743;11.35569",
                    "43.33711;11.35526",
                    "43.33704;11.35509",
                    "43.33701;11.35494",
                    "43.33699;11.35456",
                    "43.33692;11.35432",
                    "43.33689;11.35439",
                    "43.33638;11.35637",
                    "43.33613;11.35759",
                    "43.33558;11.3583",
                    "43.33446;11.35917",
                    "43.33375;11.35958",
                    "43.33248;11.35941",
                    "43.3318;11.35888",
                    "43.33075;11.35912",
                    "43.3304;11.36055",
                    "43.33023;11.36094",
                    "43.32989;11.36173",
                    "43.32963;11.36254",
                    "43.32824;11.36352",
                    "43.32771;11.36362",
                    "43.32724;11.36437",
                    "43.32678;11.36501",
                    "43.32643;11.36552",
                    "43.32496;11.36617",
                    "43.32395;11.36665",
                    "43.32374;11.36669",
                    "43.32361;11.36667",
                    "43.32302;11.36635",
                    "43.3222;11.36597",
                    "43.32132;11.36591",
                    "43.32098;11.36589",
                    "43.32091;11.36563",
                    "43.32044;11.36452",
                    "43.32012;11.364",
                    "43.31965;11.36332",
                    "43.31946;11.36299",
                    "43.31937;11.36264",
                    "43.31912;11.36222",
                    "43.31864;11.36138",
                    "43.31851;11.36096",
                    "43.3183;11.3605",
                    "43.31811;11.3601",
                    "43.3179;11.35975",
                    "43.3178;11.35945",
                    "43.31766;11.3588",
                    "43.3176;11.35866",
                    "43.31736;11.35839",
                    "43.31696;11.35832",
                    "43.31676;11.35827",
                    "43.31665;11.35817",
                    "43.31632;11.35765",
                    "43.31616;11.35738",
                    "43.31608;11.35715",
                    "43.31604;11.35688",
                    "43.31603;11.35654",
                    "43.31601;11.35633",
                    "43.31595;11.35616",
                    "43.3163;11.35565",
                    "43.31638;11.35555",
                    "43.31638;11.35531",
                    "43.31623;11.3552",
                    "43.3161;11.35531",
                    "43.31608;11.35552",
                    "43.31605;11.35574",
                    "43.3159;11.35599",
                    "43.31584;11.35599",
                    "43.31572;11.35593",
                    "43.3154;11.35582",
                    "43.31523;11.35581",
                    "43.3151;11.35588",
                    "43.31446;11.35639",
                    "43.31443;11.35626",
                    "43.31464;11.35537",
                    "43.31458;11.35446",
                    "43.31426;11.35394",
                    "43.31346;11.35281",
                    "43.31287;11.35152",
                    "43.31278;11.35109",
                    "43.31247;11.34994",
                    "43.31263;11.34948",
                    "43.31274;11.34902",
                    "43.31265;11.3486",
                    "43.31229;11.34797",
                    "43.31225;11.34789",
                    "43.31212;11.34769",
                    "43.31185;11.3475",
                    "43.31165;11.34729",
                    "43.31143;11.34716",
                    "43.31128;11.34704",
                    "43.31101;11.34676",
                    "43.31089;11.34656",
                    "43.31068;11.34605",
                    "43.31064;11.34541",
                    "43.31064;11.34508",
                    "43.31079;11.34445",
                    "43.31089;11.34413",
                    "43.31163;11.34311",
                    "43.31209;11.34264",
                    "43.31221;11.34239",
                    "43.31257;11.34125",
                    "43.31261;11.34129",
                    "43.31276;11.34136"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/36694e4c-efd9-4f60-b49d-1e88c6a17d45.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/4276c0d3-43bb-4d21-88eb-a315e984a18e.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/8910c2ef-521c-4ebd-9d57-56d3e1e3f2a7.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/3e5931ea-5766-4c60-a9ed-2978ddcbaed0.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/11827697-2eea-4812-8aa7-2452730a718d.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/da695758-1f32-4b01-9e22-c15b69c45cca.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Montaperti, dove la storia prende vita",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/060dc7cd-3f22-467f-9bb4-79cb92770e0b.Monta__43_323417998460926_11_427733273960154",
                        "latitude": 43.323417998460926,
                        "longitude": 11.427733273960154,
                        "description": "Qui ci troviamo a Montaperti, uno dei luoghi pi\u00f9 celebri della storia senese.\nIl 4 settembre 1260, in questa zona tra l\u2019Arbia e il torrente Malena, l\u2019esercito di Siena sconfisse quello di Firenze in una battaglia rimasta leggendaria.\nL\u2019episodio fu cos\u00ec famoso da entrare anche nella Divina Commedia, quando Dante ricorda l\u2019Arbia \u201ccolorata in rosso\u201d per il sangue versato.\nOggi il paesaggio \u00e8 silenzioso e rurale, ma conserva una memoria fortissima, ricordata anche dal cippo commemorativo che si trova poco distante.\nPedalare qui significa attraversare un luogo dove la campagna toscana incontra in modo sorprendente la grande storia medievale."
                    },
                    {
                        "name": "Pieve a Bozzone, sulle tracce del tempo",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/87e9f334-b653-41ed-9b9d-71c9119a09b8.Pieve__43_3213160352985_11_36594755827556",
                        "latitude": 43.3213160352985,
                        "longitude": 11.36594755827556,
                        "description": "Pieve a Bozzone \u00e8 una delle porte di rientro verso Siena, ma merita attenzione perch\u00e9 racchiude testimonianze di epoche molto diverse.\nIl nome del luogo \u00e8 legato alla Pieve di San Giovanni Battista al Bozzone, una chiesa medievale che ancora oggi racconta la lunga continuit\u00e0 di vita e di passaggio in questa parte di campagna senese.\nProprio qui vicino, l\u2019Universit\u00e0 di Siena sta studiando anche una villa romana dell\u2019agro di Saena Iulia, situata a pochi chilometri dalla citt\u00e0 e gi\u00e0 parzialmente scavata alla fine dell\u2019Ottocento.\nQuesto ci fa capire quanto fosse importante il territorio attorno a Siena gi\u00e0 in et\u00e0 romana, ben prima dello sviluppo medievale che oggi associamo alla citt\u00e0.\nMentre si pedala in questa zona, si ha davvero la sensazione di attraversare un paesaggio costruito nel tempo, dove ogni collina conserva tracce di storia antica e medievale."
                    }
                ],
                "infos": {
                    "distance": 32533
                }
            }
        ],
        "catalogue": [
            {
                "id": 62,
                "name": "E-bike front",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/186ce4f1-74d9-4391-98ee-d6f09174729c.jpg"
            },
            {
                "id": 63,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1596,
        "customer": {
            "id": 434,
            "title": "Universo Bikers",
            "description": "Vi aspettiamo al nostro negozio a San Vincenzo, Via Giacomo Matteotti 99/103 dal luned\u00ec al sabato.\r\nMattina: 9.00/12.30 Pomeriggio: 15.30/19.00",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Universo_Bikers.png",
            "text_logo": null,
            "contacts": {
                "address": "Universo Bikers, Via G. Matteotti, 99/103, 57027 San Vincenzo LI, Italia",
                "email": "negozio@universobikers.com",
                "phone": "0565 477543"
            },
            "coordinate": {
                "latitude": 43.09397,
                "longitude": 10.54256
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/ebba33b0-95b1-438a-ad22-56001f9f1498.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/e4ff2777-57e3-43d6-ac06-135e31e98692.webp"
            ]
        },
        "title": "Golfo di Baratti Ebike tour",
        "description": "Un tour molto scenografico tra il Golfo di Baratti e Populonia, dove il mare resta spesso protagonista e il percorso alterna pineta, costa e passaggi nel borgo storico. La traccia aggiunge anche un tocco pi\u00f9 \u201cexperience\u201d, con un single trail nella pineta vicino alla spiaggia e la salita verso Populonia, tra fortezza e punti panoramici sul golfo",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1596.jpg",
        "price": 25.0,
        "location": "Maremma",
        "location_id": 6,
        "tags": [
            "Natura",
            "Mare",
            "Storia"
        ],
        "routes": [
            {
                "id": 1629,
                "title": "Golfo di Baratti Ebike tour",
                "description": "Partenza / arrivo: zona San Vincenzo, percorso ad anello con rientro nello stesso punto.\n\nDati principali: sviluppo totale di circa 31 km, dislivello positivo intorno ai 240 m e tempo registrato di circa 2h. Giro di difficolt\u00e0 contenuta, ma con ritmo variabile per la presenza di tratti pi\u00f9 scorrevoli e alcuni saliscendi nella parte di Populonia.\n\nTracciato e paesaggio: la prima parte \u00e8 molto fluida e vicina al mare, con un passaggio interessante su single trail tra pineta e sabbia; la sezione centrale sale verso Populonia, toccando il borgo storico, la fortezza e la Cappella di San Sebastiano, poi rientra su tratti pi\u00f9 semplici e panoramici. Il percorso \u00e8 molto vario, con alternanza continua tra costa, vegetazione mediterranea e scorci sul golfo.\n\nNote utili: tour ideale da vivere con calma, prevedendo qualche sosta nei punti panoramici e nel borgo. Nei tratti pi\u00f9 tranquilli immersi nella natura conviene partire con acqua, uno snack e telefono carico/GPS attivo per godersi il giro in totale serenit\u00e0.",
                "notes": null,
                "start_address": "Via G. Matteotti, 99/103, 57027 San Vincenzo LI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1596.jpg",
                "track": [
                    43.09384,
                    10.54258
                ],
                "preview_track": [
                    "43.09384;10.54258",
                    "43.09375;10.54238",
                    "43.09373;10.54228",
                    "43.09366;10.54211",
                    "43.0936;10.54029",
                    "43.09367;10.53967",
                    "43.09369;10.53954",
                    "43.09355;10.53942",
                    "43.09317;10.53947",
                    "43.09057;10.53977",
                    "43.08862;10.53996",
                    "43.08783;10.53992",
                    "43.0865;10.53975",
                    "43.08487;10.53953",
                    "43.08312;10.53929",
                    "43.08219;10.53916",
                    "43.08123;10.53903",
                    "43.07918;10.53875",
                    "43.07682;10.53842",
                    "43.07382;10.53801",
                    "43.07231;10.5378",
                    "43.07054;10.53754",
                    "43.06871;10.53729",
                    "43.06553;10.53685",
                    "43.0639;10.53664",
                    "43.0634;10.53657",
                    "43.05995;10.53606",
                    "43.05336;10.53511",
                    "43.05088;10.53471",
                    "43.04987;10.53443",
                    "43.04619;10.53328",
                    "43.04125;10.53174",
                    "43.03877;10.53097",
                    "43.03485;10.52974",
                    "43.0329;10.52913",
                    "43.02943;10.52804",
                    "43.02875;10.52782",
                    "43.02869;10.52769",
                    "43.0286;10.52777",
                    "43.02604;10.5264",
                    "43.02333;10.52491",
                    "43.02008;10.52309",
                    "43.01897;10.52281",
                    "43.01723;10.52258",
                    "43.01571;10.52245",
                    "43.01377;10.52254",
                    "43.01347;10.52147",
                    "43.01274;10.5188",
                    "43.01204;10.5163",
                    "43.01114;10.51323",
                    "43.01091;10.51283",
                    "43.01068;10.51283",
                    "43.01023;10.51261",
                    "43.0098;10.51253",
                    "43.00931;10.51242",
                    "43.00889;10.5121",
                    "43.00867;10.51204",
                    "43.00828;10.51186",
                    "43.00758;10.51189",
                    "43.00678;10.51244",
                    "43.00581;10.51307",
                    "43.00549;10.51316",
                    "43.0053;10.51289",
                    "43.00502;10.51265",
                    "43.00469;10.51235",
                    "43.0043;10.51254",
                    "43.00378;10.51303",
                    "43.00315;10.51427",
                    "43.0029;10.51492",
                    "43.00265;10.51605",
                    "43.00203;10.51656",
                    "43.00172;10.51696",
                    "43.00162;10.51728",
                    "43.0019;10.51757",
                    "43.00179;10.51773",
                    "43.00139;10.51754",
                    "43.00116;10.51716",
                    "42.99981;10.51706",
                    "42.99895;10.51681",
                    "42.99879;10.51661",
                    "42.99874;10.51652",
                    "42.99844;10.51638",
                    "42.99838;10.51642",
                    "42.99831;10.51682",
                    "42.99654;10.51883",
                    "42.9965;10.51875",
                    "42.99529;10.51672",
                    "42.99328;10.51336",
                    "42.99183;10.5123",
                    "42.99152;10.51198",
                    "42.9912;10.51077",
                    "42.99049;10.50755",
                    "42.99013;10.50604",
                    "42.98989;10.50473",
                    "42.9899;10.50461",
                    "42.99;10.50406",
                    "42.99027;10.50288",
                    "42.99039;10.5023",
                    "42.99044;10.50188",
                    "42.99044;10.50151",
                    "42.9903;10.50097",
                    "42.99006;10.50001",
                    "42.98975;10.49922",
                    "42.98938;10.49786",
                    "42.98896;10.49721",
                    "42.98851;10.49677",
                    "42.98793;10.49574",
                    "42.98737;10.49524",
                    "42.98685;10.49465",
                    "42.98649;10.49438",
                    "42.98593;10.49399",
                    "42.98592;10.49419",
                    "42.98641;10.49559",
                    "42.98657;10.49626",
                    "42.98659;10.49663",
                    "42.98628;10.4963",
                    "42.98598;10.49561",
                    "42.9856;10.49516",
                    "42.98484;10.49412",
                    "42.98429;10.49373",
                    "42.98397;10.49366",
                    "42.98389;10.4934",
                    "42.98399;10.49275",
                    "42.98415;10.49247",
                    "42.98455;10.49191",
                    "42.98475;10.4918",
                    "42.98522;10.49195",
                    "42.98579;10.49185",
                    "42.9862;10.49187",
                    "42.9862;10.49187",
                    "42.98579;10.49185",
                    "42.98522;10.49195",
                    "42.98475;10.4918",
                    "42.98455;10.49191",
                    "42.98415;10.49247",
                    "42.98399;10.49275",
                    "42.98425;10.49277",
                    "42.98463;10.49262",
                    "42.98472;10.49299",
                    "42.98593;10.49399",
                    "42.9864;10.49431",
                    "42.98678;10.49458",
                    "42.98728;10.49514",
                    "42.98784;10.49563",
                    "42.98838;10.49654",
                    "42.9888;10.49706",
                    "42.98931;10.49773",
                    "42.98971;10.49912",
                    "42.99004;10.49989",
                    "42.99021;10.50068",
                    "42.99043;10.50144",
                    "42.99044;10.50184",
                    "42.99042;10.50212",
                    "42.99028;10.50279",
                    "42.99007;10.50374",
                    "42.98991;10.50456",
                    "42.98989;10.50471",
                    "42.99002;10.50556",
                    "42.99041;10.50725",
                    "42.99115;10.51054",
                    "42.99148;10.5119",
                    "42.99173;10.51224",
                    "42.99322;10.51329",
                    "42.99414;10.51481",
                    "42.99644;10.51865",
                    "42.99744;10.52034",
                    "42.99804;10.52238",
                    "42.9994;10.52614",
                    "42.99965;10.52867",
                    "42.99969;10.52919",
                    "42.99966;10.52942",
                    "42.99978;10.52963",
                    "42.99997;10.52956",
                    "43.00003;10.52928",
                    "43.00011;10.52905",
                    "43.00087;10.52817",
                    "43.00191;10.52695",
                    "43.00465;10.52378",
                    "43.00584;10.52297",
                    "43.01059;10.52268",
                    "43.01441;10.52251",
                    "43.01623;10.52245",
                    "43.01778;10.52265",
                    "43.01937;10.52286",
                    "43.02055;10.52335",
                    "43.02458;10.52561",
                    "43.02778;10.52733",
                    "43.0286;10.5278",
                    "43.0287;10.52789",
                    "43.0289;10.52788",
                    "43.0305;10.52838",
                    "43.03367;10.52937",
                    "43.0356;10.52998",
                    "43.03566;10.52984",
                    "43.03658;10.52924",
                    "43.03707;10.52909",
                    "43.03928;10.52995",
                    "43.04066;10.53012",
                    "43.04187;10.53054",
                    "43.04308;10.53106",
                    "43.04429;10.531",
                    "43.04509;10.53097",
                    "43.04684;10.5311",
                    "43.04817;10.53136",
                    "43.04942;10.53193",
                    "43.04983;10.53242",
                    "43.0514;10.53245",
                    "43.05265;10.53291",
                    "43.05375;10.53366",
                    "43.0561;10.534",
                    "43.05733;10.53417",
                    "43.06;10.53486",
                    "43.06003;10.53505",
                    "43.05995;10.53606",
                    "43.06332;10.53656",
                    "43.06374;10.53662",
                    "43.06497;10.53678",
                    "43.06789;10.53718",
                    "43.07036;10.53752",
                    "43.07222;10.53779",
                    "43.07354;10.53797",
                    "43.07676;10.53841",
                    "43.07877;10.53869",
                    "43.08116;10.53902",
                    "43.08208;10.53914",
                    "43.08291;10.53926",
                    "43.08436;10.53946",
                    "43.08612;10.5397",
                    "43.08758;10.53991",
                    "43.08832;10.53996",
                    "43.0904;10.53979",
                    "43.09305;10.53951",
                    "43.09346;10.53958",
                    "43.09352;10.53971",
                    "43.09359;10.54001",
                    "43.09359;10.54078",
                    "43.09361;10.54229",
                    "43.09359;10.54236",
                    "43.09368;10.54247",
                    "43.09378;10.54247"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/62061225-ccc0-4d46-8bef-836802fae7b0.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/a3e89426-14fc-46d6-846c-5b21176b8430.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f9337825-e19c-4397-bb46-72f08f91d39c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ec050af3-b74c-4448-81d3-978da441e7c3.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c25415da-94b9-437c-a79f-62ff2fef1d3a.webp"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Citt\u00e0 di Populonia",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/85221def-53f4-4891-8271-a226a1bdc04f.Popul__42_986225422200576_10_491800749180388",
                        "latitude": 42.986225422200576,
                        "longitude": 10.491800749180388,
                        "description": "Populonia \u00e8 un affascinante borgo della Costa degli Etruschi, affacciato sul Golfo di Baratti, dove mare, natura e storia si incontrano in un contesto unico. Antica citt\u00e0 etrusca, fu uno dei pi\u00f9 importanti centri della zona ed \u00e8 ricordata come l\u2019unica grande citt\u00e0 etrusca costruita sul mare. Ancora oggi conserva resti archeologici e testimonianze del suo passato, offrendo un\u2019esperienza che unisce panorami suggestivi e cultura."
                    },
                    {
                        "name": "Golfo di Baratti",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/7f1e3ac6-8713-40da-b39d-56dceba10713.Golfo__42_99859103071848_10_51662853330739",
                        "latitude": 42.99859103071848,
                        "longitude": 10.51662853330739,
                        "description": "Il Golfo di Baratti \u00e8 uno degli angoli pi\u00f9 suggestivi della Costa degli Etruschi, con una baia tranquilla, acque limpide e una natura mediterranea che arriva fino al mare. Oltre alla sua bellezza paesaggistica, il golfo ha anche un grande valore storico: proprio qui si sviluppava l\u2019area legata all\u2019antica Populonia, importante citt\u00e0 etrusca e romana nota per la lavorazione del ferro. Ancora oggi Baratti conserva un legame forte con questo passato, tra spiaggia, pineta e testimonianze archeologiche che rendono il luogo unico"
                    }
                ],
                "infos": {
                    "distance": 31189
                }
            }
        ],
        "catalogue": [
            {
                "id": 108,
                "name": "E-bike e Casco",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1520,
        "customer": {
            "id": 204,
            "title": "Leonardo da Vinci Bike Tour",
            "description": "Vinci Bike Tour (Leonardo da Vinci Bike Tour) \u00e8 un punto rental dedicato a chi vuole scoprire Vinci e le colline toscane in sella: propone noleggio di e-bike e MTB, anche con servizio di consegna/ritiro direttamente presso la tua struttura, oltre a tour guidati personalizzabili con guide esperte tra natura, borghi e luoghi legati a Leonardo. In negozio trovi e-bike pronte per partire e una selezione di accessori utili per pedalare in sicurezza e comfort.",
            "color": "#1a1a19",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Leonardo_da_Vinci_Bike_Tour.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/leo.png"
            ],
            "contacts": {
                "address": "Piazza Giacomo Matteotti, 6, Piazza Giacomo Matteotti, 6, 50053 Empoli FI, Italia",
                "email": "info@leonardodavincibiketour.com",
                "phone": "377 450 2034"
            },
            "coordinate": {
                "latitude": 43.7211,
                "longitude": 10.94499
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/474d2ff5-6810-40c5-9aa5-3df968b2bcfc.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/e7687e4e-4a34-4409-9f5e-301a73c849ee.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/55d23f3f-6dc9-4fd6-b0be-6f7ca08ab652.jpg"
            ]
        },
        "title": "Vinci Countryside E-Bike Tour",
        "description": "Anello cicloturistico da Empoli tutto su strade secondarie asfaltate e tranquille, quindi adatto a tutti. Si pedala tra vigne, oliveti e poderi, con salite dolci e panorami continui ai piedi del Montalbano, entrando nelle campagne di Vinci. Sono previste soste nel verde e, per chi lo desidera, degustazioni in azienda e un light lunch immersi tra filari e ulivi. \r\n\r\nVinci, borgo di origine medievale nell\u2019orbita del contado fiorentino, \u00e8 soprattutto la terra di Leonardo: nacque nel 1452 ad Anchiano e qui, osservando colline, acque e vita rurale, matur\u00f2 quella curiosit\u00e0 che ritroviamo nei suoi studi e disegni. Dopo una pausa panoramica nei dintorni del paese, il percorso rientra verso Empoli con tratti scorrevoli e piacevoli, chiudendo un giro breve ma ricco di natura, cultura e sapori toscani.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1520.jpg",
        "price": 25.0,
        "location": "Vinci",
        "location_id": 34,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1553,
                "title": "Vinci Countryside E-Bike tour",
                "description": "Anello cicloturistico da Empoli di circa 30 km (18,6 mi) e 600 m D+ (1.969 ft), tutto su strade secondarie asfaltate e tranquille, quindi adatto a tutti. Si pedala tra vigne, oliveti e poderi, con salite dolci e panorami continui ai piedi del Montalbano, entrando nelle campagne di Vinci. Sono previste soste nel verde e, per chi lo desidera, degustazioni in azienda e un light lunch immersi tra filari e ulivi. Vinci, borgo di origine medievale nell\u2019orbita del contado fiorentino, \u00e8 soprattutto la terra di Leonardo: nacque nel 1452 ad Anchiano e qui, osservando colline, acque e vita rurale, matur\u00f2 quella curiosit\u00e0 che ritroviamo nei suoi studi e disegni. Dopo una pausa panoramica nei dintorni del paese, il percorso rientra verso Empoli con tratti scorrevoli su strade secondarie.",
                "notes": "",
                "start_address": "Piazza Giacomo Matteotti, 9, 50053 Empoli FI",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    43.72118,
                    10.94509
                ],
                "preview_track": [
                    "43.72118;10.94509",
                    "43.72134;10.94578",
                    "43.72186;10.94666",
                    "43.72209;10.94708",
                    "43.72227;10.94739",
                    "43.72273;10.94712",
                    "43.72344;10.94643",
                    "43.72362;10.94629",
                    "43.72375;10.94638",
                    "43.72466;10.94553",
                    "43.7246;10.94532",
                    "43.7247;10.94555",
                    "43.72475;10.94566",
                    "43.72491;10.94589",
                    "43.72621;10.94821",
                    "43.72731;10.94972",
                    "43.72755;10.95002",
                    "43.72895;10.95085",
                    "43.72934;10.94923",
                    "43.72961;10.94841",
                    "43.73001;10.9478",
                    "43.73011;10.94771",
                    "43.73141;10.94682",
                    "43.73183;10.9467",
                    "43.73402;10.94648",
                    "43.73475;10.94658",
                    "43.73583;10.94777",
                    "43.73684;10.94747",
                    "43.73736;10.94755",
                    "43.73793;10.94859",
                    "43.73908;10.94873",
                    "43.74125;10.94816",
                    "43.74262;10.94729",
                    "43.74413;10.94589",
                    "43.745;10.9463",
                    "43.74594;10.94585",
                    "43.74714;10.94666",
                    "43.749;10.94932",
                    "43.7506;10.95118",
                    "43.75129;10.95181",
                    "43.75167;10.95295",
                    "43.7532;10.95468",
                    "43.75484;10.95639",
                    "43.75591;10.95697",
                    "43.75791;10.95719",
                    "43.75961;10.95622",
                    "43.76124;10.95606",
                    "43.76236;10.95616",
                    "43.76366;10.95642",
                    "43.76459;10.95628",
                    "43.76558;10.95639",
                    "43.76621;10.95684",
                    "43.76831;10.95722",
                    "43.76914;10.95703",
                    "43.77008;10.95736",
                    "43.7706;10.95741",
                    "43.7713;10.95795",
                    "43.7722;10.95948",
                    "43.77519;10.96071",
                    "43.77662;10.9604",
                    "43.77689;10.9599",
                    "43.77689;10.95908",
                    "43.77715;10.9585",
                    "43.7775;10.9578",
                    "43.77779;10.95755",
                    "43.77952;10.95721",
                    "43.78014;10.95752",
                    "43.78023;10.95701",
                    "43.78052;10.95686",
                    "43.78122;10.95737",
                    "43.78157;10.9573",
                    "43.78166;10.95708",
                    "43.78103;10.95626",
                    "43.78064;10.95552",
                    "43.78119;10.95596",
                    "43.78215;10.95667",
                    "43.78426;10.95901",
                    "43.78566;10.95915",
                    "43.78645;10.95971",
                    "43.78638;10.95908",
                    "43.78578;10.95765",
                    "43.78614;10.9572",
                    "43.78689;10.95791",
                    "43.78729;10.95727",
                    "43.78795;10.95706",
                    "43.78886;10.9572",
                    "43.7898;10.95735",
                    "43.79051;10.95726",
                    "43.79137;10.95776",
                    "43.79144;10.95757",
                    "43.79129;10.95726",
                    "43.79062;10.95632",
                    "43.79123;10.95619",
                    "43.79105;10.95573",
                    "43.7911;10.95467",
                    "43.7919;10.95373",
                    "43.7925;10.95348",
                    "43.79339;10.95328",
                    "43.79382;10.95294",
                    "43.79345;10.95236",
                    "43.79376;10.95181",
                    "43.79479;10.95178",
                    "43.79482;10.95068",
                    "43.79525;10.95022",
                    "43.79616;10.95047",
                    "43.79646;10.95069",
                    "43.79676;10.95018",
                    "43.79606;10.94823",
                    "43.79649;10.94721",
                    "43.79614;10.94566",
                    "43.7962;10.94403",
                    "43.79661;10.94293",
                    "43.79759;10.94206",
                    "43.79799;10.94171",
                    "43.79835;10.94255",
                    "43.79858;10.94301",
                    "43.79896;10.9431",
                    "43.79939;10.94375",
                    "43.7996;10.9454",
                    "43.79983;10.94543",
                    "43.79976;10.94407",
                    "43.79988;10.94322",
                    "43.79968;10.94265",
                    "43.79975;10.94172",
                    "43.79948;10.94027",
                    "43.79999;10.93935",
                    "43.80004;10.93939",
                    "43.79957;10.93875",
                    "43.79931;10.93761",
                    "43.79892;10.93654",
                    "43.79867;10.93563",
                    "43.79865;10.93479",
                    "43.79886;10.93439",
                    "43.79823;10.93419",
                    "43.79798;10.93467",
                    "43.79779;10.93456",
                    "43.79797;10.93352",
                    "43.79787;10.93267",
                    "43.7974;10.93114",
                    "43.7975;10.93025",
                    "43.79731;10.92976",
                    "43.79676;10.92955",
                    "43.79659;10.93025",
                    "43.79621;10.93014",
                    "43.79514;10.92898",
                    "43.79418;10.92838",
                    "43.79284;10.92847",
                    "43.79214;10.92892",
                    "43.7907;10.9292",
                    "43.78986;10.92898",
                    "43.78926;10.9288",
                    "43.78874;10.92805",
                    "43.78801;10.92719",
                    "43.78779;10.92719",
                    "43.78761;10.92751",
                    "43.78756;10.92751",
                    "43.7875;10.92689",
                    "43.78728;10.92659",
                    "43.78698;10.92647",
                    "43.78654;10.9267",
                    "43.78587;10.92646",
                    "43.78531;10.92538",
                    "43.78492;10.92502",
                    "43.7843;10.92451",
                    "43.78411;10.92517",
                    "43.78388;10.9258",
                    "43.78318;10.92651",
                    "43.7829;10.92713",
                    "43.78234;10.92801",
                    "43.78108;10.92847",
                    "43.78074;10.92881",
                    "43.78017;10.92844",
                    "43.77891;10.92751",
                    "43.7764;10.92677",
                    "43.77548;10.92697",
                    "43.7737;10.9274",
                    "43.77273;10.92833",
                    "43.7718;10.92943",
                    "43.77064;10.931",
                    "43.76992;10.93329",
                    "43.76976;10.93309",
                    "43.76787;10.92966",
                    "43.76337;10.92734",
                    "43.76097;10.92641",
                    "43.75969;10.92765",
                    "43.75705;10.92889",
                    "43.7547;10.92794",
                    "43.7544;10.92808",
                    "43.75355;10.92864",
                    "43.75187;10.92982",
                    "43.74893;10.93209",
                    "43.74738;10.9316",
                    "43.74543;10.93213",
                    "43.74417;10.93409",
                    "43.74287;10.93511",
                    "43.74145;10.93423",
                    "43.74119;10.93422",
                    "43.73921;10.93246",
                    "43.73827;10.93229",
                    "43.73725;10.9332",
                    "43.73496;10.93249",
                    "43.73329;10.93159",
                    "43.73169;10.93162",
                    "43.72951;10.93172",
                    "43.72937;10.9316",
                    "43.72925;10.9317",
                    "43.72927;10.93188",
                    "43.72942;10.93191",
                    "43.72952;10.93186",
                    "43.72951;10.93172",
                    "43.72937;10.9316",
                    "43.72925;10.9317",
                    "43.72927;10.93188",
                    "43.72909;10.93252",
                    "43.72898;10.93265",
                    "43.72859;10.93427",
                    "43.7282;10.93544",
                    "43.7276;10.93725",
                    "43.72733;10.93793",
                    "43.72722;10.93852",
                    "43.72658;10.94066",
                    "43.72594;10.94277",
                    "43.72565;10.9438",
                    "43.72561;10.94395",
                    "43.72536;10.94476",
                    "43.72475;10.94535",
                    "43.72457;10.94535",
                    "43.72463;10.94559",
                    "43.72371;10.94628",
                    "43.72266;10.94438",
                    "43.72226;10.94334",
                    "43.72161;10.94353",
                    "43.72118;10.94509"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/74d396e7-c3d5-46e1-9af0-bb7b4b3c1be7.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/cb2519e4-638e-44db-8e00-a535005f94cb.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/89b04464-cb2f-488f-9d0a-4a25525ff2c4.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b8b338a3-c4a9-4401-a16d-5c9f1ccb4688.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/6c3c212d-2ec0-421e-b531-1c970d15c2b4.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Wine tasting & Light Lunch Fattoria Dianella",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/44a871c6-0b8b-40e1-a2ae-5cac5065a0c6.downl__43_741362420892465_10_934448838233948",
                        "latitude": 43.741362420892465,
                        "longitude": 10.934448838233948,
                        "description": "Durante il tour nelle campagne di Vinci puoi aggiungere una sosta speciale alla Fattoria Dianella 1: un\u2019esperienza tra filari e colline con vista spettacolare, a pochi minuti da Empoli. La wine experience prevede una passeggiata in vigna e la visita della cantina storica, per scoprire da vicino come nascono i vini del territorio. Si chiude con una degustazione guidata: formula classica con 3 vini e bruschette con olio EVO dell\u2019azienda, oppure versione premium con 4 vini selezionati (durata circa 2 ore). Per chi desidera completare la pausa in chiave gourmet, \u00e8 possibile abbinare anche un momento \u201clight lunch\u201d/food pairing con prodotti locali, da organizzare in base a disponibilit\u00e0 e formula scelta. "
                    },
                    {
                        "name": "Borgo di Vinci e Museo di Leonardi Da Vinci",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/040620b5-b47b-4001-955e-8dfa59f062df.downl__43_787570081205345_10_92750969633926",
                        "latitude": 43.787570081205345,
                        "longitude": 10.92750969633926,
                        "description": "Nel cuore di Vinci, una delle soste pi\u00f9 affascinanti del tour \u00e8 il Museo Leonardiano, ospitato tra la Palazzina Uzielli e il Castello dei Conti Guidi. Qui si entra nel mondo di Leonardo attraverso modelli e ricostruzioni delle sue macchine, approfondimenti sui suoi studi di ingegneria e osservazioni sul paesaggio che lo ha formato. Dopo la visita, vale la pena prendersi tempo per vivere il borgo: vicoli in pietra, scorci medievali e un\u2019atmosfera raccolta che racconta l\u2019identit\u00e0 di questo angolo di Toscana. Il punto panoramico pi\u00f9 iconico \u00e8 la terrazza di Vinci, con la statua dell\u2019Uomo Vitruviano: un luogo perfetto per una pausa, una foto e per godersi la vista sulle colline del Montalbano, immaginando lo sguardo curioso di Leonardo davanti agli stessi profili."
                    },
                    {
                        "name": "Bar-Alimentari lungo il percorso",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/4a5413e7-8849-4640-b56e-8cdb0d4e605f.downl__43_796187640732775_10_95047506345509",
                        "latitude": 43.796187640732775,
                        "longitude": 10.95047506345509,
                        "description": "In questo bar alimentari potete fermarvi per comprare uno snack e una bottiglia d'Acqua. Davanti al bari si trova una terrazza panoramica che da sulle campagne di Vinci. \nNota importante: Il Bar chiude dalle 13.00 alle 16.30"
                    }
                ],
                "infos": {
                    "distance": 25403
                }
            }
        ],
        "catalogue": [
            {
                "id": 45,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 46,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1537,
        "customer": {
            "id": 381,
            "title": "ONES",
            "description": "Il negozio di bici pi\u00f9 cool. Specializzato in biciclette elettriche per ogni giorno, MTB e tanto altro. Solo nei nostri negozi trovi le bici di design pi\u00f9 ricercate, i monopattini elettrici pi\u00f9 trendy, abbigliamento e accessori organici e sostenibili. Ones non \u00e8 solo un brand di bici, \u00e8 un brand di lifestyle. Siamo specializzati nel noleggio di biciclette, offrendo una vasta gamma di bici per tutti i gusti e le esigenze. Che tu stia cercando una bici da strada, una mountain bike o una e-bike, da noi troverai il mezzo perfetto per esplorare le meraviglie naturali dell\u2019isola.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/ONES.PNG",
            "text_logo": null,
            "contacts": {
                "address": "Ones Isola d\u2019Elba Rent Bike, Via Pietro Gori, 46, 57031 Capoliveri LI, Italia",
                "email": "isoladelba@onesmoving.com",
                "phone": "3490664275"
            },
            "coordinate": {
                "latitude": 42.74415,
                "longitude": 10.37962
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/ccdda424-730c-4e49-ab3c-7af5eb2f1a28.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/b1825cba-f847-4187-bb90-e27bad6648ec.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/bb907aae-8dda-45b0-84bc-f3a19156e576.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/aca4465e-8384-49bf-a659-78d07dbe73fd.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/9721a8da-da6f-4408-a203-74f0f37b7a27.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/d5cc79ac-470d-495f-82c0-34c9da744306.png"
            ]
        },
        "title": "l'anello verde di Capoliveri, Isola D'Elba ",
        "description": "Itinerario ad anello con start/finish in zona Capoliveri (ONES Rent Bike), che collega in sequenza Museo delle Miniere, Miniera del Vallone, Tenuta delle Ripalte e Spiaggia di Istia. Distanza indicativa complessiva circa 25 km, con andamento non lungo ma \u201cmosso\u201d: brevi saliscendi e rampe localmente pi\u00f9 decise tipiche del Monte Calamita. Fondo verosimilmente misto (asfalto + sterrato/strade bianche e tratti pi\u00f9 ruvidi in zona miniere/costa), quindi ideale gravel/MTB o e-MTB",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1537.jpg",
        "price": 25.0,
        "location": "Isola d'Elba",
        "location_id": 7,
        "tags": [
            "Natura",
            "Montagne",
            "Mare",
            "Storia"
        ],
        "routes": [
            {
                "id": 1572,
                "title": "l'anello verde di Capoliveri, Isola D'Elba ",
                "description": "Un giro spettacolare nel selvaggio promontorio di Capoliveri, tra miniere di ferro, vigneti vista mare e calette dall\u2019acqua trasparente. Si parte da Capoliveri e si scende verso l\u2019area delle Miniere di Calamita, poi si pedala tra i paesaggi minerari e i sentieri costieri fino alla Tenuta delle Ripalte e alla Spiaggia di Istia, prima di rientrare. \u00c8 un tour che unisce storia, natura e mare in pochi chilometri ma con tantissima variet\u00e0.",
                "notes": null,
                "start_address": "Via Pietro Gori, 46, 57031 Capoliveri LI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    42.7442,
                    10.37972
                ],
                "preview_track": [
                    "42.7442;10.37972",
                    "42.74487;10.37872",
                    "42.74453;10.37836",
                    "42.74382;10.37833",
                    "42.74407;10.37813",
                    "42.74478;10.37795",
                    "42.74384;10.37799",
                    "42.74288;10.37812",
                    "42.74264;10.37862",
                    "42.74241;10.3793",
                    "42.74163;10.37888",
                    "42.74117;10.3784",
                    "42.74076;10.37785",
                    "42.74027;10.37696",
                    "42.74004;10.37604",
                    "42.73968;10.37581",
                    "42.74006;10.37642",
                    "42.74048;10.37811",
                    "42.741;10.37883",
                    "42.74107;10.37892",
                    "42.74194;10.37986",
                    "42.74254;10.38042",
                    "42.74268;10.38061",
                    "42.74178;10.38027",
                    "42.74021;10.37929",
                    "42.73977;10.37886",
                    "42.73918;10.3794",
                    "42.73866;10.38012",
                    "42.7377;10.38068",
                    "42.73752;10.38085",
                    "42.73711;10.38063",
                    "42.73624;10.38057",
                    "42.7351;10.3802",
                    "42.73435;10.38037",
                    "42.73423;10.38182",
                    "42.73432;10.38253",
                    "42.73418;10.38328",
                    "42.73404;10.38342",
                    "42.73354;10.38295",
                    "42.73274;10.38216",
                    "42.73225;10.38195",
                    "42.73197;10.38205",
                    "42.73139;10.38087",
                    "42.73091;10.38053",
                    "42.73041;10.3808",
                    "42.72957;10.38072",
                    "42.7284;10.38176",
                    "42.72823;10.38199",
                    "42.72818;10.38232",
                    "42.72806;10.38289",
                    "42.728;10.38324",
                    "42.72809;10.38363",
                    "42.72818;10.38409",
                    "42.7281;10.38454",
                    "42.72802;10.38488",
                    "42.728;10.38541",
                    "42.72783;10.38606",
                    "42.72767;10.38649",
                    "42.72748;10.38691",
                    "42.72732;10.3875",
                    "42.72732;10.38768",
                    "42.72741;10.38794",
                    "42.7274;10.38807",
                    "42.72725;10.38814",
                    "42.72701;10.38798",
                    "42.7269;10.38781",
                    "42.72679;10.38744",
                    "42.72659;10.38689",
                    "42.72648;10.38644",
                    "42.72649;10.38585",
                    "42.72638;10.38531",
                    "42.72614;10.38484",
                    "42.72598;10.38432",
                    "42.72582;10.38402",
                    "42.72555;10.3836",
                    "42.72527;10.38292",
                    "42.72515;10.38238",
                    "42.72491;10.38184",
                    "42.72459;10.38227",
                    "42.72407;10.383",
                    "42.72351;10.38357",
                    "42.72302;10.38439",
                    "42.723;10.38572",
                    "42.72299;10.38655",
                    "42.72293;10.38732",
                    "42.72276;10.38743",
                    "42.72237;10.38716",
                    "42.72183;10.38698",
                    "42.72132;10.38687",
                    "42.7209;10.38691",
                    "42.72052;10.3876",
                    "42.72018;10.38753",
                    "42.71999;10.38802",
                    "42.7201;10.38837",
                    "42.72082;10.38955",
                    "42.7213;10.39015",
                    "42.72174;10.39112",
                    "42.72162;10.39201",
                    "42.72219;10.39322",
                    "42.72177;10.39335",
                    "42.72163;10.39444",
                    "42.72192;10.39564",
                    "42.72064;10.3943",
                    "42.71993;10.3929",
                    "42.71906;10.39272",
                    "42.71773;10.39474",
                    "42.71733;10.39529",
                    "42.71763;10.39655",
                    "42.71723;10.39711",
                    "42.71642;10.40039",
                    "42.71635;10.39925",
                    "42.71635;10.39756",
                    "42.71614;10.39749",
                    "42.71572;10.39887",
                    "42.71557;10.39968",
                    "42.71566;10.40136",
                    "42.71551;10.40128",
                    "42.71475;10.39899",
                    "42.71463;10.39888",
                    "42.71464;10.40012",
                    "42.71475;10.40065",
                    "42.71454;10.40051",
                    "42.71368;10.39834",
                    "42.7134;10.39799",
                    "42.71238;10.39739",
                    "42.71177;10.39706",
                    "42.7118;10.39426",
                    "42.71176;10.3969",
                    "42.71219;10.39739",
                    "42.71312;10.39766",
                    "42.71387;10.3988",
                    "42.71469;10.40071",
                    "42.71475;10.40045",
                    "42.71458;10.39902",
                    "42.71471;10.39886",
                    "42.71503;10.40012",
                    "42.71565;10.40141",
                    "42.71555;10.4005",
                    "42.71569;10.39909",
                    "42.71602;10.39779",
                    "42.7163;10.3974",
                    "42.71624;10.39818",
                    "42.71634;10.40035",
                    "42.71679;10.39884",
                    "42.71748;10.39658",
                    "42.71733;10.39764",
                    "42.71708;10.40027",
                    "42.71696;10.40125",
                    "42.71803;10.40385",
                    "42.71804;10.40515",
                    "42.71864;10.40591",
                    "42.71932;10.406",
                    "42.71962;10.40792",
                    "42.71927;10.40876",
                    "42.71935;10.40937",
                    "42.72014;10.40966",
                    "42.72086;10.4101",
                    "42.72145;10.4103",
                    "42.72178;10.41057",
                    "42.72207;10.41214",
                    "42.7225;10.41254",
                    "42.72309;10.41305",
                    "42.72352;10.41309",
                    "42.72337;10.41402",
                    "42.7234;10.41504",
                    "42.72342;10.41632",
                    "42.72324;10.41721",
                    "42.72371;10.41793",
                    "42.72426;10.41856",
                    "42.72474;10.41918",
                    "42.72438;10.41979",
                    "42.7236;10.41973",
                    "42.72251;10.41915",
                    "42.72181;10.41978",
                    "42.72143;10.41984",
                    "42.72093;10.41932",
                    "42.71983;10.41975",
                    "42.71984;10.42036",
                    "42.72077;10.42112",
                    "42.72161;10.42117",
                    "42.72249;10.42088",
                    "42.72377;10.42209",
                    "42.72379;10.42258",
                    "42.72369;10.42258",
                    "42.72312;10.42286",
                    "42.72343;10.42313",
                    "42.72404;10.42411",
                    "42.7244;10.42525",
                    "42.72484;10.42518",
                    "42.72535;10.4253",
                    "42.72582;10.42628",
                    "42.72598;10.42719",
                    "42.72605;10.42861",
                    "42.72649;10.42815",
                    "42.72708;10.42776",
                    "42.72769;10.42805",
                    "42.72834;10.42864",
                    "42.72867;10.42818",
                    "42.72857;10.42718",
                    "42.72875;10.42677",
                    "42.72912;10.42753",
                    "42.72978;10.42869",
                    "42.73041;10.42877",
                    "42.73082;10.42886",
                    "42.73113;10.4289",
                    "42.73157;10.42868",
                    "42.73249;10.42904",
                    "42.73257;10.42907",
                    "42.73284;10.42827",
                    "42.73312;10.42753",
                    "42.73277;10.42714",
                    "42.7334;10.42665",
                    "42.73348;10.42614",
                    "42.73397;10.42638",
                    "42.73507;10.4268",
                    "42.73541;10.42649",
                    "42.73611;10.42503",
                    "42.73721;10.42441",
                    "42.73748;10.42401",
                    "42.73832;10.42432",
                    "42.73875;10.42408",
                    "42.73892;10.4225",
                    "42.73939;10.42242",
                    "42.74;10.42254",
                    "42.74071;10.42255",
                    "42.7417;10.42245",
                    "42.74282;10.42182",
                    "42.74281;10.42148",
                    "42.74217;10.42067",
                    "42.7416;10.41971",
                    "42.74277;10.41957",
                    "42.74327;10.41932",
                    "42.74352;10.41889",
                    "42.74348;10.41788",
                    "42.74278;10.41616",
                    "42.74244;10.41565",
                    "42.74285;10.41516",
                    "42.74276;10.41477",
                    "42.74244;10.41407",
                    "42.74261;10.41368",
                    "42.74293;10.4136",
                    "42.74259;10.41307",
                    "42.74205;10.41257",
                    "42.74201;10.41231",
                    "42.74246;10.41218",
                    "42.74288;10.41202",
                    "42.74298;10.41166",
                    "42.74221;10.40994",
                    "42.74234;10.40973",
                    "42.74306;10.40974",
                    "42.74365;10.40985",
                    "42.74372;10.40967",
                    "42.74297;10.40866",
                    "42.74283;10.40838",
                    "42.74339;10.4084",
                    "42.74407;10.40811",
                    "42.74392;10.40753",
                    "42.74402;10.40712",
                    "42.74397;10.40639",
                    "42.74378;10.40597",
                    "42.74385;10.40551",
                    "42.74389;10.40464",
                    "42.74413;10.40477",
                    "42.7447;10.40559",
                    "42.74558;10.40645",
                    "42.74606;10.40688",
                    "42.74632;10.4069",
                    "42.74651;10.40671",
                    "42.74642;10.4063",
                    "42.74642;10.40597",
                    "42.74713;10.40534",
                    "42.7472;10.40507",
                    "42.74717;10.40388",
                    "42.74654;10.40379",
                    "42.74619;10.40318",
                    "42.74665;10.40259",
                    "42.74614;10.40174",
                    "42.74467;10.39993",
                    "42.74477;10.39935",
                    "42.74596;10.39978",
                    "42.74667;10.39949",
                    "42.74725;10.39972",
                    "42.74714;10.39909",
                    "42.74562;10.39697",
                    "42.7443;10.39391",
                    "42.74348;10.39122",
                    "42.74325;10.39057",
                    "42.7441;10.39094",
                    "42.74486;10.3912",
                    "42.7458;10.39115",
                    "42.746;10.39078",
                    "42.74503;10.38888",
                    "42.7441;10.38752",
                    "42.74337;10.38647",
                    "42.74378;10.38504",
                    "42.74381;10.38468",
                    "42.74345;10.38308",
                    "42.74297;10.38256",
                    "42.74277;10.38219",
                    "42.7428;10.38188",
                    "42.7429;10.38149",
                    "42.74324;10.38102",
                    "42.7433;10.38082",
                    "42.74357;10.38036"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/596ef888-a9c5-4a9a-9729-570175374172.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/4e43180c-0c66-4eed-a65b-34a68352531e.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/a8526c7e-3fd7-40ad-b0b7-3f9536bc6abe.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d01fd2c8-eae7-4855-b9ad-ae091ad12116.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/ac1333dd-2a7f-4213-b429-6473de7939a6.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/8afc92fc-670a-4771-993c-d5401e8480ac.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "La Miniera di Capoliveri",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/db41f205-26c7-4dc9-8047-fd514a2775dc.Elba___42_711838517350095_10_394257234509842",
                        "latitude": 42.711838517350095,
                        "longitude": 10.394257234509842,
                        "description": "La Miniera di Capoliveri, sul Monte Calamita, \u00e8 uno di quei luoghi in cui l\u2019Isola d\u2019Elba mostra il suo volto pi\u00f9 sorprendente: un paesaggio quasi \u201clunare\u201d, scolpito dall\u2019estrazione del ferro, che per\u00f2 si apre all\u2019improvviso su panorami di mare incredibili. Qui la storia non \u00e8 solo nei racconti: \u00e8 scritta nei gradoni di cava, nei vecchi macchinari e nelle tracce del lavoro che ha segnato la comunit\u00e0 locale fino alla chiusura delle miniere elbane nel 1981. Oggi l\u2019area si visita attraverso il Museo della Vecchia Officina e percorsi che fanno entrare letteralmente nel mondo dei minatori, tra archeologia industriale, natura selvaggia e colori di terra e roccia unici nel Mediterraneo."
                    }
                ],
                "infos": {
                    "distance": 25198
                }
            }
        ],
        "catalogue": [
            {
                "id": 58,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 59,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1524,
        "customer": {
            "id": 375,
            "title": "MAREA Bike",
            "description": "Marea Bike \u00e8 un bike rental specializzato in e-bike / e-mtb in Toscana, attivo in Maremma (area Terme di Saturnia). Offre noleggio e-bike, tour guidati (anche in formula wine tour e cicloturismo enogastronomico), escursioni di gruppo e un comodo servizio delivery/consegna presso la struttura.",
            "color": "#000000",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/MAREA_Bike.jpeg",
            "text_logo": [
                null
            ],
            "contacts": {
                "address": "Via Giuseppe Verdi Catabbio, Via Giuseppe Verdi Catabbio, 58055 Catabbio GR, Italia",
                "email": "infomareabike@gmail.com",
                "phone": "338 691 9521"
            },
            "coordinate": {
                "latitude": 42.70157,
                "longitude": 11.56827
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8bbbe2fb-b2d7-4b7d-953b-b21598ca99fe.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/684b65a8-752d-4533-b259-ed546a569a94.jpeg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/3cd072f0-7d73-4d70-9722-02797f33a185.jpeg"
            ]
        },
        "title": "Terme di Saturnia E-Bike Tour",
        "description": "Si parte dal borgo di Semproniano, tra stradine tranquille e primi saliscendi panoramici, entrando subito nella Maremma pi\u00f9 autentica. Dopo pochi chilometri si raggiunge Animanatura Wild Sanctuary, un luogo speciale dove vengono accolti e protetti animali selvatici salvati da circhi o da situazioni di disagio: una sosta diversa dal solito, che d\u00e0 un valore in pi\u00f9 alla pedalata. Ripartendo, si prosegue tra colline, vigneti e macchia mediterranea fino al borgo di Saturnia, perfetto per una pausa e per respirare l\u2019atmosfera del paese. \n\nDa qui si scende alle Cascate del Mulino, le celebri terme libere, dove chi vuole pu\u00f2 concedersi un bagno rigenerante nelle acque calde. L\u2019itinerario riprende poi verso il piccolo borgo di Capanne, con una risalita dolce e costante che regala belle viste aperte sulla campagna. L\u2019ultima parte \u00e8 un rientro piacevole verso Catabbio, fino a MAREA Bike, con la sensazione di aver attraversato in poche ore borghi, natura e terme.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1524.jpg",
        "price": 25.0,
        "location": "Via G. Verdi, 58055 Catabbio GR",
        "location_id": null,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1558,
                "title": "Terme di Saturnia E-Bike Tour",
                "description": "Si parte da Semproniano e, tra strade tranquille e scorci di Maremma, si raggiunge Anima Natura Wild Sanctuary per una sosta speciale a contatto con animali salvati. Si prosegue poi verso il borgo di Saturnia, ideale per una breve pausa, e si scende alle Cascate del Mulino per un momento di relax nelle terme libere. Ripartendo, si risale verso il borgo di Capanne tra colline e campagna aperta, prima di rientrare a Catabbio fino a MAREA Bike, con negli occhi panorami e nell\u2019aria il profumo della Toscana pi\u00f9 autentica.",
                "notes": "",
                "start_address": "Via G. Verdi, 58055 Catabbio GR",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    42.70158,
                    11.56825
                ],
                "preview_track": [
                    "42.70158;11.56825",
                    "42.70109;11.56906",
                    "42.70168;11.56958",
                    "42.70279;11.56603",
                    "42.70365;11.56469",
                    "42.70439;11.56339",
                    "42.70582;11.56106",
                    "42.70685;11.56025",
                    "42.7088;11.56071",
                    "42.70987;11.56055",
                    "42.71091;11.56065",
                    "42.71266;11.5592",
                    "42.71438;11.55772",
                    "42.71493;11.55672",
                    "42.71557;11.55451",
                    "42.71588;11.55319",
                    "42.71471;11.55192",
                    "42.71324;11.5513",
                    "42.7131;11.54878",
                    "42.71218;11.54742",
                    "42.71288;11.54476",
                    "42.71338;11.54343",
                    "42.71372;11.54181",
                    "42.71484;11.54069",
                    "42.71598;11.54032",
                    "42.71766;11.54061",
                    "42.72037;11.5408",
                    "42.72194;11.54005",
                    "42.72252;11.54021",
                    "42.72364;11.5408",
                    "42.72522;11.54194",
                    "42.72596;11.54206",
                    "42.72692;11.54143",
                    "42.72801;11.54184",
                    "42.72819;11.54198",
                    "42.7294;11.54143",
                    "42.72996;11.54046",
                    "42.73;11.54044",
                    "42.72973;11.54106",
                    "42.72837;11.54196",
                    "42.72817;11.54193",
                    "42.72751;11.54142",
                    "42.72629;11.54016",
                    "42.7234;11.5405",
                    "42.72308;11.54033",
                    "42.72302;11.53977",
                    "42.72178;11.53921",
                    "42.7202;11.53885",
                    "42.71889;11.53825",
                    "42.71703;11.53743",
                    "42.71541;11.53626",
                    "42.71506;11.53546",
                    "42.71424;11.53535",
                    "42.71296;11.53428",
                    "42.71149;11.53286",
                    "42.70918;11.53164",
                    "42.7072;11.53139",
                    "42.70621;11.53185",
                    "42.70591;11.53271",
                    "42.70519;11.53351",
                    "42.70455;11.53457",
                    "42.70376;11.53451",
                    "42.70259;11.53366",
                    "42.70146;11.53207",
                    "42.69987;11.53157",
                    "42.69813;11.53201",
                    "42.6964;11.53227",
                    "42.69559;11.53171",
                    "42.6942;11.53072",
                    "42.69339;11.52939",
                    "42.69129;11.5283",
                    "42.69051;11.52738",
                    "42.68953;11.52756",
                    "42.68843;11.52717",
                    "42.68729;11.52697",
                    "42.68634;11.52653",
                    "42.68573;11.52663",
                    "42.68543;11.52556",
                    "42.68463;11.52444",
                    "42.68393;11.52465",
                    "42.68297;11.52368",
                    "42.68094;11.52323",
                    "42.67979;11.52333",
                    "42.67883;11.52319",
                    "42.67826;11.52405",
                    "42.67593;11.5243",
                    "42.67334;11.5245",
                    "42.66989;11.52376",
                    "42.669;11.52384",
                    "42.66897;11.52279",
                    "42.66925;11.51975",
                    "42.66889;11.51499",
                    "42.66879;11.51215",
                    "42.66864;11.51154",
                    "42.66865;11.5114",
                    "42.6682;11.51003",
                    "42.66836;11.50914",
                    "42.66891;11.50734",
                    "42.66936;11.50649",
                    "42.66715;11.5053",
                    "42.66582;11.50484",
                    "42.66506;11.50478",
                    "42.66506;11.50478",
                    "42.66555;11.50451",
                    "42.66573;11.50439",
                    "42.66548;11.50329",
                    "42.6654;11.50248",
                    "42.66518;11.5021",
                    "42.665;11.50128",
                    "42.66509;11.49951",
                    "42.66467;11.4988",
                    "42.66374;11.49842",
                    "42.66259;11.49827",
                    "42.66189;11.49841",
                    "42.66133;11.49785",
                    "42.66115;11.49762",
                    "42.65969;11.4963",
                    "42.6587;11.49569",
                    "42.65699;11.50032",
                    "42.6561;11.5025",
                    "42.65626;11.50432",
                    "42.65493;11.50557",
                    "42.65369;11.5061",
                    "42.65257;11.50641",
                    "42.65189;11.5066",
                    "42.65129;11.50705",
                    "42.65097;11.50743",
                    "42.65025;11.50778",
                    "42.65003;11.50871",
                    "42.65002;11.51029",
                    "42.6497;11.51175",
                    "42.64853;11.51183",
                    "42.6481;11.51213",
                    "42.64816;11.51186",
                    "42.64902;11.51181",
                    "42.65157;11.51163",
                    "42.65498;11.51142",
                    "42.65627;11.5112",
                    "42.65682;11.51124",
                    "42.65723;11.511",
                    "42.65771;11.50997",
                    "42.65802;11.50968",
                    "42.65949;11.51068",
                    "42.66003;11.51091",
                    "42.66199;11.51006",
                    "42.66289;11.5101",
                    "42.66448;11.51144",
                    "42.66511;11.51151",
                    "42.66809;11.51121",
                    "42.6686;11.5115",
                    "42.66879;11.51215",
                    "42.66889;11.51499",
                    "42.66925;11.51975",
                    "42.66897;11.52279",
                    "42.669;11.52384",
                    "42.66989;11.52376",
                    "42.67334;11.5245",
                    "42.67551;11.52563",
                    "42.6764;11.52553",
                    "42.67703;11.52616",
                    "42.67784;11.52614",
                    "42.67837;11.52888",
                    "42.67885;11.52895",
                    "42.67971;11.52866",
                    "42.68094;11.52813",
                    "42.68183;11.52915",
                    "42.68179;11.53033",
                    "42.68213;11.53084",
                    "42.68213;11.53206",
                    "42.68261;11.53264",
                    "42.68274;11.53328",
                    "42.68267;11.53346",
                    "42.68317;11.534",
                    "42.68374;11.53613",
                    "42.68381;11.53735",
                    "42.68469;11.5373",
                    "42.68642;11.53658",
                    "42.68852;11.53766",
                    "42.68806;11.53799",
                    "42.68728;11.53821",
                    "42.68579;11.54068",
                    "42.68506;11.54154",
                    "42.68394;11.54312",
                    "42.68475;11.54421",
                    "42.68506;11.54603",
                    "42.68494;11.54775",
                    "42.68635;11.54722",
                    "42.68809;11.54591",
                    "42.68912;11.54659",
                    "42.68963;11.54763",
                    "42.69053;11.54873",
                    "42.69136;11.55034",
                    "42.6918;11.55187",
                    "42.6914;11.55309",
                    "42.69215;11.55505",
                    "42.69355;11.55706",
                    "42.69494;11.55717",
                    "42.69649;11.55919",
                    "42.69818;11.55999",
                    "42.69852;11.56108",
                    "42.69854;11.56161",
                    "42.69827;11.56247",
                    "42.69878;11.56349",
                    "42.69934;11.56376",
                    "42.70007;11.56477",
                    "42.70032;11.56481",
                    "42.70041;11.56505",
                    "42.70154;11.56621",
                    "42.70144;11.56748",
                    "42.70158;11.56825"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c73448e0-8321-4cab-bf1c-891665fd1081.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/3931e57a-32c7-4e23-b076-8a1681b2c11c.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b2831146-6e88-420e-bfe9-8ec36a5db2ba.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/8791c1d1-ddce-43be-bf94-488a20484f17.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Borgo di Semproniano",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/aa486573-eadf-407d-b3eb-a3ba053cf4cf.downl__42_73002117071166_11_54045104980469",
                        "latitude": 42.73002117071166,
                        "longitude": 11.54045104980469,
                        "description": "Semproniano \u00e8 un piccolo borgo collinare in provincia di Grosseto, tra Monte Amiata e Maremma, con ampi panorami sulle valli dell\u2019Albegna e del Fiora. Il nome \u00e8 tradizionalmente collegato all\u2019et\u00e0 romana e nel territorio sono state trovate anche tracce di epoca etrusca. Le prime notizie certe risalgono al Medioevo, quando l\u2019area rientrava nei domini degli Aldobrandeschi. Nel Trecento pass\u00f2 nell\u2019orbita della Repubblica di Siena e, dopo il Cinquecento, entr\u00f2 nel Granducato di Toscana. Nel borgo si notano ancora elementi dell\u2019impianto difensivo, con resti di mura e della rocca. Oggi conserva un\u2019atmosfera raccolta e autentica, tipica dei paesi dell\u2019entroterra maremmano."
                    },
                    {
                        "name": "Borgo di Saturnia",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d97f3518-b461-48fc-9064-6989d8e83d4c.downl__42_664961941398886_11_504775719804458",
                        "latitude": 42.664961941398886,
                        "longitude": 11.504775719804458,
                        "description": "Saturnia \u00e8 un antico borgo della Maremma (frazione del Comune di Manciano) noto fin dall\u2019antichit\u00e0 per le sue sorgenti termali. Il territorio era frequentato gi\u00e0 in et\u00e0 protostorica e conserva testimonianze etrusche, tra cui necropoli nell\u2019area circostante. In epoca romana divenne un centro importante lungo la Via Clodia e fu elevata a colonia nel 183 a.C., lasciando tracce ancora visibili nel tessuto del paese. Restano infatti tratti delle mura e, soprattutto, la Porta Romana, legata al passaggio dell\u2019antica strada. Nel Medioevo il borgo pass\u00f2 sotto diverse signorie (tra cui gli Aldobrandeschi) e fu conteso fino alla definitiva conquista senese. Oggi Saturnia unisce atmosfera di \u201cpaese di pietra\u201d e cultura termale, con le Cascate del Mulino e le terme che attirano visitatori tutto l\u2019anno."
                    },
                    {
                        "name": "Terme di Saturnia",
                        "type": "funny",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/6ffe4154-3687-4b56-a225-ef81f56fb552.downl__42_64805713396946_11_512122350541178",
                        "latitude": 42.64805713396946,
                        "longitude": 11.512122350541178,
                        "description": "Le Terme di Saturnia sono alimentate da una sorgente naturale di acqua sulfurea che sgorga costantemente a temperatura calda (circa 37 \u00b0C) e, scorrendo, crea vasche e piccoli salti d\u2019acqua tra le rocce calcaree. La tradizione termale qui \u00e8 antichissima: gi\u00e0 gli Etruschi e poi i Romani frequentavano l\u2019area per il benessere legato alle acque. Nel tempo Saturnia \u00e8 diventata uno dei luoghi termali pi\u00f9 noti della Toscana, con un\u2019offerta che affianca strutture termali organizzate e punti accessibili in natura. L\u2019esperienza \u00e8 caratterizzata dall\u2019odore tipico dello zolfo, dall\u2019acqua ricca di minerali e dall\u2019effetto \u201cspa a cielo aperto\u201d nel paesaggio maremmano."
                    },
                    {
                        "name": "Animanatura - Wild Sanctuary",
                        "type": "funny",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/c7fd6162-b86c-48df-87ec-cdf615cc8f4b.downl__42_71510765242678_11_53649947784288",
                        "latitude": 42.71510765242678,
                        "longitude": 11.53649947784288,
                        "description": "Anima Natura Wild Sanctuary \u00e8 un santuario per animali selvatici ed esotici a Semproniano, nel cuore della Maremma, a pochi chilometri dalle Terme di Saturnia. Qui vengono accolti e seguiti animali salvati da circhi, traffici illegali e situazioni di maltrattamento o difficolt\u00e0, con l\u2019obiettivo di garantire loro benessere e un ambiente il pi\u00f9 possibile adatto alla specie. Il centro porta avanti anche attivit\u00e0 di sensibilizzazione e visite/esperienze guidate, pensate per far conoscere da vicino la tutela della fauna e il rapporto uomo-natura.\n"
                    }
                ],
                "infos": {
                    "distance": 29974
                }
            }
        ],
        "catalogue": [
            {
                "id": 25,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 26,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1598,
        "customer": {
            "id": 435,
            "title": "Easybike Maremma",
            "description": "Grazie ai Bicycle Tours organizzati da Easybike Maremma\r\nscoprirete le tradizioni dell\u2019antica terra di Maremma.\r\nUna terra incorniciata da paesaggi mozzafiato,\r\narricchita da sapori caratteristici rinomati in tutto il mondo,\r\nun posto dove cultura, arte, storia, natura e gusto si sposano perfettamente.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Easybike_Maremma.png",
            "text_logo": null,
            "contacts": {
                "address": "Easybike Maremma di Seri Emiliano, Via Cesare Battisti, 2, 58043 Castiglione della Pescaia GR, Italia",
                "email": "info@easybikemaremma.it",
                "phone": "338 371 0101"
            },
            "coordinate": {
                "latitude": 42.7638,
                "longitude": 10.88209
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/c8fc984c-1ee9-4b7c-961d-4e75c48d00bd.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/adbea9b3-fe54-4e2c-9eac-2807d60ef534.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/e9c9edde-4e2b-488b-961b-c41f5a64dc42.webp"
            ]
        },
        "title": "Ebike tour vigneti e degustazione nella Maremma ",
        "description": "Un tour tra vigneti, campagna maremmana e strade bianche, pensato per scoprire il territorio con un ritmo rilassato e panoramico. Il percorso tocca l\u2019area della cantina Le Mortelle e di Cacciagrande, alternando tratti nel verde a sezioni pi\u00f9 aperte tra filari e poderi. \u00c8 un giro molto piacevole, ideale per chi cerca una pedalata scorrevole con una forte identit\u00e0 toscana e la possibilit\u00e0 di abbinarla a una sosta in cantina.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1598.jpg",
        "price": 25.0,
        "location": "Maremma",
        "location_id": 6,
        "tags": [
            "Natura",
            "Mare",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1631,
                "title": "Ebike tour vigneti e degustazione",
                "description": "Partenza / arrivo: percorso ad anello con partenza e rientro nello stesso punto, nell\u2019area rurale tra i vigneti della Maremma.\n\nDati principali: sviluppo totale di circa 26 km e dislivello positivo contenuto, intorno ai 135 m; giro facile-intermedio, con andamento regolare e senza salite lunghe.\n\nTracciato e paesaggio: il percorso alterna strade di campagna, tratti tra vigneti e sezioni pi\u00f9 aperte tipiche della pianura maremmana, con un profilo generalmente scorrevole e qualche lieve ondulazione. Lungo il tracciato sono presenti riferimenti come la cantina Cacciagrande e il Viale dei Cipressi, che aggiungono interesse paesaggistico al giro.\n\nNote utili: tour adatto a essere affrontato con ritmo tranquillo, anche prevedendo una sosta in cantina o qualche pausa panoramica. Nei tratti pi\u00f9 immersi nella campagna \u00e8 una buona idea partire con acqua, uno snack e telefono carico/GPS attivo per godersi il tour in totale serenit\u00e0.",
                "notes": null,
                "start_address": "Via Cesare Battisti, 2, 58043 Castiglione della Pescaia GR, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1598.jpg",
                "track": [
                    42.76379,
                    10.88219
                ],
                "preview_track": [
                    "42.76379;10.88219",
                    "42.76353;10.88221",
                    "42.76333;10.88259",
                    "42.76334;10.88276",
                    "42.76334;10.88326",
                    "42.76364;10.88389",
                    "42.76382;10.88421",
                    "42.76382;10.88431",
                    "42.76391;10.88435",
                    "42.76411;10.88457",
                    "42.76455;10.88485",
                    "42.7652;10.88536",
                    "42.76562;10.88593",
                    "42.76595;10.88644",
                    "42.76606;10.88654",
                    "42.76635;10.88612",
                    "42.76745;10.88429",
                    "42.76792;10.8846",
                    "42.76817;10.88456",
                    "42.76836;10.88477",
                    "42.76864;10.88517",
                    "42.76874;10.88536",
                    "42.76896;10.88527",
                    "42.76915;10.88509",
                    "42.77001;10.8856",
                    "42.77162;10.88649",
                    "42.77193;10.88673",
                    "42.77247;10.88744",
                    "42.77381;10.8885",
                    "42.77647;10.88895",
                    "42.77816;10.88897",
                    "42.77994;10.88973",
                    "42.78236;10.88953",
                    "42.7857;10.8888",
                    "42.78624;10.88887",
                    "42.78727;10.89011",
                    "42.79076;10.89487",
                    "42.7934;10.89877",
                    "42.79362;10.89889",
                    "42.79418;10.89906",
                    "42.79507;10.89948",
                    "42.79603;10.89966",
                    "42.79661;10.90019",
                    "42.79809;10.90221",
                    "42.79855;10.90303",
                    "42.79883;10.90393",
                    "42.79909;10.9051",
                    "42.799;10.90589",
                    "42.79879;10.90681",
                    "42.7983;10.90998",
                    "42.79792;10.91188",
                    "42.79833;10.9129",
                    "42.79831;10.91334",
                    "42.79874;10.91546",
                    "42.79908;10.91632",
                    "42.80075;10.92027",
                    "42.80075;10.92086",
                    "42.80018;10.92258",
                    "42.80132;10.92423",
                    "42.80287;10.92542",
                    "42.80316;10.92578",
                    "42.80789;10.92857",
                    "42.80861;10.9287",
                    "42.80958;10.92971",
                    "42.81051;10.93036",
                    "42.81156;10.93097",
                    "42.81299;10.9316",
                    "42.81321;10.93179",
                    "42.81397;10.93234",
                    "42.81491;10.93356",
                    "42.81641;10.93561",
                    "42.81703;10.93666",
                    "42.8174;10.93762",
                    "42.81765;10.93892",
                    "42.81874;10.941",
                    "42.81982;10.94274",
                    "42.82062;10.94375",
                    "42.8218;10.94507",
                    "42.82202;10.94519",
                    "42.82191;10.94595",
                    "42.82411;10.94686",
                    "42.82479;10.94812",
                    "42.82506;10.9501",
                    "42.82622;10.95174",
                    "42.82506;10.95328",
                    "42.82281;10.95682",
                    "42.8219;10.95902",
                    "42.8203;10.96153",
                    "42.8196;10.96245",
                    "42.81762;10.9649",
                    "42.81072;10.96477",
                    "42.8097;10.96439",
                    "42.80868;10.96449",
                    "42.80794;10.96468",
                    "42.80573;10.964",
                    "42.80352;10.96333",
                    "42.80296;10.96289",
                    "42.80392;10.96317",
                    "42.8053;10.96374",
                    "42.80556;10.96348",
                    "42.80807;10.95707",
                    "42.81124;10.95606",
                    "42.81362;10.95416",
                    "42.81435;10.95349",
                    "42.81441;10.95272",
                    "42.81421;10.9525",
                    "42.81414;10.95155",
                    "42.81403;10.95037",
                    "42.81371;10.94992",
                    "42.81311;10.94966",
                    "42.80873;10.94896",
                    "42.80987;10.94473",
                    "42.80736;10.94397",
                    "42.80638;10.9439",
                    "42.80657;10.9422",
                    "42.80593;10.93974",
                    "42.80531;10.93855",
                    "42.8032;10.93645",
                    "42.80233;10.93463",
                    "42.80143;10.93356",
                    "42.80122;10.93319",
                    "42.80051;10.93265",
                    "42.79938;10.92912",
                    "42.79728;10.92708",
                    "42.79781;10.9266",
                    "42.80081;10.92347",
                    "42.79876;10.92095",
                    "42.79681;10.91975",
                    "42.79345;10.9157",
                    "42.79053;10.9131",
                    "42.78745;10.91203",
                    "42.78488;10.91137",
                    "42.78429;10.91116",
                    "42.78335;10.90971",
                    "42.78244;10.90873",
                    "42.78166;10.90759",
                    "42.78119;10.90618",
                    "42.78046;10.90403",
                    "42.77993;10.90232",
                    "42.77924;10.90094",
                    "42.77896;10.89946",
                    "42.77888;10.89927",
                    "42.77877;10.8982",
                    "42.77816;10.89601",
                    "42.77784;10.89431",
                    "42.77766;10.89367",
                    "42.77755;10.8933",
                    "42.77682;10.89253",
                    "42.77636;10.89223",
                    "42.77617;10.89183",
                    "42.77527;10.8908",
                    "42.77402;10.88937",
                    "42.77328;10.88891",
                    "42.77305;10.88804",
                    "42.7727;10.88764",
                    "42.77201;10.88684",
                    "42.77177;10.8866",
                    "42.77028;10.88576",
                    "42.76926;10.8851",
                    "42.76894;10.88498",
                    "42.76874;10.88493",
                    "42.76859;10.885",
                    "42.76817;10.88456",
                    "42.76611;10.88261",
                    "42.76604;10.88261",
                    "42.76521;10.88327",
                    "42.76435;10.88391",
                    "42.76403;10.88403",
                    "42.76405;10.88292",
                    "42.76405;10.8822"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c6323adc-92e1-4ec1-b716-7b6ff01c221d.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/e2c38d24-7b74-49f8-bf86-c8901ee9dc57.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d1cc9f33-b9b2-4259-9c06-2138ca5fce85.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/92541138-46d0-4547-b712-c2297dadf07c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f9a68361-ceaf-4035-aa6d-6e276d530e2b.webp"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Azienda vitivinicola Cacciagrande",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/8a67a10d-25c5-4baf-9f37-2f4053f45cdc.le_mo__42_82504051380916_10_953249746775114",
                        "latitude": 42.82504051380916,
                        "longitude": 10.953249746775114,
                        "description": "Cacciagrande \u00e8 un\u2019azienda vitivinicola a conduzione familiare situata nel cuore della Maremma toscana, vicino a Castiglione della Pescaia. Fondata nel 1997 da Bruno Tuccio, nasce dal desiderio di valorizzare un territorio di grande fascino, caratterizzato dalla vicinanza del mare, dai venti del maestrale e da suoli ricchi di mineralit\u00e0. Nel tempo, l\u2019azienda ha costruito la propria identit\u00e0 puntando su qualit\u00e0, autenticit\u00e0 e rispetto del territorio, dando vita a vini che esprimono con personalit\u00e0 il carattere genuino della Maremma."
                    }
                ],
                "infos": {
                    "distance": 25657
                }
            }
        ],
        "catalogue": [
            {
                "id": 110,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 111,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1587,
        "customer": {
            "id": 380,
            "title": "Biciclettaio - Gaiole in Chianti",
            "description": "Biciclettaio \u00e8 il bike rent di Gaiole in Chianti gestito da Filippo, punto di riferimento per chi vuole pedalare tra le colline del Chianti Classico. Offre noleggio di e-bike moderne e ben mantenute, ideali per affrontare sterrati e salite in totale relax. Propone tour panoramici in e-bike alla scoperta di borghi, vigneti e strade bianche, con itinerari anche ispirati a L\u2019Eroica. In negozio trovi assistenza competente, consigli sui percorsi e supporto per organizzare la giornata in sella. Disponibili servizi come regolazione bici, caschi e accessori, oltre a indicazioni su tracce e punti di interesse. Un\u2019esperienza completa, pensata per divertirsi e vivere il Chianti al ritmo giusto.",
            "color": "#ffffff",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Biciclettaio_-_Gaiole_in_Chianti.jpg",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/Progetto_senza_titolo.png"
            ],
            "contacts": {
                "address": "Via G. Marconi, 5, Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "email": "rental@bicyclesinchianti.com",
                "phone": "05771390071"
            },
            "coordinate": {
                "latitude": 43.46728,
                "longitude": 11.43466
            },
            "tours": 4,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8290a122-144d-4087-a8fb-9ab3edd8948f.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/7565c2ce-222e-4e8a-bd67-54c2940dc9a2.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/72782e04-007a-451f-9a23-2d3239ae3b48.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/099cdfa4-dcdf-4e40-9342-a33bdf177312.webp"
            ]
        },
        "title": "La lega del Chianti Gaiole Castellina e Radda",
        "description": "Percorso facile e panoramico nel Chianti, consigliato in e-bike per alcuni tratti in salita pi\u00f9 ripidi. Da Gaiole si passa per San Sano e Pieve Asciata, con passaggio vicino ai \u201cPeperoni\u201d di Piero Giadrossi e al Parco Sculture del Chianti. Tra sterrati de L\u2019Eroica e splendide colline si raggiungono Vagliagli, Castellina e Radda in Chianti, ideali per soste tra panorami, borghi e gelato. Prima del rientro a Gaiole, possibile degustazione presso l\u2019Azienda Agricola Le Miccine.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1587.jpg",
        "price": 25.0,
        "location": "Chianti",
        "location_id": 35,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1620,
                "title": "Gaiole-Ovest-Corto",
                "description": "Percorso facile e panoramico nel cuore del Chianti, consigliato in e-bike per alcuni tratti con salita ripida. Da Gaiole si segue la strada principale fino al bivio per Lecchi in Chianti, poi si raggiunge San Sano lungo una bella strada panoramica. Il tour prosegue verso Pieve Asciata con un breve sterrato e una salita pi\u00f9 impegnativa che porta vicino ai celebri \u201cPeperoni\u201d di Piero Giadrossi e al Parco Sculture del Chianti, perfetto per una sosta tra arte e natura. Si continua su un tratto sterrato de L\u2019Eroica verso Vagliagli, con deviazione panoramica al piazzale con obelisco. Da qui, tra strade bianche e colline, si raggiunge Castellina in Chianti, ideale per una sosta in centro o in gelateria, e poi Radda in Chianti, altro borgo imperdibile. Prima del rientro a Gaiole, possibile tappa enogastronomica con degustazione presso Le Miccine. Attenzione: fino a Vagliagli (circa 20 km) non ci sono bar o ristori.\n",
                "notes": null,
                "start_address": "Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1587.jpg",
                "track": [
                    43.46717,
                    11.43449
                ],
                "preview_track": [
                    "43.46717;11.43449",
                    "43.46621;11.43579",
                    "43.46475;11.43546",
                    "43.46445;11.43434",
                    "43.46436;11.43315",
                    "43.46438;11.43292",
                    "43.46424;11.4326",
                    "43.46368;11.43121",
                    "43.46352;11.43086",
                    "43.46328;11.43051",
                    "43.46301;11.43004",
                    "43.46275;11.42963",
                    "43.46166;11.4283",
                    "43.45799;11.426",
                    "43.45661;11.42551",
                    "43.45471;11.42393",
                    "43.45436;11.42356",
                    "43.45296;11.42147",
                    "43.45147;11.41957",
                    "43.4507;11.41906",
                    "43.4495;11.41867",
                    "43.44766;11.41784",
                    "43.44607;11.41748",
                    "43.44566;11.41885",
                    "43.44469;11.42016",
                    "43.44311;11.42156",
                    "43.43977;11.42022",
                    "43.43752;11.41947",
                    "43.43487;11.41937",
                    "43.43347;11.42088",
                    "43.43303;11.42044",
                    "43.43142;11.41771",
                    "43.43101;11.41714",
                    "43.43042;11.41681",
                    "43.42968;11.41655",
                    "43.4295;11.41588",
                    "43.43018;11.41511",
                    "43.43078;11.41433",
                    "43.43171;11.41372",
                    "43.43186;11.41313",
                    "43.43158;11.4126",
                    "43.43097;11.41183",
                    "43.43031;11.41031",
                    "43.42958;11.40986",
                    "43.42873;11.40846",
                    "43.42781;11.4083",
                    "43.42676;11.40729",
                    "43.42673;11.4064",
                    "43.42637;11.40487",
                    "43.42509;11.40412",
                    "43.42389;11.40409",
                    "43.42398;11.40305",
                    "43.42452;11.40291",
                    "43.42486;11.40214",
                    "43.42407;11.40124",
                    "43.42431;11.40037",
                    "43.42563;11.3983",
                    "43.42631;11.39698",
                    "43.42748;11.39535",
                    "43.42834;11.39496",
                    "43.42848;11.39486",
                    "43.42825;11.39441",
                    "43.42696;11.39445",
                    "43.42554;11.39549",
                    "43.42471;11.39592",
                    "43.42308;11.39569",
                    "43.42244;11.39371",
                    "43.42305;11.39226",
                    "43.42331;11.39099",
                    "43.42254;11.38959",
                    "43.42235;11.38917",
                    "43.42269;11.38883",
                    "43.42232;11.3892",
                    "43.42138;11.3891",
                    "43.42024;11.38935",
                    "43.41783;11.38979",
                    "43.41693;11.38904",
                    "43.41567;11.3892",
                    "43.41538;11.38968",
                    "43.41381;11.3905",
                    "43.41146;11.39255",
                    "43.41035;11.39521",
                    "43.41072;11.39644",
                    "43.41138;11.39745",
                    "43.4124;11.39779",
                    "43.41183;11.3987",
                    "43.41034;11.39794",
                    "43.41023;11.3971",
                    "43.40964;11.39562",
                    "43.40874;11.39433",
                    "43.40731;11.39292",
                    "43.40677;11.39289",
                    "43.40637;11.3923",
                    "43.40496;11.39144",
                    "43.40456;11.39178",
                    "43.40389;11.39207",
                    "43.40357;11.39197",
                    "43.4022;11.39176",
                    "43.40138;11.39035",
                    "43.40026;11.38946",
                    "43.39977;11.38843",
                    "43.39934;11.3885",
                    "43.39833;11.38529",
                    "43.39808;11.38352",
                    "43.39814;11.38237",
                    "43.39769;11.38233",
                    "43.39603;11.38159",
                    "43.39543;11.38101",
                    "43.39408;11.3812",
                    "43.39364;11.38121",
                    "43.39364;11.38121",
                    "43.39408;11.3812",
                    "43.39561;11.38102",
                    "43.39643;11.38071",
                    "43.3966;11.38015",
                    "43.39703;11.37843",
                    "43.39838;11.37646",
                    "43.39968;11.3756",
                    "43.40068;11.37343",
                    "43.40123;11.37253",
                    "43.4013;11.37069",
                    "43.40169;11.36855",
                    "43.40139;11.36668",
                    "43.40105;11.36484",
                    "43.40077;11.3639",
                    "43.40129;11.36307",
                    "43.40141;11.36255",
                    "43.4016;11.36168",
                    "43.40227;11.36093",
                    "43.40296;11.36095",
                    "43.40349;11.36067",
                    "43.40352;11.35986",
                    "43.40359;11.35939",
                    "43.40334;11.35897",
                    "43.40291;11.35869",
                    "43.40291;11.35721",
                    "43.40368;11.35708",
                    "43.40383;11.35668",
                    "43.40361;11.35598",
                    "43.40416;11.35557",
                    "43.40492;11.35591",
                    "43.40544;11.35552",
                    "43.40589;11.3555",
                    "43.40658;11.35602",
                    "43.40657;11.35528",
                    "43.40702;11.3544",
                    "43.40758;11.35433",
                    "43.40798;11.35375",
                    "43.40865;11.35405",
                    "43.40895;11.35326",
                    "43.40964;11.35332",
                    "43.40985;11.35292",
                    "43.41003;11.35254",
                    "43.41024;11.3523",
                    "43.41209;11.35186",
                    "43.41319;11.35119",
                    "43.41396;11.35032",
                    "43.41404;11.35032",
                    "43.41444;11.35047",
                    "43.41462;11.35007",
                    "43.41482;11.34904",
                    "43.41529;11.34881",
                    "43.41602;11.34889",
                    "43.41663;11.34879",
                    "43.4167;11.34878",
                    "43.41718;11.34845",
                    "43.41711;11.34784",
                    "43.41728;11.34723",
                    "43.41849;11.34645",
                    "43.4192;11.34678",
                    "43.41963;11.34699",
                    "43.42014;11.34702",
                    "43.42051;11.34725",
                    "43.42121;11.34737",
                    "43.42138;11.34763",
                    "43.42156;11.34791",
                    "43.42163;11.34782",
                    "43.42164;11.3477",
                    "43.42135;11.34751",
                    "43.42096;11.34727",
                    "43.42031;11.34712",
                    "43.41988;11.34697",
                    "43.41946;11.34695",
                    "43.41868;11.34642",
                    "43.41832;11.34633",
                    "43.41728;11.34621",
                    "43.41716;11.34591",
                    "43.41732;11.34475",
                    "43.41774;11.34452",
                    "43.41838;11.34376",
                    "43.41903;11.3427",
                    "43.41953;11.34218",
                    "43.41995;11.34126",
                    "43.42005;11.34012",
                    "43.42073;11.33993",
                    "43.42121;11.33931",
                    "43.42192;11.33767",
                    "43.42258;11.33704",
                    "43.42284;11.33649",
                    "43.42328;11.33683",
                    "43.42383;11.33659",
                    "43.42464;11.33538",
                    "43.42507;11.33523",
                    "43.42619;11.3348",
                    "43.42674;11.33423",
                    "43.42691;11.3346",
                    "43.42732;11.33482",
                    "43.42767;11.33473",
                    "43.42871;11.3344",
                    "43.42968;11.33347",
                    "43.43034;11.33364",
                    "43.43147;11.33368",
                    "43.4327;11.33329",
                    "43.43339;11.33287",
                    "43.43448;11.33242",
                    "43.43528;11.33129",
                    "43.43589;11.32995",
                    "43.43643;11.32871",
                    "43.43658;11.32762",
                    "43.43676;11.32723",
                    "43.43671;11.32692",
                    "43.43699;11.32663",
                    "43.43737;11.32543",
                    "43.43748;11.32528",
                    "43.43713;11.32489",
                    "43.43623;11.32369",
                    "43.43569;11.32178",
                    "43.43556;11.32089",
                    "43.43576;11.3201",
                    "43.4357;11.31922",
                    "43.43571;11.31846",
                    "43.43568;11.31731",
                    "43.43528;11.31609",
                    "43.43487;11.31558",
                    "43.4347;11.31529",
                    "43.43421;11.31457",
                    "43.43472;11.31324",
                    "43.43481;11.31301",
                    "43.43513;11.31261",
                    "43.43526;11.3122",
                    "43.43553;11.31157",
                    "43.43636;11.31124",
                    "43.43812;11.31139",
                    "43.43892;11.3105",
                    "43.44005;11.31",
                    "43.44004;11.30743",
                    "43.44021;11.30522",
                    "43.44044;11.30352",
                    "43.4406;11.30244",
                    "43.44133;11.30195",
                    "43.442;11.30159",
                    "43.44249;11.30169",
                    "43.44256;11.3015",
                    "43.44268;11.30098",
                    "43.44318;11.30074",
                    "43.44324;11.30001",
                    "43.44382;11.29908",
                    "43.44474;11.29971",
                    "43.44537;11.29981",
                    "43.44622;11.29934",
                    "43.44725;11.2978",
                    "43.44787;11.29694",
                    "43.44791;11.29615",
                    "43.44822;11.29534",
                    "43.44906;11.29468",
                    "43.44981;11.29385",
                    "43.45139;11.2927",
                    "43.45175;11.29232",
                    "43.45214;11.29205",
                    "43.45322;11.29237",
                    "43.45448;11.29199",
                    "43.45508;11.29195",
                    "43.45632;11.29231",
                    "43.45826;11.29199",
                    "43.45906;11.29162",
                    "43.46136;11.29043",
                    "43.46201;11.29019",
                    "43.46413;11.28961",
                    "43.46485;11.28942",
                    "43.46651;11.28881",
                    "43.46715;11.28831",
                    "43.46734;11.28795",
                    "43.46769;11.28738",
                    "43.46812;11.28717",
                    "43.46813;11.2873",
                    "43.46813;11.28786",
                    "43.46793;11.28798",
                    "43.46783;11.2873",
                    "43.46847;11.28677",
                    "43.46898;11.28618",
                    "43.4701;11.28589",
                    "43.47115;11.28543",
                    "43.47147;11.28547",
                    "43.47222;11.28571",
                    "43.47271;11.28588",
                    "43.47285;11.28603",
                    "43.47301;11.28634",
                    "43.4731;11.28668",
                    "43.47312;11.28691",
                    "43.47312;11.28714",
                    "43.47298;11.28847",
                    "43.4734;11.28875",
                    "43.47386;11.28736",
                    "43.47435;11.28588",
                    "43.47471;11.28695",
                    "43.4754;11.28855",
                    "43.47595;11.28881",
                    "43.47608;11.28897",
                    "43.47617;11.28917",
                    "43.47649;11.29076",
                    "43.47589;11.29156",
                    "43.47526;11.2939",
                    "43.47539;11.29615",
                    "43.47653;11.29705",
                    "43.47703;11.29824",
                    "43.47701;11.30083",
                    "43.47728;11.30168",
                    "43.47811;11.30243",
                    "43.47891;11.30415",
                    "43.48037;11.30573",
                    "43.48093;11.30551",
                    "43.48107;11.30599",
                    "43.48105;11.30719",
                    "43.48151;11.30893",
                    "43.48113;11.3106",
                    "43.48139;11.31147",
                    "43.48263;11.31224",
                    "43.48353;11.31321",
                    "43.48451;11.31351",
                    "43.48507;11.31538",
                    "43.48566;11.31695",
                    "43.48573;11.31827",
                    "43.48522;11.31994",
                    "43.48496;11.32125",
                    "43.48436;11.32407",
                    "43.48368;11.3252",
                    "43.48145;11.32537",
                    "43.48069;11.32617",
                    "43.48027;11.3272",
                    "43.48035;11.32755",
                    "43.48027;11.32875",
                    "43.47972;11.32898",
                    "43.47929;11.32978",
                    "43.47922;11.33116",
                    "43.47862;11.33194",
                    "43.47711;11.333",
                    "43.47613;11.33324",
                    "43.47429;11.33362",
                    "43.47413;11.33369",
                    "43.47407;11.3338",
                    "43.47406;11.33397",
                    "43.47496;11.33616",
                    "43.47604;11.33835",
                    "43.47579;11.34069",
                    "43.47557;11.34315",
                    "43.4758;11.34457",
                    "43.47532;11.34672",
                    "43.47636;11.34667",
                    "43.47679;11.34743",
                    "43.47741;11.34932",
                    "43.47753;11.35011",
                    "43.47763;11.35138",
                    "43.4779;11.35204",
                    "43.47795;11.35297",
                    "43.47857;11.35439",
                    "43.47895;11.35532",
                    "43.48043;11.35629",
                    "43.48148;11.35675",
                    "43.48268;11.35746",
                    "43.48333;11.35848",
                    "43.48352;11.35964",
                    "43.48349;11.35988",
                    "43.48436;11.36149",
                    "43.48469;11.36381",
                    "43.48491;11.36483",
                    "43.48463;11.36601",
                    "43.48446;11.36682",
                    "43.48442;11.36699",
                    "43.48465;11.36814",
                    "43.48483;11.36925",
                    "43.4852;11.36976",
                    "43.48567;11.36993",
                    "43.48591;11.37023",
                    "43.48616;11.37096",
                    "43.48634;11.37229",
                    "43.48641;11.37295",
                    "43.48639;11.37326",
                    "43.48615;11.37411",
                    "43.48616;11.37462",
                    "43.48649;11.37518",
                    "43.4869;11.37589",
                    "43.48681;11.37749",
                    "43.48695;11.37845",
                    "43.48779;11.37979",
                    "43.48791;11.38074",
                    "43.48858;11.38247",
                    "43.48992;11.38395",
                    "43.49005;11.38462",
                    "43.49026;11.38509",
                    "43.49029;11.38583",
                    "43.49026;11.38594",
                    "43.49006;11.38628",
                    "43.4899;11.38631",
                    "43.48983;11.38622",
                    "43.48972;11.38617",
                    "43.48966;11.38631",
                    "43.48967;11.38644",
                    "43.48957;11.38689",
                    "43.4894;11.38851",
                    "43.48928;11.38909",
                    "43.48927;11.38926",
                    "43.48953;11.39005",
                    "43.48998;11.39098",
                    "43.49019;11.39144",
                    "43.4904;11.39318",
                    "43.49031;11.39383",
                    "43.49008;11.39471",
                    "43.49011;11.39567",
                    "43.48999;11.39637",
                    "43.48958;11.39699",
                    "43.48832;11.39959",
                    "43.48765;11.39977",
                    "43.48637;11.39943",
                    "43.48598;11.39899",
                    "43.48592;11.39816",
                    "43.48526;11.39795",
                    "43.48463;11.39746",
                    "43.4845;11.39664",
                    "43.48423;11.39597",
                    "43.48321;11.3961",
                    "43.48252;11.39613",
                    "43.48189;11.39562",
                    "43.48116;11.39576",
                    "43.48067;11.39522",
                    "43.48097;11.39406",
                    "43.4805;11.39353",
                    "43.47982;11.39318",
                    "43.47943;11.39302",
                    "43.47878;11.39342",
                    "43.47821;11.39266",
                    "43.47781;11.39248",
                    "43.47808;11.3934",
                    "43.47809;11.39432",
                    "43.47875;11.39482",
                    "43.47851;11.39525",
                    "43.47678;11.39395",
                    "43.47632;11.39423",
                    "43.47552;11.395",
                    "43.47386;11.39651",
                    "43.47288;11.39776",
                    "43.47113;11.40054",
                    "43.46952;11.40202",
                    "43.46899;11.40218",
                    "43.46613;11.40586",
                    "43.46509;11.40793",
                    "43.46414;11.4094",
                    "43.46238;11.41333",
                    "43.46145;11.41394",
                    "43.45977;11.4154",
                    "43.45814;11.41633",
                    "43.45731;11.41771",
                    "43.45716;11.41848",
                    "43.45707;11.41941",
                    "43.45795;11.42004",
                    "43.459;11.42136",
                    "43.45782;11.42238",
                    "43.45656;11.42347",
                    "43.45708;11.42464",
                    "43.45787;11.42538",
                    "43.45791;11.42597",
                    "43.4607;11.42725",
                    "43.46267;11.42952",
                    "43.46293;11.42989",
                    "43.46315;11.43028",
                    "43.46344;11.43074",
                    "43.46362;11.43108",
                    "43.46407;11.43226",
                    "43.4646;11.43307",
                    "43.46492;11.43326",
                    "43.46516;11.43351",
                    "43.46545;11.43394",
                    "43.46559;11.43408",
                    "43.46575;11.43418",
                    "43.46612;11.43431",
                    "43.46637;11.43435",
                    "43.46673;11.43436",
                    "43.46722;11.43426",
                    "43.46717;11.43449"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/edd752b5-e9fd-4d89-a5a4-fd13b171c4a8.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b1364262-dbdd-4f60-8512-4f6a3bbb6cf1.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/d4f92d08-3a96-4992-acb2-e9f1a9d79f58.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/07fca181-85e8-4ffd-a384-a75f929bfdb5.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/90140618-d094-4ab7-a8b2-bb0508671963.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/2f733044-d373-4b02-a62a-bf0785d5a609.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "San Sano (borgo panoramico)",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/0f0507f4-0c7c-4889-be1e-b83d177b15e9.san_s__43_42270837198352_11_388787093996966",
                        "latitude": 43.42270837198352,
                        "longitude": 11.388787093996966,
                        "description": "Dopo il primo tratto del tour, il percorso raggiunge il borgo di San Sano lungo una strada molto panoramica, immersa tra vigneti e colline del Chianti. \u00c8 una delle prime tappe pi\u00f9 belle dal punto di vista paesaggistico, ideale per una breve sosta foto e per godersi il panorama. Il borgo ha un\u2019atmosfera tranquilla e autentica, perfetta per entrare subito nello spirito del tour. In questa fase del percorso consigliamo di avere con s\u00e9 acqua e uno snack, perch\u00e9 prima di Vagliagli le possibilit\u00e0 di ristoro sono limitate. San Sano \u00e8 quindi soprattutto una tappa scenografica, ottima per una pausa breve."
                    },
                    {
                        "name": "Parco Sculture del Chianti",
                        "type": "funny",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/40cabc6a-93a0-421e-a4fb-8bae89534666.Parco__43_39355148808473_11_381148726414724",
                        "latitude": 43.39355148808473,
                        "longitude": 11.381148726414724,
                        "description": "Proseguendo il tour, dopo un facile tratto sterrato e una salita pi\u00f9 impegnativa, si arriva in una zona molto particolare del percorso, dove si trovano i grandi \u201cPeperoni\u201d dello scultore Piero Giadrossi. Poco distante (meno di 200 metri) si trova l\u2019ingresso del Parco Sculture del Chianti, tappa facoltativa molto interessante per chi desidera unire bici, arte e natura. Il parco \u00e8 visitabile con biglietto d\u2019ingresso e rappresenta una sosta originale lungo il giro. Dopo questa area, il percorso continua su un tratto sterrato de L\u2019Eroica. Poco pi\u00f9 avanti, sulla destra, si trova il ristorante Cacio e Pepe, ottima opzione per una sosta pranzo o per una pausa ristoro pi\u00f9 comoda."
                    },
                    {
                        "name": "Ristorante La Taverna Di Vagliagli",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/48c3b0d6-cda1-4a22-a207-88a1f029be9f.tratt__43_42163605005048_11_347745212661655",
                        "latitude": 43.42163605005048,
                        "longitude": 11.347745212661655,
                        "description": "Prima di entrare nel centro di Vagliagli, il tour prevede una breve deviazione verso un piazzale panoramico con obelisco, da cui si gode una splendida vista sulle colline circostanti: un punto perfetto per foto e pausa. In paese, a seconda del giorno e degli orari, si possono trovare aperti il circolo o l\u2019alimentari per uno snack veloce o per rifornirsi. Per chi desidera una sosta pi\u00f9 completa, \u00e8 possibile pranzare presso La Taverna di Vagliagli. Questa tappa \u00e8 particolarmente utile perch\u00e9 arriva dopo una parte iniziale del percorso con pochi punti di ristoro. Vagliagli unisce quindi panorama, relax e una buona opportunit\u00e0 per fermarsi a mangiare."
                    },
                    {
                        "name": "Castellina in Chianti (borgo, ristoro e gelato)",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/c18a6b15-9342-4a44-acad-3bb3613b525d.caste__43_46813492316128_11_287861343288776",
                        "latitude": 43.46813492316128,
                        "longitude": 11.287861343288776,
                        "description": "Il tour prosegue verso Castellina in Chianti attraverso una bellissima strada in gran parte sterrata, molto piacevole e tipica del territorio. Castellina \u00e8 una tappa ideale per una sosta pi\u00f9 lunga: nel centro storico si trovano facilmente bar, ristoranti e diversi punti di ristoro. La sosta in gelateria \u00e8 particolarmente consigliata, soprattutto nelle giornate pi\u00f9 calde, ed \u00e8 uno dei momenti pi\u00f9 apprezzati del tour. Per uno snack veloce, il centro offre soluzioni pratiche come bar e locali informali. Proseguendo poi verso Radda in Chianti, il percorso attraversa un\u2019altra zona molto bella del Chianti, con possibilit\u00e0 di un\u2019ulteriore pausa tra borgo, caff\u00e8 o una sosta dolce prima del rientro."
                    }
                ],
                "infos": {
                    "distance": 51106
                }
            }
        ],
        "catalogue": [
            {
                "id": 56,
                "name": "E-bike",
                "description": "E-MTB front BOTTECCHIA HYDRON BE50",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/8feb07a0-293b-4656-89ab-252eb7b8d9f1.png"
            },
            {
                "id": 57,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1554,
        "customer": {
            "id": 201,
            "title": "E-Bike Tuscany",
            "description": "descrizione da cambiare",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/E-Bike_Tuscany_Pienza.png",
            "text_logo": null,
            "contacts": {
                "address": "Via della Buca, 23, Via della Buca, 23, 53026 Pienza SI, Italia",
                "email": "info@e-biketuscany.com",
                "phone": "3478815780"
            },
            "coordinate": {
                "latitude": 43.07724,
                "longitude": 11.67845
            },
            "tours": 2,
            "gallery": []
        },
        "title": "Val d'Orcia & Pienza ebike Tour (Variante Breve)",
        "description": "Percorso collinare scorrevole, con andamento \u201ca onde\u201d: salite brevi per cambiare ritmo e discese fluide su strade secondarie panoramiche. Fondo tipicamente misto (asfalto + tratti di strada bianca), dove pu\u00f2 comparire brecciolino o ghiaietta soprattutto nei raccordi rurali; guida tranquilla e linee pulite nelle curve.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1554.jpg",
        "price": 25.0,
        "location": "Val d'Orcia",
        "location_id": 36,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1587,
                "title": "Pienza & Val D'Orcia E-bike Tour",
                "description": "- Pedalerete all'interno del set del Gladiatore e visiteremo la meravigliosa cittadina di Pienza, Bagno Vignoni e San Quirico di Val d'Orcia\n- Vi aspetta un'escursione ad anello di circa 17 miglia (28km) su comode E-BIKE lungo strade bianche super panoramiche.\n- Il punto di partenza e rientro \u00e8 Pienza, e il tour ha una durata stimati di 2.5/3h pause incluse.\n- Padbike ha sviluppato una innovativa app di Navigazione che vi guider\u00e0 lungo tutto il percorso!",
                "notes": "",
                "start_address": "Via della Buca, 23, 53026 Pienza SI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    43.07742,
                    11.67944
                ],
                "preview_track": [
                    "43.07742;11.67944",
                    "43.07739;11.6798",
                    "43.07719;11.68063",
                    "43.07707;11.68116",
                    "43.07703;11.68149",
                    "43.07699;11.68168",
                    "43.07694;11.68175",
                    "43.07667;11.68181",
                    "43.07633;11.68181",
                    "43.0762;11.6817",
                    "43.07613;11.68151",
                    "43.07597;11.68081",
                    "43.07597;11.68052",
                    "43.07607;11.67972",
                    "43.07601;11.67931",
                    "43.07593;11.67843",
                    "43.07616;11.67699",
                    "43.07671;11.67512",
                    "43.07697;11.67422",
                    "43.07695;11.6739",
                    "43.07694;11.67375",
                    "43.07694;11.67341",
                    "43.07692;11.67327",
                    "43.07684;11.67322",
                    "43.07673;11.67328",
                    "43.07635;11.674",
                    "43.07541;11.67483",
                    "43.07457;11.67549",
                    "43.07398;11.67702",
                    "43.07337;11.67839",
                    "43.0724;11.68004",
                    "43.07204;11.68018",
                    "43.07219;11.67905",
                    "43.07197;11.67857",
                    "43.06949;11.67885",
                    "43.06902;11.67964",
                    "43.0686;11.67991",
                    "43.06845;11.67946",
                    "43.06855;11.67872",
                    "43.06851;11.67854",
                    "43.06846;11.67847",
                    "43.06833;11.67845",
                    "43.06845;11.67829",
                    "43.06868;11.67807",
                    "43.06848;11.67607",
                    "43.06693;11.67474",
                    "43.06651;11.6737",
                    "43.06669;11.67304",
                    "43.06657;11.67261",
                    "43.06622;11.67212",
                    "43.06562;11.67187",
                    "43.06508;11.67215",
                    "43.06301;11.67076",
                    "43.06096;11.66896",
                    "43.0605;11.66708",
                    "43.0603;11.66637",
                    "43.06076;11.66597",
                    "43.06182;11.66702",
                    "43.0627;11.66687",
                    "43.064;11.66649",
                    "43.06489;11.66669",
                    "43.06544;11.66719",
                    "43.06632;11.66649",
                    "43.06651;11.66572",
                    "43.06739;11.66614",
                    "43.06843;11.66727",
                    "43.06922;11.66762",
                    "43.07064;11.6675",
                    "43.07144;11.66753",
                    "43.07238;11.66777",
                    "43.07253;11.66776",
                    "43.07184;11.66761",
                    "43.07083;11.6674",
                    "43.06984;11.66756",
                    "43.06867;11.66749",
                    "43.06783;11.6665",
                    "43.06697;11.66592",
                    "43.06643;11.66628",
                    "43.06571;11.66712",
                    "43.06513;11.66701",
                    "43.06452;11.66646",
                    "43.06314;11.66659",
                    "43.06217;11.66705",
                    "43.06094;11.66606",
                    "43.0604;11.66611",
                    "43.05922;11.66484",
                    "43.05792;11.6631",
                    "43.05678;11.66166",
                    "43.05626;11.66153",
                    "43.05462;11.66088",
                    "43.05328;11.65843",
                    "43.05242;11.65739",
                    "43.05118;11.65683",
                    "43.05009;11.65693",
                    "43.04898;11.65579",
                    "43.04777;11.65463",
                    "43.0463;11.65461",
                    "43.04496;11.65207",
                    "43.04424;11.6514",
                    "43.04305;11.64887",
                    "43.04149;11.64792",
                    "43.03948;11.64836",
                    "43.03736;11.64714",
                    "43.03618;11.64649",
                    "43.03496;11.64522",
                    "43.03483;11.64503",
                    "43.03481;11.6448",
                    "43.03451;11.6432",
                    "43.03362;11.63845",
                    "43.03344;11.63586",
                    "43.0336;11.6338",
                    "43.03337;11.63062",
                    "43.03334;11.63005",
                    "43.03335;11.62949",
                    "43.03341;11.62866",
                    "43.03346;11.62791",
                    "43.03348;11.62773",
                    "43.03357;11.62756",
                    "43.03363;11.62752",
                    "43.03404;11.62761",
                    "43.03425;11.62766",
                    "43.03446;11.62763",
                    "43.03712;11.62718",
                    "43.03722;11.62717",
                    "43.03879;11.62689",
                    "43.03906;11.62688",
                    "43.03984;11.62688",
                    "43.04034;11.62686",
                    "43.04057;11.6268",
                    "43.04079;11.62672",
                    "43.04125;11.62662",
                    "43.04155;11.62652",
                    "43.04305;11.62576",
                    "43.04425;11.62515",
                    "43.04446;11.6251",
                    "43.04482;11.62506",
                    "43.04554;11.62505",
                    "43.04579;11.6251",
                    "43.04639;11.6254",
                    "43.0466;11.62547",
                    "43.047;11.62549",
                    "43.04701;11.62555",
                    "43.04708;11.62583",
                    "43.04707;11.6262",
                    "43.04714;11.62653",
                    "43.04787;11.62714",
                    "43.04809;11.62717",
                    "43.04835;11.62711",
                    "43.04937;11.62659",
                    "43.05135;11.62723",
                    "43.05308;11.62688",
                    "43.05566;11.62615",
                    "43.05683;11.62643",
                    "43.05693;11.62664",
                    "43.05695;11.62679",
                    "43.05684;11.62772",
                    "43.05656;11.62881",
                    "43.05639;11.63115",
                    "43.05665;11.633",
                    "43.05625;11.63481",
                    "43.05602;11.63628",
                    "43.05606;11.6379",
                    "43.0561;11.63784",
                    "43.05627;11.6397",
                    "43.05699;11.64091",
                    "43.05759;11.64221",
                    "43.05834;11.64231",
                    "43.05964;11.64188",
                    "43.06042;11.64202",
                    "43.06157;11.64388",
                    "43.06361;11.64752",
                    "43.06446;11.64834",
                    "43.06531;11.64855",
                    "43.06593;11.6482",
                    "43.06677;11.64813",
                    "43.06815;11.64755",
                    "43.06782;11.64614",
                    "43.06747;11.64454",
                    "43.06885;11.64306",
                    "43.07034;11.64203",
                    "43.06965;11.64128",
                    "43.06952;11.64072",
                    "43.06974;11.63945",
                    "43.07028;11.63713",
                    "43.07034;11.63502",
                    "43.07059;11.63469",
                    "43.07069;11.63441",
                    "43.07042;11.63485",
                    "43.07032;11.63666",
                    "43.07001;11.63866",
                    "43.06959;11.64017",
                    "43.06956;11.64098",
                    "43.06977;11.64143",
                    "43.07037;11.64212",
                    "43.07207;11.64289",
                    "43.07396;11.64684",
                    "43.07696;11.64795",
                    "43.07777;11.6468",
                    "43.07891;11.64659",
                    "43.08052;11.64674",
                    "43.08172;11.64604",
                    "43.08192;11.64603",
                    "43.08434;11.65004",
                    "43.08507;11.65078",
                    "43.08707;11.65237",
                    "43.08762;11.65296",
                    "43.08842;11.6551",
                    "43.08801;11.65696",
                    "43.08686;11.65909",
                    "43.0861;11.66115",
                    "43.0854;11.66326",
                    "43.08511;11.66452",
                    "43.08407;11.66665",
                    "43.08313;11.66668",
                    "43.08221;11.66728",
                    "43.08133;11.66859",
                    "43.08099;11.66954",
                    "43.08039;11.67007",
                    "43.07985;11.67038",
                    "43.07929;11.67123",
                    "43.07877;11.67234",
                    "43.07825;11.67335",
                    "43.07887;11.6733",
                    "43.07947;11.67393",
                    "43.07923;11.67444",
                    "43.07821;11.67604",
                    "43.07776;11.67675",
                    "43.07767;11.67687",
                    "43.07727;11.67726",
                    "43.0772;11.67723",
                    "43.07724;11.67723",
                    "43.0775;11.67743",
                    "43.0776;11.67744",
                    "43.0776;11.67748",
                    "43.07758;11.6778",
                    "43.07753;11.67873",
                    "43.07748;11.67936"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/12373f76-0b64-4604-bc37-96e8b766ed2a.jpeg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/772a363a-2c4d-4d87-aad8-4602815d2a45.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5ccca818-95fb-43b4-853d-b8017395e521.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/7c0a1144-eccc-4956-a93f-3882469cb29c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/da93cc65-110b-44ce-9ddb-b75b05f5b3da.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/dba88379-e796-4d9c-affb-8e2314d21964.gladi__43_072525494088616_11_667730417102575",
                        "latitude": 43.072525494088616,
                        "longitude": 11.667730417102575,
                        "description": ""
                    },
                    {
                        "name": "Cappella Vitaleta",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/ef192568-74f0-41e5-9dde-d7929d491323.vital__43_07068069926638_11_634402042254807",
                        "latitude": 43.07068069926638,
                        "longitude": 11.634402042254807,
                        "description": "La Cappella della Madonna di Vitaleta, situata nella Val d'Orcia, \u00e8 un piccolo gioiello architettonico con una storia affascinante. La sua origine \u00e8 legata a una leggenda secondo cui la Madonna apparve a una pastorella nel XVI secolo, indicando il luogo dove sarebbe stata eretta una chiesa. "
                    }
                ],
                "infos": {
                    "distance": 25249
                }
            }
        ],
        "catalogue": [
            {
                "id": 33,
                "name": "E-bike + Casco",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/3df4f2f3-1ae0-4da7-b811-479b2b27b755.jpg"
            }
        ]
    },
    {
        "id": 1600,
        "customer": {
            "id": 380,
            "title": "Biciclettaio - Gaiole in Chianti",
            "description": "Biciclettaio \u00e8 il bike rent di Gaiole in Chianti gestito da Filippo, punto di riferimento per chi vuole pedalare tra le colline del Chianti Classico. Offre noleggio di e-bike moderne e ben mantenute, ideali per affrontare sterrati e salite in totale relax. Propone tour panoramici in e-bike alla scoperta di borghi, vigneti e strade bianche, con itinerari anche ispirati a L\u2019Eroica. In negozio trovi assistenza competente, consigli sui percorsi e supporto per organizzare la giornata in sella. Disponibili servizi come regolazione bici, caschi e accessori, oltre a indicazioni su tracce e punti di interesse. Un\u2019esperienza completa, pensata per divertirsi e vivere il Chianti al ritmo giusto.",
            "color": "#ffffff",
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Biciclettaio_-_Gaiole_in_Chianti.jpg",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/Progetto_senza_titolo.png"
            ],
            "contacts": {
                "address": "Via G. Marconi, 5, Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "email": "rental@bicyclesinchianti.com",
                "phone": "05771390071"
            },
            "coordinate": {
                "latitude": 43.46728,
                "longitude": 11.43466
            },
            "tours": 4,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8290a122-144d-4087-a8fb-9ab3edd8948f.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/7565c2ce-222e-4e8a-bd67-54c2940dc9a2.jpg",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/72782e04-007a-451f-9a23-2d3239ae3b48.webp",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/099cdfa4-dcdf-4e40-9342-a33bdf177312.webp"
            ]
        },
        "title": "Gaiole - Radda in Chianti + Degustazione",
        "description": "Tour e-bike ad anello da Gaiole in Chianti tra strade secondarie e strade bianche, nel cuore del Chianti Classico. Il percorso raggiunge Radda in Chianti, borgo medievale circondato da vigne, e prosegue fino a Badia a Coltibuono, antica abbazia fondata nel 1051, dove \u00e8 possibile fare wine tasting, pranzo e, facoltativamente, visita alle cantine. Dopo la sosta si rientra a Gaiole tra colline, boschi e paesaggi iconici.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1600.webp",
        "price": 25.0,
        "location": "Chianti",
        "location_id": 35,
        "tags": [
            "Natura",
            "Storia"
        ],
        "routes": [
            {
                "id": 1633,
                "title": "Gaiole - Radda in Chianti + Degustazione",
                "description": "Questo tour e-bike parte da Gaiole in Chianti e si sviluppa su un affascinante anello tra strade secondarie e strade bianche, ideale per vivere il Chianti Classico in modo autentico e rilassato. Fin dai primi chilometri il percorso entra in un paesaggio fatto di vigneti, oliveti, boschi e poderi storici, in un territorio che per secoli ha avuto un ruolo centrale nella storia del Chianti: Gaiole, insieme a Radda e Castellina, faceva parte infatti della storica Lega del Chianti, istituita dalla Repubblica Fiorentina.\n\nIl tour raggiunge poi Radda in Chianti, uno dei borghi pi\u00f9 rappresentativi della zona, noto per il suo impianto medievale, le antiche mura difensive e la posizione panoramica tra le valli dell\u2019Arbia e della Pesa. Passeggiare o pedalare nei dintorni di Radda significa attraversare uno dei luoghi simbolo del vino Chianti Classico, dove storia, architettura e paesaggio si fondono in modo naturale.\n\nDa qui si prosegue verso Badia a Coltibuono, una delle tappe pi\u00f9 suggestive del tour. L\u2019abbazia fu fondata nel 1051 dai monaci vallombrosani di Giovanni Gualberto e divenne presto un importante centro agricolo e vitivinicolo del territorio. Oggi offre visite guidate con degustazione, che includono ambienti storici come il chiostro, i saloni affrescati e le antiche cantine di affinamento; qui i partecipanti possono concedersi un wine tasting e il pranzo, con possibilit\u00e0 facoltativa di visita alle cantine.\n\nTerminata la sosta, il rientro verso Gaiole regala ancora scorci tip",
                "notes": null,
                "start_address": "Via G. Marconi, 5, 53013 Gaiole In Chianti SI, Italia",
                "difficulty": "Easy",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    43.46734,
                    11.43443
                ],
                "preview_track": [
                    "43.46734;11.43443",
                    "43.46621;11.43579",
                    "43.46475;11.43546",
                    "43.46445;11.43434",
                    "43.46436;11.43315",
                    "43.46438;11.43292",
                    "43.46424;11.4326",
                    "43.46368;11.43121",
                    "43.46352;11.43086",
                    "43.46328;11.43051",
                    "43.46301;11.43004",
                    "43.46275;11.42963",
                    "43.46166;11.4283",
                    "43.45799;11.426",
                    "43.45661;11.42551",
                    "43.45471;11.42393",
                    "43.45436;11.42356",
                    "43.45296;11.42147",
                    "43.45147;11.41957",
                    "43.45126;11.41925",
                    "43.45147;11.4189",
                    "43.45326;11.41862",
                    "43.4552;11.41975",
                    "43.45646;11.41935",
                    "43.45726;11.41826",
                    "43.45768;11.41667",
                    "43.45955;11.41551",
                    "43.46086;11.41464",
                    "43.46223;11.4135",
                    "43.464;11.41027",
                    "43.46414;11.4094",
                    "43.46509;11.40793",
                    "43.46613;11.40586",
                    "43.46899;11.40218",
                    "43.47085;11.40098",
                    "43.47212;11.39829",
                    "43.473;11.3976",
                    "43.47486;11.39539",
                    "43.47622;11.39456",
                    "43.47658;11.39389",
                    "43.4775;11.39468",
                    "43.4788;11.39514",
                    "43.47828;11.39453",
                    "43.478;11.39383",
                    "43.47783;11.39277",
                    "43.47786;11.3924",
                    "43.47821;11.39266",
                    "43.47878;11.39342",
                    "43.47943;11.39302",
                    "43.47982;11.39318",
                    "43.4805;11.39353",
                    "43.48097;11.39406",
                    "43.48067;11.39522",
                    "43.48116;11.39576",
                    "43.48189;11.39562",
                    "43.48252;11.39613",
                    "43.48321;11.3961",
                    "43.48423;11.39597",
                    "43.4845;11.39664",
                    "43.48463;11.39746",
                    "43.48526;11.39795",
                    "43.48592;11.39816",
                    "43.48598;11.39899",
                    "43.48637;11.39943",
                    "43.48765;11.39977",
                    "43.48832;11.39959",
                    "43.48958;11.39699",
                    "43.48999;11.39637",
                    "43.49011;11.39567",
                    "43.49008;11.39471",
                    "43.49031;11.39383",
                    "43.4904;11.39318",
                    "43.49019;11.39144",
                    "43.48998;11.39098",
                    "43.48953;11.39005",
                    "43.48927;11.38926",
                    "43.48928;11.38909",
                    "43.4894;11.38851",
                    "43.48957;11.38689",
                    "43.48969;11.38648",
                    "43.48977;11.38642",
                    "43.48995;11.38637",
                    "43.49011;11.38622",
                    "43.49029;11.38586",
                    "43.49026;11.38509",
                    "43.49005;11.38462",
                    "43.48992;11.38395",
                    "43.48858;11.38247",
                    "43.48791;11.38074",
                    "43.48779;11.37979",
                    "43.48695;11.37845",
                    "43.48681;11.37749",
                    "43.4869;11.37589",
                    "43.48707;11.37567",
                    "43.48753;11.37527",
                    "43.48757;11.37487",
                    "43.48742;11.37415",
                    "43.48711;11.37363",
                    "43.48649;11.37314",
                    "43.48641;11.37308",
                    "43.48637;11.37334",
                    "43.48613;11.37422",
                    "43.48623;11.37474",
                    "43.48639;11.375",
                    "43.4868;11.37568",
                    "43.48691;11.37604",
                    "43.4868;11.37767",
                    "43.48747;11.3794",
                    "43.48785;11.38013",
                    "43.48817;11.38162",
                    "43.48961;11.38355",
                    "43.48999;11.38418",
                    "43.49011;11.38481",
                    "43.49029;11.3852",
                    "43.49024;11.38601",
                    "43.49003;11.38632",
                    "43.48988;11.3863",
                    "43.48982;11.3862",
                    "43.4897;11.38619",
                    "43.48966;11.38634",
                    "43.48966;11.38648",
                    "43.48956;11.38691",
                    "43.48939;11.38862",
                    "43.48927;11.38913",
                    "43.48928;11.3893",
                    "43.48958;11.39018",
                    "43.49003;11.39104",
                    "43.49017;11.39209",
                    "43.49041;11.3933",
                    "43.49028;11.39389",
                    "43.4901;11.39494",
                    "43.4901;11.39586",
                    "43.48993;11.39646",
                    "43.4895;11.39717",
                    "43.48819;11.39966",
                    "43.48764;11.3998",
                    "43.48755;11.40071",
                    "43.48749;11.40122",
                    "43.48763;11.40126",
                    "43.48798;11.40073",
                    "43.48878;11.40119",
                    "43.4889;11.40177",
                    "43.48874;11.40298",
                    "43.48873;11.40375",
                    "43.48893;11.40516",
                    "43.48923;11.4064",
                    "43.48996;11.40777",
                    "43.48998;11.40979",
                    "43.48944;11.41101",
                    "43.48952;11.41178",
                    "43.49017;11.41261",
                    "43.4906;11.41356",
                    "43.49008;11.41634",
                    "43.49033;11.41776",
                    "43.49095;11.41834",
                    "43.49111;11.41958",
                    "43.49131;11.42119",
                    "43.49066;11.42148",
                    "43.49059;11.42171",
                    "43.4908;11.42178",
                    "43.49134;11.42183",
                    "43.49169;11.4226",
                    "43.49286;11.42401",
                    "43.49314;11.42533",
                    "43.49307;11.42606",
                    "43.49341;11.42641",
                    "43.49346;11.42677",
                    "43.49351;11.42714",
                    "43.49376;11.42738",
                    "43.49368;11.42796",
                    "43.4931;11.42916",
                    "43.49357;11.42956",
                    "43.49382;11.42996",
                    "43.49419;11.42975",
                    "43.4944;11.42976",
                    "43.49486;11.43141",
                    "43.49493;11.4328",
                    "43.49434;11.43457",
                    "43.49451;11.43522",
                    "43.49417;11.43751",
                    "43.49408;11.43838",
                    "43.49481;11.43917",
                    "43.49484;11.4393",
                    "43.49477;11.43947",
                    "43.49455;11.4402",
                    "43.4944;11.44109",
                    "43.49408;11.44209",
                    "43.49285;11.44241",
                    "43.49224;11.44396",
                    "43.49111;11.44302",
                    "43.48981;11.44328",
                    "43.48894;11.4442",
                    "43.48787;11.4451",
                    "43.48812;11.4461",
                    "43.48884;11.44749",
                    "43.48982;11.44839",
                    "43.48992;11.4496",
                    "43.49046;11.45002",
                    "43.49083;11.45011",
                    "43.49069;11.45043",
                    "43.49027;11.4505",
                    "43.48977;11.4504",
                    "43.48987;11.45055",
                    "43.49083;11.45066",
                    "43.49139;11.45116",
                    "43.49171;11.45131",
                    "43.49239;11.45113",
                    "43.49351;11.45041",
                    "43.49377;11.45062",
                    "43.49375;11.45126",
                    "43.49467;11.45114",
                    "43.49476;11.45033",
                    "43.4953;11.4499",
                    "43.49517;11.45011",
                    "43.49464;11.4504",
                    "43.49419;11.4512",
                    "43.49372;11.45109",
                    "43.49373;11.45045",
                    "43.49302;11.45069",
                    "43.49217;11.45117",
                    "43.49155;11.45129",
                    "43.49118;11.45082",
                    "43.4906;11.45069",
                    "43.48972;11.45041",
                    "43.48964;11.45044",
                    "43.48939;11.45062",
                    "43.48868;11.44912",
                    "43.48755;11.44831",
                    "43.48665;11.44755",
                    "43.4855;11.44628",
                    "43.48441;11.4448",
                    "43.48375;11.44383",
                    "43.48251;11.44372",
                    "43.47979;11.44442",
                    "43.47906;11.44404",
                    "43.47701;11.44461",
                    "43.47558;11.44299",
                    "43.47471;11.44276",
                    "43.47225;11.44262",
                    "43.47201;11.44219",
                    "43.47119;11.44122",
                    "43.47048;11.43978",
                    "43.47041;11.43877",
                    "43.47034;11.43712",
                    "43.46952;11.4375",
                    "43.46936;11.43736",
                    "43.46924;11.43495",
                    "43.46891;11.43509",
                    "43.46884;11.43469",
                    "43.4691;11.43362",
                    "43.46918;11.43312",
                    "43.46864;11.43318",
                    "43.4679;11.43371",
                    "43.46746;11.43414",
                    "43.46734;11.43443"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/00b0c558-e178-4c22-b223-ffbc21c13b65.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/0e69c034-508d-41b8-bf36-fe30de0b173f.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/e0573aac-0947-4569-9f50-40447384c397.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/eaef6103-a947-496c-96c0-d285656166a9.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/f938fd84-dd41-4c19-84a5-e0d5a5b479f6.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Badia a Passignano (Abbazia di San Michele Arcangelo)",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/89e102c6-172e-40bb-8153-e7c4f7e26b44.badia__43_49529139617956_11_449894203206869",
                        "latitude": 43.49529139617956,
                        "longitude": 11.449894203206869,
                        "description": "Un complesso monastico che sembra quasi un castello, immerso tra vigne e boschi del Chianti. Nell\u2019XI secolo accolse la riforma vallombrosana legata a San Giovanni Gualberto (che qui mor\u00ec nel 1073), diventando un punto importante della vita monastica toscana.\nDentro l\u2019abbazia c\u2019\u00e8 anche un vero \u201cgioiello\u201d del Rinascimento: l\u2019Ultima Cena affrescata da Domenico Ghirlandaio, datata 1476, una delle sue prime versioni sul tema.\n\u00c8 una tappa perfetta da raccontare durante il tour perch\u00e9 unisce spiritualit\u00e0, arte e paesaggio in pochi metri: silenzio, pietra antica e colline del Chianti tutto intorno."
                    },
                    {
                        "name": "Radda in Chianti",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/79da3b8c-e579-44b2-851b-5d5d9f4e5369.radda__43_486427232399784_11_375014837421354",
                        "latitude": 43.486427232399784,
                        "longitude": 11.375014837421354,
                        "description": "Radda \u00e8 uno dei borghi simbolo del Chianti Classico: un centro raccolto, ancora protetto da tratti di mura, con un impianto medievale fatto di vicoli e piccole piazze.\nPer secoli fu la sede della Lega del Chianti, l\u2019antica organizzazione amministrativa della Repubblica di Firenze: lo ricorda il Palazzo del Podest\u00e0, riconoscibile dalla facciata decorata con tanti stemmi dei podest\u00e0 che si sono succeduti nel tempo.\nAccanto, la zona della chiesa di San Niccol\u00f2 completa la scena \u201cda borgo fortificato\u201d e rende Radda un passaggio molto scenografico e ricco di storia, oltre che di vino e panorami."
                    }
                ],
                "infos": {
                    "distance": 24920
                }
            }
        ],
        "catalogue": [
            {
                "id": 56,
                "name": "E-bike",
                "description": "E-MTB front BOTTECCHIA HYDRON BE50",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": "https://padbike-admin.s3.amazonaws.com/rental_object_icon/8feb07a0-293b-4656-89ab-252eb7b8d9f1.png"
            },
            {
                "id": 57,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1323,
        "customer": {
            "id": 34,
            "title": "Padbike",
            "description": "Padbike, a tour operator based in Florence, specialized in designing and organizing E-Bike travel experiences.\r\nIn 2024 it opened an in-house Software & Development division for the development of Outdoora.",
            "color": "#404040",
            "theme_dark": true,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Padbike.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/provaRisorsa_1.png"
            ],
            "contacts": {
                "address": "Via dei Renai, 13, Via dei Renai, 13, 50125 Firenze FI, Italia",
                "email": "padbikeapp@gmail.com",
                "phone": "+393888353749"
            },
            "coordinate": {
                "latitude": 43.76491,
                "longitude": 11.25982
            },
            "tours": 12,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/21851540-c174-42ce-9ec2-d50341a79f83.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/389e886d-2941-43cc-bc89-86cfd16f0c82.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8aa350b2-3694-4348-ac22-b832c90da9c1.jpg"
            ]
        },
        "title": "Sellaronda in due giorni",
        "description": "PERCHE' IL SELLARONDA IN 2 GIORNI?\r\nGeneralmente la maggior parte dei turisti percorre il Sella ronda in una sola giornata, ma noi di Padbike non ci piace seguire la folla!\r\n\r\nLo percorreremo invece in due giorni, superando oltre 100 km di sentieri con 6000 m di dislivello nel corso di 13 ore di guida. In questo modo percorreremo alcuni dei sentieri pi\u00f9 spettacolari e meno conosciuti delle dolomiti. Ci fermeremo a met\u00e0 strada in un caloroso rifugio a oltre 2000m di quota!",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1323.jpg",
        "price": 250.0,
        "location": "Dolomiti",
        "location_id": 2,
        "tags": [
            "Natura",
            "Montagne"
        ],
        "routes": [
            {
                "id": 1356,
                "title": "Da Selva di Val Gardena a Rifugio Bech de Roches",
                "description": "Day 1",
                "notes": "THIS IS DAY 1",
                "start_address": "Bike RS, Selva di Val Gardena",
                "difficulty": "Hard",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    46.55619,
                    11.76724
                ],
                "preview_track": [
                    "46.55619;11.76724",
                    "46.55604;11.76776",
                    "46.55609;11.76798",
                    "46.55601;11.76815",
                    "46.55565;11.76798",
                    "46.55403;11.80007",
                    "46.55402;11.80066",
                    "46.55434;11.80136",
                    "46.55434;11.80136",
                    "46.55428;11.80185",
                    "46.55421;11.80218",
                    "46.55421;11.80253",
                    "46.55404;11.80236",
                    "46.55394;11.802",
                    "46.55402;11.80168",
                    "46.55378;11.80215",
                    "46.55386;11.80172",
                    "46.55359;11.80169",
                    "46.55365;11.80243",
                    "46.5537;11.80284",
                    "46.55357;11.80274",
                    "46.55367;11.8032",
                    "46.55344;11.80328",
                    "46.5533;11.80306",
                    "46.55335;11.80378",
                    "46.55317;11.80382",
                    "46.5527;11.80325",
                    "46.55266;11.80323",
                    "46.55246;11.80321",
                    "46.55236;11.80277",
                    "46.55204;11.80233",
                    "46.55172;11.80251",
                    "46.55217;11.80297",
                    "46.55209;11.8033",
                    "46.55215;11.80367",
                    "46.55211;11.80399",
                    "46.55201;11.80432",
                    "46.5519;11.80457",
                    "46.55186;11.8045",
                    "46.55184;11.80422",
                    "46.55158;11.80407",
                    "46.55118;11.80425",
                    "46.55092;11.80461",
                    "46.55068;11.80497",
                    "46.55063;11.80519",
                    "46.55065;11.80534",
                    "46.55074;11.80559",
                    "46.55086;11.80586",
                    "46.55071;11.80613",
                    "46.5505;11.80594",
                    "46.5504;11.80634",
                    "46.55019;11.80674",
                    "46.55009;11.80662",
                    "46.55005;11.80718",
                    "46.55;11.80798",
                    "46.54981;11.80843",
                    "46.54987;11.80883",
                    "46.55022;11.8093",
                    "46.55061;11.80981",
                    "46.55061;11.80981",
                    "46.55015;11.81042",
                    "46.54976;11.81112",
                    "46.54956;11.81157",
                    "46.54969;11.81203",
                    "46.55007;11.81223",
                    "46.55031;11.81291",
                    "46.55021;11.81317",
                    "46.54981;11.81317",
                    "46.54911;11.81364",
                    "46.54906;11.81384",
                    "46.54892;11.81431",
                    "46.54883;11.81513",
                    "46.54851;11.81644",
                    "46.54838;11.81685",
                    "46.54824;11.81694",
                    "46.54813;11.81706",
                    "46.54809;11.817",
                    "46.548;11.81713",
                    "46.54781;11.81726",
                    "46.54774;11.81806",
                    "46.54716;11.81907",
                    "46.54695;11.81949",
                    "46.54663;11.8201",
                    "46.54678;11.82056",
                    "46.54699;11.8212",
                    "46.5472;11.82164",
                    "46.54761;11.82207",
                    "46.54778;11.82228",
                    "46.54768;11.82241",
                    "46.54774;11.82244",
                    "46.54767;11.82261",
                    "46.54727;11.8227",
                    "46.54733;11.82288",
                    "46.54758;11.82316",
                    "46.54785;11.82377",
                    "46.54814;11.82413",
                    "46.54855;11.82424",
                    "46.54885;11.82458",
                    "46.54933;11.82489",
                    "46.54943;11.82499",
                    "46.54916;11.82534",
                    "46.5491;11.8255",
                    "46.54889;11.82572",
                    "46.54927;11.82592",
                    "46.54911;11.82604",
                    "46.54914;11.82622",
                    "46.5493;11.82668",
                    "46.54923;11.82689",
                    "46.54813;11.82688",
                    "46.54791;11.82696",
                    "46.54801;11.82783",
                    "46.54852;11.82825",
                    "46.54847;11.82865",
                    "46.5485;11.82895",
                    "46.54858;11.82926",
                    "46.54881;11.82992",
                    "46.54877;11.83073",
                    "46.54884;11.83164",
                    "46.54859;11.83204",
                    "46.54848;11.83231",
                    "46.54864;11.83274",
                    "46.54877;11.83327",
                    "46.54888;11.83374",
                    "46.5488;11.8342",
                    "46.5487;11.83477",
                    "46.54874;11.83523",
                    "46.54873;11.83687",
                    "46.54869;11.83744",
                    "46.54871;11.83808",
                    "46.54858;11.83851",
                    "46.5486;11.83915",
                    "46.54847;11.83924",
                    "46.54808;11.84003",
                    "46.54753;11.84012",
                    "46.54737;11.84025",
                    "46.54742;11.8404",
                    "46.54747;11.84094",
                    "46.5478;11.84191",
                    "46.54869;11.843",
                    "46.5498;11.8445",
                    "46.54986;11.84479",
                    "46.54992;11.84518",
                    "46.55034;11.84555",
                    "46.55108;11.84714",
                    "46.55075;11.84993",
                    "46.55061;11.85152",
                    "46.55034;11.85223",
                    "46.55005;11.8528",
                    "46.55007;11.85341",
                    "46.55016;11.85363",
                    "46.5502;11.85393",
                    "46.55012;11.85488",
                    "46.55041;11.856",
                    "46.55042;11.85649",
                    "46.55048;11.85704",
                    "46.55049;11.85743",
                    "46.55046;11.85807",
                    "46.55065;11.85872",
                    "46.5508;11.85928",
                    "46.55081;11.85978",
                    "46.55077;11.85997",
                    "46.55113;11.86092",
                    "46.55127;11.86174",
                    "46.55143;11.86231",
                    "46.5516;11.86302",
                    "46.5513;11.86344",
                    "46.55154;11.86444",
                    "46.55156;11.86493",
                    "46.55163;11.86529",
                    "46.5518;11.86591",
                    "46.55191;11.86625",
                    "46.55184;11.86648",
                    "46.55217;11.86744",
                    "46.55212;11.86881",
                    "46.55231;11.8695",
                    "46.55242;11.86973",
                    "46.55329;11.87137",
                    "46.55335;11.87161",
                    "46.55354;11.87203",
                    "46.55383;11.87255",
                    "46.55397;11.87294",
                    "46.55411;11.87319",
                    "46.5543;11.87474",
                    "46.55486;11.87554",
                    "46.55559;11.87604",
                    "46.55584;11.87622",
                    "46.55643;11.8769",
                    "46.55678;11.87714",
                    "46.55713;11.87775",
                    "46.55733;11.87813",
                    "46.55762;11.87851",
                    "46.55783;11.87906",
                    "46.55797;11.87959",
                    "46.55836;11.88038",
                    "46.55869;11.88104",
                    "46.55895;11.88192",
                    "46.55932;11.88265",
                    "46.55968;11.88324",
                    "46.56017;11.88347",
                    "46.56069;11.88347",
                    "46.56107;11.88378",
                    "46.56121;11.8843",
                    "46.56137;11.88499",
                    "46.56141;11.88512",
                    "46.56174;11.88566",
                    "46.56196;11.88613",
                    "46.56231;11.88653",
                    "46.56285;11.88706",
                    "46.56325;11.88713",
                    "46.56373;11.88761",
                    "46.56431;11.88812",
                    "46.5648;11.88832",
                    "46.5653;11.88832",
                    "46.56572;11.88857",
                    "46.56626;11.88884",
                    "46.56686;11.88915",
                    "46.56735;11.88948",
                    "46.56778;11.88978",
                    "46.56798;11.88993",
                    "46.56794;11.89047",
                    "46.56805;11.8908",
                    "46.56834;11.89111",
                    "46.56877;11.89131",
                    "46.56894;11.89136",
                    "46.56934;11.89149",
                    "46.57;11.89156",
                    "46.57054;11.89167",
                    "46.57108;11.89212",
                    "46.57144;11.89253",
                    "46.57177;11.89289",
                    "46.57222;11.89294",
                    "46.57292;11.89309",
                    "46.57344;11.89363",
                    "46.57382;11.89425",
                    "46.57417;11.89452",
                    "46.57463;11.89491",
                    "46.57506;11.89528",
                    "46.57529;11.89547",
                    "46.57548;11.89563",
                    "46.57582;11.89593",
                    "46.57616;11.89636",
                    "46.57657;11.89699",
                    "46.57694;11.89738",
                    "46.57726;11.89784",
                    "46.57787;11.89837",
                    "46.57821;11.89882",
                    "46.57846;11.89931",
                    "46.57853;11.89939",
                    "46.57883;11.89973",
                    "46.57917;11.90039",
                    "46.57944;11.90076",
                    "46.57985;11.90103",
                    "46.58006;11.90121",
                    "46.58035;11.90152",
                    "46.58071;11.90197",
                    "46.58091;11.90229",
                    "46.58113;11.90233",
                    "46.58131;11.90245",
                    "46.58143;11.9027",
                    "46.58157;11.90303",
                    "46.58176;11.90306",
                    "46.58202;11.90313",
                    "46.58225;11.90317",
                    "46.58243;11.9033",
                    "46.5826;11.90359",
                    "46.58279;11.90373",
                    "46.58315;11.90384",
                    "46.58373;11.90401",
                    "46.5844;11.90417",
                    "46.58464;11.90439",
                    "46.58478;11.90439",
                    "46.58513;11.90436",
                    "46.58546;11.90421",
                    "46.5856;11.90383",
                    "46.58548;11.90328",
                    "46.58555;11.90319",
                    "46.586;11.90306",
                    "46.58623;11.90297",
                    "46.58632;11.90283",
                    "46.5862;11.90159",
                    "46.58585;11.90167",
                    "46.58565;11.90186",
                    "46.58557;11.90218",
                    "46.58813;11.88655",
                    "46.58865;11.88662",
                    "46.58903;11.88651",
                    "46.5895;11.88703",
                    "46.58951;11.88743",
                    "46.58957;11.8877",
                    "46.59021;11.88802",
                    "46.59004;11.88843",
                    "46.59034;11.88884",
                    "46.59028;11.88924",
                    "46.59031;11.88961",
                    "46.59069;11.88956",
                    "46.5911;11.88958",
                    "46.59136;11.88969",
                    "46.59149;11.88957",
                    "46.59155;11.88988",
                    "46.5918;11.89006",
                    "46.5919;11.89066",
                    "46.59147;11.89186",
                    "46.59097;11.89252",
                    "46.58946;11.89408",
                    "46.58894;11.89478",
                    "46.58699;11.89469",
                    "46.58576;11.89444",
                    "46.58463;11.89534",
                    "46.58463;11.89534",
                    "46.58508;11.89593",
                    "46.58544;11.896",
                    "46.58561;11.8963",
                    "46.58551;11.89654",
                    "46.58543;11.89673",
                    "46.58525;11.89689",
                    "46.58504;11.89724",
                    "46.58483;11.89746",
                    "46.58453;11.89756",
                    "46.58415;11.89755",
                    "46.58386;11.89756",
                    "46.5837;11.89773",
                    "46.58336;11.89775",
                    "46.58296;11.89761",
                    "46.58252;11.89758",
                    "46.58219;11.89758",
                    "46.5824;11.89773",
                    "46.58263;11.89793",
                    "46.58289;11.89812",
                    "46.58309;11.89836",
                    "46.5834;11.89863",
                    "46.58378;11.89898",
                    "46.5841;11.89932",
                    "46.58448;11.89938",
                    "46.58587;11.89922",
                    "46.58743;11.89822",
                    "46.58918;11.89776",
                    "46.58974;11.89701",
                    "46.59041;11.89626",
                    "46.59109;11.89567",
                    "46.5915;11.8956",
                    "46.59244;11.8954",
                    "46.59305;11.89503",
                    "46.59361;11.89498",
                    "46.59418;11.89503",
                    "46.59491;11.89513",
                    "46.59544;11.8952",
                    "46.59585;11.89511",
                    "46.59608;11.89454",
                    "46.59641;11.89462",
                    "46.59658;11.89437",
                    "46.59703;11.89324",
                    "46.59731;11.8929",
                    "46.5976;11.89341",
                    "46.59732;11.89444",
                    "46.59768;11.89472",
                    "46.5984;11.89377",
                    "46.59922;11.89414",
                    "46.59987;11.89424",
                    "46.60086;11.89394",
                    "46.60194;11.89401",
                    "46.60263;11.89384",
                    "46.603;11.89396",
                    "46.60323;11.89407",
                    "46.60354;11.89412",
                    "46.60408;11.89388",
                    "46.6049;11.89349",
                    "46.6055;11.89344",
                    "46.60635;11.89337",
                    "46.60738;11.89326",
                    "46.60761;11.89311",
                    "46.60765;11.89351",
                    "46.60758;11.89402",
                    "46.60754;11.89424",
                    "46.60781;11.89414",
                    "46.60816;11.89415",
                    "46.6086;11.89416",
                    "46.60881;11.89434",
                    "46.60904;11.89437",
                    "46.60917;11.89453",
                    "46.60929;11.89467",
                    "46.60929;11.89499",
                    "46.60913;11.89523",
                    "46.60881;11.89533",
                    "46.60856;11.89536",
                    "46.60863;11.89556",
                    "46.60888;11.89556",
                    "46.60925;11.89551",
                    "46.60946;11.89581",
                    "46.60953;11.8961",
                    "46.60922;11.89617",
                    "46.61468;11.93686",
                    "46.61453;11.93685",
                    "46.61445;11.93683",
                    "46.61412;11.9367",
                    "46.61423;11.93688",
                    "46.61409;11.93733",
                    "46.61402;11.93775",
                    "46.61423;11.93795",
                    "46.61437;11.93809",
                    "46.6144;11.93847",
                    "46.61444;11.9387",
                    "46.61426;11.93867",
                    "46.61411;11.93901",
                    "46.61383;11.93921",
                    "46.61331;11.93948",
                    "46.61271;11.93916",
                    "46.61171;11.93941",
                    "46.61152;11.93908",
                    "46.61064;11.93871",
                    "46.61005;11.93835",
                    "46.6096;11.93801",
                    "46.60905;11.9379",
                    "46.60837;11.93779",
                    "46.60785;11.938",
                    "46.60717;11.93793",
                    "46.60694;11.93791",
                    "46.60609;11.93754",
                    "46.60579;11.937",
                    "46.60517;11.9368",
                    "46.60489;11.93665",
                    "46.60368;11.93712",
                    "46.60304;11.93756",
                    "46.60216;11.93763",
                    "46.60141;11.9375",
                    "46.60106;11.93706",
                    "46.60042;11.93681",
                    "46.59951;11.93689",
                    "46.59882;11.93686",
                    "46.59838;11.93624",
                    "46.59757;11.9352",
                    "46.59711;11.93483",
                    "46.59655;11.93509",
                    "46.59584;11.93499",
                    "46.5956;11.93442",
                    "46.59519;11.93415",
                    "46.59482;11.93266",
                    "46.59471;11.93193",
                    "46.59361;11.92936",
                    "46.59312;11.92858",
                    "46.59228;11.92772",
                    "46.59157;11.92816",
                    "46.59072;11.92851",
                    "46.59026;11.9286",
                    "46.5897;11.92863",
                    "46.5889;11.92848",
                    "46.58848;11.9285",
                    "46.58748;11.92729",
                    "46.58704;11.9267",
                    "46.58666;11.92618",
                    "46.58619;11.92586",
                    "46.586;11.92593",
                    "46.58536;11.92658",
                    "46.58501;11.92672",
                    "46.5846;11.92661",
                    "46.58439;11.92727",
                    "46.5841;11.92818",
                    "46.58392;11.92876",
                    "46.58358;11.92905",
                    "46.58348;11.92947",
                    "46.58302;11.92963",
                    "46.58263;11.92979",
                    "46.58243;11.92974",
                    "46.58217;11.92988",
                    "46.58199;11.93007",
                    "46.58161;11.93016",
                    "46.5813;11.9303",
                    "46.58102;11.93055",
                    "46.58078;11.93057",
                    "46.58049;11.93054",
                    "46.58018;11.93055",
                    "46.58003;11.93015",
                    "46.57952;11.92942",
                    "46.57912;11.92916",
                    "46.57851;11.92914",
                    "46.57808;11.9292",
                    "46.57758;11.92937",
                    "46.57715;11.92973",
                    "46.57656;11.93034",
                    "46.57599;11.93118",
                    "46.57528;11.93254",
                    "46.57471;11.93354",
                    "46.57442;11.93449",
                    "46.57408;11.93448",
                    "46.57377;11.93415",
                    "46.57368;11.93392",
                    "46.57349;11.93298",
                    "46.57383;11.93238",
                    "46.57383;11.93212",
                    "46.57354;11.93188",
                    "46.57309;11.93218",
                    "46.57254;11.93312",
                    "46.57216;11.93375",
                    "46.57221;11.93458",
                    "46.57204;11.93503",
                    "46.57186;11.93541",
                    "46.57124;11.93603",
                    "46.57052;11.93627",
                    "46.57024;11.93688",
                    "46.56989;11.93707",
                    "46.56929;11.93744",
                    "46.56916;11.93691",
                    "46.5684;11.93782",
                    "46.56816;11.93807",
                    "46.56786;11.93816",
                    "46.56782;11.93778",
                    "46.55613;11.92277",
                    "46.55578;11.92184",
                    "46.55512;11.92117",
                    "46.55466;11.92127",
                    "46.55396;11.92134",
                    "46.55302;11.92129",
                    "46.55275;11.92124",
                    "46.55251;11.92075",
                    "46.55199;11.92019",
                    "46.55106;11.91995",
                    "46.54912;11.91883",
                    "46.54837;11.91801",
                    "46.54818;11.91701",
                    "46.54794;11.91598",
                    "46.54798;11.91424",
                    "46.54844;11.91336",
                    "46.54741;11.91096",
                    "46.54703;11.91052",
                    "46.54683;11.9101",
                    "46.54655;11.91033",
                    "46.54586;11.9112",
                    "46.54553;11.91215",
                    "46.54525;11.91296",
                    "46.54461;11.91373",
                    "46.54332;11.9144",
                    "46.54286;11.91492",
                    "46.54223;11.9149",
                    "46.54193;11.91471",
                    "46.54152;11.91468",
                    "46.54092;11.9148",
                    "46.54029;11.91498",
                    "46.53937;11.91608",
                    "46.53883;11.91655",
                    "46.53833;11.91697",
                    "46.5379;11.91708",
                    "46.53732;11.91687",
                    "46.53678;11.91683",
                    "46.53641;11.9169",
                    "46.53582;11.91645",
                    "46.53535;11.91608",
                    "46.53484;11.91618",
                    "46.53451;11.91629",
                    "46.53398;11.91625",
                    "46.53407;11.91603",
                    "46.53409;11.9159",
                    "46.53382;11.91536",
                    "46.5337;11.91497",
                    "46.53393;11.91388",
                    "46.53403;11.91373",
                    "46.53405;11.91346",
                    "46.53355;11.91208",
                    "46.53336;11.91105",
                    "46.53347;11.91024",
                    "46.53303;11.91012",
                    "46.53294;11.90975",
                    "46.53383;11.90779",
                    "46.53381;11.90751",
                    "46.53368;11.90769",
                    "46.53352;11.90769",
                    "46.53348;11.90765",
                    "46.53359;11.90752",
                    "46.53355;11.90722",
                    "46.5335;11.90696",
                    "46.53339;11.90726",
                    "46.53318;11.90717",
                    "46.53307;11.90685",
                    "46.53297;11.90675",
                    "46.53285;11.90697",
                    "46.53279;11.90693",
                    "46.53266;11.90678",
                    "46.5327;11.90652",
                    "46.53282;11.90631",
                    "46.53273;11.9063",
                    "46.5328;11.90605",
                    "46.5326;11.90599",
                    "46.53267;11.90583",
                    "46.53253;11.90536",
                    "46.53262;11.90509",
                    "46.5325;11.90492",
                    "46.5324;11.90479",
                    "46.53227;11.90462",
                    "46.53195;11.90436",
                    "46.53175;11.9043",
                    "46.53148;11.90438",
                    "46.53139;11.90433",
                    "46.53141;11.90428",
                    "46.53132;11.90422",
                    "46.53137;11.90403",
                    "46.53121;11.90382",
                    "46.53068;11.90362",
                    "46.53059;11.90357",
                    "46.53049;11.90372",
                    "46.5304;11.90347",
                    "46.53028;11.90295",
                    "46.5301;11.90264",
                    "46.52997;11.90214",
                    "46.52981;11.90187",
                    "46.52971;11.90177",
                    "46.52985;11.90138",
                    "46.52987;11.9002",
                    "46.52928;11.89921",
                    "46.52926;11.89732",
                    "46.5288;11.89708",
                    "46.52845;11.89667",
                    "46.52866;11.8959",
                    "46.52845;11.89483",
                    "46.52769;11.89508",
                    "46.5271;11.89453",
                    "46.52634;11.89349",
                    "46.52632;11.89291",
                    "46.52594;11.89169",
                    "46.52494;11.89084",
                    "46.52396;11.88892",
                    "46.52268;11.88826",
                    "46.52253;11.88738",
                    "46.52159;11.88428",
                    "46.52143;11.88377",
                    "46.52114;11.88282",
                    "46.52102;11.88217",
                    "46.52088;11.88155",
                    "46.52082;11.88077",
                    "46.52085;11.88046",
                    "46.52088;11.8804",
                    "46.52086;11.87976",
                    "46.52071;11.87909",
                    "46.5207;11.8784",
                    "46.52078;11.87775",
                    "46.52086;11.87739",
                    "46.52098;11.87676",
                    "46.52058;11.87549",
                    "46.52022;11.8748",
                    "46.52019;11.87452",
                    "46.5201;11.87414",
                    "46.52001;11.87396",
                    "46.5193;11.87377",
                    "46.51925;11.87341",
                    "46.51925;11.87249",
                    "46.51964;11.87175",
                    "46.51295;11.86385",
                    "46.51286;11.86387",
                    "46.51267;11.86453"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/0a724b64-58f6-4afa-932f-056c56a35e3e.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/7d1327c5-9347-44ec-b65c-6ba6dc74488d.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/b569bb9d-721e-43e0-96ca-144776608edc.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/a8c38040-0966-44ba-8ab0-d55f32e8d1db.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Ristorante Sas La Crusc",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/5ea92003-6bff-42d6-9426-5b52d1bf178c.1_jpe__46_614406024953865_11_938441728707405",
                        "latitude": 46.614406024953865,
                        "longitude": 11.938441728707405,
                        "description": "Consigliamo sostare a questo ristorante e assaggiare una delle loro specialit\u00e0 tipiche alto Adesine. Da bere consigliamo lo sciroppo di sambuco diluito in acqua frizzante!"
                    },
                    {
                        "name": "Passo Gardena",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/ddd621f4-f7dc-4862-a3a0-2b9d0ec5e45c.2_jpe__46_54995195257764_11_806912338361146",
                        "latitude": 46.54995195257764,
                        "longitude": 11.806912338361146,
                        "description": "Il primo dei quattro passi che percorrerai durante questo Sella Ronda Tour in 2 Giorni!"
                    },
                    {
                        "name": "Corvara",
                        "type": "funny",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/9eb3912f-3148-4402-84b0-fe3646d886e9.3_jpe__46_552307819285105_11_869500323664399",
                        "latitude": 46.552307819285105,
                        "longitude": 11.869500323664399,
                        "description": "piccola citt\u00e0 nella quale nel caso di necessit\u00e0 potete trovare una farmacia, un supermarket e un meccanico di bici"
                    },
                    {
                        "name": "Alle 17.00 l'ultimo impianto del Bech de Roces chiude! ",
                        "type": "photo",
                        "image": "",
                        "latitude": 46.567570170203304,
                        "longitude": 11.937781507149339,
                        "description": "Ricordiamo di non fare troppo tardi altrimenti si rischia di non prendere in tempo l'ultimo impianto di risalita che vi porter\u00e0 al rifugio!"
                    }
                ],
                "infos": {
                    "distance": 45591
                }
            },
            {
                "id": 1357,
                "title": "Da Rifugio Bech de Roches a Selva di Val Gardena",
                "description": "Da Passo Campolongo a Selva di Val Gardena\r\nPassando per Arabba, Porta Vescovo, Passo Pordoi, \r\nCanazei, Col Rodella, Passo Sella\r\n ( \u2191 800m  \u2193 2700  38 km )\r\n\r\nDopo un'abbondate colazione al Rifugio Bec de Roces, \u00e8 giunto il momento di prepararci per quella che sar\u00e0 l'ultima giornata del Sellaronda E-MTB Tour.  \r\n\r\nVi aspettano discese lievemente pi\u00f9 tecniche rispetto alla giornata precedente!",
                "notes": "THIS IS DAY 2",
                "start_address": "Rifugio Bech de Roces",
                "difficulty": "Hard",
                "day": 2,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    46.51269,
                    11.86448
                ],
                "preview_track": [
                    "46.51269;11.86448",
                    "46.51287;11.86383",
                    "46.51237;11.86379",
                    "46.51212;11.86376",
                    "46.51233;11.86356",
                    "46.51211;11.86338",
                    "46.51216;11.86316",
                    "46.51179;11.8634",
                    "46.51186;11.86299",
                    "46.51206;11.86242",
                    "46.51216;11.86192",
                    "46.51225;11.86115",
                    "46.51228;11.8605",
                    "46.51231;11.86014",
                    "46.5124;11.86001",
                    "46.5123;11.85991",
                    "46.51228;11.85967",
                    "46.51234;11.85942",
                    "46.51228;11.85944",
                    "46.5122;11.85937",
                    "46.51204;11.85892",
                    "46.51203;11.85859",
                    "46.512;11.85822",
                    "46.51185;11.85765",
                    "46.51158;11.85772",
                    "46.51118;11.85751",
                    "46.51091;11.85763",
                    "46.51084;11.8579",
                    "46.51079;11.85822",
                    "46.51069;11.85788",
                    "46.51059;11.85834",
                    "46.51052;11.85847",
                    "46.51043;11.85866",
                    "46.50983;11.85972",
                    "46.50974;11.85967",
                    "46.50948;11.85907",
                    "46.50921;11.85964",
                    "46.50894;11.85941",
                    "46.50858;11.85881",
                    "46.5084;11.85876",
                    "46.50831;11.85927",
                    "46.5082;11.85923",
                    "46.5081;11.85873",
                    "46.50791;11.85876",
                    "46.50773;11.8589",
                    "46.50765;11.85913",
                    "46.50753;11.85929",
                    "46.50736;11.85975",
                    "46.50731;11.85997",
                    "46.50715;11.85971",
                    "46.50699;11.85982",
                    "46.50693;11.85986",
                    "46.50688;11.8599",
                    "46.50686;11.85985",
                    "46.50678;11.85974",
                    "46.50652;11.85996",
                    "46.50605;11.86064",
                    "46.50599;11.86091",
                    "46.50598;11.86178",
                    "46.50569;11.86365",
                    "46.50551;11.86499",
                    "46.50497;11.86596",
                    "46.50487;11.86613",
                    "46.50454;11.86669",
                    "46.50418;11.86754",
                    "46.50394;11.86861",
                    "46.50366;11.86905",
                    "46.50267;11.87021",
                    "46.50199;11.87121",
                    "46.50145;11.87242",
                    "46.50044;11.87327",
                    "46.50072;11.87405",
                    "46.50083;11.87432",
                    "46.49937;11.87466",
                    "46.499;11.87486",
                    "46.49852;11.87457",
                    "46.49809;11.87447",
                    "46.49784;11.8745",
                    "46.49729;11.87423",
                    "46.49729;11.87423",
                    "46.49705;11.87357",
                    "46.49645;11.87331",
                    "46.4962;11.87298",
                    "46.49585;11.87322",
                    "46.49596;11.87365",
                    "46.49573;11.8739",
                    "46.49566;11.87417",
                    "46.49526;11.8747",
                    "46.4952;11.8742",
                    "46.47287;11.87081",
                    "46.47277;11.87009",
                    "46.47264;11.86829",
                    "46.47267;11.86779",
                    "46.47273;11.86626",
                    "46.47353;11.86549",
                    "46.47369;11.86662",
                    "46.47406;11.86751",
                    "46.47493;11.86874",
                    "46.47513;11.86886",
                    "46.47529;11.86707",
                    "46.47546;11.86663",
                    "46.47562;11.86633",
                    "46.47581;11.86596",
                    "46.47612;11.86594",
                    "46.47612;11.86567",
                    "46.47676;11.86602",
                    "46.47682;11.86732",
                    "46.477;11.86965",
                    "46.47764;11.87003",
                    "46.47814;11.87053",
                    "46.47877;11.86949",
                    "46.47902;11.86881",
                    "46.47918;11.86873",
                    "46.47934;11.86805",
                    "46.47979;11.8675",
                    "46.48044;11.8671",
                    "46.48104;11.8662",
                    "46.48114;11.86645",
                    "46.48136;11.86677",
                    "46.48148;11.86627",
                    "46.48155;11.86641",
                    "46.48172;11.86659",
                    "46.48219;11.86592",
                    "46.4823;11.86614",
                    "46.48245;11.86683",
                    "46.4828;11.86671",
                    "46.48314;11.86655",
                    "46.48377;11.86648",
                    "46.48339;11.86504",
                    "46.48341;11.86275",
                    "46.48304;11.85967",
                    "46.48415;11.85664",
                    "46.48587;11.856",
                    "46.48603;11.85497",
                    "46.48569;11.85385",
                    "46.48552;11.8519",
                    "46.48543;11.85118",
                    "46.48575;11.85065",
                    "46.48601;11.84833",
                    "46.48583;11.84722",
                    "46.48619;11.84619",
                    "46.48672;11.84477",
                    "46.48672;11.84477",
                    "46.48737;11.84525",
                    "46.48787;11.84511",
                    "46.4881;11.84446",
                    "46.488;11.81486",
                    "46.48764;11.81404",
                    "46.48744;11.81362",
                    "46.48737;11.81353",
                    "46.48745;11.81261",
                    "46.48747;11.81253",
                    "46.4876;11.8121",
                    "46.48724;11.81173",
                    "46.48745;11.81053",
                    "46.48741;11.81036",
                    "46.48754;11.80966",
                    "46.48776;11.8091",
                    "46.48774;11.80794",
                    "46.48778;11.80737",
                    "46.48763;11.8066",
                    "46.48756;11.8058",
                    "46.48772;11.80513",
                    "46.48771;11.80437",
                    "46.48771;11.80368",
                    "46.48797;11.80253",
                    "46.48794;11.80156",
                    "46.48739;11.80083",
                    "46.48639;11.80074",
                    "46.48572;11.80076",
                    "46.48526;11.80095",
                    "46.48507;11.80073",
                    "46.48499;11.80001",
                    "46.48518;11.79991",
                    "46.48563;11.79977",
                    "46.48607;11.79983",
                    "46.48608;11.79952",
                    "46.48631;11.79924",
                    "46.48601;11.79876",
                    "46.48489;11.7975",
                    "46.48403;11.79569",
                    "46.48338;11.79359",
                    "46.48361;11.79267",
                    "46.48258;11.79043",
                    "46.48153;11.78942",
                    "46.48084;11.78892",
                    "46.47469;11.80176",
                    "46.47468;11.80305",
                    "46.47484;11.80338",
                    "46.47511;11.80424",
                    "46.47517;11.80467",
                    "46.4754;11.80472",
                    "46.47582;11.80574",
                    "46.47587;11.80563",
                    "46.47597;11.80564",
                    "46.47616;11.80569",
                    "46.47589;11.8049",
                    "46.47619;11.80519",
                    "46.47623;11.80495",
                    "46.47655;11.80538",
                    "46.47674;11.8055",
                    "46.47658;11.80494",
                    "46.47686;11.80523",
                    "46.47707;11.80534",
                    "46.47705;11.80508",
                    "46.47741;11.80504",
                    "46.47785;11.80528",
                    "46.47832;11.80549",
                    "46.47844;11.80522",
                    "46.47865;11.80507",
                    "46.47876;11.80463",
                    "46.47898;11.80465",
                    "46.47907;11.80465",
                    "46.47915;11.80463",
                    "46.47921;11.80423",
                    "46.47954;11.80414",
                    "46.47975;11.8033",
                    "46.4801;11.80287",
                    "46.48035;11.8024",
                    "46.48051;11.80169",
                    "46.48101;11.80105",
                    "46.48124;11.8007",
                    "46.48135;11.80021",
                    "46.48141;11.79953",
                    "46.4812;11.79939",
                    "46.48124;11.79929",
                    "46.48124;11.79914",
                    "46.48131;11.79894",
                    "46.4815;11.79874",
                    "46.48173;11.79809",
                    "46.48175;11.79758",
                    "46.48239;11.7965",
                    "46.48269;11.79644",
                    "46.48273;11.79619",
                    "46.48301;11.7961",
                    "46.48341;11.79545",
                    "46.48348;11.79525",
                    "46.48374;11.79484",
                    "46.4839;11.79455",
                    "46.48394;11.79367",
                    "46.48383;11.79292",
                    "46.48384;11.79168",
                    "46.48402;11.79055",
                    "46.48464;11.79167",
                    "46.48536;11.79102",
                    "46.48577;11.79084",
                    "46.48602;11.79092",
                    "46.48644;11.79108",
                    "46.48639;11.79083",
                    "46.48742;11.78996",
                    "46.48706;11.78922",
                    "46.48643;11.78862",
                    "46.48633;11.78829",
                    "46.48665;11.78822",
                    "46.48814;11.7886",
                    "46.48891;11.7881",
                    "46.48956;11.78799",
                    "46.49053;11.7878",
                    "46.49088;11.78771",
                    "46.49111;11.78743",
                    "46.4914;11.78712",
                    "46.49146;11.78692",
                    "46.49173;11.78684",
                    "46.49342;11.78683",
                    "46.49344;11.78672",
                    "46.49259;11.78596",
                    "46.49142;11.78503",
                    "46.49094;11.78503",
                    "46.49092;11.7846",
                    "46.49113;11.78415",
                    "46.49101;11.7826",
                    "46.491;11.78247",
                    "46.49153;11.78262",
                    "46.4915;11.78209",
                    "46.49221;11.78193",
                    "46.49294;11.78188",
                    "46.49238;11.78147",
                    "46.49232;11.78122",
                    "46.50236;11.75227",
                    "46.50259;11.75137",
                    "46.50241;11.75091",
                    "46.50145;11.75005",
                    "46.50226;11.75077",
                    "46.503;11.75168",
                    "46.50351;11.75166",
                    "46.50398;11.75238",
                    "46.5045;11.7531",
                    "46.5052;11.75479",
                    "46.50591;11.75587",
                    "46.50605;11.75665",
                    "46.50609;11.75683",
                    "46.5063;11.75707",
                    "46.5066;11.75707",
                    "46.50678;11.75705",
                    "46.50735;11.75655",
                    "46.50772;11.75605",
                    "46.50829;11.75533",
                    "46.50831;11.75529",
                    "46.50857;11.75503",
                    "46.50925;11.75459",
                    "46.5094;11.75409",
                    "46.50987;11.75351",
                    "46.51036;11.75274",
                    "46.51077;11.75221",
                    "46.51175;11.7513",
                    "46.51233;11.75182",
                    "46.51288;11.75252",
                    "46.51378;11.75259",
                    "46.51472;11.7528",
                    "46.51556;11.75302",
                    "46.51614;11.75272",
                    "46.51676;11.75231",
                    "46.51696;11.75213",
                    "46.51749;11.75216",
                    "46.51803;11.75202",
                    "46.51853;11.75167",
                    "46.51866;11.75114",
                    "46.519;11.7507",
                    "46.51936;11.75049",
                    "46.51942;11.75041",
                    "46.51943;11.75064",
                    "46.51916;11.75112",
                    "46.51916;11.75122",
                    "46.51933;11.75115",
                    "46.51941;11.75097",
                    "46.51946;11.75106",
                    "46.51933;11.7513",
                    "46.51938;11.75184",
                    "46.51919;11.75271",
                    "46.51899;11.75286",
                    "46.51897;11.75324",
                    "46.51894;11.75353",
                    "46.51909;11.75372",
                    "46.51906;11.75403",
                    "46.51918;11.75433",
                    "46.51932;11.75489",
                    "46.51948;11.75545",
                    "46.51945;11.75641",
                    "46.51966;11.75659",
                    "46.5198;11.75732",
                    "46.51998;11.75751",
                    "46.52015;11.7574",
                    "46.52097;11.75793",
                    "46.52115;11.75724",
                    "46.52124;11.75714",
                    "46.52193;11.75789",
                    "46.52194;11.75754",
                    "46.52171;11.75684",
                    "46.52186;11.7572",
                    "46.52193;11.75702",
                    "46.52245;11.75768",
                    "46.52287;11.75844",
                    "46.52317;11.75927",
                    "46.52317;11.75865",
                    "46.52298;11.75753",
                    "46.52288;11.75741",
                    "46.52296;11.75737",
                    "46.52307;11.75763",
                    "46.52319;11.75763",
                    "46.52312;11.75727",
                    "46.52287;11.75669",
                    "46.52371;11.7567",
                    "46.52404;11.75669",
                    "46.52449;11.75556",
                    "46.52463;11.75619",
                    "46.52435;11.75695",
                    "46.52452;11.75677",
                    "46.52449;11.75707",
                    "46.52461;11.75713",
                    "46.52487;11.75723",
                    "46.5248;11.75748",
                    "46.52442;11.75756",
                    "46.5247;11.75771",
                    "46.52489;11.75828",
                    "46.5251;11.75896",
                    "46.5255;11.7591",
                    "46.52584;11.75899",
                    "46.52619;11.75931",
                    "46.52661;11.75987",
                    "46.52721;11.76014",
                    "46.52732;11.76006",
                    "46.52744;11.75992",
                    "46.52777;11.7601",
                    "46.52807;11.76096",
                    "46.52819;11.7613",
                    "46.52834;11.76148",
                    "46.52861;11.76098",
                    "46.52845;11.76074",
                    "46.52865;11.76069",
                    "46.52905;11.7618",
                    "46.52909;11.76269",
                    "46.52916;11.76294",
                    "46.52957;11.76199",
                    "46.52966;11.76166",
                    "46.52973;11.76262",
                    "46.5297;11.76334",
                    "46.52979;11.76348",
                    "46.52991;11.76256",
                    "46.53018;11.76355",
                    "46.53024;11.76383",
                    "46.53038;11.76281",
                    "46.53048;11.76275",
                    "46.53077;11.76359",
                    "46.53099;11.76405",
                    "46.53119;11.76527",
                    "46.53155;11.76624",
                    "46.53164;11.7668",
                    "46.53112;11.76774",
                    "46.53037;11.76925",
                    "46.53047;11.76923",
                    "46.53052;11.76933",
                    "46.53056;11.76941",
                    "46.53092;11.76932",
                    "46.53101;11.76974",
                    "46.53084;11.77008",
                    "46.5306;11.77089",
                    "46.53045;11.77137",
                    "46.53094;11.77102",
                    "46.53107;11.77067",
                    "46.53123;11.77082",
                    "46.53111;11.77108",
                    "46.53145;11.77082",
                    "46.53162;11.77058",
                    "46.5317;11.77031",
                    "46.53178;11.77044",
                    "46.5318;11.77068",
                    "46.53164;11.77095",
                    "46.53169;11.77099",
                    "46.5319;11.77072",
                    "46.53211;11.7703",
                    "46.53231;11.77042",
                    "46.53258;11.77084",
                    "46.53269;11.77128",
                    "46.53269;11.77128",
                    "46.53255;11.77154",
                    "46.53263;11.77181",
                    "46.53326;11.77177",
                    "46.53338;11.77214",
                    "46.53367;11.77227",
                    "46.53424;11.77196",
                    "46.53472;11.7717",
                    "46.53482;11.77133",
                    "46.53559;11.7707",
                    "46.53608;11.77054",
                    "46.53648;11.76986",
                    "46.53679;11.7694",
                    "46.53697;11.76935",
                    "46.53705;11.76934",
                    "46.53721;11.76906",
                    "46.53732;11.76895",
                    "46.53732;11.7688",
                    "46.53745;11.7688",
                    "46.53782;11.76922",
                    "46.53877;11.76972",
                    "46.53946;11.77017",
                    "46.5397;11.77023",
                    "46.54088;11.76992",
                    "46.54223;11.76993",
                    "46.54253;11.76973",
                    "46.54403;11.76923",
                    "46.54522;11.76861",
                    "46.54582;11.76787",
                    "46.54649;11.76756",
                    "46.54705;11.76761",
                    "46.54726;11.76747",
                    "46.54743;11.76767",
                    "46.54846;11.76707",
                    "46.54974;11.76623",
                    "46.55012;11.76596",
                    "46.55036;11.76552",
                    "46.55065;11.76459",
                    "46.55145;11.76359",
                    "46.55195;11.76348",
                    "46.55247;11.76346",
                    "46.55307;11.76334",
                    "46.55329;11.7625",
                    "46.5535;11.76158",
                    "46.55363;11.761",
                    "46.55384;11.76005",
                    "46.55406;11.7591",
                    "46.55434;11.75856",
                    "46.5548;11.7578",
                    "46.55545;11.75671",
                    "46.55605;11.75569",
                    "46.55635;11.75512"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/da5caa60-64fe-4515-b0f6-f82a3b4095d6.JPG",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/1190dba3-2359-4394-b888-cb4fcb60cd7f.JPG",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5f56b662-4d95-47da-9a02-d6c4ae9aad9c.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/40de3bd0-409b-4a76-bcdc-37c664028af4.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Passo Pordoi",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/37bc82fc-fd60-4af5-98af-64309b292978.4_jpe__46_48749282129211_11_812611278146509",
                        "latitude": 46.48749282129211,
                        "longitude": 11.812611278146509,
                        "description": "Questo \u00e8 il terzo passo di montagna che gira intorno al massiccio Piz Boe. Se hai lo skipass giornaliero,puoi anche prendere l'impianto di risalita che ti porta a oltre 3300 metri in cima al Piz Boe. Puoi lasciare la tua bici allucchettata alla base dell'impianto. La funivia si chiama Sass Pordoi"
                    },
                    {
                        "name": "Ristorante Miara Hutte",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/d1eab139-4170-4dbb-814c-845864b658be.5_jpe__46_50146071598068_11_750030103139583",
                        "latitude": 46.50146071598068,
                        "longitude": 11.750030103139583,
                        "description": "Se avete fame quando passate da qui, vi consigliamo caldamente una sosta in questa baita di montagna!"
                    },
                    {
                        "name": "Baita Pra Valentini",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/bc1891d5-3f3b-45a8-9abf-3db723feb4d1.6_jpe__46_54800022949746_11_766459345817568",
                        "latitude": 46.54800022949746,
                        "longitude": 11.766459345817568,
                        "description": "Se avete fame quando passate da qui, vi consigliamo caldamente una sosta in questa baita di montagna!"
                    }
                ],
                "infos": {
                    "distance": 37579
                }
            }
        ],
        "catalogue": [
            {
                "id": 47,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 48,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 1588,
        "customer": {
            "id": 430,
            "title": "La Biciclettaia",
            "description": "Benvenuti a \"La Biciclettaia\", il vostro punto di riferimento per il noleggio di biciclette ad Alberese, nel cuore del Parco Naturale della Maremma. Con una vasta scelta di biciclette \u2013 dalle MTB alle e-bike, city bike, e-bike per bambini e seggiolini \u2013 offriamo soluzioni su misura per ogni esigenza. Pedalate tra i suggestivi sentieri del parco o lungo la ciclabile che conduce a Marina di Alberese e scoprite la bellezza incontaminata di questa riserva naturale. Con \"La Biciclettaia\", ogni uscita diventa un'avventura indimenticabile.",
            "color": null,
            "theme_dark": false,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/La_Biciclettaia.png",
            "text_logo": null,
            "contacts": {
                "address": "Via del Bersagliere, 2, Via del Bersagliere, 2, 58100 Alberese GR, Italia",
                "email": "labiciclettaia23@gmail.com",
                "phone": "+39 393 984 0290"
            },
            "coordinate": {
                "latitude": 42.66919,
                "longitude": 11.10376
            },
            "tours": 1,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/ed8f149f-cbfa-4962-8c84-289477678ab1.avif",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/d35ee35c-6ac7-4342-b888-2e55c103489a.avif"
            ]
        },
        "title": "Parco Regionale della Maremma ",
        "description": "Un tour semplice adatto a tutti, di una durata di circa 2,5/3 ore pause incluse nel quale percorrerete un tour ad anello all'interno nel Parco passando per i suoi scorci pi\u00f9 spettacolari.\n",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/1166.png",
        "price": 25.0,
        "location": "Maremma",
        "location_id": 6,
        "tags": [
            "Natura",
            "Mare",
            "Storia"
        ],
        "routes": [
            {
                "id": 1621,
                "title": "Parco NAturale della Maremma E-bike Tour",
                "description": "Vi aspetta un tour semplice adatto a tutti all'interno dei uno dei parchi naturali pi\u00f9 spettacolari della Toscana; Il arco della Maremma. Il parco naturale della Maremma \u00e8 un'area naturale protetta dell'Italia centrale, che occupa il territorio dei Monti dell'Uccellina, in provincia di Grosseto; \u00e8 stato il primo parco della regione Toscana.25km di pista ciclabile nei quali passerete tra ulivi secolari, Torri Rinascimentali e una natura incontaminata.",
                "notes": "",
                "start_address": "Via del Bersagliere, 2, 58100 Alberese GR",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://c02.purpledshub.com/uploads/sites/39/2024/04/Giant-Defy-Advanced-Pro-2-18.jpg?w=1029&webp=1",
                "track": [
                    42.66884,
                    11.10447
                ],
                "preview_track": [
                    "42.66884;11.10447",
                    "42.66953;11.10384",
                    "42.67106;11.10247",
                    "42.67236;11.10117",
                    "42.6701;11.09533",
                    "42.66955;11.09206",
                    "42.66933;11.08981",
                    "42.67039;11.08689",
                    "42.67078;11.0841",
                    "42.67066;11.08142",
                    "42.67065;11.07968",
                    "42.6701;11.07912",
                    "42.66934;11.07893",
                    "42.66874;11.07829",
                    "42.66872;11.07714",
                    "42.66868;11.07611",
                    "42.66828;11.07486",
                    "42.66848;11.07398",
                    "42.66871;11.07267",
                    "42.66841;11.07221",
                    "42.66765;11.07232",
                    "42.66666;11.07231",
                    "42.66565;11.07222",
                    "42.66436;11.07281",
                    "42.66269;11.07293",
                    "42.66109;11.073",
                    "42.65993;11.07295",
                    "42.65849;11.07287",
                    "42.65714;11.07406",
                    "42.65545;11.07527",
                    "42.65405;11.0756",
                    "42.65285;11.07595",
                    "42.65165;11.07701",
                    "42.65136;11.07684",
                    "42.65127;11.07587",
                    "42.65084;11.07509",
                    "42.64982;11.07429",
                    "42.64846;11.07423",
                    "42.64748;11.07445",
                    "42.64691;11.07393",
                    "42.64641;11.07272",
                    "42.64602;11.0717",
                    "42.64556;11.07191",
                    "42.64461;11.07264",
                    "42.64389;11.07315",
                    "42.6432;11.07284",
                    "42.64259;11.07284",
                    "42.64225;11.07242",
                    "42.64109;11.07134",
                    "42.64049;11.07059",
                    "42.64075;11.0689",
                    "42.64088;11.06792",
                    "42.6409;11.06799",
                    "42.6406;11.06799",
                    "42.64004;11.06756",
                    "42.63952;11.0674",
                    "42.63998;11.06687",
                    "42.6421;11.06619",
                    "42.64478;11.06498",
                    "42.64613;11.06334",
                    "42.6456;11.06164",
                    "42.64689;11.05712",
                    "42.64743;11.05596",
                    "42.64813;11.05242",
                    "42.64918;11.04866",
                    "42.6501;11.0455",
                    "42.65061;11.04319",
                    "42.65101;11.04045",
                    "42.65133;11.038",
                    "42.651;11.03773",
                    "42.65075;11.03748",
                    "42.65046;11.03743",
                    "42.65034;11.037",
                    "42.65042;11.03635",
                    "42.65037;11.03622",
                    "42.65027;11.03531",
                    "42.65001;11.03491",
                    "42.65015;11.03374",
                    "42.65026;11.03292",
                    "42.65093;11.03211",
                    "42.65128;11.03083",
                    "42.65152;11.0305",
                    "42.65158;11.02884",
                    "42.65164;11.02815",
                    "42.65387;11.02404",
                    "42.65442;11.0233",
                    "42.65777;11.01611",
                    "42.65928;11.01608",
                    "42.6603;11.01699",
                    "42.66023;11.01704",
                    "42.65857;11.01974",
                    "42.65676;11.02687",
                    "42.65523;11.0329",
                    "42.65387;11.03827",
                    "42.65393;11.03866",
                    "42.65426;11.03881",
                    "42.65484;11.03913",
                    "42.65509;11.03932",
                    "42.65608;11.03988",
                    "42.65672;11.04021",
                    "42.65719;11.04051",
                    "42.65769;11.04082",
                    "42.65824;11.0411",
                    "42.65852;11.04125",
                    "42.65901;11.04153",
                    "42.65957;11.04187",
                    "42.6603;11.0423",
                    "42.66097;11.04269",
                    "42.66189;11.04324",
                    "42.66245;11.04356",
                    "42.66242;11.04361",
                    "42.66301;11.0439",
                    "42.66389;11.04444",
                    "42.66437;11.04468",
                    "42.66481;11.04492",
                    "42.66579;11.04553",
                    "42.66666;11.04602",
                    "42.66686;11.04599",
                    "42.66788;11.04654",
                    "42.66913;11.04731",
                    "42.66931;11.04741",
                    "42.66941;11.04718",
                    "42.66962;11.04729",
                    "42.67097;11.04809",
                    "42.67222;11.04876",
                    "42.67246;11.04871",
                    "42.67397;11.04774",
                    "42.67421;11.04803",
                    "42.67446;11.04914",
                    "42.67475;11.05316",
                    "42.67547;11.0561",
                    "42.67862;11.06809",
                    "42.67979;11.07046",
                    "42.68116;11.07209",
                    "42.68108;11.07293",
                    "42.67979;11.07391",
                    "42.67972;11.07396",
                    "42.67994;11.0751",
                    "42.68035;11.07659",
                    "42.68215;11.08313",
                    "42.68412;11.09038",
                    "42.68415;11.09078",
                    "42.68153;11.0931",
                    "42.67991;11.09454",
                    "42.67964;11.09484",
                    "42.67944;11.09505",
                    "42.67811;11.09617",
                    "42.67231;11.10137",
                    "42.66957;11.1038",
                    "42.6689;11.10441"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/99842b48-8c4d-4041-bb59-31f808918499.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/14bbb355-b8e2-4a94-9ab8-951526c729ad.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/3ff4d859-28b3-4393-beeb-e40b8b18b227.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/190d271d-6080-4816-a190-4cff1b14ad88.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/c4bcff46-f481-4aeb-8dc4-5241520362b6.webp"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Torre di Colle Lungo",
                        "type": "history",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/48b65889-f251-4ee5-bd45-77f1f4fb7063.torre__42_6409006158222_11_067919665947556",
                        "latitude": 42.6409006158222,
                        "longitude": 11.067919665947556,
                        "description": "La fortificazione con funzione di avvistamento venne fatta costruire dai Senesi in epoca rinascimentale per rafforzare il sistema difensivo costiero lungo uno dei tratti litoranei controllati dalla Repubblica di Siena.\n\n"
                    },
                    {
                        "name": "Bar - Bistrot",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/dc14bbdc-553e-4675-ab1d-9148251eb905.risto__42_650995146805734_11_037743536289781",
                        "latitude": 42.650995146805734,
                        "longitude": 11.037743536289781,
                        "description": "Se stai cercando un punto di ristoro immerso nella natura incontaminata del Parco della Maremma, vicino alla spiaggia di Marina di Alberese, Ristoro La Viola \u00e8 la scelta perfetta."
                    },
                    {
                        "name": "Foce del Fiume Ombrone",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/f3432310-056e-45d4-a9fe-b1d74c49c9d8.foce___42_660256131234505_11_017098426818848",
                        "latitude": 42.660256131234505,
                        "longitude": 11.017098426818848,
                        "description": "Un luogo dove la Maremma mostra il suo lato pi\u00f9 autentico: il fiume si apre verso il mare tra canneti, dune e grandi spazi naturali. \u00c8 una zona ricca di fauna e perfetta per una sosta \u201cvista natura\u201d, con panorami aperti e luce bellissima, soprattutto nelle ore pi\u00f9 fresche della giornata."
                    },
                    {
                        "name": "Ulivi Secolari",
                        "type": "photo",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/983fecce-2645-431c-ad45-f981b81c57a6.ulivi__42_668712275561234_11_077139193657787",
                        "latitude": 42.668712275561234,
                        "longitude": 11.077139193657787,
                        "description": "Un luogo dove la Maremma mostra il suo lato pi\u00f9 autentico: il fiume si apre verso il mare tra canneti, dune e grandi spazi naturali. \u00c8 una zona ricca di fauna e perfetta per una sosta \u201cvista natura\u201d, con panorami aperti e luce bellissima, soprattutto nelle ore pi\u00f9 fresche della giornata."
                    }
                ],
                "infos": {
                    "distance": 23316
                }
            }
        ],
        "catalogue": [
            {
                "id": 100,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 50.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 101,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    },
    {
        "id": 958,
        "customer": {
            "id": 34,
            "title": "Padbike",
            "description": "Padbike, a tour operator based in Florence, specialized in designing and organizing E-Bike travel experiences.\r\nIn 2024 it opened an in-house Software & Development division for the development of Outdoora.",
            "color": "#404040",
            "theme_dark": true,
            "logo": "https://padbike-admin.s3.amazonaws.com/customer_logo/Padbike.png",
            "text_logo": [
                "https://padbike-admin.s3.amazonaws.com/customer.Customer.customer_logo/provaRisorsa_1.png"
            ],
            "contacts": {
                "address": "Via dei Renai, 13, Via dei Renai, 13, 50125 Firenze FI, Italia",
                "email": "padbikeapp@gmail.com",
                "phone": "+393888353749"
            },
            "coordinate": {
                "latitude": 43.76491,
                "longitude": 11.25982
            },
            "tours": 12,
            "gallery": [
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/21851540-c174-42ce-9ec2-d50341a79f83.JPG",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/389e886d-2941-43cc-bc89-86cfd16f0c82.png",
                "https://padbike-admin.s3.amazonaws.com/customer_gallery/8aa350b2-3694-4348-ac22-b832c90da9c1.jpg"
            ]
        },
        "title": "San Gimignano  E-Bike Tour short",
        "description": "Tour ad anello panoramico con partenza da San Gimignano, tra strade bianche, vigneti e filari di olivi con vista continua sulle celebri torri medievali. Il percorso, di 26 km e 500 m di dislivello, \u00e8 scorrevole e senza tratti tecnici: ideale per e-bike e biker di ogni livello, richiede solo un minimo di confidenza con sterrati e qualche breve salita.\n\nLungo l\u2019itinerario \u00e8 prevista una sosta alla Fattoria Poggio Alloro, azienda agricola con vista spettacolare su San Gimignano, dove \u00e8 possibile fermarsi per uno snack oppure concludere il tour con degustazione di vini e visita in cantina.\n\nFondata come borgo medievale lungo la Via Francigena, San Gimignano \u00e8 famosa per le sue torri: nel Trecento erano oltre 70, oggi ne restano 14 che le hanno valso il riconoscimento UNESCO come straordinario esempio di citt\u00e0 murata ben conservata.",
        "image": "https://padbike-admin.s3.amazonaws.com/track_photo/958.jpeg",
        "price": 25.0,
        "location": "San Gimignano",
        "location_id": 37,
        "tags": [
            "Natura",
            "Citt\u00e0",
            "Storia"
        ],
        "routes": [
            {
                "id": 1090,
                "title": "DA SAN GIMIGNANO A SIENA E-BIKE TOUR",
                "description": "Anello di 26 km e 500 m D+, facile e adatto a tutti, su panoramiche strade bianche tra vigneti, oliveti e splendide viste sulle torri medievali di San Gimignano, antico borgo sulla Via Francigena e oggi sito UNESCO. Lungo il percorso \u00e8 prevista una sosta alla Fattoria Poggio Alloro, dove chi lo desidera pu\u00f2 concludere il tour con snack, degustazione vini e visita in cantina.",
                "notes": "",
                "start_address": "Monte Riggioni",
                "difficulty": "Medium",
                "day": 1,
                "image": "https://padbike-admin.s3.amazonaws.com/track_photo/958.jpeg",
                "track": [
                    43.46452,
                    11.04208
                ],
                "preview_track": [
                    "43.46452;11.04208",
                    "43.46456;11.04189",
                    "43.46494;11.04165",
                    "43.46598;11.04171",
                    "43.46629;11.0415",
                    "43.46669;11.04094",
                    "43.46701;11.04049",
                    "43.46718;11.04034",
                    "43.4678;11.04005",
                    "43.46849;11.04017",
                    "43.46885;11.04045",
                    "43.46982;11.04082",
                    "43.47011;11.04097",
                    "43.47024;11.04094",
                    "43.47046;11.04054",
                    "43.47116;11.03833",
                    "43.47118;11.03805",
                    "43.47118;11.03689",
                    "43.47118;11.03557",
                    "43.47121;11.03404",
                    "43.47166;11.03287",
                    "43.47219;11.03241",
                    "43.47324;11.03177",
                    "43.47441;11.03106",
                    "43.47505;11.03056",
                    "43.47624;11.02942",
                    "43.47631;11.02913",
                    "43.47642;11.02883",
                    "43.47653;11.02868",
                    "43.4766;11.02853",
                    "43.47676;11.02718",
                    "43.47708;11.02534",
                    "43.47786;11.02312",
                    "43.47802;11.02289",
                    "43.4781;11.02209",
                    "43.47801;11.02143",
                    "43.47804;11.01982",
                    "43.47867;11.01827",
                    "43.47959;11.01696",
                    "43.48045;11.01542",
                    "43.48043;11.01353",
                    "43.48113;11.01068",
                    "43.48222;11.00813",
                    "43.48291;11.00721",
                    "43.48336;11.00544",
                    "43.48366;11.00419",
                    "43.48374;11.00431",
                    "43.48407;11.00476",
                    "43.48483;11.00502",
                    "43.48539;11.0054",
                    "43.48586;11.0051",
                    "43.48656;11.00547",
                    "43.48716;11.00569",
                    "43.4878;11.0055",
                    "43.48837;11.0051",
                    "43.4888;11.0053",
                    "43.48903;11.00516",
                    "43.48946;11.00467",
                    "43.4902;11.005",
                    "43.49035;11.00607",
                    "43.49084;11.00647",
                    "43.4913;11.00802",
                    "43.4908;11.00902",
                    "43.48968;11.00965",
                    "43.48974;11.0099",
                    "43.49135;11.01214",
                    "43.49141;11.01365",
                    "43.49158;11.01468",
                    "43.4919;11.01628",
                    "43.49223;11.01814",
                    "43.49203;11.01976",
                    "43.49259;11.02033",
                    "43.4932;11.02163",
                    "43.49383;11.02258",
                    "43.49416;11.02332",
                    "43.49416;11.02381",
                    "43.49448;11.0242",
                    "43.49515;11.02558",
                    "43.49573;11.02557",
                    "43.49583;11.02544",
                    "43.49581;11.02573",
                    "43.49542;11.0268",
                    "43.49595;11.02937",
                    "43.49564;11.03143",
                    "43.49542;11.03256",
                    "43.49559;11.03416",
                    "43.49597;11.03573",
                    "43.49613;11.03664",
                    "43.49607;11.03864",
                    "43.49683;11.0401",
                    "43.49719;11.04083",
                    "43.49866;11.04163",
                    "43.49876;11.04162",
                    "43.49845;11.04177",
                    "43.49658;11.04361",
                    "43.49567;11.04569",
                    "43.49547;11.04727",
                    "43.49529;11.0494",
                    "43.4953;11.05025",
                    "43.49446;11.05202",
                    "43.49293;11.053",
                    "43.4921;11.05521",
                    "43.4914;11.0564",
                    "43.49017;11.05886",
                    "43.48978;11.06029",
                    "43.48934;11.06259",
                    "43.48911;11.06521",
                    "43.48833;11.06523",
                    "43.48762;11.06519",
                    "43.48734;11.06573",
                    "43.48724;11.06713",
                    "43.48743;11.06852",
                    "43.48748;11.06922",
                    "43.48691;11.06934",
                    "43.48621;11.07015",
                    "43.48578;11.07132",
                    "43.48572;11.07197",
                    "43.4841;11.0732",
                    "43.48328;11.0736",
                    "43.4832;11.0743",
                    "43.48307;11.0751",
                    "43.48255;11.07603",
                    "43.48155;11.07803",
                    "43.48073;11.07891",
                    "43.47999;11.07985",
                    "43.4797;11.0806",
                    "43.47917;11.08047",
                    "43.47814;11.07984",
                    "43.4774;11.08013",
                    "43.47672;11.08106",
                    "43.4764;11.0816",
                    "43.47622;11.08399",
                    "43.47618;11.08505",
                    "43.47548;11.08622",
                    "43.47509;11.08611",
                    "43.47459;11.08618",
                    "43.47378;11.08629",
                    "43.47282;11.08533",
                    "43.47247;11.08527",
                    "43.47223;11.08555",
                    "43.47236;11.08573",
                    "43.4723;11.0859",
                    "43.47178;11.08624",
                    "43.47154;11.08626",
                    "43.47064;11.08623",
                    "43.46999;11.08681",
                    "43.46984;11.08832",
                    "43.46996;11.08947",
                    "43.47016;11.09154",
                    "43.46978;11.09289",
                    "43.4677;11.09404",
                    "43.46568;11.09389",
                    "43.4647;11.0939",
                    "43.46451;11.09411",
                    "43.46421;11.09601",
                    "43.46329;11.09653",
                    "43.46216;11.0969",
                    "43.46214;11.10048",
                    "43.46211;11.10273",
                    "43.46056;11.10312",
                    "43.46009;11.10316",
                    "43.45998;11.10315",
                    "43.45954;11.10136",
                    "43.45954;11.10068",
                    "43.4594;11.09918",
                    "43.45912;11.09487",
                    "43.45899;11.09391",
                    "43.45884;11.0933",
                    "43.45881;11.09274",
                    "43.45877;11.09045",
                    "43.45939;11.08801",
                    "43.45964;11.08677",
                    "43.46002;11.08671",
                    "43.46045;11.08665",
                    "43.46005;11.08581",
                    "43.45944;11.08571",
                    "43.45908;11.08594",
                    "43.45934;11.08531",
                    "43.45934;11.08373",
                    "43.45951;11.08285",
                    "43.46028;11.0813",
                    "43.45959;11.07893",
                    "43.45915;11.07663",
                    "43.45966;11.076",
                    "43.46165;11.07491",
                    "43.46208;11.07413",
                    "43.46292;11.07207",
                    "43.46304;11.0709",
                    "43.46359;11.06931",
                    "43.46451;11.06846",
                    "43.46594;11.06731",
                    "43.46624;11.06667",
                    "43.46676;11.0649",
                    "43.46714;11.06441",
                    "43.46852;11.06365",
                    "43.46954;11.06187",
                    "43.47081;11.06002",
                    "43.47326;11.057",
                    "43.47472;11.05609",
                    "43.47586;11.05351",
                    "43.47767;11.05087",
                    "43.47865;11.04943",
                    "43.47857;11.04845",
                    "43.47875;11.04666",
                    "43.47885;11.04582",
                    "43.47878;11.04527",
                    "43.47761;11.04412",
                    "43.47639;11.04267",
                    "43.47437;11.04159",
                    "43.47327;11.0409",
                    "43.47299;11.04073",
                    "43.4717;11.04016",
                    "43.47101;11.04021",
                    "43.4707;11.04053",
                    "43.47046;11.04054",
                    "43.47026;11.04091",
                    "43.47011;11.04091",
                    "43.47004;11.04093",
                    "43.46898;11.04055",
                    "43.46861;11.04025",
                    "43.46813;11.04004",
                    "43.46728;11.04028",
                    "43.46711;11.04039",
                    "43.46692;11.04058",
                    "43.46658;11.04113",
                    "43.46626;11.04153",
                    "43.46587;11.04175",
                    "43.46486;11.04168",
                    "43.46455;11.04198",
                    "43.46452;11.04208"
                ],
                "gallery": [
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/dd406238-2117-4ade-bf35-701df8fb3617.webp",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/931da443-05a2-4ffa-9828-add2aba60036.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/702c5b27-3188-47bc-98d2-f6c63dd996e8.JPG",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5775b2bb-addf-4c04-b030-174b8113ed9b.jpg",
                    "https://padbike-admin.s3.amazonaws.com/route_gallery/5627573c-9411-4e9d-8edf-4fad42945e26.jpg"
                ],
                "instructions": [],
                "pois": [
                    {
                        "name": "Fattoria Poggio Alloro",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/36206707-5e0f-4a07-86de-66921c8e2969.brind__43_487618940887884_11_065172161906961",
                        "latitude": 43.487618940887884,
                        "longitude": 11.065172161906961,
                        "description": "Alla Fattoria Poggio Alloro (San Gimignano) gli ospiti possono vivere un\u2019autentica esperienza enogastronomica in azienda agricola biologica: degustazioni guidate di Vernaccia di San Gimignano, rossi toscani ed olio extravergine di produzione propria, accompagnati da salumi, formaggi, ortaggi dell\u2019orto e piatti tipici \u201cfarm to table\u201d serviti con vista unica sulle torri. \u00c8 possibile abbinare visita alla cantina, alla fattoria e ai vigneti per conoscere da vicino la filiera dei prodotti che si trovano nel bicchiere e nel piatto. "
                    },
                    {
                        "name": "Vista panoramica di San Gimignano",
                        "type": "food",
                        "image": "https://padbike-admin.s3.amazonaws.com/route_poi_gallery/9481e472-c23c-42a1-aa8e-b83da666d542.san-g__43_47865266743813_11_046624183654787",
                        "latitude": 43.47865266743813,
                        "longitude": 11.046624183654787,
                        "description": "da qui potrete godere di una vista mozzafiato di san gimignano"
                    }
                ],
                "infos": {
                    "distance": 24977
                }
            }
        ],
        "catalogue": [
            {
                "id": 47,
                "name": "E-bike",
                "description": "ammortizzata e disponibile in varie taglie",
                "price": 60.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": true,
                "icon_type": "bike",
                "custom_icon": null
            },
            {
                "id": 48,
                "name": "Casco",
                "description": "Disponibile in varie misure",
                "price": 5.0,
                "confirmationRequired": true,
                "pricePerDay": true,
                "requireTallInfos": false,
                "icon_type": "helmet",
                "custom_icon": null
            }
        ]
    }
]

let _fetch: (url: string, data: any) => Promise<any>;
let thenJson = (data: any) => {
  return data;
};
let catchLogout = (err: any) => {
  return err;
};

const currentToken = () => {
    try {
       const d = JSON.parse(localStorage.outdooraData)
       if(d) {
        const token = d.account.token
        return token
       }
    }catch {

    }
    return undefined
}

if (LOCALSTORAGE) {
  _fetch = (url: string, config: any) => {
    const myPromise = new Promise((resolve, reject) => {
      const resouce = url.split("3000/")[1].split("/")[0];
      const rand = Math.floor(Math.random() * (1500 - 500 + 1) + 500);
      if (config.method === "GET") {
        setTimeout(() => {
          let resp = [];
          if (localStorage[resouce]) {
            try {
              resp = JSON.parse(localStorage[resouce]);
            } catch (e) {
              resp = [];
            }
          }
          resolve(resp);
        }, rand);
      } else {
        setTimeout(() => {
          resolve(undefined);
        }, rand);
      }
    });
    return myPromise;
  };
} else {
  _fetch = fetch;
  thenJson = (resp: any) => {
    if (resp.status === 401) {
      delete localStorage.auth_token;
    }
    return resp.json();
  };
  catchLogout = (err: any) => {
    if (err.status === 401) {
      delete localStorage.auth_token;
    }
    throw err;
  };
}

class Client {
    baseUrl = window.location.href.startsWith("http://localhost:3000")
      ? "http://127.0.0.1:8000"
      : "";
  
    protected url(path: string, authenticated = true) {
      if (authenticated) {
        return `${this.baseUrl}/api/${path}`;
      }
      return `${this.baseUrl}/${path}`;
    }

  
    get(path: string, authenticated = true) {
      return _fetch(this.url(path, authenticated), {
        method: "GET",
        headers: {
            "accept-language": window.lang,
            'x-user-token': currentToken()
        }
      })
        .then(thenJson)
        .catch(catchLogout);
    }
  
    post(path: string, data: any, authenticated = true) {
      return _fetch(this.url(path, authenticated), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "accept-language": window.lang,
          'x-user-token': currentToken()
        },
        body: JSON.stringify(data),
      })
        .then(thenJson)
        .catch(catchLogout);
    }
  
    put(path: string, data: any) {
      return _fetch(this.url(path), {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "accept-language": window.lang,
          'x-user-token': currentToken()
        },
        body: JSON.stringify(data),
      })
        .then(thenJson)
        .catch(catchLogout);
    }
  
    delete(path: string) {
      return _fetch(this.url(path), {
        method: "DELETE",
        headers: {
            "accept-language": window.lang,
            'x-user-token': currentToken()
        },
      })
        .then(thenJson)
        .catch(catchLogout);
    }
  }
  
  class CrudService extends Client {
    resource = "";
  
    list() {
      console.log("LIST ", this.resource);
      return this.get(`${this.resource}/`);
    }
  
    add(data: any) {
      console.log("ADD NEW ", this.resource, data);
      return this.post(`${this.resource}/`, data);
    }
  
    update(id: any, data: any) {
      console.log("UPDATE ", this.resource, id, data);
      return this.put(`${this.resource}/${id}/`, data);
    }
  
    remove(id: any) {
      console.log("DELETE ", this.resource, id);
      return this.delete(`${this.resource}/${id}/`);
    }
  }
  
  
  class _TrackService extends CrudService {
    resource = "public_tracks";

    // Normalizza il catalogo (icone bici/casco) e scarta i tour senza percorsi.
    private adaptList(t: any) {
        (t || []).forEach((x: any) => {
            (x.catalogue || []).forEach((e: any) => {
                if (e.icon_type === 'bike' && !e.custom_icon) {
                    e.typeIcon = bikeGif
                } else if (e.icon_type === 'helmet' && !e.custom_icon) {
                    e.typeIcon = helmetGif
                } else {
                    e.typeIcon = e.custom_icon
                }
            })
        })
        return (t || []).filter((tt: any) => tt.routes && tt.routes.length > 0);
    }

    // Applica lo stesso adattamento del catalogo a un singolo tour (dettaglio).
    private adaptOne(x: any) {
        if (!x) return x;
        (x.catalogue || []).forEach((e: any) => {
            if (e.icon_type === 'bike' && !e.custom_icon) {
                e.typeIcon = bikeGif
            } else if (e.icon_type === 'helmet' && !e.custom_icon) {
                e.typeIcon = helmetGif
            } else {
                e.typeIcon = e.custom_icon
            }
        })
        return x;
    }

    // Lista paginata. page 0 = 70 tour, pagine successive = 20.
    // Passando destination filtra lato server per quella destinazione.
    list(page: number = 0, destination?: any): any {
        let path = `${this.resource}/?page=${page}`
        if (destination) {
            path += `&destination=${destination}`
        }
        return this.get(path).then((t: any) => {
            return this.adaptList(t)
        })
        .catch((e: any) => {
            // Il fallback mock ha senso solo per la prima pagina non filtrata.
            if (page === 0 && !destination) {
                return this.adaptList(mockprod)
            }
            return []
        });
    }

    // Ricerca server-side per l'autocomplete (min 3 caratteri lato client).
    search(q: string): any {
        return this.get(`${this.resource}/search/?q=${encodeURIComponent(q)}`)
            .then((t: any) => this.adaptList(t))
            .catch(() => []);
    }

    // Marker leggeri per la mappa, filtrati per bounding box + zoom.
    mapMarkers(bbox?: string, zoom?: number): any {
        let path = `${this.resource}/map/`
        const params: string[] = []
        if (bbox) params.push(`bbox=${bbox}`)
        if (zoom != null) params.push(`zoom=${zoom}`)
        if (params.length) path += `?${params.join('&')}`
        return this.get(path).catch(() => []);
    }

    detail(tourId: any): any {
        return this.get(`${this.resource}/${tourId}/`).then((x: any) => this.adaptOne(x))
    }
  }

  class _PaymentService extends CrudService {
    resource = "tour_payment"

    createCheckoutSession(data: any, amount: number, currency: string, userInfos: any) {
        return this.add({amount, currency, data, userInfos})
    }

    status(sessionId: string, paymentId: any) {
        return this.get(`${this.resource}/status/?session_id=${sessionId}&paymentId=${paymentId}`)
    }

    /**
     * Logga un errore client-side lato server. Best effort: se anche questo fallisce
     * ce ne facciamo una ragione (non vogliamo bloccare il flusso).
     */
    logClientError(context: string, error: any, paymentId?: any, sessionId?: any, attempt?: number) {
        try {
            const errorStr = (error && (error.stack || error.message)) || String(error);
            return this.post('log_client_error/', {
                context,
                error: errorStr,
                paymentId,
                sessionId,
                attempt,
            });
        } catch (e) {
            // ignora
            return Promise.resolve();
        }
    }
  }

  class _LoginService extends CrudService {

    resource = "google_login";

    login(id_token: any, form_infos: any): any {
        return this.add({id_token, form_infos});
    }

    updateAccount(user_infos?: any):any {
        let obj = {}
        if(user_infos) {
            obj = {form_infos: user_infos}
        }
        return this.post('account/', obj)
    }

    paymentList():any {
        return this.get('account/payments/')
    }
  }

  class _ManagerService extends CrudService {

    bookings(token:any):any {
        return this.get(`manager/bookings/${token}/`)
    }

    updateHeights(token:any, bookingId:any, heights:any):any {
        return this.post(`manager/bookings/${token}/heights/`, { bookingId, heights })
    }

    // Sezione "Orari e chiusure": legge lo stato del negozio e lo salva (il
    // pannello manda sempre TUTTO). Se i dati non sono validi il server risponde
    // 400 con { error, errors: [...] } e non salva niente.
    schedule(token:any):any {
        return this.get(`manager/schedule/${token}/`)
    }

    saveSchedule(token:any, data:any):any {
        return this.post(`manager/schedule/${token}/`, data)
    }
  }
 
  class _DestinationService extends CrudService {

    resource = "destination_list"

  }

  export const TrackService = new _TrackService();

  export const PaymentService = new _PaymentService();

  export const ManagerService = new _ManagerService();

  export const DestinationService = new _DestinationService();

  export const LoginService = new _LoginService();
